// uq-ko-KR
module.exports = {
  "text_a11y_home_membership_description": "마이 페이지ㆍ구매 내역",
  "text_a11y_home_navigation_description": "제품 찾기ㆍ키워드 검색",
  "text_a11y_favorites_add": "위시리스트에 추가",
  "text_a11y_close": "닫기",
  "text_a11y_breadcrumbs": "Breadcrumbs",
  "text_a11y_carousel_next": "다음",
  "text_a11y_carousel_previous": "이전",
  "text_a11y_favorites_added": "위시리스트에 추가됨",
  "text_a11y_helpfulvoting_votedown": "도움이 안돼요",
  "text_a11y_helpfulvoting_voteup": "도움이 돼요",
  "text_a11y_info_icon": "상세정보",
  "text_a11y_lineup": "Lineup",
  "text_a11y_more": "더 보기",
  "text_a11y_product_list": "Product List",
  "text_a11y_rating_apply": "별 5 개 중 1 개\n별 5 개 중 2 개\n별 5 개 중 3 개\n별 5 개 중 4 개\n별 5 개 중 5 개",
  "text_a11y_rating_apply-1": "별 5 개 중 1 개",
  "text_a11y_rating_apply-2": "별 5 개 중 2 개",
  "text_a11y_rating_apply-3": "별 5 개 중 3 개",
  "text_a11y_rating_apply-4": "별 5 개 중 4 개",
  "text_a11y_rating_apply-5": "별 5 개 중 5 개",
  "text_a11y_rating_average": "별 5개 중 {count}개",
  "text_a11y_rating_rate": "별 5 개 중 1 개\n별 5 개 중 2 개\n별 5 개 중 3 개\n별 5 개 중 4 개\n별 5 개 중 5 개",
  "text_a11y_rating_rate-1": "별 5 개 중 1 개",
  "text_a11y_rating_rate-2": "별 5 개 중 2 개",
  "text_a11y_rating_rate-3": "별 5 개 중 3 개",
  "text_a11y_rating_rate-4": "별 5 개 중 4 개",
  "text_a11y_rating_rate-5": "별 5 개 중 5 개",
  "text_a11y_rating_select": "별 1개 리뷰 보기\n별 2개 리뷰 보기\n별 3개 리뷰 보기\n별 4개 리뷰 보기\n별 5개 리뷰 보기",
  "text_a11y_rating_select-1": "별 1개 리뷰 보기",
  "text_a11y_rating_select-2": "별 2개 리뷰 보기",
  "text_a11y_rating_select-3": "별 3개 리뷰 보기",
  "text_a11y_rating_select-4": "별 4개 리뷰 보기",
  "text_a11y_rating_select-5": "별 5개 리뷰 보기",
  "text_a11y_related_product_list": "Related Product List",
  "text_a11y_scrolltotop": "맨위로",
  "text_a11y_search_icon": "UNIQLO 검색",
  "text_a11y_toggle_arrow": "트리형 구조 열기",
  "text_a11y_wearing_items": "착용 제품",
  "text_about_tls": "TLS에 대하여",
  "text_connect_membership_description": "유니클로 APP과 온라인 회원정보 연결되었습니다.",
  "text_linkedaccount": "회원정보 연결했습니다.",
  "text_max_address_registration": "최대 10개의 주소를 저장할 수 있습니다.",
  "text_no_registered_address": "등록된 배송 주소가 없습니다.",
  "text_setas_default": "기본 배송지 설정",
  "text_log_in": "로그인",
  "text_ok": "확인",
  "text_coupon_used": "이 쿠폰은 사용 완료되었습니다.",
  "text_redeem_allcoupons": "선택한 쿠폰이 모두 사용되었습니다.",
  "text_backto_coupons": "쿠폰 목록으로 돌아가기",
  "text_no_coupon": "쿠폰이 없습니다.",
  "text_onlinestore": "온라인 스토어",
  "text_redeem_coupon_title": "쿠폰 사용 확인",
  "text_redeem_coupons": "사용",
  "text_redeem_coupons_success": "쿠폰이 사용되었습니다.",
  "text_retailstore": "매장",
  "text_wantto_redeem": "한 번 교환하면 변경할 수 없습니다.",
  "text_enewsletter_setting_change_complete": "이메일 뉴스레터 수신 동의 설정 변경 완료",
  "text_gu_enewsletter_list": "GU 전자 뉴스레터",
  "text_multiple_enewsletter_subscribe_annotation": "여러 개의 전자 뉴스레터를 구독하면 2개 이상의 전자 뉴스레터를 받게 됩니다.",
  "text_returnto_enewsletter_edit_setting": "이전 페이지로 돌아가기",
  "text_edit_enewsletter_setting": "이메일 뉴스레터 수신 동의 설정",
  "text_edit_enewsletter_setting_instruction": "광고성 이메일 수신을 원하실 경우 아래의 동의 버튼을 체크해 주시기 바랍니다.",
  "text_enewsletter_edit_continue": "계속",
  "text_enewsletter_setting_change": "광고성 이메일 수신 동의 정보 변경",
  "text_enewsletter_setting_update_complete_notification": "광고성 이메일 수신 동의 정보가 변경 되었습니다. 감사합니다.",
  "text_enewsletter_setting_update_notification_send": "이메일 뉴스레터 수신 동의, 변경, 해지 완료시 이메일로 안내 드리고 있습니다. 수신 거부 혹은 스팸으로 등록된 경우가 있을 수 있음으로 사전에 이메일 설정을 확인해 주시기 바랍니다.",
  "text_save_update": "저장",
  "text_uq_enewsletter_list": "동의",
  "text_enter_new_email_address_description": "변경할 이메일 주소를 입력해 주세요. 이메일 변경시 회원아이디도 해당 이메일로 변경 됩니다. 단, 변경 이전의 이메일주소로 생성된 주문정보가 있으신 경우, 관련한 안내메일은 변경 이전의 이메일로 전송됩니다.",
  "text_preview": "미리 보기",
  "text_gender_text": "성별 등 등록된 정보를 바탕으로 제품을 추천받을 수 있습니다.",
  "text_returnto_membership_edit": "회원정보 수정으로 돌아가기",
  "text_return_to_profile_page": "회원정보로 돌아가기",
  "text_pw_valid_numbersoftexts": "암호는 8-20자여야 하며 숫자, 문자를 포함해야 합니다. 특수문자 입력을 원하시는 경우 @ $ ! % * # ? & 에 한하여 사용이 가능합니다.",
  "text_account_profile_details": "회원 정보",
  "text_returnto_membership": "My page로 돌아가기",
  "text_change_email": "이메일 주소(아이디) 변경",
  "text_error_ccpa_age_consent_over_16_yaers_old_agreement_uncheck": "계속하려면 클릭해 주세요.",
  "text_register_credit_card": "새 신용카드 등록",
  "text_termsof_conditions": "이용약관",
  "text_gu_privacy_policy": "text_gu_privacy_policy",
  "text_privacy_policy": "개인정보처리방침",
  "text_display_country_name": "text_display_country_name",
  "text_checkbox_instruction": "내용 확인 후 동의해주세요.",
  "text_error_incorrect_verification_code": "입력한 코드가 유효하지 않습니다. 인증 코드가 올바른지 확인해 주세요.",
  "text_account_registration_email_settings": "이메일 수신 설정",
  "text_email_address_verification": "이메일 주소 인증",
  "text_email_verification_code_expired_description": "인증코드가 만료되었습니다.",
  "text_email_verification_code_expired_title": "인증코드가 만료됨",
  "text_failed_to_receive_verification_code_description01": "인증코드를 등록하신 메일 주소로 전송하였습니다. 확인 후 인증코드를 입력해 주세요.",
  "text_failed_to_receive_verification_code_description02": "인증코드를 수신하지 못한 경우 이메일 계정 정보 및 스팸메일함을 확인해 주세요.",
  "text_submit_verification_code_and_password": "다음",
  "text_verification_code_sent_message": "등록하신 이메일 주소로 인증 코드가 발송되었습니다. 확인 후 인증 코드를 입력해 주세요.",
  "text_login": "로그인",
  "text_coupon_list": "쿠폰 목록",
  "text_membership_purchase_history": "구매 내역",
  "text_purchase_history": "구매제품",
  "text_familyname": "성(Last name)",
  "text_firstname": "이름(First name)",
  "text_phone_required": "전화번호",
  "text_valid_phonetic_familyname": "이름을 입력해 주세요",
  "text_valid_phonetic_firstname": "성 입력",
  "text_familyname_furigana": "이름",
  "text_furgana_firstname": "성",
  "text_valid_familyname": "성을 입력해 주세요.",
  "text_valid_firstname": "이름을 입력해 주세요.",
  "text_redeemed": "사용됨",
  "text_neck_size": "목둘레",
  "text_asean_ec_migration_password_reset_request01": "2월 20일부로 유니클로 온라인스토어가 업데이트되었습니다. 업데이트 이후 최초 로그인 진행 시 비밀번호의 재설정이 필요합니다.\n{forgot_password} 링크를 통하여 비밀번호 재설정 후 이용 부탁드립니다.",
  "text_do_not_show_notification": "text_do_not_show_notification",
  "text_ecwelcome_coupon_description_no_placeholder": "회원가입 후 유니클로만의 특별한 혜택을 누려보세요.",
  "text_error_login_account_locked_message": "text_error_login_account_locked_message",
  "text_login_email_pw_entry": "이메일 주소와 비밀번호로 로그인해 주세요.",
  "text_new_registration": "신규 회원가입",
  "text_onlineregistration_needed": "온라인 스토어 이용을 위해 회원가입이 필요합니다. 회원가입 후 유니클로만의 특별한 혜택을 누려보세요.",
  "text_verification_announcement_description": "text_verification_announcement_description",
  "text_verification_announcement_title": "text_verification_announcement_title",
  "text_email_address": "이메일 주소(아이디)",
  "text_checkbox_show_pw": "비밀번호 표시",
  "text_pw": "비밀번호",
  "text_send_verification_code": "인증코드 전송",
  "text_email_verification_code": "인증코드",
  "text_failed_to_receive_verification_code": "인증코드를 받지 못한 경우",
  "text_ph_email_verification_code": "6자리 인증코드",
  "text_resend_verification_code": "인증코드 재전송",
  "text_indicator_enter_verification_code": "인증코드 입력",
  "text_verification_code_expiration_notes": "인증코드 유효시간은 30분입니다. 확인 후 바로 입력 부탁드립니다. 이 페이지를 닫거나 새로고침을 할 경우 처음부터 다시 진행되오니, 유의하시기 바랍니다.",
  "text_register": "등록",
  "text_reset_pw": "비밀번호를 잊어버리셨나요?",
  "text_password_change_request_reason01": "",
  "text_pwreset": "비밀번호 재설정",
  "text_verification_enter_code_description02": "text_verification_enter_code_description02",
  "text_ph_login_id": "이메일(example@uniqlo.com)",
  "text_verification_enter_code_description01": "text_verification_enter_code_description01",
  "text_error_verification_enter_code_title": "text_error_verification_enter_code_title",
  "text_new_registration_title": "신규 회원가입",
  "text_email_verification_input_page": "인증코드 입력",
  "text_failed_to_logut_description": "text_failed_to_logut_description",
  "text_failed_to_logut_title": "text_failed_to_logut_title",
  "text_my_size": "마이사이즈",
  "text_creditcard_list": "신용카드",
  "text_edit_pw_title": "비밀번호 변경",
  "text_posted_review": "작성한 리뷰",
  "text_details": "상세 정보",
  "text_view_detail": "상세 보기",
  "text_arm_length": "팔 길이",
  "text_body_length": "키",
  "text_bottoms_shoes_size": "신발 사이즈",
  "text_bust_size": "가슴 사이즈",
  "text_chest_bust_size": "가슴/흉부",
  "text_cup_size": "컵 사이즈",
  "text_edit_my_size": "마이 사이즈 수정",
  "text_foot_size": "발 사이즈",
  "text_head_size": "머리 사이즈",
  "text_hip_size": "허리 사이즈",
  "text_howto_register_my_size": "버튼을 눌러 마이 사이즈 등록해 주세요",
  "text_leg_length": "다리 길이",
  "text_metrology_arm_length": "팔 길이 (cm)",
  "text_metrology_body_length": "키 (cm)",
  "text_metrology_bust_size": "가슴둘레 (cm)",
  "text_metrology_chest_bust_size": "가슴/흉부 (cm)",
  "text_metrology_cm": "센티미터",
  "text_metrology_cup_size": "컵 사이즈",
  "text_metrology_foot_size": "발 사이즈 (cm)",
  "text_metrology_head_size": "머리 사이즈 (cm)",
  "text_metrology_height": "높이 (cm)",
  "text_metrology_hip_size": "엉덩이 사이즈 (cm)",
  "text_metrology_kg": "kg(킬로그램)",
  "text_metrology_leg_length": "다리 길이 (cm)",
  "text_metrology_neck_size": "목둘레(cm)",
  "text_metrology_sleeve_length": "소매 길이 (cm)",
  "text_metrology_under_bust_size": "언더바스트 (cm)",
  "text_metrology_waist_size": "허리 사이즈 (cm)",
  "text_metrology_weight": "체중 (kg)",
  "text_my_size_basic_size": "기본 사이즈",
  "text_my_size_desciption01": "마이 사이즈는 회원님의 신체 치수를 기록합니다. 유니클로는 등록된 사이즈를 기준으로 적합한 사이즈를 추천해 드립니다.",
  "text_my_size_maximum_register": "마이 사이즈는 최대 {max}개까지 등록할 수 있습니다.",
  "text_my_size_name": "마이 사이즈 등록 이름",
  "text_my_size_register_edit": "마이 사이즈 등록",
  "text_my_size_tops_size": "상의 사이즈",
  "text_no_registered_my_size": "등록된 마이 사이즈가 없습니다.",
  "text_recently_purchased_size": "최근 구매한 제품 사이즈",
  "text_register_my_size": "등록",
  "text_register_my_size_description": "마이 사이즈 등록 하였습니다. 등록된 사이즈는 수정 가능 합니다.",
  "text_register_new_my_size": "마이사이즈 신규 등록",
  "text_remove_my_size": "마이 사이즈 삭제",
  "text_remove_my_size_description01": "{my_size_name}로 등록된 사이즈를 삭제하시겠습니까?",
  "text_remove_my_size_title": "마이 사이즈 삭제",
  "text_returnto_my_size": "마이 사이즈로 돌아가기",
  "text_shoulder_width": "어깨 넓이",
  "text_under_bust_size": "밴드 사이즈",
  "text_waist_size": "허리 사이즈",
  "text_women_innner_size": "여성 이너웨어 사이즈",
  "text_email_address_confirmation_form": "이메일 주소를 다시 입력해 주세요.",
  "text_enter_mobile_phone": "전화번호를 입력해 주세요",
  "text_uqtop": "UNIQLO 홈",
  "text_order_history_online_note": "주문 후 주문현황 확인, 교환/반품 요청, 영수증 발행 등을 하실 수 있습니다.",
  "text_order_history_in_store_purchase_information": "전자 영수증에 대한 자세한 내용을 보려면 {clickHere} 클릭하세요.",
  "text_contact_notes": "회원정보에 오기입이 없는지 다시 한번 확인해주세요.",
  "text_current_location": "현재 위치",
  "text_max_card_notes": "최대 5개의 신용카드를 저장할 수 있습니다.",
  "text_no_credit_card": "등록된 신용카드가 없습니다.",
  "text_register_address": "확인",
  "text_current_pw": "현재 비밀번호",
  "text_edit_pw_complete": "비밀번호가 변경 완료",
  "text_edit_pw_description": "비밀번호가 변경 완료 되었습니다.",
  "text_enter_currentpw": "현재 비밀번호를 입력해 주세요.",
  "text_about_mail_receive_settings": "이메일 수신 설정",
  "text_birthday_date_format": "YYYY/MM/DD",
  "text_create": "전송",
  "text_enter_postalcode": "우편번호를 입력해 주세요.",
  "text_enter_registered_membership_email_address": "등록 정보 입력",
  "text_enter_varification_registered_information": "등록된 “우편번호”, “생년월일”, “전화번호” 중 하나를 입력해 주세요.",
  "text_new_password_confrimation": "비밀번호(확인용)",
  "text_ph_new_password_confirmation": "비밀번호와 비밀번호(확인용) 정보가 일치하지 않습니다.",
  "text_pwreset_action1": "비밀번호 재설정 링크는 요청 후 2시간 후에 만료됩니다.",
  "text_pwreset_action2": "비밀번호 재설정 링크는 요청 후 2시간 후에 만료됩니다. 링크가 만료된 경우 “비밀번호를 잊으셨나요?”를 클릭해 주세요",
  "text_pwreset_complete": "비밀번호 재설정",
  "text_pwreset_complete1": "비밀번호가 업데이트되었습니다.",
  "text_pwreset_description": "회원가입 시 등록하신 이메일 주소를 입력해 주세요. 비밀번호 재설정 링크가 포함된 안내 메일이 발송됩니다.",
  "text_pwreset_description_without_two_factor_verification": "text_pwreset_description_without_two_factor_verification",
  "text_pwreset_maildetail": "회원정보 내 등록한 이메일 주소로 메시지가 전송되었습니다. 비밀번호 재설정을 원하시는 경우, 해당 이메일 확인 후 진행 부탁드립니다.",
  "text_pwreset_mailsent": "확인 이메일이 전송되었습니다.",
  "text_select_require": "필수선택",
  "text_validate_items": "확인사항",
  "text_enter_phone": "전화번호를 입력해 주세요.",
  "text_edit_pw": "비밀번호 변경",
  "text_email_sent": "등록하신 이메일 주소로 확인 메일이 전송되었습니다.",
  "text_enter_newpw": "새 비밀번호를 입력해 주세요.",
  "text_new_password_validation_format_characters": "8~ 20자",
  "text_new_password_validation_format_numbers_and_alphabets": "영문+숫자",
  "text_new_password_validation_format_special_characters": "특수문자 (사용가능 문자 : !\"#$%&'()*+,-./:;<=>?@[]^_`{}|~ )",
  "text_new_pw": "새 비밀번호",
  "text_postalcode": "우편번호",
  "text_birthday": "생년월일",
  "text_hint_in_case_address_city_overflow": "주소 힌트",
  "text_no_posted_review": "작성하신 리뷰가 없습니다.",
  "text_total_posted_review": "작성한 리뷰 수",
  "text_faq": "자주하는 질문",
  "text_membership_email_address": "회원 이메일(아이디) 주소",
  "text_no_purchasehistory": "현재 이 계정에 대한 주문이 없습니다.",
  "text_no_purchasehistory_description1": "매장 내 구매는 결제 시 멤버십 바코드 제시 시 구매일 익일까지 반영됩니다. 온라인 매장에서 구매하신 상품은 배송일 익일까지 반영됩니다.",
  "text_order_history_note": "매장과 온라인 스토어에서 구입하신 제품을 확인할 수 있습니다.",
  "text_purchase_history_imark_title": "구매제품이력이란?",
  "text_product_unavailable": "이 제품은 품절 되었습니다.",
  "text_maminfo_description_item01": "유니클로 APP을 통한 구매",
  "text_maminfo_description_item02": "온라인 스토어 MY PAGE 및 구매 내역 확인",
  "text_maminfo_description_item03": "온라인 스토어 위시리스트",
  "text_maminfo_description_item04": "온라인 스토어 쿠폰",
  "text_maminfo_description_item05": "UNIQLO Pay 서비스 *",
  "text_maminfo_description_uqpay": "연결을 해제하면 UNIQLO Pay가 비활성화되며 결제 정보도 삭제되니 유의하시기 바랍니다. 이 서비스를 이용하려면 UNIQLO Pay 결제 정보를 다시 등록해야 합니다.",
  "text_maminfo_remove_linkage_message01": "온라인스토어 회원정보가 유니클로 APP과 연결이 해제됩니다. 진행하시겠습니까?",
  "text_maminfo_remove_linkage_message02": "연결 해제시, 유니클로 APP 통한 상품 구매가 불가하며, 연결시 사용된 온라인 회원정보가 동시에 해제 됩니다.",
  "text_meminfo_description_details01": "유니클로 APP 서비스와 온라인 스토어의 회원 정보와의 연결을 해제합니다.",
  "text_meminfo_description_details02": "연결 해제 시, 유니클로 APP을 통하여 아래의 서비스를 이용할 수 없게 됩니다.",
  "text_meminfo_description_details03": "추후 다시 회원 정보를 연결하시면, 유니클로 APP을 통한 구매 및 온라인 스토어 MY PAGE, 구매 내역, 위시리스트, 쿠폰은 이용 가능합니다.",
  "text_remove_linkage": "회원정보 연결해제",
  "text_remove_linkage_completed": "회원 정보 연결 해제",
  "text_remove_linkage_confirmation_title": "유니클로 APP의 연결된 회원정보를 해제하시겠습니까?",
  "text_month": "월",
  "text_expirationdate": "유효기간",
  "text_membership_agreement": "이용약관",
  "text_deliverydate": "배송 예정일",
  "text_change": "변경",
  "text_sleeve_length": "소매 길이",
  "text_edit_address_validation_description": "text_edit_address_validation_description",
  "text_edit_shipping_address": "text_edit_shipping_address",
  "text_enter_address_validation_description": "text_enter_address_validation_description",
  "text_enter_address_validation_title": "text_enter_address_validation_title",
  "text_proceed_anyway_address_validation_description_01": "text_proceed_anyway_address_validation_description_01",
  "text_proceed_anyway_address_validation_description_02": "text_proceed_anyway_address_validation_description_02",
  "text_recommend_address_validation_title": "text_recommend_address_validation_title",
  "text_submit_edit_address_validation": "text_submit_edit_address_validation",
  "text_submit_proceed_address_validation": "text_submit_proceed_address_validation",
  "text_submit_proceed_anyway_address_validation": "text_submit_proceed_anyway_address_validation",
  "text_verify_shipping_address_title": "text_verify_shipping_address_title",
  "text_current_shipping_address": "현재 주소",
  "text_delete_address_title": "주소 삭제",
  "text_bill_address": "청구지 주소 사명",
  "text_account_registration_email_address_mistake_notes": "입력한 메일 주소가 문제 없는지 확인해 주세요.",
  "text_account_registration_preview": "미리 보기",
  "text_aleady_logged_in_message": "로그인 되어 있습니다. 다른 계정으로 로그인 원하시는 경우, 로그아웃 후 이용해 주세요.",
  "text_aleady_logged_in_message_title": "로그인됨",
  "text_ecwelcome_coupon_annotation": "쿠폰 부여에는 다소 시간이 발생합니다. 양해 부탁드리겠습니다.",
  "text_error_failed_create_welcome_coupon01": "웰컴 쿠폰 생성 중 오류가 발생했습니다.",
  "text_error_failed_create_welcome_coupon02": "웰컴 쿠폰을 받으려면 고객센터로 문의해 주세요.",
  "text_get_ecwelcome_coupon": "온라인스토어 쿠폰이 발급되었습니다.",
  "text_howto_use_coupon": "쿠폰 사용 방법",
  "text_new_registration_e-mail": "등록이 완료되면 입력한 이메일 주소로 등록 확인 이메일이 발송됩니다. 회원 등록 전 이메일 수신 설정을 확인해 주세요.",
  "text_new_registration_textonprivacypolicy": "이용 약관 및 개인 정보 처리방침 정책을 확인해 주세요.",
  "text_new_registration_thanks": "회원 등록해 주셔서 감사합니다.",
  "text_register_magazine": "광고성 이메일 수신 동의 (선택)",
  "text_return_to_create_account": "신규 회원가입 화면으로 돌아가기",
  "text_thanks_registration_mail": "등록하신 이메일 주소로 회원등록 확인 메일이 전송되었습니다.",
  "text_genderother": "미입력/기타",
  "text_unregistered": "미등록",
  "text_usecoupon_button": "쿠폰 사용 (직원 전용)",
  "text_indicator_check_email": "이메일 확인",
  "text_indicator_send_verification_code": "인증코드 전송",
  "text_indicator_verification_completed": "완료",
  "text_store": "매장",
  "text_404": "페이지를 찾을 수 없습니다.",
  "text_contactus": "고객센터",
  "text_email_address_verification_completed": "이메일 주소 인증이 완료되었습니다.",
  "text_verification_code_sent": "새 인증코드가 전송되었습니다.",
  "text_bill_address_imark_title": "청구지 주소관련",
  "text_bill_address_imark1": "유니클로 온라인스토어에서 처음 구매하시는 고객님의 대금 상환 및 매장 결제를 선택하신 고객님의 회원 주소는 배송지 주소로 등록됩니다.",
  "text_login_imark_description": "회원님의 소중한 개인정보 보호를 위해 다음과 같은 경우 비밀번호 변경해 주세요.\n• 다른 서비스에서 동일한 비밀번호를 사용 중입니다.\n• 최근에 비밀번호를 변경하지 않았습니다.\n비밀번호를 변경하려면 회원정보 페이지에서 비밀번호 변경을 선택해 주세요.",
  "text_login_imark_description01": "회원님의 소중한 개인정보 보호를 위해 다음과 같은 경우 비밀번호 변경해 주세요.",
  "text_login_imark_description02": "• 다른 서비스에서 동일한 비밀번호를 사용 중입니다.",
  "text_login_imark_description03": "• 최근에 비밀번호를 변경하지 않았습니다.",
  "text_login_imark_description04": "비밀번호를 변경하려면 회원정보 페이지에서 비밀번호 변경을 선택해 주세요.",
  "text_uqpay_unavailable_reason_not_registered": "UNIQLO Pay 가 미등록되어, 결제수단으로 이용 하실수 없습니다. UNIQLO Pay 등록하시면 사용 가능 하십니다.",
  "text_keyicon_description": "이 페이지에서 입력하신 정보는 TLS로 보호되어 전송됩니다. 일부 브라우저 혹은 휴대전화 단말기에서는 당사의 일부 페이지에 액세스할 수 없습니다. 양해 부탁 드리겠습니다.",
  "text_uqpay_activation_message01": "유니클로 APP에서 UNIQLO Pay에 등록하면 모든 유니클로 매장에서 편리하게 결제할 수 있습니다.",
  "text_uqpay_activation_message02": "유니클로 APP에서 UNIQLO Pay에 대해 자세히 알아보기",
  "text_uqpay_activation_title": "UNIQLO Pay 활성화",
  "text_uqpay_deactivate": "비활성화",
  "text_uqpay_deactivation_completed_title": "UNIQLO Pay 비활성화 완료됨",
  "text_uqpay_deactivation_completed01": "UNIQLO Pay 비활성화가 완료되었습니다.",
  "text_uqpay_deactivation_confirmation01": "UNIQLO Pay 서비스를 비활성화하시겠어요?",
  "text_uqpay_deactivation_message01": "UNIQLO Pay 서비스를 비활성화하시겠어요?",
  "text_uqpay_deactivation_message02": "등록된 UNIQLO Pay 결제 정보는 비활성화 후에는 복구할 수 없습니다. 또한 비활성화 후에는 UNIQLO Pay 서비스 및 캠페인 정보를 더는 받을 수 없습니다.",
  "text_uqpay_deactivation_title": "UNIQLO Pay 비활성화",
  "text_uniqlo_pay": "UNIQLO Pay",
  "text_returnto_previous_page": "이전 페이지로 돌아가기",
  "text_change_verification_email_address": "다른 이메일 주소 변경",
  "text_confirm_and_send_verification_code": "인증코드 전송",
  "text_email_address_verify_description01": "등록된 이메일 주소가 인증되지 않았습니다. 이메일 주소를 인증해 주세요.",
  "text_email_verification_confirmation": "등록된 이메일 주소로 인증 진행 하시겠습니까?",
  "text_email_verification_issue_notes_01": "인증코드 전송후 페이지로 다시 돌아오는 경우 여기 {link}에서 자세한 내용을 참조해 주세요.",
  "text_email_verification_issue_notes_02": "인증코드 전송후 페이지로 다시 돌아오고 코드를 이미 가지고 있다면, 이 {enter_verification_code} 페이지로 바로 이동후 인증 절차를 완료해 주세요. 자세한 내용은 여기 {link}를 참조해 주세요.",
  "text_enter_email": "유효한 이메일 주소를 입력해 주세요.",
  "text_enter_pw": "비밀번호를 입력해 주세요.",
  "text_error_email_verification_code_invalid": "인증코드가 만료되었거나, 유효하지 않습니다.",
  "text_postal_code_verification": "우편번호(확인용)",
  "text_retry_change_email_address": "이메일 주소 다시 입력",
  "text_verify_email_address": "이메일 주소 확인",
  "text_new_email_address": "변경할 이메일(아이디) 입력",
  "text_new_email_address_confirmation": "변경할 이메일 입력(아이디 / 확인용)",
  "text_change_email_title": "이메일 주소(아이디) 변경",
  "text_email_verification_steps": "이메일 인증 단계",
  "text_verification_code_instruction01": "입력 내용에 문제가 없는지 확인해 주세요. 신규 회원가입 및 이메일 변경 완료를 위해서는 이메일 인증이 필요합니다. 입력한 이메일 주소로 전송되는 인증코드를 다음 페이지에서 입력해 주세요.",
  "text_verification_code_instruction02": "해당 이메일을 수신하실 수 있도록 사전에 확인해 주세요.",
  "text_error_failed_get_wish_list_added_item_details": "제품 정보를 가져오지 못했습니다. 페이지를 새로고침 해 주세요.",
  "text_no_wishlist_styling_item": "스타일링 위시리스트가 비어있습니다.",
  "text_product_name_place_holder": "제품 이름을 가져오지 못했습니다.",
  "text_wish_list_login_required": "위시리스트 추가를 원하시면 온라인 스토어에 로그인해 주세요.",
  "text_wishlist_alteration_available_item": "수선이 가능합니다.",
  "text_wishlist_size_not_select": "사이즈가 선택되지 않았습니다. 제품 페이지에서 사이즈를 선택해 주세요",
  "text_wishlist_styling_instruction": "위시리스트에 추가하려면 마음에 드는 스타일링의 하트를 눌러주세요.",
  "text_account_deletion_confirm_termsof_use": "이용약관 확인",
  "text_account_deletion_customer_center_respond_note": "회원 탈퇴하신 경우 고객센터 측에서 확인 및 대응이 어렵습니다. 양해 부탁드립니다.",
  "text_account_deletion_gu_membership_withdrawal": "About GU membership withdrawal",
  "text_account_deletion_note_01": "온라인 스토어에서 주문 내역을 확인할 수 없습니다.",
  "text_account_deletion_note_02": "주문한 제품의 반품 및 교환이 어렵습니다.",
  "text_account_deletion_note_03": "회원 탈퇴를 하신 경우 매장픽업 주문의 수령 및 환불이 어렵습니다.",
  "text_account_deletion_note_04": "제품이 배송지로 도착하기 전 탈퇴를 하는 경우 환불이 어렵습니다.",
  "text_account_deletion_note_05": "주문 명세서 및 영수증 발급이 불가능합니다.",
  "text_account_deletion_note_06": "쿠폰 사용이 불가능합니다.",
  "text_account_deletion_note_07": "유니클로 APP과 연결된 회원정보가 해제됩니다.",
  "text_account_deletion_note_title": "주의사항",
  "text_account_deletion_plst_membership_withdrawal": "text_account_deletion_plst_membership_withdrawal",
  "text_account_deletion_uniqlo_membership_withdrawal": "회원 탈퇴 관련 안내",
  "text_checkbox_agreement_uqpay": "UNIQLO Pay 이용약관에 동의합니다.",
  "text_error_withdrawal_agreement_checkbox": "내용 확인후 동의해 주세요.",
  "text_thanksforusing": "이용해 주셔서 감사합니다.",
  "text_uqpay_termsof_use": "UNIQLO Pay 이용약관",
  "text_withdrawal": "회원 탈퇴",
  "text_withdrawal_agreement": "취소 동의",
  "text_withdrawal_agreement_description": "회원 탈퇴를 희망하시는 고객님은 주의 사항 및 회원 탈퇴 관련 안내을 확인해 주세요. 위 사항에 동의하실 경우 동의란에 체크 후 「회원 탈퇴」 버튼을 눌러 주세요.",
  "text_withdrawal_agreement_uqpay": "UNIQLO Pay 이용약관에도 동의해 주세요.",
  "text_withdrawal_annotation1": "통합회원 해제에는 시간차가 있는 경우가 있습니다. 해제 안되신 경우 조금뒤에 다시 시도해 주세요.",
  "text_withdrawal_completion": "회원 탈퇴 완료",
  "text_withdrawal_confirmation": "온라인 스토어 회원을 탈퇴하시겠습니까?",
  "text_withdrawal_confirmation_title": "회원 탈퇴 확인",
  "text_withdrawal_description1": "유니클로 온라인스토어 회원 탈퇴시, 회원관련 모든 서비스를 이용하실 수 없습니다. \n탈퇴 후 회원 정보를 복원할 수 없습니다.",
  "text_withdrawal_description2": "유니클로APP 에서 회원연결 해제가 안되는 경우,단말기 캐시를 삭제후 새로고침을 해 주세요. 회원 탈퇴를 희망하시는 분은 '이용약관'에 동의하신 후 '탈퇴하기' 버튼을 클릭해 주시기 바랍니다.",
  "text_withdrawal_servicelist_name": "유니클로 APP",
  "text_withdrawal_servicelist_title": "연결 삭제되는 서비스",
  "text_withdrawal_title": "회원 탈퇴 절차",
  "text_checkbox_agreement": "동의합니다.",
  "text_alert_transition_title": "이 페이지에서 나가시겠습니까?",
  "text_gender": "성별",
  "text_linkto_confirm": "미리 보기",
  "text_connect_membership": "유니클로 APP과 온라인 회원정보 연결",
  "text_error_failed_account_linkage": "일시적인 시스템 오류가 발생하였습니다. \n 잠시 후 다시 시도해 주세요.",
  "text_error_failed_account_linkage_title": "회원정보 연결 실패",
  "text_linkaccount": "회원정보 연결",
  "text_linkaccount_confirmation": "연결 확인",
  "text_returnto_uqapp": "유니클로 APP으로 돌아가기",
  "text_address_notes_require_vietnames": "VN만_주소",
  "text_enter_address_line02": "상세 주소 입력해 주세요",
  "text_error_city_field_over_maximum_length_instruction_01": "시/구/군 입력 가능한 문자수 상한 초과시, [번지]에 계속 입력해 주세요.",
  "text_hint_in_case_address_apt_overflow": "최대 50자까지 입력 가능합니다.",
  "text_invalid_postal_code": "올바른 우편번호를 입력하세요. 오류가 지속되면 나중에 다시 시도해 주세요",
  "text_postal_code_not_found": "입력한 우편번호로 주소를 찾을 수 없습니다. 우편번호를 확인해 주세요.",
  "text_postal_code_unknown_manual_input_required": "우편번호에서 주소를 찾을 수 없었어요.이 우편번호를 사용하시는 경우는 번거로우시겠지만 수동으로 입력해 주십시오.",
  "text_postal_code_update_required": "입력된 우편번호가 존재 하지 않습니다. 확인후 다시 입력해 주세요.",
  "text_returnto_address_book": "배송지 목록으로 돌아가기",
  "text_search_address_postal_code": "우편번호 검색",
  "text_search_by_postal_code": "우편번호로 주소검색",
  "text_semi_order_neck_size_colon": "목둘레:",
  "text_ccpa_age_consent_over_16_years_old_agreement": "14세 미만 가입 불가",
  "text_ccpa_age_consent_over_16_years_old_agreement_age_confirmation_title": "연령 확인",
  "text_ccpa_age_consent_over_16_years_old_agreement_button": "제출",
  "text_ccpa_age_consent_over_16_years_old_agreement_checkbox": "14세 미만 가입 불가",
  "text_ccpa_age_consent_over_16_years_old_agreement_message01": "만 14세 미만 가입 불가",
  "text_ccpa_age_consent_over_16_years_old_agreement_title": "만 14세 미만 가입 불가",
  "text_error_ccpa_age_consent_over_16_years_old_agreement_uncheck_app": "유니클로 APP을 사용하려면 여기를 확인해주세요.",
  "text_coupon_select_error": "선택한 쿠폰은 사용할 수 없습니다. 다른 쿠폰을 선택 해 주세요.",
  "text_coupon_code": "쿠폰 코드:",
  "text_dateof_use": "유효기간",
  "text_expirationdate:": "만료일:",
  "text_promo_code": "쿠폰 코드:",
  "text_unselect": "선택 취소",
  "text_until": "기한",
  "text_birthday_input_hint_text": "생일(YYYY/MM/DD) 형태로 입력해 주세요. 등록 후 생년월일을 수정은 불가능 합니다.",
  "text_error_birthday_input_incomplete": "(YYYY/MM/DD)형태로 올바르게 입력해 주세요.",
  "text_error_invalid_birthday_entered": "(YYYY/MM/DD)형태로 올바르게 입력해 주세요.",
  "text_new_account_registration_complete": "회원 등록이 완료 되었습니다.",
  "text_register_credt_card": "새 신용카드 등록",
  "text_returnto_card_list": "신용카드로 돌아가기",
  "text_returnto_form": "등록 양식으로 돌아가기",
  "text_enewsletter_checkbox": "오류를 확인하세요.",
  "text_enewsletter_description01": "현재 구독 중인 전자 뉴스레터가 선택됩니다. 구독을 원하는 뉴스레터를 확인하세요. 구독을 취소하려면 전자 뉴스레터를 선택 해제하세요.",
  "text_enewsletter_preview_description": "오류가 없는지 확인해 주세요.",
  "text_enewsletter_update_complete": "이메일 뉴스레터 수신 동의 설정 업데이트 완료",
  "text_enewsletter_update_complete_description01": "요청이 완료되었습니다.",
  "text_enewsletter_update_complete_description02": "세부정보를 확인하기 위해 이메일을 보내드립니다. 오류가 없는지 확인해 주세요.",
  "text_enewsletter_update_complete_description03": "구독을 취소해도 전자 뉴스레터 전송을 중단하는 데 시간이 걸립니다.",
  "text_enewsletter_update_preview_title": "미리 보기",
  "text_error_edit_enewsletter_setting_subscribe_existing_user": "구독하길 원하는 전자 뉴스레터를 선택하세요. 전자 뉴스레터 구독을 취소하려면 구독 중인 전자 뉴스레터를 선택 해제하세요.",
  "text_error_edit_enewsletter_setting_subscribe_first_user": "전자 뉴스레터를 구독하려면 전자 뉴스레터를 하나 이상 선택하세요.",
  "text_error_failed_get_price_inventory": "죄송합니다. 페이지를 로드하는 동안 문제가 발생했습니다. 문제를 해결하려면 페이지를 새로고침하세요.",
  "text_error_failed_get_price_inventory_title": "시스템 오류",
  "text_error_subscribe": "마케팅 수신 동의에 따른 광고 메일 수신 등록에 오류가 발생 했습니다. 다시 시도해 주세요.",
  "text_gumail_magazine": "GU 전자 뉴스레터",
  "text_returnto_enewsletter_top": "이메일 뉴스레터 수신 동의 TOP 으로 돌아가기",
  "text_subscribe_enewsletter": "전자 뉴스레터 구독",
  "text_unsubscribe_enewsletter": "전자 뉴스레터 구독 취소",
  "text_uq_gu_enewsletter_setting_description01": "이 페이지에서 UNIQLO 전자 뉴스레터 설정을 변경할 수 있습니다.",
  "text_edit_email_verification_code_instruction_01": "이메일 확인",
  "text_edit_email_verification_code_sent_message": "이메일 확인",
  "text_error_change_email_address_duplicated": "이미 등록된 이메일 주소입니다.",
  "text_error_change_email_address_postal_code_incorrect": "입력한 우편번호가 올바르지 않습니다. 우편번호를 확인후 다시 시도해 주세요.",
  "text_error_email_verification_already_completed": "이 이메일 주소는 이미 인증되었습니다.",
  "text_error_entered_confirmation_email_address_incorrect": "입력한 이메일 주소가 올바르지 않습니다. 이메일 주소를 확인후 다시 시도해 주세요.",
  "text_return_to_profile": "이메일 확인",
  "text_verification_code_resent": "이메일 확인",
  "text_verification_code_resent_message": "이메일 확인",
  "text_verify_email_address_description01": "계정과 연결된 이메일 주소로 확인 이메일을 받게 됩니다. 이메일을 꼭 확인해 주세요",
  "text_newsletter_subscribe_description_01": "마케팅 수신 동의",
  "text_agree": "동의",
  "text_disagree": "미동의",
  "text_gdpr_consent_marketing_non_personalized_agreement": "단체 알림 메시지의 형태로 마케팅 메시지 수신에 개인정보를 사용하는 것에 동의합니다",
  "text_gdpr_consent_marketing_non_personalized_sub": "(단체 메시지)",
  "text_gdpr_consent_marketing_non_personalized_title": "마케팅 수신 동의",
  "text_gdpr_consent_marketing_personalized_agreement": "알림 메시지 형태로 마케팅 메시지 발신을 위해, 개인정보를 분석및 처리하는 데 동의합니다.",
  "text_gdpr_consent_marketing_personalized_sub": "(개인 메시지)",
  "text_gdpr_consent_marketing_personalized_title": "마케팅 수신 동의",
  "text_gdpr_consent_scan_de_chance_personalized_agreement": "나는 주사위 게임(Scan de Chance)에 참여하고, 주사위 게임 티켓을 받기 위한 요구 조건을 충족했을 때 푸시 메시지를 받을 수 있도록 UNIQLO가 내 개인정보를 사용하는 데 동의합니다.",
  "text_gdpr_consent_scan_de_chance_personalized_sub": "(사용자가 자신의 이름과 회원 ID를 사용하여 주사위 게임을 플레이하고 쿠폰을 받을 수 있도록 허용)",
  "text_gdpr_consent_scan_de_chance_personalized_title": "주사위 게임에 대한 동의",
  "text_gdpr_email": "이메일",
  "text_gdpr_no_consent": "미동의",
  "text_gdpr_privacy_settings": "APP 알림및 개인정보 설정",
  "text_gdpr_privacy_settings_title": "APP 알림및 개인정보 설정",
  "text_gdpr_push_notificaion": "APP 알림 설정",
  "text_gdpr_setting_change_instruction": "언제든지 \"회원정보\" → \"알림설정\" 메뉴 통하여 설정 변경 가능 하십니다.",
  "text_gdpr_settings_update_confirmation": "다음 내용으로 업데이트됩니다.",
  "text_gdpr_update": "제출",
  "text_gdpr_update_complete": "업데이트 완료됨",
  "text_gdpr_update_complete_description": "개인정보가 업데이트되었습니다.",
  "text_gdpr_uq_app_data_description": "이 서비스를 계속 사용하려면 GDPR 정책에 동의해야 합니다. 모든 서비스를 거부하거나 일부 서비스에 부분적으로 동의할 수 있습니다. 동의하지 않으면 특정 서비스를 사용할 수 없습니다.",
  "text_gdpr_uq_app_data_title": "유니클로 APP과 개인정보",
  "text_gdrp_title_uniqlo": "유니클로 APP 및 개인정보",
  "text_gdrp_title_uniqlo_description": "UNIQLO는 고객의 개인정보를 당사 시스템에 저장할 때 고객의 권리를 존중하기 위해 최선을 다하고 있습니다. 고객은 아래에 동의하면 서비스 제공을 위해 당사가 자신의 개인정보를 저장 및 처리할 수 있도록 허용할 수 있습니다. 위와 별개로, \"푸시 메시지\"는 개인정보 수집 · 이용 동의와 별개로 동의를 받습니다.",
  "text_returnto_origin": "원래 페이지로 돌아가기",
  "text_terms_and_condition_details_link": "자세한 내용을 보려면 아래 링크를 클릭해 주세요",
  "text_couponformat_error": "바코드 생성을 실패했습니다.",
  "text_error_invalid_phone_number_registered": "회원정보에 등록된 전화번호 또는 배송 주소가 유효하지 않습니다. 회원정보 페이지에서 전화번호 또는 배송 주소를 업데이트해 주세요.",
  "text_asean_ec_email_verification_troubleshooting_steps": "이메일 ID 확인",
  "text_checkbox_rememberme": "계정 정보 기억하기",
  "text_ecwelcome_coupon_description": "신규 회원 가입시 {coupon_name} 을 드립니다.",
  "text_emai_valid_characters": "유효한 이메일 주소를 입력해 주세요.",
  "text_email_valid_characters": "유효한 이메일 주소를 입력해 주세요.",
  "text_error_failed_login_description": "오류가 발생했습니다. 다시 로그인해 주세요",
  "text_error_login_title": "로그인 실패",
  "text_login_complete": "로그인됨",
  "text_login_description1": "회원님의 소중한 개인정보를 안전하게 보호하기 위해, 비밀번호를 주기적으로 변경해 주세요.",
  "text_login_imark_description-1": "회원님의 소중한 개인정보 보호를 위해 다음과 같은 경우 비밀번호 변경해 주세요.",
  "text_login_imark_description-2": "• 다른 서비스에서 동일한 비밀번호를 사용 중입니다.",
  "text_login_imark_description-3": "• 최근에 비밀번호를 변경하지 않았습니다.",
  "text_login_imark_description-4": "비밀번호를 변경하려면 회원정보 페이지에서 비밀번호 변경을 선택해 주세요.",
  "text_login_pw_valid_numberoftexts": "비밀번호는 8~20자여야 하며 숫자와 문자를 모두 포함해야 합니다.",
  "text_login_security_notice_description01": "회원님의 소중한 개인정보 보호를 위해 다음과 같은 경우 비밀번호 변경해 주세요.\n• 다른 서비스에서 동일한 비밀번호를 사용 중입니다.\n• 최근에 비밀번호를 변경하지 않았습니다.\n비밀번호를 변경하려면 회원정보 페이지에서 비밀번호 변경을 선택해 주세요.",
  "text_login_unmatch": "죄송합니다. 아이디 또는 비밀번호가 일치하지 않습니다. 스펠링을 확인하고 다시 시도해 주세요.",
  "text_logout_complete": "로그아웃됨",
  "text_pw_valid_characters": "문자와 숫자(8~20자 내) 를 모두 포함한 비밀번호를 입력해 주세요.",
  "text_valid_email": "유효한 이메일 주소를 입력해 주세요.",
  "text_valid_email_characters": "유효한 이메일 주소를 입력해 주세요.",
  "text_ca_enter_postalcode": "우편번호 5자리를 입력해 주세요(예:00000)",
  "text_invalid_postal_code_format": "우편번호 5자리를 입력해 주세요(예:00000)",
  "text_enter_my_size_name": "마이 사이즈 등록 이름을 입력해 주세요.",
  "text_error_my_size_entry_height_foot_inch_range": "이 양식에 {min}에서 {max}까지 입력해 주세요.",
  "text_error_my_size_entry_range": "이 양식에 {range}를 입력해 주세요.",
  "text_error_my_size_height_foot_inch_either_field_empty": "cm를 입력해 주세요.",
  "text_error_my_size_height_foot_inch_entry_out_of_available_range": "cm는 {cm_min}에서 {cm_max}까지 입력하세요.",
  "text_invalid_my_size_decimal_point": "소수점 첫째 자리까지 입력해 주세요.",
  "text_invalid_my_size_name": "기호나 특수 문자는 입력할 수 없습니다.",
  "text_metrology_shoulder_wdth": "어깨 넓이 (cm)",
  "text_my_size_nude_dimension": "신체 치수 측정값",
  "text_my_size_preview": "확인",
  "text_my_size_recommend_size": "사이즈 추천",
  "text_my_size_set_recommend_size": "권장 사이즈로 설정",
  "text_remove_my_size_description02": "{default_my_size_name}로 등록된 사이즈가 마이 사이즈로 설정됩니다.",
  "text_returnto_my_size_form": "입력 양식으로 돌아가기",
  "text_ca_validate_postalcode": "문자 혹은 숫자만 입력 가능합니다.",
  "text_checkbox_receiveall": "광고성 메일 수신 동의",
  "text_day": "날짜",
  "text_email_verification_code_format": "인증코드 6자리를 입력해 주세요.",
  "text_enewsletter_howto_change_description": "※ 본 동의 사항은 선택사항으로 거부 할수 있으며, 거부 하시더라도 서비스 이용에 제한은 없습니다.\n단, 이벤트 정보, 신제품 출시 등 맞춤형 서비스를 제공 받으실 수 없습니다.",
  "text_enter_email_verification_code": "인증코드를 입력해 주세요.",
  "text_error_future_birthday": "생년월일은 미래 날짜를 지정할 수 없습니다.",
  "text_error_too_long_ago_birthday": "생년월일 날짜가 유효하지 않습니다.",
  "text_female": "여성",
  "text_invalid_symbol_postal_code": "문자 혹은 숫자만 입력 가능합니다.",
  "text_mail_alreadyregistered": "죄송합니다. 이미 회원으로 가입되어 있는 이메일입니다. 다른 이메일을 사용해 주세요.",
  "text_male": "남성",
  "text_new_registration_app_description": "UNIQLO APP으로 쇼핑을 더 편리하게, 결제 시 회원 바코드를 제시하면 구매이력 저장! 지금 APP 신규 다운로드 후 온라인 스토어 가입하면 웰컴 쿠폰 증정!",
  "text_new_registration_confirm": "등록 내용 확인",
  "text_new_registration_notes": "반드시 영문과 숫자만 입력해 주세요. 이 계정과 연결된 이메일 주소로 주문 확인등 정보가 이메일이 전송됩니다.",
  "text_new_registration_thanks_i_mark_description1": "• 온라인 주문을 완료하면 주문 확인 이메일을 받게 됩니다.",
  "text_new_registration_thanks_i_mark_description2": "• 10분 안으로 등록 이메일 또는 주문 확인 이메일을 받지 못한 경우 아래 이메일 설정 또는 상태를 확인해 주세요.",
  "text_new_registration_thanks_i_mark_description3": "• 스팸 메일 설정을 확인해 주세요.",
  "text_new_registration_thanks_i_mark_description4": "• 이메일 설정: “UNIQLO.com” 도메인을 허용해 주세요.",
  "text_new_registration_thanks_i_mark_description5": "• 이메일 서버 사용량이 너무 많을 수 있습니다.",
  "text_new_registration_thanks_i_mark_description6": "• 등록하신 이메일 주소에 오류가 있는 경우",
  "text_new_registration_thanks_i_mark_description7": "• 그외 이유 혹은 문희사항은 FAQ 혹은 고객센터를 통해 확인 부탁 드립니다.",
  "text_nochange_birthday": "등록 후에는 생년월일을 수정할 수 없습니다.",
  "text_referto": "여기를 참조해 주세요.",
  "text_register_mem_address": "회원 주소 등록",
  "text_returnto_order": "장바구니로 돌아가기",
  "text_uqbaby_magazine": "UNIQLO 베이비 뉴스레터",
  "text_uqkids_magazine": "UNIQLO 키즈 뉴스레터",
  "text_uqlargesize_magazine": "UNIQLO 확장 사이즈 뉴스레터",
  "text_uqmail_magaginze": "이메일",
  "text_uqmail_magaginze_fr": "UNIQLO 뉴스레터",
  "text_uqmen_magazine": "UNIQLO 남성 뉴스레터",
  "text_uqonline_selecteditems_magazine": "UNIQLO 온라인 매장 소식레터",
  "text_uqsmallsize_magazine": "UNIQLO 엑스트라 스몰 사이즈 뉴스레터",
  "text_uqwomen_magazine": "UNIQLO 여성 뉴스레터",
  "text_verify_email_verification_code": "등록",
  "text_returnto_new_member_registration": "입력 화면으로 돌아가기",
  "text_new_account_annotation1": "전화 걸기",
  "text_nomail_received": "받은 메일이 없는 경우",
  "text_openinghour:": "운영 시간 :",
  "text_thanks_registration": "회원 등록해 주시어 감사합니다.",
  "text_tollfree_dial": "전화번호 :",
  "text_uqonline": "유니클로 온라인 스토어",
  "text_deliverydate:": "배송 예정일",
  "text_email_sentto_user": "등록하신 이메일 주소로 확인 메일이 전송되었습니다.",
  "text_enter_newpw_nosymbols": "비밀번호는 8~20자여야 하며 숫자와 문자를 모두 포함해야 합니다.",
  "text_enter_phone_validcharacters": "유효한 전화번호를 입력해 주세요.",
  "text_password_reset_verification_option_list": "비밀번호 재설정 방법을 선택해 주세요.",
  "text_pw_invalid_symbol_input": "비밀번호에는 기호·특수문자는 사용할 수 없습니다.",
  "text_pw_valid_numlimit": "비밀번호는 문자와 숫자를 모두 포함해야 합니다.",
  "text_pw_valid_symbols": "다음 기호만 사용해 주세요.\n- _ . @",
  "text_pw_valid_symbols-1": "다음 기호만 사용해 주세요.",
  "text_pw_valid_symbols-2": "- _ . @",
  "text_pwreset_frommail": "이메일에서 비밀번호 재설정",
  "text_pwreset_tomail": "비밀번호 재설정 이메일 전송",
  "text_select_date": "YYYY/MM/DD",
  "text_enter_correctpw": "정확한 비밀번호를 입력해 주세요.",
  "text_newpw_difference": "새 비밀번호는 현재 비밀번호와 달라야합니다.",
  "text_newpw_valid_characters": "비밀번호는 8~20자여야 하며 숫자와 문자를 모두 포함해야 합니다.",
  "text_newpw_valid_numberoftexts": "암호는 8-20자여야 하며 숫자, 문자를 포함해야 합니다. 특수문자 입력을 원하시는 경우 @ $ ! % * # ? & 에 한하여 사용이 가능합니다.",
  "text_no_match_pw": "비밀번호가 일치해야 합니다. 다시 시도해 주세요.",
  "text_pw_confirm": "비밀번호를 확인해 주세요.",
  "text_pw_contain_num_letters": "비밀번호는 8~20자여야 하며 숫자와 문자를 모두 포함해야 합니다.",
  "text_backto": "뒤로",
  "text_enter_birthday": "생년월일을 입력해 주세요.",
  "text_invalid_phone_num": "올바른 전화번호를 입력해 주세요.",
  "text_no_validation": "제공된 정보가 기록과 일치하지 않습니다. 스펠링을 확인하고 다시 시도해 주세요.",
  "text_ph_phone_number": "휴대폰 번호",
  "text_reset_password_account_not_found": "회원정보가 존재 하지 않습니다. 이 링크를 사용 할수 없습니다.",
  "text_year": "년도",
  "text_pwreset_remarks": "• 10분 안으로 등록 이메일 또는 주문 확인 이메일을 받지 못한 경우 아래 이메일 설정 또는 상태를 확인해 주세요.",
  "text_error_enter_valid_mobile_phone_number": "전화번호 형식 오류",
  "text_change_email_address_completed": "이메일 주소 변경 완료됨",
  "text_change_email_address_completed_description": "이메일 주소가 변경되었습니다.",
  "text_error_failed_update_enews_subscription_settings_description_01": "이메일 주소는 변경되었지만 이메일 뉴스레터 수신 동의 설정 업데이트에 실패했습니다. 새로운 메일 주소로 이메일 뉴스레터 수신동의를 원하시는 경우 재설정을 해주시기 바랍니다.",
  "text_error_failed_update_enews_subscription_settings_title": "이메일 뉴스레터 수신 동의 설정 변경에 실패",
  "text_error_invalid_character_input_phonetic_first_name": "성은 카타카나로 입력해 주세요",
  "text_error_invalid_character_input_phonetic_last_name": "이름을 카타카나로 입력해 주세요",
  "text_gender_others": "선택하지 않음",
  "text_ph_family_name": "성을 입력해 주세요.",
  "text_ph_first_name": "이름을 입력해 주세요.",
  "text_ph_phone_number_01": "전화번호를 입력하세요.",
  "text_ph_phone_number_02": "전화번호를 입력하세요.",
  "text_phone_number_additional_notes": "유선전화가 없으면 휴대폰 번호를 입력해 주세요.",
  "text_re_enter_email_address_unmatch": "위와 동일한 이메일 주소를 입력해 주세요.",
  "text_room_num": "상세 주소",
  "text_verify_new_email_verification_code": "변경 사항 저장",
  "text_date": "날짜",
  "text_no_purchasehistory_description2": "결제시 회원바 바코드를 보여주시면 24시간 이내에 구매이력에 정보가 반영 됩니다.",
  "text_title_purchase_history": "구매 내역 상세",
  "text_helpfful": "도움돼요 수",
  "text_helpful": "도움돼요 수",
  "text_total_helpfful": "도움돼요 리뷰 수",
  "text_email:": "이메일:",
  "text_enter_pw_nosymbols": "비밀번호는 8~20자여야 하며 숫자와 문자를 모두 포함해야 합니다.",
  "text_no_register_item": "미입력",
  "text_app_authentication_login_instruction_01": "생체 인증을 활성화하려면 로그인이 필요합니다.",
  "text_app_authentication_registration": "생체 인식을 활성화하려면 인증이 필요합니다.",
  "text_app_authentication_settings_description": "이 기능을 사용하면 로그인 할 때 비밀번호 대신 장치에 등록 된 생체 인식 정보를 사용할 수 있습니다.",
  "text_app_authentication_settings_title": "생체 인증 설정",
  "text_uqpay_activate": "활성화",
  "text_uqpay_biometricauthentication_description": "인증해 주세요",
  "text_uqpay_security_code_description": "text_uqpay_security_code_description",
  "text_confirm": "확인",
  "text_coupon_instruction": "쿠폰 사용 전 스탭에게 화면을 제시해 주세요.",
  "text_coupon_name:": "쿠폰 :",
  "text_coupon_used_staff": "사용한 쿠폰으로 표시(직원 전용)",
  "text_membership_error": "온라인 스토어를 이용하시려면 회원 가입이 필요합니다.",
  "text_remove_wishlist": "위시리스트에 추가됨",
  "text_wishlist_size_not_select_short": "제품 페이지에서 사이즈를 선택해 주세요",
  "text_agree_to_withdraw_app_membership": "유니클로 APP 계정 삭제에 동의합니다.",
  "text_app_terms_of_use": "APP 이용약관",
  "text_explanation_withdraw_from_app_membership": "확인을 누르시면 온라인스토어 회원 탈퇴 화면으로 이동합니다.",
  "text_maminfo_remove_linkage_uqpay": "UNIQLO Pay 서비스를 이용 중인 경우, 연결 해제 시 UNIQLO Pay 결제 정보가 삭제되어 UNIQLO Pay 서비스를 이용하실 수 없으니 유의하시기 바랍니다.",
  "text_remove_linkage_link": "연결 해제에 대해 자세히 알아보기",
  "text_select_other_countries": "다른 국가 선택",
  "text_withdraw": "회원 탈퇴",
  "text_withdraw_from_app_membership": "계정 삭제",
  "text_withdraw_from_app_membership_completion_other_app_membership_remain_01": "유니클로 APP 회원 탈퇴 되었습니다.",
  "text_withdraw_from_app_membership_completion_other_app_membership_remain_02": "다른 국가의 APP 회원정보에는 영향을 주지 않습니다. 다른 국가에서 회원 탈퇴를 원하실 경우에는 해당 국가를 선택하신 후 탈퇴 절차를 반복하시기 바랍니다.",
  "text_withdraw_from_app_membership_completion01": "유니클로 APP 계정 삭제 절차가 완료되었습니다.",
  "text_withdraw_from_app_membership_completion02": "다시 사용하시려면 유니클로 APP을 재설치하세요.",
  "text_withdraw_from_app_membership_description": "APP 계정을 삭제하시면, 위시리스트 및 구매 제품 확인이 불가합니다.",
  "text_withdrawal_checkbox_afterunderline": "동의",
  "text_withdrawal_membership": "예",
  "text_withdrawal_quit": "아니오",
  "text_withdrawal_return_and_refund_cancel_message_01": "온라인 스토어 탈퇴 진행시, 환불및 반품접수가 취소 됩니다. 자세한 문의는 고객센터로 연락 부탁 드리겠습니다.",
  "text_withdrawal_yes": "예",
  "text_backto_checkout": "결제로 돌아가기",
  "text_backto_wishlist": "위시리스트로 돌아가기",
  "text_error_failed_get_ecwelcome_coupon01": "곧 온라인 스토어 웰컴 쿠폰이 발급 예정입니다.",
  "text_error_failed_get_ecwelcome_coupon02": "보유하신 쿠폰은 회원정보 페이지에서 확인 가능합니다.",
  "text_linkto_coupon_list": "쿠폰 리스트",
  "text_loggedin": "로그인됨",
  "text_loggedout": "로그아웃됨",
  "text_login_instruction01": "로그인하시면 온/오프라인 회원정보 통합을 통해 쿠폰 및 구매 정보 확인 등 더욱 풍부한 서비스 이용이 가능합니다.",
  "text_login_instruction02": "위 메일주소로 온라인 스토어 회원정보과 연결 되어 있습니다.",
  "text_logout_instruction01": "로그아웃하면 유니클로 APP을 통한 구매 및 온라인 스토어 MY PAGE, 구매 내역, 위시리스트, 쿠폰은 이용할 수 없습니다.",
  "text_password_reset_successful_message": "비밀번호 재설정 성공",
  "text_password_reset_successful_title": "비밀번호 재설정 성공",
  "text_title_email_settings": "이메일 설정",
  "text_uqmail_magazine": "동의",
  "text_error_alteration_unavailable": "",
  "text_home": "홈",
  "text_help_and_others": "text_help_and_others",
  "text_uqpay_error_regist_bankpay": "text_uqpay_error_regist_bankpay",
  "text_app_coupon_login_notice": "쿠폰을 사용하려면 로그인해 주세요.",
  "month": "월",
  "text_onlinestore_coupon": "온라인 스토어 전용 쿠폰",
  "text_uqpay_error_occurred_credit_card": "text_uqpay_error_occurred_credit_card",
  "text_members_pass": "회원정보",
  "text_coupon_have_expiration_date": "유효기간이 {date}인 쿠폰이 있습니다.",
  "text_skip": "건너뛰기",
  "text_reload": "새로고침",
  "text_app_order_status_delivery_completed_pudo": "배송 완료",
  "text_app_order_status_order_complete_pudo": "주문을 접수했습니다.",
  "text_app_order_status_preparing_order_pudo": "픽업 준비 중입니다.",
  "text_app_order_status_receivable_term_expired": "수령 기한 만료로 인해 주문이 취소되었습니다.",
  "text_app_order_status_shipment_confirmed_pudo": "발송 완료되었습니다.",
  "text_uqpay_instruction_link": "text_uqpay_instruction_link",
  "text_ph_store_search": "매장명, 주소, 키워드 검색",
  "date_format": "MM/dd (E) HH:mm",
  "text_search_history": "검색 기록",
  "text_search_history_empty": "여기에서 검색 기록을 볼 수 있습니다.",
  "text_app_feedback_dialog_description01": "유니클로 APP을 이용해 주셔서 감사합니다.",
  "text_app_feedback_dialog_description02": "유니클로 APP 개선을 위해 고객님의 소중한 의견 부탁드리겠습니다.",
  "text_app_feedback_dialog_rating01": "좋아요!",
  "text_app_feedback_dialog_rating02": "개선이 필요해요.",
  "text_push_notifcation_confirmation_dialog_title": "text_push_notifcation_confirmation_dialog_title",
  "text_app_orderstatus_return_details_button_label": "반품 상태 보기",
  "text_app_personalization_onboarding_welcome_message": "text_app_personalization_onboarding_welcome_message",
  "text_app_onboarding_personalised_notifications_description_01": "text_app_onboarding_personalised_notifications_description_01",
  "text_app_onboarding_personalised_notifications_description_02": "text_app_onboarding_personalised_notifications_description_02",
  "text_app_onboarding_personalised_notifications_toggle_01": "text_app_onboarding_personalised_notifications_toggle_01",
  "text_app_onboarding_personalised_notifications_toggle_02": "text_app_onboarding_personalised_notifications_toggle_02",
  "text_app_onboarding_push_notifications_consent_dialog_description_01": "동의하시면, 주문 상태 업데이트에 대한 알림을 받으실 수 있습니다.",
  "text_app_onboarding_push_notifications_consent_dialog_description_02": "동의하시면, 유니클로의 새로운 소식 및 추천 제품, 할인, 쿠폰 등 다양한 광고 정보를 수신하실 수 있습니다.\n알림해제는 , '회원정보 > 설정 > APP알림설정' 을  통해 해제 가능합니다.",
  "text_change_color_and_size_button": "text_change_color_and_size_button",
  "text_change_color_and_size_title": "text_change_color_and_size_title",
  "text_product": "제품",
  "text_app_update_dialog_cancel": "취소",
  "date_dash": "-",
  "duration_format": "{from}~{to}",
  "NSFaceIDUsageDescription": "비밀번호 대신 FaceID를 사용할 수 있습니다.",
  "NSUserTrackingUsageDescription": "최적화된 정보를 받으려면 추적을 허용해 주세요.",
  "text_add_store": "매장 추가",
  "text_add_store_favorite_search": "매장 검색 후 즐겨찾는 매장에 추가",
  "text_added_favorite_message": "위시리스트에 추가되었습니다.",
  "text_app_promote_appstore_later": "나중에",
  "text_app_promote_appstore_review": "리뷰",
  "text_app_promote_appstore_review_description": "UNIQLO가 마음에 든다면 리뷰를 남겨주세요.",
  "text_app_promote_appstore_review_title": "유니클로앱을 이용해 주셔서 감사합니다.",
  "text_app_viewmore_you_may_also_like": "추천 제품 더 보기",
  "text_barcode_scan_instruction1": "아래의 틀안에 제품바코드 또는 QR 코드를 맞추어 주세요",
  "text_barcode_scan_instruction2": "화면에 초점이 맞춰질 때까지 기다려 주세요.",
  "text_barcode_scan_instruction3": "제품 바코드 번호를 직접 입력",
  "text_camera_document": "카메라 및 문서",
  "text_certification_not_verified": "이 WEB 사이트의 보안인증서에 문제가 있어 표시가 중단 되었습니다.",
  "text_close_window_confirmation": "이 화면을 닫으시겠어요?",
  "text_closed_shop": "구입 매장이 폐점 되었습니다.",
  "text_coupon_barcode": "쿠폰 바코드",
  "text_dial_confimation": "{phone}로 전화를 거시겠어요?",
  "text_disconnected": "인터넷에 연결되지 않았습니다.",
  "text_do_not_show_again": "다시 표시하지 않습니다.",
  "text_failed_get_postalcode": "우편번호를 찾지 못했습니다.",
  "text_favorite_removed": "제품이 삭제되었습니다.",
  "text_from": "발송인: {sender}",
  "text_howto_add_favorite": "즐겨찾기에 추가하려면 하트를 클릭하세요.",
  "text_input_productid": "바코드 번호 입력",
  "text_input_productid_manually": "제품택에 기재된 13자리 바코드 번호를 입력해 주세요.",
  "text_inventory_search_description": "재고 검색 등 다양한 서비스를 이용할 수 있습니다.",
  "text_iq_chat_inquiry_app": "채팅 문의",
  "text_location_access_confirmation": "UNIQLO APP은 위치 서비스를 사용합니다.\n위치 서비스를 켜시겠습니까?",
  "text_made_coupon_redeemed": "쿠폰이 사용되었습니다.",
  "text_make_coupon_redeemed": "쿠폰 사용",
  "text_mystore_description": "이 매장을 즐겨찾는 매장으로 설정 하겠습니까? 즐겨잦는 매장 설정시 제품 페이지에 재고 정보가 표시 됩니다.",
  "text_no_favorite": "위시리스트에 0개의 제품이 있습니다.",
  "text_no_favorite_store": "즐겨찾는 매장설정 0건 입니다.",
  "text_no_notification": "수신된 알림이 없습니다.",
  "text_not_now": "이번에 건너뛰기",
  "text_notification": "APP 알림",
  "text_off": "OFF",
  "text_on": "ON",
  "text_open_in_brawser": "브라우저에서 열기",
  "text_ph_keyword_search": "키워드,카테고리 검색",
  "text_privacy_settings": "개인정보 설정",
  "text_productid_instruction": "제품택에 기재된 13자리 바코드 번호를 입력해 주세요.",
  "text_prohibited_camera_access": "카메라 접근 권한이 비활성화되었습니다. 설정으로 이동하여 카메라 접근 권한을 허용해 주세요",
  "text_purchase_history_removed": "구매이력을 삭제했습니다.",
  "text_push_notification_rejected": "기기의 설정으로 이동하여 업데이트 APP 알림을 받도록 허용하세요.",
  "text_recently_scanned": "최근 스캔한 내역",
  "text_redeem_confirmation": "모든 쿠폰은 1회만 사용할 수 있으며 재사용할 수 없습니다. 쿠폰을 사용하시겠습니까?",
  "text_removed_purchase_history_description": "구매 내역이 삭제되면 취소할 수 없습니다.",
  "text_remvoe_purchase_history_confirmation": "구매 내역을 삭제하시겠습니까?",
  "text_resend": "재전송",
  "text_retail_and_online_store_coupon": "매장&온라인 스토어 쿠폰",
  "text_retailstore_coupon": "매장 전용 쿠폰",
  "text_save_account_info_message": "회원정보를 저장 하시겠습니까?",
  "text_scan": "스캔",
  "text_search_history_remove_confirmation": "검색 기록이 없습니다.",
  "text_search_history_removed": "삭제되었습니다.",
  "text_search_store_filter": "필터",
  "text_send_productid": "제품 바코드를 송신 했습니다.",
  "text_set": "설정",
  "text_set_mystore": "즐겨찾는 매장설정",
  "text_store_inventory": "매장 재고",
  "text_store_navigate": "{destination} 가는 경로를 표시합니다.",
  "text_store_navigation_instruction": "{location}가 지도에 표시됩니다. {location} 가는 경로를 위해 위치 서비스를 활성화합니다.",
  "text_terms_and_conditions_update": "개인정보 처리방침이 일부 변경되었습니다.【회원정보 설정・기타】의『개인정보 처리방침』에서 확인해 주세요.",
  "text_unavailable_qrcode": "사용할 수없는 QR 코드입니다",
  "text_unsend": "미송신",
  "text_update_account_info_message": "회원정보가 변경 되었습니다. 업데이트 하시겠습니까?",
  "text_update_app_version": "업데이트",
  "text_uqapp_help": "유니클로 APP 문의하기",
  "text_version": "버전: {version}",
  "text_view_store_location": "매장 위치 보기",
  "text_withdraw_from_app_membership_error01": "유니클로 APP 계정 삭제 실패",
  "text_withdraw_from_app_membership_error02": "나중에 다시 시도해 주세요.",
  "time_format": "hh:mm a",
  "NSCameraUsageDescription": "바코드 스캐닝과 이미지 검색을 사용하려면 카메라에 대한 접근을 허용해 주세요.",
  "NSLocationWhenInUseUsageDescription": "주변 매장을 검색하려면 위치 서비스에 대한 접근을 허용해 주세요.",
  "NSPhotoLibraryAddUsageDescription": "기기에 이미지를 저장하려면 사진 라이브러리에 대한 액세스를 허용해 주세요.",
  "NSPhotoLibraryUsageDescription": "이미지 검색을 허용하시려면 사진에 대한 접근을 허용해 주세요.",
  "text_ImageSearch_prohibited_camera_access": "카메라를 사용하여 이미지를 검색하려면 카메라 설정을 켜야 합니다. 설정을 열고 카메라 사용 권한을 부여해 주세요.",
  "text_app_header_baby": "BABY",
  "text_app_header_kids": "KIDS",
  "text_app_header_men": "MEN",
  "text_app_header_uniqlo_top": "UNIQLO 홈페이지",
  "text_app_header_women": "WOMEN",
  "text_app_member_label": "APP 회원",
  "text_app_setting_country": "국가",
  "text_country_switcher_title": "국가 선택",
  "text_select_country_language": "국가 및 언어 선택",
  "text_select_country_language_explanation": "이미 가지고 있는 UQ 계정을 사용하려면 계정에 해당하는 국가를 선택하세요.",
  "text_selecting_country_dialog_message": "이 온보딩 후 국가를 변경하려면 멤버십 탭의 APP설정에서 변경할 수 있습니다.",
  "text_selecting_country_dialog_title": "국가 선택",
  "text_switching_country_dialog_message": "국가를 전환한 후에는 해당 국가에 연결된 다른 UNIQLO 계정으로 로그인해야 합니다. 위시리스트와 구매 내역도 국가별로 다릅니다.",
  "text_switching_country_dialog_title": "국가 변경",
  "text_app_api_general_error": "오류가 발생했습니다. 온라인 상태일 때 다시 시도하세요.",
  "text_show_only_in_stock_store_description_01": "재고가 있는 매장으로 검색 범위를 좁힐 수 있습니다.",
  "text_allow_camera_access": "스캔",
  "text_app_update_instruction01": "유니클로 APP의 최신 버전이 출시되었습니다. 최신 APP 기능에 액세스하려면 업데이트하세요.",
  "text_dont_receive": "거절",
  "text_push_notification": "APP 알림 설정",
  "text_app_ios_att_intro_description": "고객님의 활동을 사용/공유하도록 허용하면 맞춤형 광고를 제안할 수 있습니다.",
  "text_app_ios_att_intro_title": "맞춤형 뉴스와 정보를 제공해 드려요",
  "text_app_ios_att_permission_deny": "추적하지 않도록 APP에 요청",
  "text_app_for_you": "나에게 맞는 제품",
  "text_app_new": "NEW",
  "text_app_whats_new": "새로운 기능",
  "text_app_search_tab": "카테고리",
  "text_app_onboarding_push_notifications_consent": "광고성정보 알림 수신에 동의하시겠습니까?",
  "text_app_onboarding_push_notifications_description_01": "APP 알림 수신을 위해서는 OS 설정에서 알림을 켜고 맞춤 알림을 허용해야 합니다.",
  "text_app_onboarding_push_notifications_description_02": "동의하시면 신상품 및 할인 프로모션 등 유니클로 소식을 수신하실 수 있습니다.\n 알림 해제를 원할 시, ”회원 정보>설정>APP 알림 설정”에서 변경 가능합니다.",
  "text_app_onboarding_push_notifications_description_03": "APP 알림을 받으려면 기기 설정에서도 알림을 켜야 합니다.",
  "text_app_onboarding_push_notifications_device_settings": "APP 알림 설정",
  "text_app_onboarding_push_notifications_no": "아니오",
  "text_app_onboarding_push_notifications_privacy_policy": "개인정보처리방침",
  "text_app_onboarding_push_notifications_toggle": "광고성 APP 알림 설정",
  "text_app_onboarding_push_notifications_yes": "예",
  "text_app_onboarding_title01": "유니클로 APP 혜택!",
  "text_app_onboarding_title02": "출시 전에 제품을 미리 볼 수 있습니다.",
  "text_app_onboarding_title03": "UNIQLO Pay로 더 빠르게 결제하세요.",
  "text_app_onboarding_title04": "APP 알림을 통해 다양한 혜택과 정보를 받아 보세요.",
  "text_app_push_notifications": "APP 알림 설정",
  "text_onboarding_instruction01": "유니클로 회원을 위한 특별 가격. 특별 사이즈는 온라인 스토어에서만 제공됩니다.",
  "text_onboarding_instruction02": "제품 리뷰, 스타일링 제안 및 매장 이용 여부를 확인하세요.",
  "text_onboarding_instruction03": "빠르고 쉽게 결제하세요. 쿠폰을 받으려면 등록하세요!",
  "text_onboarding_instruction04": "주문 상태, 소식등을 다양한 메시지 유형을 사용 가능으로 설정합니다.",
  "text_app_message": "메시지",
  "text_app_messagebox_notification": "알림",
  "text_app_news": "뉴스",
  "text_app_order_quantity": "수량",
  "text_app_order_status_arrival_at_store_family_mart": "상품 수령가능",
  "text_app_order_status_arrival_at_store_lawson": "상품 수령가능",
  "text_app_order_status_arrival_at_store_sej": "상품 수령가능",
  "text_app_order_status_arrival_at_store_store_pick_up": "픽업이 준비되었습니다.",
  "text_app_order_status_delivery_complited_ship_to_address": "배송 완료",
  "text_app_order_status_no_order_history": "주문 이력이 없습니다.",
  "text_app_order_status_order_cancel": "주문이 취소되었습니다.",
  "text_app_order_status_order_complete_cvs_pick_up": "주문해 주셔서 감사합니다.",
  "text_app_order_status_order_complete_ship_to_address": "주문을 접수했습니다.",
  "text_app_order_status_order_complete_store_pick_up": "주문을 접수했습니다.",
  "text_app_order_status_pick_up_completed_cvs_pick_up": "상품 수령가능",
  "text_app_order_status_pick_up_completed_store_pick_up_order_pick": "픽업 완료",
  "text_app_order_status_preparing_order_cvs_pick_up": "상품 준비중",
  "text_app_order_status_preparing_order_ship_to_address": "배송 준비 중입니다.",
  "text_app_order_status_preparing_order_store_pick_up_order_pick": "픽업 준비 중입니다.",
  "text_app_order_status_provisional_order": "주문 준비 중입니다.",
  "text_app_order_status_shipment_confirmed_cvs_pick_up": "상품 준비중",
  "text_app_order_status_shipment_confirmed_ship_to_address": "발송 완료되었습니다.",
  "text_app_order_status_shipment_confirmed_store_pick_up_order_pick": "픽업 준비 중입니다.",
  "text_app_order_status_title": "주문 상태",
  "text_app_order_status_waiting_for_payment": "결제가 완료되지 않았습니다.",
  "text_app_order_status_waiting_for_payment_due_request": "진행하고 계신 주문의 결제가 아직 완료되지 않았습니다. {time}까지 결제를 완료해 주세요.",
  "text_app_order_status_waiting_for_payment_pay_in_store": "결제가 확인되지 않았습니다. {expiryDatetime}까지 {storeName}에서 결제를 완료하세요.",
  "text_app_order_status_waiting_for_post_payment": "결제가 완료되지 않았습니다. {time}까지는{paymentMethod}로 결제를 진행해 주세요.",
  "text_app_order_total": "총 결제 금액",
  "text_app_orders": "주문",
  "text_app_orderstatus_login_required": "주문 상태를 확인하려면 로그인하세요.",
  "text_app_payment_method": "결제 수단",
  "text_app_pickup_due_date": "픽업 기한",
  "text_app_unattended_delivery_location": "위탁장소 지정",
  "text_uqpay_credit_card_number_label": "신용카드 번호",
  "text_uqpay_error_bank_ng_description": "text_uqpay_error_bank_ng_description",
  "text_uqpay_no_identification": "인증되지 않음",
  "text_uqpay_regist_credit_card_title": "신용카드 등록",
  "text_uqpay_settings_option": "옵션",
  "text_error_uqpay_register_email_address_description": "text_error_uqpay_register_email_address_description",
  "text_uqpay_back": "뒤로",
  "text_uqpay_bank_account_number_label": "계좌번호",
  "text_uqpay_bank_account_number_placeholder": "숫자7자리",
  "text_uqpay_bankpay_bank_terms_of_use": "{bankname} Bank Pay거래규정",
  "text_uqpay_bankpay_terms_of_use": "Bank Pay이용규약",
  "text_uqpay_bankpay_terms_of_use_description": "text_uqpay_bankpay_terms_of_use_description",
  "text_uqpay_bankpay_terms_of_use_title": "Bank Pay 거래 규칙",
  "text_uqpay_birthday_label": "생년월일",
  "text_uqpay_branch_code_label": "지점번호",
  "text_uqpay_branch_code_placeholder": "숫자3자리",
  "text_uqpay_catchphrase": "text_uqpay_catchphrase",
  "text_uqpay_credit_card_expiration_date_expires": "{date} 유효기간 지남",
  "text_uqpay_credit_card_expiration_date_label": "유효기간",
  "text_uqpay_credit_card_expiration_date_placeholder": "MM / YY",
  "text_uqpay_credit_card_expiration_date_soon": "{date} 유효기간이 다가오고 있습니다.",
  "text_uqpay_credit_card_name_label": "신용카드 명의(영문입력)",
  "text_uqpay_credit_card_name_placeholder": "타로가 무엇인가요?",
  "text_uqpay_credit_card_number_placeholder": "1234 5678 9012 3456",
  "text_uqpay_credit_card_security_code_label": "보안코드(CSV)",
  "text_uqpay_credit_card_security_code_placeholder": "3~4자리 숫자",
  "text_uqpay_deactivate_description": "이 휴대폰의 UNIQLO Pay 설정이 해제되었습니다.UNIQLO Pay를 이용하시려면 재등록이 필요합니다.",
  "text_uqpay_deposit_type_current_account": "당좌예금",
  "text_uqpay_deposit_type_label": "예금 종류",
  "text_uqpay_deposit_type_ordinary_deposit_label": "보통예금",
  "text_uqpay_device_authentication_available": "단말기인증이 설정되었습니다",
  "text_uqpay_dropdown_form_placeholder": "선택해 주세요",
  "text_uqpay_error_3d_secure_fail": "text_uqpay_error_3d_secure_fail",
  "text_uqpay_error_3d_secure_required": "text_uqpay_error_3d_secure_required",
  "text_uqpay_error_bank_account_number_01": "숫자7자리를 입력해 주세요",
  "text_uqpay_error_bank_account_number_02": "입력하신 계좌번호는 확인할 수 없습니다.",
  "text_uqpay_error_branch_code": "숫자3자리를 입력해 주세요",
  "text_uqpay_error_credit_card_another_account_description": "이 신용카드는 다른 계정으로 등록되었습니다.이 신용카드를 이용하려면 유니클로 고객지원센터로 문의하십시오.",
  "text_uqpay_error_credit_card_ng_description": "이 신용카드는 등록할 수 없습니다.입력 내용을 확인하시거나 다른 신용카드를 등록해 주세요.",
  "text_uqpay_error_credit_card_reasons_description": "이 신용카드는 신용카드사의 사정으로 등록할 수 없습니다.번거로우시겠지만 신용카드사에 문의해주세요.",
  "text_uqpay_error_credit_card_registered_description": "이 신용카드는 이미 등록되어 있습니다.번거로우시겠지만 다른 신용카드를 등록해주세요.",
  "text_uqpay_error_cvv_input_5_times_description": "신용카드 등록 한도에 초과하여 UNIQLO Pay가 정지되었습니다. 내일 다시 시도해 주세요.",
  "text_uqpay_error_da_passcode_not_set_description": "설정을 진행해 주세요",
  "text_uqpay_error_da_passcode_not_set_title": "단말기 패스워드가 설정되어 있지 않습니다.",
  "text_uqpay_error_da_payment_not_set_description": "단말기 인증을 설정하려면 결제 방법 등록이 필요합니다.",
  "text_uqpay_error_da_payment_not_set_title": "결제수단을 등록 해주세요",
  "text_uqpay_error_duplicate_registration_description": "등록 정보가 중복되어 있습니다.",
  "text_uqpay_error_emailverification": "이메일 주소 인증이 되지 않아 등록이 중단되었습니다.",
  "text_uqpay_error_full_width_kana": "영문 입력? 한글 입력?",
  "text_uqpay_error_incompatible_card_description": "대응하지 않는 금융기관입니다.",
  "text_uqpay_error_input": "입력 에러",
  "text_uqpay_error_mobile_phone_number": "정확한 휴대폰 번호를 입력하세요.",
  "text_uqpay_error_not_available": "UNIQLO Pay는 이용하실 수 없습니다.",
  "text_uqpay_error_not_payment": "결제 수단이 설정되지 않았습니다.",
  "text_uqpay_error_pause": "UNIQLO Pay는 잠정 중단됩니다.",
  "text_uqpay_error_sms_authentication_code_disagreement": "인증 번호가 일치하지 않습니다.",
  "text_uqpay_error_sms_authentication_description": "잠시 기다린 후 다시 시도하세요.",
  "text_uqpay_error_sms_authentication_lock_description": "일일 최대 시도 횟수에 도달했습니다. 다음날 이후에 시도하세요.",
  "text_uqpay_error_sms_authentication_try_again_description": "인증 번호가 일치하지 않습니다. 처음부터 다시 시도해 주세요.",
  "text_uqpay_error_title": "오류",
  "text_uqpay_error_usage_restrictions": "UNIQLO Pay 이용이 제한됩니다.",
  "text_uqpay_error_usage_restrictions_description": "지금은 UNIQLO Pay를 사용할 수 없습니다. 도움이 필요하면 UNIQLO 고객 지원 센터에 문의하세요.",
  "text_uqpay_first_name_kana_placeholder": "성",
  "text_uqpay_help_faq": "자주 묻는 질문",
  "text_uqpay_help_identification": "본인인증과 이용한도액에 관련",
  "text_uqpay_help_title": "도움이 필요하면 여기를 클릭하세요.",
  "text_uqpay_help_unsend_sms": "SMS를 받지 못한 경우 여기를 클릭하세요.",
  "text_uqpay_help_unsend_sms_title": "SMS를 받지 못한 경우 여기를 클릭하세요.",
  "text_uqpay_how_to_uqpay": "UNIQLO Pay의 사용방법",
  "text_uqpay_identification": "본인인증 완료",
  "text_uqpay_info": "정보",
  "text_uqpay_input_sms_authentication_description": "SMS로 받은 인증 번호를 입력하세요.",
  "text_uqpay_input_sms_authentication_title": "인증 번호 입력",
  "text_uqpay_inquiry": "FAQ(문의하기)",
  "text_uqpay_last_name_kana_placeholder": "이름",
  "text_uqpay_loading": "UNIQLO Pay준비중",
  "text_uqpay_logout_description": "로그아웃하면 UNIQLO Pay와 관련된 각종 설정도 초기화 됩니다.UNIQLO Pay를 사용한 혜택이나 서비스, 캠페인 등을 받을 수 없게 됩니다.로그아웃 해도 될까요?",
  "text_uqpay_logout_title": "로그아웃하면 UNIQLO Pay가 초기화됩니다.",
  "text_uqpay_lp_title": "UNIQLO Pay 설명",
  "text_uqpay_maintenance_description": "현재 일시적 오류로 UNIQLO Pay 이용이 불가합니다.",
  "text_uqpay_maintenance_title": "UNIQLO Pay가 점검 중입니다.",
  "text_uqpay_membership_card": "text_uqpay_membership_card",
  "text_uqpay_mobile_phone_number_label": "휴대폰 번호",
  "text_uqpay_mobile_phone_number_placeholder": "휴대폰 번호를 입력하세요(하이픈 제외).",
  "text_uqpay_model_change_new_description": "UNIQLO Pay는 하나의 휴대폰에서만 사용할 수 있습니다. 등록 절차를 완료하면 다른 휴대폰에서 UNIQLO Pay를 사용할 수 없습니다. 보안을 위해 결제 수단을 다시 등록해야 합니다.",
  "text_uqpay_model_change_new_title": "UNIQLO Pay 등록 안내",
  "text_uqpay_model_change_old_description": "다른 휴대폰에서 새로운 UNIQLO Pay 계정을 설정했거나, UNIQLO Pay에 등록할 때와 다른 계정으로 로그인했거나, APP을 다시 설치했기 때문에 이 휴대폰에서 UNIQLO Pay가 비활성화되었습니다.",
  "text_uqpay_model_change_old_title": "UNIQLO Pay가 비활성화되었습니다.",
  "text_uqpay_more_info": "자세한 내용은 여기",
  "text_uqpay_name_kana_label": "성명(카타가나)",
  "text_uqpay_onboarding_instruction04": "APP 하나로 스마트하게 쇼핑하세요.\nUNIQLO Pay를 경험해 보세요.",
  "text_uqpay_other": "기타",
  "text_uqpay_passcode_setting": "단말기 패스워드 설정",
  "text_uqpay_pause_uqpay": "UNIQLO Pay 이용을 일시 정지",
  "text_uqpay_payment_complete": "UNIQLO Pay 이용통지",
  "text_uqpay_payment_d_pay_description": "text_uqpay_payment_d_pay_description",
  "text_uqpay_payment_d_pay_registration_error": "text_uqpay_payment_d_pay_registration_error",
  "text_uqpay_payment_method": "결제 방법",
  "text_uqpay_payment_method_limit": "결제 방법 등록 제한치를 초과 했습니다.",
  "text_uqpay_payment_method_no_card_description": "회원ID에 UNIQLO Pay를 추가하려면 은행 계좌혹은 신용카드를 등록해야 합니다.UNIQLO Pay를 추가하여 편리하게 쇼핑해 보세요.",
  "text_uqpay_payment_method_no_card_title": "은행 계좌, 신용카드 등록",
  "text_uqpay_regist": "등록",
  "text_uqpay_regist_bankpay": "은행계좌 등록",
  "text_uqpay_regist_bankpay_bank_account_title": "은행계좌 정보 입력",
  "text_uqpay_regist_bankpay_bank_label": "은행명",
  "text_uqpay_regist_bankpay_title": "은행계좌 등록",
  "text_uqpay_regist_bankpay_to_authentication": "등의후 등록",
  "text_uqpay_regist_bankpay_to_bank_website": "은행 사이트 이동",
  "text_uqpay_regist_bankpay_up_to_1": "은행계좌 등록은 1개만 가능",
  "text_uqpay_regist_credit_card": "신용카드 등록",
  "text_uqpay_regist_credit_card_up_to_5": "신용카드 등록은 5개까지 가능",
  "text_uqpay_regist_new_payment_method": "새로운 결제수단 등록",
  "text_uqpay_regist_new_payment_method_title": "새로운 결제수단 등록",
  "text_uqpay_regist_payment_complete_description_01": "회원ID에 UNIQLO Pay가 추가되었습니다.\n매장 및 온라인 스토어 결제로 UNIQLO Pay를 이용하실 수 있습니다.",
  "text_uqpay_regist_payment_complete_description_02": "이 내용을 결제 방법으로 설정하겠습니까?",
  "text_uqpay_regist_payment_complete_title": "결제수단을 등록 했습니다.",
  "text_uqpay_register_d_pay": "text_uqpay_register_d_pay",
  "text_uqpay_register_d_pay_up_to_01": "text_uqpay_register_d_pay_up_to_01",
  "text_uqpay_remove": "삭제",
  "text_uqpay_remove_payment_method": "결제 방법을 삭제",
  "text_uqpay_remove_payment_method_description": "한번 삭제하시면 재등록이 필요합니다.",
  "text_uqpay_remove_payment_method_title": "이 결제 방법을 삭제하시겠습니까?",
  "text_uqpay_resend_sms": "SMS 재전송",
  "text_uqpay_resume_use_uqpay": "UNIQLO Pay의 이용을 재개",
  "text_uqpay_resume_use_uqpay_description": "[UNIQLO Pay 이용 재개] 를 선택하면 회원ID로 UNIQLO Pay를 이용할 수 있습니다.",
  "text_uqpay_screen_lock": "탭하여 멤버십 카드 + UNIQLO Pay 표시",
  "text_uqpay_search_bank_no_match": "일치하는 은행은 없습니다.",
  "text_uqpay_search_bank_placeholder": "은행명 검색",
  "text_uqpay_select_bank": "은행 선택",
  "text_uqpay_send_sms": "SMS 전송",
  "text_uqpay_send_sms_complete": "SMS 인증 코드가 발송되었습니다.",
  "text_uqpay_set_payment_method": "이 내용을 결제 방법으로 설정",
  "text_uqpay_settings_title": "UNIQLO Pay 설정",
  "text_uqpay_sms_authenticate": "인증",
  "text_uqpay_sms_authentication_code_label": "인증 번호",
  "text_uqpay_sms_authentication_code_placeholder": "인증 번호 6자리 입력",
  "text_uqpay_sms_authentication_complete": "인증이 완료되었습니다.",
  "text_uqpay_sms_authentication_description": "신원을 확인하기 위해 휴대폰으로 인증 SMS를 전송합니다. 휴대폰 번호를 입력하세요.",
  "text_uqpay_sms_authentication_failure": "text_uqpay_sms_authentication_failure",
  "text_uqpay_sms_authentication_start_over": "text_uqpay_sms_authentication_start_over",
  "text_uqpay_sms_authentication_title": "SMS 인증",
  "text_uqpay_start": "시작",
  "text_uqpay_terms_of_use": "UNIQLO Pay이용규약",
  "text_uqpay_terms_of_use_agree": "이용 규약에 동의",
  "text_uqpay_tutorial_a": "결제 방법을 등록하고 UNIQLO Pay 설정을 완료하세요.",
  "text_uqpay_tutorial_b": "「기타」에서는, 단말 인증의 설정이나 UNIQLO Pay의 사용법등을 확인할 수 있습니다.",
  "text_uqpay_tutorial_c": "결제 방법 등록의 본인 인증과 이용 한도액은 이쪽에서 확인해 주십시오.",
  "text_uqpay_use_device_authentication": "회원ID 표시 시 단말기 인증 사용",
  "text_uqpay_withdrawal": "삭제",
  "text_uqpay_withdrawal_complete": "UNIQLO Pay를 삭제 했습니다.",
  "text_uqpay_withdrawal_confirmation_description": "한번 삭제하시면 재등록이 필요합니다.",
  "text_uqpay_withdrawal_confirmation_title": "UNIQLO Pay를 비활성화하시겠습니까?",
  "text_uqpay_withdrawal_description_01": "비활성화하시겠습니까?",
  "text_uqpay_withdrawal_description_02": "UNIQLO Pay 이용을 해제하면 UNIQLO Pay를 사용한 혜택이나 서비스, 캠페인 등을 받을 수 없게 되며 UNIQLO Pay와 관련된 각종 설정도 초기화됩니다.UNIQLO Pay를 일시적으로 정지할 수도 있습니다.",
  "text_uqpay_withdrawal_uqpay": "UNIQLO Pay의 이용삭제",
  "text_app_update_dialog_appstore": "APP 스토어",
  "text_app_update_dialog_description": "최신 버그 수정 및 기능을 이용하려면 APP스토어로 이동하여 업데이트하세요.",
  "text_app_update_dialog_title": "APP을 업데이트했습니다!",
  "text_added_wishlist": "위시리스트에 추가됨",
  "text_error_add_failed": "위시리스트에 제품을 추가할 수 없음",
  "text_item_already_added": "제품이 이미 추가되었습니다.",
  "text_app_push_notification_setting_promotion_for_modal": "기간 한정 혜택, 신제품, 배송 상태에 대한 맞춤형 메시지를 받으려면 APP 알림을 허용하세요!",
  "text_app_added_items": "{number}개 제품",
  "text_app_camera_usage": "UNIQLO가 카메라에 액세스하도록 허용하시겠습니까?",
  "text_app_date_time_timezone_format": "YYYY/MM/DD K:mm a z",
  "text_app_empty_list": "없음",
  "text_app_error_failed_get_email": "우편 주소를 찾을 수 없습니다.",
  "text_app_error_general": "죄송합니다. 문제가 발생했습니다. 다시 시도하시겠습니까?",
  "text_app_error_occuerred": "오류가 발생했습니다.",
  "text_app_error_occurred_with_code": "시스템 오류 {errorcode} 발생",
  "text_app_error_scan_checksum": "바코드 읽지 못함(체크섬 오류)",
  "text_app_error_scan_format": "바코드 읽지 못함(잘못된 형식)",
  "text_app_error_scan_general": "바코드를 읽지 못했습니다.",
  "text_app_error_try_again": "오류가 발생했습니다. 다시 시도하세요.",
  "text_app_error_webview": "웹사이트를 로드할 수 없습니다.",
  "text_app_location_access_notes": "UNIQLO가 위치에 액세스하도록 허용하시겠습니까?",
  "text_app_name": "UNIQLO",
  "text_app_notification_default_channel": "메시지",
  "text_app_notification_icon": "메시지",
  "text_app_notification_title": "UNIQLO",
  "text_app_oss_licenses": "OSS 라이센스",
  "text_app_photo_usage": "UNIQLO가 사진에 액세스하도록 허용하시겠습니까?",
  "text_app_remove_favorite_item": "제품 삭제",
  "text_app_remove_wishlist": "위시리스트에서 제품을 삭제해 주세요",
  "text_app_review_number_display": "({count})",
  "text_brighten_display": "밝기",
  "text_coupon_until_date": "{date}까지",
  "text_debug": "디버그",
  "text_error": "오류",
  "text_error_occurred": "시스템 오류 발생",
  "text_frequent_search_keyword": "인기 키워드",
  "text_fun_contents": "엔터테인먼트",
  "text_input_barcode_number": "바코드 입력",
  "text_irregular_opening_exist": "영업시간(변동가능있음)",
  "text_mystore_unset": "즐겨찾는 매장 미설정",
  "text_not_carried": "배송안됨",
  "text_product_sale_discontinued": "판매 중단됨",
  "text_product_scan_instruction_title": "스캔 방법",
  "text_product_size_unset": "사이즈가 등록되어 있지 않습니다.",
  "text_quantity_select_required": "장바구니에 추가할 수량을 선택해 주세요.",
  "text_quantity_select_required_title": "수량",
  "text_retain_coupon_num": "총 {number}개",
  "text_scanned_history_remove_confirmation": "스캔 기록을 지우시겠어요?",
  "text_scanto_win": "행운의 스캔(SCAN TO WIN)",
  "text_search_result_num": "{number}개 제품",
  "text_searching": "검색 중",
  "text_size_unselected": "미정",
  "text_app_location_settings": "위치 정보 설정",
  "text_app_advertising_notification_settings": "APP 회원만의 맞춤 혜택을 받아보시겠어요?",
  "text_app_advertising_notification_settings_allow_description": "경고, 사운드 및 아이콘 배지가 알림에 표현될 수 있습니다. 설정에서 이를 구성할 수 있습니다",
  "text_app_advertising_notification_settings_allow_device_settings": "기기 설정화면에서 알림을 허용해주세요.",
  "text_app_advertising_notification_settings_allow_title": "유니클로'에서 알림을 보내고자 합니다.",
  "text_app_advertising_notification_settings_description_01": "유니클로의 새로운 소식 및 추천 제품, 할인, 쿠폰 등 다양한 광고 정보를 수신하실 수 있습니다.",
  "text_app_advertising_notification_settings_description_02": "광고성 APP 알림 수신 동의는 회원정보>설정>APP 알림설정을 통해 변경하실 수 있습니다.",
  "text_app_advertising_notification_settings_no": "미동의",
  "text_app_advertising_notification_settings_not_allow": "허용 안 함",
  "text_app_advertising_notification_settings_yes": "동의",
  "text_error_app_advertising_notification_settings": "알림 수신 동의 설정 중 오류가 발생하였습니다. 다시 시도 또는 닫기를 클릭해주세요.",
  "text_app_notification_settings": "APP 알림 설정",
  "text_app_advertising_notification_settings_link": "상세 보기",
  "text_app_push_notification_settings_allow_required": "유니클로 APP에서 알림을 받으려면 설정을 열고 알림을 허용하세요.",
  "text_app_push_notification_settings_description_01": "사용자 맞춤 쿠폰 및 혜택 등을 알려드립니다.",
  "text_app_push_notification_settings_description_02": "유니클로의 새로운 소식을 알려드립니다.",
  "text_app_push_notification_settings_description_03": "주문 현황을 알려드립니다.",
  "text_app_push_notification_off": "APP 알림이 꺼져 있습니다.",
  "text_app_push_notification_settings": "APP 알림 설정",
  "text_app_iq_chat_description_01": "IQ 채팅은 부담없이 상담할 수 있는 쇼핑 도우미입니다.",
  "text_app_iq_chat_description_02": "각 페이지에서 IQ 채팅 아이콘과 IQ 채팅 아이콘 옆에 나타나는 말풍선 메시지를 표시하거나 숨길 수 있습니다.",
  "text_app_iq_chat_hide_message": "말풍선 메시지 숨기기",
  "text_app_iq_chat_off": "표시안함",
  "text_app_iq_chat_setting": "IQ채팅 설정",
  "text_app_iq_chat_show_message": "IQ 채팅 아이콘 및 말풍선 메시지 표시",
  "text_app_personalised_notifications": "맞춤 알림",
  "text_app_orderstatus_show_pickup_code_button": "text_app_orderstatus_show_pickup_code_button",
  "text_bopus_pickup_code": "text_bopus_pickup_code",
  "text_bopus_pickup_description": "text_bopus_pickup_description",
  "text_bopus_pickup_description_empty": "text_bopus_pickup_description_empty",
  "text_bopus_pickup_detail_title": "text_bopus_pickup_detail_title",
  "text_bopus_pickup_information_description": "text_bopus_pickup_information_description",
  "text_bopus_pickup_modal_title": "text_bopus_pickup_modal_title",
  "text_bopus_questionaire": "text_bopus_questionaire",
  "text_bopus_questionaire_description": "text_bopus_questionaire_description",
  "text_bopus_welcome_modal_title": "text_bopus_welcome_modal_title",
  "text_how_to_match": "text_how_to_match",
  "text_no_recommendations": "text_no_recommendations",
  "text_recommended_for_you_title": "text_recommended_for_you_title",
  "text_sales": "text_sales",
  "text_cart_non_match_item_removed_description": "제품 정보 변경으로 인해 장바구니에서 일부 제품이 삭제되었습니다.",
  "text_cart_non_match_item_removed_title": "일부 제품 삭제 되었습니다.",
  "text_cart_update_confirmation": "장바구니에 제품을 추가했습니다. 장바구니를 확인해 주세요.",
  "text_cart_update_title": "장바구니가 업데이트되었습니다.",
  "text_error_cart_reset_description": "죄송합니다. 장바구니에 일시적 오류가 발생 하였습니다.. 오류를 수정을 위해 장바구니 제품을 다시 재설정 부탁 드리겠습니다.",
  "text_error_cart_reset_title": "시스템 오류",
  "text_no_item_cart": "장바구니가 현재 비어 있습니다.",
  "text_online_store_shopping_cart": "온라인 스토어 장바구니",
  "text_purchase_description": "[주문하기] 버튼을 누른 후 30분간 재고가 임시 확보되므로, 빠른 결제 부탁드립니다.",
  "text_recommendation_personalization_cart_no_item_title": "추천 제품",
  "text_recommendation_personalization_cart_title": "추천 제품",
  "text_remove_item": "장바구니에서 이 제품을 삭제하시겠습니까?",
  "text_remove_item_gift_option_applied": "장바구니에서 이 제품을 삭제하시겠습니까? 적용된 기프트박스가 삭제됩니다.",
  "text_remove_item_title": "제품 삭제",
  "text_shopping_cart": "장바구니",
  "text_store_inventory_cart_description_01": "빠르면 1시간 안에 주문을 받아보실 수 있습니다(매장 영업시간에만 해당).",
  "text_store_inventory_cart_description_02": "ORDER & PICK (당일픽업) 주문은 배송비가 부과되지 않습니다.",
  "text_view_recommendation_personalization_cart": "추천 제품 보기",
  "text_checkout": "주문하기",
  "text_recommendation_personalization_cart_free_shipping_message_01": "{additional} 추가 구매 시, 무료배송.",
  "text_cart_content_total": "합계",
  "text_delete": "삭제",
  "text_cart_free_shipping": "무료 배송 대상 (30,000원 이상 구매 또는 [매장으로 배송] 선택 시)",
  "text_gift_option": "기프트박스 선택",
  "text_apply_coupon": "쿠폰 적용",
  "text_gift_box_materials": "기프트박스 포함",
  "text_gift_option_delivery_effect": "기프트 박스는 구매 후 단순 변심으로 인한 교환 및 반품은 불가하므로, 선택 전 사이즈를 꼭 확인해 주세요.",
  "text_gift_wrapping": "모든 제품은 선물 포장되어 있습니다.",
  "text_gift_wrapping_unavailable": "죄송합니다. 라지 제품의 경우 기프트박스 선택이 불가능합니다.",
  "text_store_inventory_purchase_add_to_cart_alteration_message": "ORDER & PICK (당일픽업) 주문은 수선이 불가합니다. 매장에서 제품 수령 후 수선 신청을 부탁드립니다.",
  "text_store_inventory_purchase_add_to_cart_complete_item_summary": "요약: 제품 {item_quantity}개",
  "text_store_inventory_purchase_add_to_cart_complete_message_01": "매장에서 재고 유무의 확인 이후 최종 주문이 확정됩니다. \n매장의 재고가 부족한 경우 주문이 취소될 수 있습니다.",
  "text_store_inventory_purchase_add_to_cart_complete_message_02": "ORDER & PICK (당일픽업) 제품 수령 시 쇼핑백이 무료 제공됩니다.",
  "text_store_inventory_purchase_add_to_cart_complete_receive_store": "픽업 매장: {store_name}",
  "text_store_inventory_purchase_add_to_cart_complete_title": "제품을 추가했습니다.",
  "text_store_inventory_purchase_add_to_cart_submit_button": "장바구니에 담기",
  "text_store_inventory_purchase_add_to_cart_title": "{store_name}에서 수령",
  "text_store_inventory_purchase_switch_cart_change_button": "픽업 매장 변경",
  "text_store_inventory_purchase_switch_cart_check_button": "장바구니 확인",
  "text_store_inventory_purchase_switch_cart_message_02": "매장을 변경하면 해당 제품이 삭제됩니다.",
  "text_store_inventory_purchase_switch_cart_title": "픽업 매장 변경 확인",
  "text_view_cart": "장바구니 보기",
  "text_view_multibuy_item": "세트할인 제품 보기",
  "text_logout_confirmation": "로그아웃하시겠습니까?",
  "text_multibuy_not_applied": "세트할인이 적용되지 않았습니다.",
  "text_employee_discount_amount_total": "사원판매",
  "text_item_total": "제품 소계",
  "text_recommendation_personalization_cart_purchase_again": "재구매",
  "text_recommendation_personalization_cart_purchase_together": "자주 함께 구매하는 제품",
  "text_recommendation_personalization_cart_ranking": "랭킹",
  "text_recommendation_personalization_cart_wishlist": "위시리스트에 있는 제품",
  "text_cart_shipping_cost": "{additional} 추가 구매 시, 무료배송 / 배송 방법을 [매장으로 배송] 선택 시, 배송비가 부과되지 않습니다.",
  "text_add_gift_option": "기프트박스 선택",
  "text_multibuy_applied": "세트할인이 적용되었습니다.",
  "text_coupon_about_title": "쿠폰 설명",
  "text_gift_option_imark_description01": "기프트박스는 조립전 상태로 배송 됩니다.(주문당 1개)",
  "text_store_inventory_purchase_not_available_on_pc_message_01": "ORDER & PICK (당일픽업)은 PC와 UNIQLO APP에서 모두 사용 가능합니다.",
  "text_store_inventory_purchase_not_available_on_pc_message_02": "휴대폰에서 ORDER & PICK (당일픽업)에 접속해 주세요.",
  "text_add_available_item_to_cart_message": "text_add_available_item_to_cart_message",
  "text_alteration_applied": "text_alteration_applied",
  "text_alteration_note": "W1.5의 9개국 모두에 적용되는 면책 조항",
  "text_cart_meta_description": "UNIQLO 장바구니",
  "text_cart_outofstock": "이 제품은 재고가 없습니다.",
  "text_chat_support": "채팅 지원",
  "text_chat_support_notes01": "상담원이 질문에 답변드립니다.",
  "text_chat_support_open_hour": "9:00~18:00(연중무휴. 단,근로자의날 휴무)",
  "text_error_blacklist_account": "회원계정 문제로 인해 온라인 스토어에서 주문 할수 없습니다.",
  "text_error_booking_inconsistency": "죄송합니다. 결제 도중 오류가 발생했습니다.  현재 진행 중인 결제는 취소될 예정입니다.  하단의 「OK 버튼」을 눌러 다시 결제를 시도해 주시기 바랍니다.  결제 완료 전까지 결제 페이지를 이탈하거나 웹사이트를 신규로 생성하지 않도록 부탁 드립니다.",
  "text_error_cart_lack_of_inventory_message01": "장바구니에 품절된 제품이 포함되어 있습니다. 계속 진행을 원하시면 장바구니 내 품절 제품을 삭제해 주세요.",
  "text_error_employee_discount_restrict_item": "이 제품은 사원판매가 적용되지 않으므로 이 제품을 삭제해 주세요",
  "text_error_employee_discount_restrict_item_in_cart": "사원판매 불가 제품이 장바구니에 있습니다. 장바구니에서 제품을 삭제해 주세요",
  "text_error_l1_split_unavailable_item_cart": "이 제품이 업데이트되었습니다. 장바구니에서 제품을 삭제하고 제품을 검색하여 최신 정보를 확인해 주세요",
  "text_error_l1_split_unavailable_item_cart_title": "구매 불가한 제품이 장바구니에 있습니다.",
  "text_error_ok": "OK",
  "text_error_over_purchase_limit_color": "{product_name}제품은 컬러별 {color_upper_limit}개까지 구매 가능합니다. 수량을 변경해 주세요.",
  "text_error_over_purchase_limit_product": "{product_name}의 구매 한도는 {product_upper_limit}개입니다. 수량을 변경하세요.",
  "text_error_over_purchase_limit_product_color": "{product_name} 제품은 컬러별 {color_upper_limit}개, 총{product_upper_limit}개까지 구매 가능합니다. 수량을 변경해 주세요.",
  "text_error_quantity_limit_item_cart": "구매 수량 제한으로 인해 장바구니에 제품을 추가할 수 없습니다. 수량을 확인하세요.",
  "text_error_quantity_outofstock": "장바구니에 구매 불가능한 제품이 있습니다. “결제”를 클릭하기 전에 해당 제품을 삭제 혹은 업데이트해 주세요.",
  "text_including_pre_order": "예약판매 제품이 포함되어 있습니다.",
  "text_including_reselling": "재판매 제품 포함",
  "text_outofstock_delete_item": "이 제품은 현재 품절입니다. 장바구니에서 이 제품을 삭제해 주세요",
  "text_product_price": "가격",
  "text_purchase_description_imark1": "장바구니 제품의 재고가 확보 되지 않았습니다.",
  "text_purchase_description_imark2": "장바구니에서 \"결제하기\" 누른 후 실 결제 전 60분 이내에는 재고가 확보되어 있습니다. 빠른 결제 부탁드리겠습니다.",
  "text_select_color_and_size_message": "text_select_color_and_size_message",
  "text_similar_items": "함께 본 제품",
  "text_start_chat_support": "채팅",
  "text_unavailable_product": "장바구니에 구매 불가능한 제품이 있습니다. 장바구니 내용을 변경한 후 “결제” 버튼을 눌러주세요.",
  "text_unavailable_remove_item": "이 제품은 구매 불가능합니다. 이 제품을 삭제해 주세요",
  "text_error_price_calculation_coupon": "일시적 시스템 오류가 발생하였습니다.\n 새로고침 후 다시 시도해 주세요.",
  "text_error_coupon_code_empty_unselected": "쿠폰 코드를 입력하시거나 사용 가능한 쿠폰을 선택해 주세요.",
  "text_error_gift_wapping_unavailable": "장바구니의 일부 제품이 너무 커서 포장이 불가능합니다.",
  "text_error_invalid_gift_option_applied": "오류가 발생했습니다. 기프트박스를 다시 선택해 주세요.",
  "text_error_message_card_exceed_length_limitation": "입력한 내용이 최대 길이를 초과했습니다.",
  "text_error_message_card_exceed_max_character_single_line": "한 줄에는 최대 {msg_max_wide_chars_per_line}개 문자까지 가능합니다.",
  "text_error_message_card_exceed_max_line": "메시지 카드에는 최대 {msg_max_lines}까지 가능합니다.",
  "text_error_message_card_exceed_narrow_character_single_line": "한 줄에는 최대 {msg_max_narrow_chars_per_line}개 문자까지 가능합니다.",
  "text_error_proceed_checkout_gift_option_unavailable": "장바구니 합계가 최대값을 초과합니다. 장바구니에서 기프트박스선택 혹은 상품을 삭제해 주세요.",
  "text_gift_option_delivery_effect_01": "text_gift_option_delivery_effect_01",
  "text_gift_option_unavailable_delivery_method_combination": "선택한 배송 방법에는 기프트박스를 사용할 수 없습니다. 결제로 이동하여 배송 방법을 변경한 다음 기프트박스를 적용해 주세요.",
  "text_gift_wrapping_unavailable_item": "대형 제품이 포함되어 있으므로 기프트박스를 선택 할 수 없습니다. 죄송하지만 선택을 변경해 주세요.",
  "text_comma": ",",
  "text_error_store_inventory_purchase_add_to_cart_over_quantity_01": "6개 이상 제품은 구매할 수 없습니다. 수량을 변경하세요.",
  "text_error_store_inventory_purchase_add_to_cart_over_quantity_02": "(장바구니에 {item_quantity}개 제품이 있습니다)",
  "text_store_inventory_purchase_not_available_on_pc_title": "주문 후 픽업 설명",
  "text_store_inventory_purchase_service_instructuion_submit_button": "확인",
  "text_store_inventory_purchase_switch_cart_message_01": "장바구니에 {store_name}에 있는 제품이 있습니다.",
  "text_store_inventory_purchase_switch_cart_message_03": "동시에 여러 매장에서 제품을 구매할 수 없습니다.",
  "text_cart_error_description": "시스템 오류가 발생하였습니다. \n 세부정보를 확인해 주세요.",
  "text_deliverto": "배송 주소",
  "text_shipping_fee_tbd": "결제 단계에서 확인",
  "text_how_much_of_your_gift_card_balance_would_you_like_to_use": "기프트 카드를 어느 정도 사용하시겠어요?",
  "text_there_is_no_billing_information_associated_with_your_account": "온라인 스토어 주문시 청구지 주소가 필요 합니다.",
  "text_address_validation_notes01": "배송 주소를 확인하세요. 주소가 정확하지 않으면 주문이 취소되거나, 지연될 수 있습니다.",
  "text_cart_amount_exceed": "장바구니 합계가 최대 한도를 초과했습니다. 장바구니 제품을 변경해 주세요.",
  "text_cart_amount_exceed_without_upper_limit": "장바구니 합계가 최대 한도를 초과했습니다. 장바구니 제품을 변경해 주세요.",
  "text_coupon_unavailable_message_title": "쿠폰을 사용할 수 없습니다.",
  "text_coupon_unavailable_remove_sampling_coupon_item_from_cart": "제품에 쿠폰이 적용되었습니다. 장바구니에서 제품을 삭제하면 적용된 쿠폰이 삭제됩니다.",
  "text_error_delivery_and_giftoption_combination": "선택한 배송 방법으로는 기프트박스를 선택할 수 없습니다. 선물 옵션을 삭제하거나, 배송 방법을 변경해 주세요.",
  "text_error_go_back_cart": "죄송합니다. 결제 도중 오류가 발생했습니다. 현재 진행 중인 결제는 취소될 예정입니다. 하단의 「OK 버튼」을 눌러 다시 결제를 시도해 주시기 바랍니다. 결제 완료 전까지 결제 페이지를 이탈하거나 웹사이트를 신규로 생성하지 않도록 부탁 드립니다.",
  "text_unapply_receipt": "선택한 결제수단으로는 영수증을 발행할 수 없습니다.",
  "text_unavailable_option_for_employee_discount": "사원판매와 함께 사용이 불가합니다.",
  "text_checkout_step": "단계",
  "text_delivery_method_select_message": "배송 방법 선택",
  "text_select_shipping_address_message": "배송 주소 선택",
  "text_error_checkout_with_bankpay_timeout_description": "결제 가능시간 초과",
  "text_error_checkout_with_bankpay_timeout_title": "결제 가능시간 초과",
  "text_select_prefecture": "주를 선택하세요.",
  "text_error_kcp_order_not_created_title": "주문 오류로 인한 결제 자동취소 예정",
  "text_error_kcp_order_unkown_title": "주문 상태를 확인해 주세요.",
  "text_failed_proceed_kcp_payment_description_01": "결제 과정에서 오류로 결제가 정상적으로 완료되지 않았습니다. 처음부터 다시 시도해 주세요.",
  "text_failed_proceed_kcp_payment_description_02": "예기치 못한 오류로 인해 주문이 정상적으로 완료되지 않았습니다. 불편을 끼쳐드려 대단히 죄송합니다. 결제하신 금액은 자동 환불처리될 예정입니다. 주문절차를 처음부터 다시 시도해 주시기 바랍니다.",
  "text_failed_proceed_kcp_payment_description_03": "주문 내역을 확인해 주세요. 주문 내역이 확인되지 않는 경우 결제하신 금액은 자동 환불 처리될 예정이며, 주문절차를 처음부터 다시 시도해 주시기 바랍니다.",
  "text_failed_proceed_kcp_payment_title": "결제에 실패하였습니다.",
  "text_kcp_check_order_history": "주문 상세 및 배송 현황을 주문 내역에서 확인하실 수 있습니다.",
  "text_payment_kcp_complete": "결제가 정상적으로 완료되었습니다.",
  "text_create_order_settings": "주문설정을 등록",
  "text_express_checkout_divided_delivery_applied_message_01": "분할 배송이 진행되는 주문은 매장에서 픽업을 선택하실 수 없습니다. 다른 배송수단을 선택해 주세요.",
  "text_express_checkout_divided_delivery_applied_title": "해당 매장에서 픽업하실 수 없습니다.",
  "text_express_checkout_selected_store_unavailable_message_01": "주문설정에서 등록된 매장에서 구매하실 수 없습니다. 다른 배송 방법을 선택해 주세요.",
  "text_express_checkout_selected_store_unavailable_title": "해당 매장에서 픽업하실 수 없습니다.",
  "text_express_order_register_uqpay_message_01": "UNIQLO Pay를 이용하려면 등록이 필요합니다.",
  "text_express_order_register_uqpay_title": "UNIQLO Pay 등록",
  "text_order_settings_not_registered_message_01": "배송지 정보를 등록하시면 다음에도 간단하게 불러올 수 있습니다. 이대로 결제를 진행하시거나 주문설정을 등록해 주세요.",
  "text_order_settings_not_registered_title": "주문설정이 등록되지 않았습니다.",
  "text_returnto_cart": "장바구니로 돌아가기",
  "text_error_gift_option_unavailable_pre_order_item_in_cart_description_01": "장바구니에 예약 제품이 있어 기프트 박스 적용한 결제가 불가 합니다. 기프트 박스 해제 혹은 장바구니에서 제품을 삭제해 주세요.",
  "text_error_gift_option_unavailable_pre_order_item_in_cart_title": "기프트박스를 사용 할수 없습니다.",
  "text_express_order_buy_now_with": "지금 구매하기",
  "text_express_order_buy_now_with_uqpay": "UNIQLO Pay로 지금 구매하기",
  "text_express_order_buy_now_with_uqpay_message_01": "“UNIQLO Pay로 지금 구매하기”를 이용하면 각종 절차를 건너뛰고 구매하실 수 있습니다.",
  "text_coupon": "쿠폰",
  "text_delivery_method_unavailable_selected_cvs_description": "text_delivery_method_unavailable_selected_cvs_description",
  "text_delivery_method_unavailable_selected_cvs_title": "text_delivery_method_unavailable_selected_cvs_title",
  "text_cvs_pickup_choose_location": "픽업 위치 선택",
  "text_cvs_pickup_store_select_instruction": "아래 링크에서 픽업 매장을 선택하세요.",
  "text_applied_retail_store_coupon": "적용 쿠폰",
  "text_coupon_expires": "이 쿠폰은 {date} {time}까지 사용 가능합니다.",
  "text_available_coupon": "사용 가능한 쿠폰",
  "text_coupon_detail": "쿠폰 세부정보",
  "text_add": "등록",
  "text_added_coupon": "쿠폰이 추가되었습니다.",
  "text_coupon_description1": "리스트에서 사용할 쿠폰을 선택 후 적용 버튼을 눌러주세요.",
  "text_coupon_unavailable_employee_discount": "직원은 쿠폰을 사용할 수 없습니다.",
  "text_enter_coupon_code": "쿠폰 코드를 입력해 주세요.",
  "text_no_available_coupon": "사용 가능한 쿠폰이 없습니다.",
  "text_ph_coupon_code": "쿠폰 코드 입력",
  "text_successfully_added": "추가됨",
  "text_store_inventory_purchase_title": "ORDER & PICK (당일픽업)",
  "text_order_and_pick_pickup_order_date_after_receive_email_description": "text_order_and_pick_pickup_order_date_after_receive_email_description",
  "text_store_inventory_purhcase_payment_method_notes_01": "신용카드만 결제수단으로 이용할 수 있습니다. 주문 완료 후 매장에서 재고를 확인합니다. 구매한 제품이 매장에 준비되면 메일로 안내드리겠습니다.",
  "text_american_express": "AMERICAN EXPRESS",
  "text_bancontact": "Bancontact",
  "text_billing_address_registration_required_for_credit_card_payment": "신용카드 결제에는 청구지 주소가 필요합니다.",
  "text_carte_bancaire": "은행 카드",
  "text_continue_to_register_new_credit_card": "계속",
  "text_credit_card_information_input_on_review_order": "다음 페이지에서 신용카드 정보를 입력하세요.",
  "text_credit_card_no_security_code_hint_text": "text_credit_card_no_security_code_hint_text",
  "text_credit_card_unavailable_partially_divided_delivery_description": "text_credit_card_unavailable_partially_divided_delivery_description",
  "text_dinersclub": "다이너스 클럽",
  "text_discover": "찾기",
  "text_jcb": "JCB",
  "text_mastercard": "Mastercard",
  "text_visa": "Visa",
  "text_register_billing_address_button_label": "계속",
  "text_divided_delivery_store_credit_card_option_required": "분할 배송 방법을 사용하려면 신용카드 정보를 저장해야 합니다.",
  "text_edit_enewsletter_setting_description02": "UNIQLO 뉴스레터 구독을 취소하려면 아래에 이메일 주소도 제출해 주세요.",
  "text_edit_enewsletter_setting_description01": "최신 컬렉션 출시, 신제품, 독점 프로모션 및 멤버십 혜택에 대한 최신 정보를 얻으려면 아래에 이메일 주소를 제출하세요.",
  "text_add_credit_card_title": "신용카드 추가",
  "text_credit_card_select_message_01": "사용하려는 신용카드를 아래에서 선택하세요.",
  "text_use_new_credit_card": "다른 신용카드 사용",
  "text_use_selected_credit_card": "선택한 신용카드 사용",
  "text_save_update_credit_card": "이 신용카드 저장 또는 업데이트",
  "text_remove_card_confirmation": "이 신용카드를 삭제하시겠어요?",
  "text_remove_card_title": "신용카드 삭제",
  "text_review_order_terms_and_conditions_agreement_message_01": "본 주문은 예약판매 제품을 포함한 주문입니다.",
  "text_review_order_terms_and_conditions_agreement_message_02": "예약판매 제품은 주문 후 30분 이내에만 주문 취소가 가능합니다.",
  "text_review_order_terms_and_conditions_agreement_title": "예약판매 제품을 포함한 주문에 대해서",
  "text_select_pickup_store": "픽업 매장을 선택하세요.",
  "text_about_message_card": "메시지 카드만 원하신다면 메시지를 입력하지 말아주십시오.",
  "text_apply_gift_option": "적용",
  "text_error_failed_get_gift_option": "오류가 발생했습니다. 기프트박스를 선택할 수 없습니다.",
  "text_gift_message": "메시지",
  "text_gift_option_unavailable_pre_order_item_in_cart": "예약판매 제품이 장바구니에 있어 기프트 옵션을 사용할 수 없습니다.",
  "text_message_card_name01": "메시지 카드",
  "text_message_card_note01": "메시지 제한",
  "text_message_card_note02": "문자를 입력해 주세요. 메시지 텍스트는 {msg_max_wide_chars_per_line}자부터 {msg_max_lines}줄 사이에 입력할 수 있습니다. 한 줄에 {msg_max_wide_chars_per_line}자가 초과되면 새 줄로 시작해 주세요. 이 최대값을 초과하는 줄이나 문자는 인쇄되지 않습니다.",
  "text_message_card_note03": "기호를 포함하지 마세요. 로마 숫자는 OS에 따라 다릅니다.",
  "text_no_gift_option": "기프트박스 미적용",
  "text_no_message_card": "메시지 카드 없음",
  "text_ph_message_form": "메시지 카드 있음",
  "text_select_gift_box": "기프트박스 선택",
  "text_select_message_card": "메시지 카드 선택",
  "text_selected_gift_box": "기프트 박스",
  "text_selected_message_card": "메시지 카드",
  "text_store_pickup_additional_notes01": "PH 클릭 및 배송 날짜 노트 수집",
  "text_store_pickup_additional_notes02": "PH 클릭 및 배송 날짜 노트 수집",
  "text_store_pickup_mail_notification_note": "[매장으로 배송]을 선택한 경우 제품에 따라 준비 기간이 2일 이상 소요될 수 있습니다. \n준비 완료 메일 혹은 APP 알림 확인 후 매장에 방문해 주세요.",
  "text_find_store": "매장 찾기",
  "text_apply_selected_coupon": "적용",
  "text_store_details": "매장 세부정보",
  "text_items_in_online_store_cart_description_01": "장바구니에 아직 제품이 있습니다. 결제를 진행하시겠습니까?",
  "text_store_inventory_purchase_complete_order_thanks": "매장 재고 현황 확인",
  "text_store_inventory_purchase_order_complete_message_01": "제품이 준비되면, 실제 픽업 가능 일자는 메일로 안내드리겠습니다.",
  "text_store_inventory_purchase_order_complete_message_02": "선택한 매장에 재고가 있는 경우 재고를 확보하지 못하면 주문이 취소됩니다. *재고 상황에 따라 등록하신 전화번호로 매장에서 연락을 드릴 수 있습니다.",
  "text_store_inventory_purchase_estimated_pickup_date": "예상 픽업 가능 일자",
  "text_pre_order_item_in_delivery_group": "예약판매 제품",
  "text_cancelled_externalpayment_description_01": "결제가 완료되지 않아 주문이 취소되었습니다. 계속하시려면 주문 내역 또는 쇼핑 계속하기를 눌러 주세요.",
  "text_cancelled_externalpayment_description_02": "최대 결제 시도 횟수를 초과하였습니다. 주문을 처음부터 다시 생성하신 후 결제를 시도해 주세요.",
  "text_cancelled_externalpayment_guest_checkout_description_01": "text_cancelled_externalpayment_guest_checkout_description_01",
  "text_cancelled_externalpayment_guest_checkout_description_02": "text_cancelled_externalpayment_guest_checkout_description_02",
  "text_completed_externalpayment_description_01": "결제가 완료되었습니다. 주문 상세 및 결제 정보를 주문 내역에서 확인하실 수 있습니다.",
  "text_externalpayment_due_time": "text_externalpayment_due_time",
  "text_externalpayment_order_complete_payment_not_completed_yet": "진행하고 계신 주문의 결제가 아직 완료되지 않았습니다.",
  "text_externalpayment_order_not_completed": "주문이 아직 진행중입니다",
  "text_failed_proceed_externalpayment_description_03": "text_failed_proceed_externalpayment_description_03",
  "text_failed_proceed_externalpayment_description_07": "결제에 실패했습니다. 주문 내역에서 결제를 다시 시도해 주세요.",
  "text_failed_proceed_externalpayment_description_09": "고객님의 결제 정보를 가져오지 못했습니다. 주문 내역에서 결제 상태를 확인해 주세요.",
  "text_failed_proceed_externalpayment_guest_checkout_description_07": "text_failed_proceed_externalpayment_guest_checkout_description_07",
  "text_failed_proceed_externalpayment_guest_checkout_description_9": "text_failed_proceed_externalpayment_guest_checkout_description_9",
  "text_go_to_guest_account": "text_go_to_guest_account",
  "text_go_to_order_history": "구매 내역 보기",
  "text_kcp_order_cancelled_description_01": "구매 제한 조건을 초과하여 주문이 자동적으로 취소되었습니다. 계속하시려면 주문 내역 또는 쇼핑 계속하기를 눌러 주세요.",
  "text_kcp_order_cancelled_description_02": "구매 제한 조건을 초과하여 주문이 자동적으로 취소되었습니다. 계속하시려면 주문 내역 또는 쇼핑 계속하기를 눌러 주세요.",
  "text_kcp_payment_due_time_desciription_order_complete": "결제하기 버튼을 눌러 결제를 완료해 주세요. 결제가 완료되지 않을 경우 주문이 자동으로 취소됩니다.",
  "text_naver_pay_payment_due_time": "30분 이내에 결제를 완료해 주세요.",
  "text_naver_pay_payment_due_time_desciription_order_complete": "결제하기 버튼을 눌러 결제를 완료해 주세요. 결제가 완료되지 않을 경우 주문이 자동으로 취소됩니다.",
  "text_payment_error_externalpayment_title": "결제 오류 안내",
  "text_payment_externalpayment_payment_status_unknown": "결제 상태 확인 필요",
  "text_change_order_settings": "주문설정 변경",
  "text_change_order_settings_confirmation": "주문설정을 변경하시겠습니까?",
  "text_check_order_settings": "주문설정 확인",
  "text_check_order_settings_without_change_order_settings": "현재의 주문설정을 확인",
  "text_complete_order_pay_at_store_thanks": "주문이 아직 완료되지 않았습니다.",
  "text_complete_order_pay_at_store_thanks_message": "1시간 이내에 매장 계산대에서 결제해 주세요.",
  "text_d_pay_check_order_history": "주문 상세내역은 주문이력을 확인해 주세요",
  "text_d_pay_order_complete_payment_not_completed_yet": "주문은 아직 완료되지 않았습니다.",
  "text_d_pay_payment_complete": "d수단 결제완료",
  "text_d_pay_payment_due_time": "60분 이내로 결제 진행해주세요.",
  "text_d_pay_payment_due_time_desciription_order_complete": "60분 이내로 결제 진행해주세요.결제는 구매내역에서도 가능합니다.결제가 이루어지지 않았을 때에는 주문이 취소됩니다.",
  "text_error_externalpayment_order_not_created_title": "text_error_externalpayment_order_not_created_title",
  "text_error_externalpayment_order_unkown_title": "text_error_externalpayment_order_unkown_title",
  "text_error_order_status_not_confirmed": "주문 처리 중 일시적인 시스템 오류가 발생했습니다.\n “주문 내역“에서 주문 상태를 확인해 주세요.\n 주문 내역이 확인 되지 않을 경우 주문을 다시 시도해 주세요.",
  "text_externalpayment_check_order_history": "상세는 주문 내역에서 확인하실 수 있습니다.",
  "text_failed_proceed_d_pay_payment_description_01": "d수단으로 결제할수 있는 상한 금액입니다. 혹은 이미 주문이 취소되어 주문 결제를 진행할 수 없습니다. d수단의 결제 금액·주문 상황을 확인해 주세요.",
  "text_failed_proceed_d_pay_payment_title": "d결제에 실패 하였습니다.",
  "text_failed_proceed_externalpayment_description_01": "text_failed_proceed_externalpayment_description_01",
  "text_failed_proceed_externalpayment_description_02": "text_failed_proceed_externalpayment_description_02",
  "text_failed_proceed_externalpayment_description_04": "text_failed_proceed_externalpayment_description_04",
  "text_failed_proceed_paypay_payment_description_01": "PayPay로 결제할수 있는 상한 금액입니다. 혹은 이미 주문이 취소되어 주문 결제를 진행할 수 없습니다. PayPay로의 결제 금액·주문 상황을 확인해 주세요.",
  "text_failed_proceed_paypay_payment_title": "PayPay로 결제할 수 없었습니다",
  "text_new_order_settings_created": "주문설정이 등록되었습니다.",
  "text_new_order_settings_created_based_on_order_information_message_01": "아래의 배송지를 주문설정에 등록하였습니다. 다음 주문부터 결제 과정을 단축할 수 있습니다.",
  "text_order_completed_with_order_information_diffrent_order_settings_message_01": "등록된 주문설정과 다른 배송지로 주문이 완료되었습니다. 주문 설정을 변경하시겠습니까?",
  "text_order_settings_delivery_address": "배송 주소",
  "text_order_settings_pickup_store": "픽업 매장",
  "text_payin_store_notes2": "• 바코드는 주문 내역 페이지의 세부정보에도 표시됩니다.",
  "text_payin_store_notes3": "『메뉴』/ 『회원정보・등록・삭제』/ 『구입이력』/ 『주문내역』",
  "text_payin_store_notes4": "• 매장 영업시간을 확인하세요.",
  "text_paypay_check_order_history": "주문 상세내역은 주문이력을 확인해 주세요",
  "text_paypay_order_complete_payment_not_completed_yet": "주문은 아직 완료되지 않았습니다.",
  "text_paypay_payment_complete": "PayPay 결제완료",
  "text_paypay_payment_due_time": "60분 이내로 결제 진행해주세요.",
  "text_paypay_payment_due_time_desciription_order_complete": "60분 이내로 결제 진행해주세요.결제는 구매내역에서도 가능합니다.결제가 이루어지지 않았을 때에는 주문이 취소됩니다",
  "text_received_order": "주문을 접수했습니다.",
  "text_complete_order_thanks_message": "구매해주셔서 감사합니다!",
  "text_back_to_cart": "장바구니로 돌아가기",
  "text_free": "무료",
  "text_cancelled_externalpayment_description_03": "결제가 완료되지 않아 주문이 취소되었습니다. 계속하시려면 주문 내역 또는 쇼핑 계속하기를 눌러 주세요.",
  "text_cancelled_externalpayment_description_04": "최대 결제 시도 횟수를 초과하였습니다. 주문을 처음부터 다시 생성하신 후 결제를 시도해 주세요.",
  "text_completed_externalpayment_description_02": "결제가 완료되었습니다. 주문 상세 및 결제 정보를 주문 내역에서 확인하실 수 있습니다.",
  "text_completed_externalpayment_guest_checkout_description_01": "text_completed_externalpayment_guest_checkout_description_01",
  "text_completed_externalpayment_guest_checkout_description_02": "text_completed_externalpayment_guest_checkout_description_02",
  "text_error_d_pay_payment_already_complete_description_01": "이미 해당주문의 결제는 완료 되었습니다.",
  "text_error_d_pay_payment_already_complete_title": "결제 완료",
  "text_error_d_pay_payment_unavailable_description_01": "주문이 이미 취소되었거나 결제를 여러 번 시도했기 때문에 d결제가 불가능합니다.",
  "text_error_d_pay_payment_unavailable_title": "d수단으로 결제를 하지 못했습니다.",
  "text_error_d_pay_serial_retry_payment_rejected_description_01": "여러 번 결제 버튼이 눌려, 보안 측면에서 결제 절차를 진행할 수 없습니다. 5분 후에 다시 시도해보세요.",
  "text_error_d_pay_serial_retry_payment_rejected_title": "현재 이용을 제한하고 있습니다.",
  "text_error_paypay_payment_already_complete_description_01": "이미 이 주문의 결제는 완료되었습니다.",
  "text_error_paypay_payment_already_complete_title": "결제 완료",
  "text_error_paypay_payment_unavailable_description_01": "주문이 이미 취소되었습니다. 혹은 이미 여러 번 결제를 시도하여 PayPay로 결제할 수 없습니다.",
  "text_error_paypay_payment_unavailable_title": "페이페이로 결제가 되지 않았습니다.",
  "text_error_paypay_serial_retry_payment_rejected_description_01": "여러 번 결제 버튼이 눌려, 보안 측면에서 결제 절차를 진행할 수 없습니다. 5분 후에 다시 시도해보세요.",
  "text_error_paypay_serial_retry_payment_rejected_title": "현재 이용을 제한하고 있습니다.",
  "text_externalpayment_due_time_desciription_02": "이미 결제를 완료하신 경우, 잠시 기다리시거나 페이지를 새로고침하여 주문 상태를 업데이트해 주세요.",
  "text_kcp_order_cancelled_description_03": "구매 제한 조건을 초과하여 주문이 자동적으로 취소되었습니다. 계속하시려면 주문 내역 또는 쇼핑 계속하기를 눌러 주세요.",
  "text_kcp_order_cancelled_description_04": "",
  "text_kcp_order_cancelled_description_05": "",
  "text_official_receipt": "접수",
  "text_order_history_payment_instruction": "아직 결제가 완료되지 않은 주문이 있습니다. 여기를 클릭 후 결제를 완료해 주세요.",
  "text_uq_gift_card": "UNIQLO 기프트 카드",
  "text_view_order_detail": "주문 내역",
  "text_cvs_family_mart": "패밀리마트",
  "text_cvs_lawson_ministop": "로손/미니스톱",
  "text_cvs_seven_eleven": "세븐일레븐",
  "text_externalpayment_button_label": "text_externalpayment_button_label",
  "text_externalpayment_due_time_desciription_01": "30분 이내에 결제가 완료되지 않을 경우, 주문이 취소됩니다.",
  "text_failed_proceed_externalpayment_description_06": "죄송합니다. 결제 과정에서 오류로 인해 결제가 정상적으로 완료되지 않았습니다. 다시 시도해 주세요.",
  "text_naver_pay_button_label": "결제하기",
  "text_common_order_history_delivery_method_ship_by_mail_notes01": "이 주문은 우편함 수령입니다",
  "text_d_pay_payment_button_label": "d수단로 결제",
  "text_failed_proceed_externalpayment_title": "결제에 실패했습니다",
  "text_pay_by_d_pay": "d수단 결제",
  "text_pay_by_paypay": "PayPay 결제",
  "text_payin_store_barcode": "매장 결제 바코드",
  "text_payment_store": "결제할 매장",
  "text_paypay_payment_button_label": "PayPay로 결제",
  "text_unavailable": "이용 불가",
  "text_d_pay_external_faq_link": "d수단 결제 관련",
  "text_paypay_external_faq_link": "PayPay로 결제 관련",
  "text_cvs_pickup_package_count": "이 주문은 {count}개 패키지로 분할되어 발송 예정입니다.",
  "text_new_store_pickup_service": "text_new_store_pickup_service",
  "text_klarna_pay_later": "klarna 추후 결제",
  "text_klarna_pay_now": "klarna",
  "text_shipping_speed_option_express_note": "(토요일 주문에 한하여, 일요일 오전 9시까지 배송)",
  "text_shipping_speed_option_express_after_7am": "오전 7시 이후",
  "text_shipping_speed_option_express_free_entry": "비밀번호 없이 출입 가능",
  "text_shipping_speed_option_express_howto_enter_gate": "출입 방법",
  "text_shipping_speed_option_express_input_common_entrance_password": "공동현관 비밀번호",
  "text_shipping_speed_option_express_notification": "공지사항",
  "text_shipping_speed_option_express_order_arrive": "주문 도착 시",
  "text_kcp_order_cancelled": "이 주문은 구매 한도로 초과하여 취소되었습니다.",
  "text_error_order_settings_shipping_address_update": "변경에 실패했습니다. 변경 내용을 확인하신 후 다시 등록해 주세요.",
  "text_order_settings_billing_address_updated_confirmation": "배송지가 변경되지 않았습니다. 확인해 주시기 바랍니다.",
  "text_order_settings_billing_address_updated_title": "변경 완료",
  "text_order_settings_shipping_address_update_link": "배송지를 변경하려는 경우",
  "text_order_settings_shipping_address_updated_description": "변경이 완료되었습니다. 주문 시 배송지를 다시 확인해 주시기 바랍니다.",
  "text_order_settings_shipping_address_updated_title": "변경 완료",
  "text_available": "구매 가능",
  "text_pickup_in_this_store": "선택한 매장에서 수령",
  "text_checkout_find_pickup_store": "수령할 매장 검색",
  "text_checkout_and_order_detail_retail_delivery_fee": "text_checkout_and_order_detail_retail_delivery_fee",
  "text_apple_pay_payment_amount": "Apple Pay 결제금액",
  "text_credit_card_payment_total_amount": "신용카드 합계",
  "text_d_pay_payment_amount": "d수단 결제금액",
  "text_gift_amount": "기프트박스",
  "text_gift_card_payment_total_amount": "기프트 카드 합계",
  "text_payment_due": "결제 기한",
  "text_paypal_payment_amount": "PayPal 결제금액",
  "text_paypay_payment_amount": "PayPay 결제 금액",
  "text_cvs_pickup_code_family_mart": "픽업 코드/인증 코드",
  "text_cvs_pickup_code_lawson_ministop": "픽업 코드/인증 코드",
  "text_cvs_pickup_code_seven_eleven": "픽업 코드",
  "text_cvs_pickup_slip_btn_lawson_ministop": "픽업 바코드 열기",
  "text_cvs_pickup_slip_btn_seven_eleven": "픽업 영수증 열기",
  "text_order_history_payment_due_time": "30분 이내에 결제를 완료해 주세요.",
  "text_transportation_insight": "배송 현황",
  "text_store_inventory_purchase_estimated_pickup_date_notes_01": "제품이 준비되면, 실제 픽업 가능 일자는 메일로 안내드리겠습니다.",
  "text_payment_method_description": "다음 중 결제 수단을 선택하세요.",
  "text_guest_checkout_guest_id_note": "text_guest_checkout_guest_id_note",
  "text_view_all_credit_card": "text_view_all_credit_card",
  "text_payment_back_to_select_credit_card": "text_payment_back_to_select_credit_card",
  "text_payment_with_credit_card": "text_payment_with_credit_card",
  "text_order_complete_loading": "현재 결제 처리 중입니다. 잠시만 기다려주시기 바랍니다.",
  "text_payment_externalpayment_complete": "결제 완료되었습니다.",
  "text_payment_completed_description_01": "구매해 주셔서 감사합니다. 주문이 완료되었습니다.",
  "text_payment_completed_description_02": "주문 상세 및 결제 정보는 구매 내역에서 확인하실 수 있습니다.",
  "text_continue_to_exchange": "계속",
  "text_error_payment_due_time": "죄송합니다. 결제 중 문제가 발생했습니다. 30분 이내에 다시 결제해 주시기 바랍니다.",
  "text_error_payment_status": "결제 상태 확인 중",
  "text_error_payment_status_description": "결제 상태를 확인 중에 있습니다. 잠시만 기다려 주세요.",
  "text_error_payment_maximum_number": "최대 결제 시도 횟수를 초과하였습니다. 처음부터 다시 주문해 주세요.",
  "text_order_completed_got_it": "확인",
  "text_error_order_completed_time_expired": "결제 시간이 초과되었습니다.",
  "text_error_order_completed_time_expired_description": "주문 가능한 결제 시간을 초과되어 취소되었습니다. 처음부터 다시 주문해 주세요.",
  "text_error_order_completed_purchase_limitation": "죄송합니다. 구매할 수 있는 최대 제품 수를 초과하여 주문이 자동으로 취소되었습니다.",
  "text_error_order_completed_already_paid_title": "이미 결제가 완료되었습니다.",
  "text_error_order_completed_already_paid_description": "이 주문은 이미 결제가 완료되었습니다. 잠시 기다리시거나 페이지를 새로고침하여 주문 상태를 업데이트해 주세요.",
  "text_order_history_pay_now": "결제하기",
  "text_order_history_unpaid_order_message": "아직 결제가 완료되지 않은 주문이 있습니다.",
  "text_order_history_unpaid_order_title": "결제가 완료되지 않았습니다.",
  "text_order_history_unpaid_order_description_01": "{paymentMethod}를 통한 결제 실패로 인해 주문이 아직 완료되지 않았습니다.",
  "text_order_history_unpaid_order_description_02": "{countdownTimer} 내에 결제를 다시 시도해 주세요. 그 이후에는 주문이 자동으로 취소됩니다.",
  "text_error_unpaid_order_01": "주문 가능한 결제 시간을 초과되어 취소되었습니다. 처음부터 다시 주문해 주세요.",
  "text_error_unpaid_order_02": "주문을 취소한 후 새로 주문하실 수 있습니다.",
  "text_order_history_child_orders_list": "다음은 동시에 배치된 다른 부분입니다.",
  "text_error_order_history_preparing_order_title": "잠시만 기다려주세요.",
  "text_error_order_history_preparing_order_success_description": "주문이 접수되었습니다. 현재 사용자가 많아 주문 내역을 확인하시려면 잠시 후 다시 접속을 부탁 드리겠습니다.",
  "text_error_order_history_preparing_order_failed_description": "현재 사용자가 급증하고 있습니다. 잠시 후 결제를 다시 시도해 주세요.",
  "text_item_preparing_order": "주문 상태가 곧 업데이트됩니다. 잠시 기다리시거나 페이지를 새로고침해 주세요.",
  "text_submit_payment_method": "계속",
  "text_enter_card_number": "신용카드 번호를 입력하세요.",
  "text_d_pay_official_description_01": "주문 완료 후 주문완료 화면에서 60분 이내에 d결제 완료해주세요.",
  "text_d_pay_payment_instruction_01": "주문 후 주문 완료 화면에서 결제 진행해주세요.",
  "text_add_a_gift_card": "기프트 카드 추가",
  "text_enter_uq_gift_card_number": "기프트 카드 번호를 입력하세요.",
  "text_enter_uq_gift_card_pin": "PIN을 입력하세요.",
  "text_gift_card_balance_inquiry": "기프트 카드 적용",
  "text_gift_card_payment_apply": "계속",
  "text_gift_card_payment_restriction_notes": "나머지 잔액은 신용카드, PayPal 또는 Apple Pay로 결제할 수 있습니다. 아래 결제 기한이 아니더라도 배송 주소를 기준으로 세금 조정이 이루어집니다.",
  "text_gift_card_total_amount_due": "합계",
  "text_remove_gift_card": "기프트 카드 삭제",
  "text_remove_gift_card_description": "선택한 기프트 카드를 삭제하시겠어요?",
  "text_return_to_checkout": "결제페이지로 돌아가기",
  "text_return_to_select_payment_store": "주소 저장으로 돌아가기",
  "text_uq_gift_card_balance": "기프트 카드 잔액",
  "text_uq_gift_card_expiration_date": "만료일",
  "text_uq_gift_card_full_amount": "모두 적용",
  "text_uq_gift_card_number": "기프트 카드 번호",
  "text_uq_gift_card_pin": "PIN",
  "text_uq_gift_card_specific_amount": "금액 입력",
  "text_contact_information": "연락처",
  "text_google_pay_payment_description_01": "Google pay 결제수단",
  "text_failed_proceed_externalpayment_description_05": "text_failed_proceed_externalpayment_description_05",
  "text_ideal_bank": "iDeal 은행",
  "text_ideal_payment_description_01": "iDeal 결제수단",
  "text_ideal_select_bank": "iDeal 은행 선택",
  "text_payment_externalpayment_confirmation": "text_payment_externalpayment_confirmation",
  "text_klarna_payment_description_01": "klarna 결제수단",
  "text_edit_pay_later_invoice_address": "청구지 주소 수정",
  "text_error_pay_later_consent": "text_error_pay_later_consent",
  "text_np_pay_later_about_pay_later_description": "상품 도착 확인후, 「편의점」 「우체국」 「은행」 「LINE Pay」에서 후불로 결제 할수 있어 안심·간단한 결제 방법입니다.",
  "text_np_pay_later_about_pay_later_notes_01": "청구서는 상품과 별도로 우편으로 보내드립니다.(상품 출하 후, 1주일 정도) ※ 공휴일, 연말연시 기간은 청구서 발소이 늦어집니다.",
  "text_np_pay_later_about_pay_later_notes_02": "편의점/우체국/은행/LINE Pay에서 기간 내에 결제해주세요.",
  "text_np_pay_later_about_pay_later_notes_03": "유니클로 매장에서 후불 결제가 불가능합니다.",
  "text_np_pay_later_about_pay_later_title": "후불결제 관련",
  "text_np_pay_later_description_cancel_order_failed_credibility_inspection": "NP 후불 이용 시 주문 완료 후 여신심사가 진행됩니다. 여신이 불가할 경우 주문이 취소됩니다.",
  "text_np_pay_later_notes_01": "유니클로 매장에서는 후불 결제가 불가능합니다",
  "text_np_pay_later_usage_agreement_checkbox": "아래 동의후 NP 후불로 결제",
  "text_pay_later_invoice_address": "청구지 주소",
  "text_pay_later_notes02": "배달 후 1주일* 후에 청구서를 받게 됩니다. *주문량에 따라 지연될 수 있습니다.",
  "text_pay_later_notes03": "결제일까지 편의점, 우체국, 은행에서 결제를 완료해 주세요.",
  "text_pay_later_notes04": "UNIQLO에서는 결제가 불가능합니다.",
  "text_pay_later_restricitions": "주문고객은 성인혹은, 주문고객이 미성년자인 경우에는 법정대리인에 의한 주문 동의가 필요 합니다.",
  "text_checkout_find_payment_store": "결제할 매장 검색",
  "text_payin_store_description_03": "신용카드 및 QR 코드 결제만 가능합니다.(현금 결제 불가)",
  "text_payin_store_description1": "주문 완료 후, 1시간 이내에 매장에서 결제를 완료해 주세요.",
  "text_payin_store_description2": "주문 완료 후, 1시간 이내에 결제가 완료되지 않을 경우 주문은 자동 취소됩니다.",
  "text_payin_store_title": "매장 결제 시 주의 사항",
  "text_payin_store_title1": "주문 완료 후 1시간 이내",
  "text_payin_store_title2": "매장 직원에게 주문 완료 화면을 제시해 주세요.",
  "text_payin_this_store": "결제할 매장을 선택해 주세요.",
  "text_store_pickup_notes01": "결제 바코드는 주문 완료 후 표시되는 화면 혹은 구매 내역서에서 확인 가능합니다. 지정 점포에서 결제가 완료되면 주문 확정 안내 메일이 발송됩니다.",
  "text_confirm_paypal_checkout": "계속",
  "text_paypal_payment_description1": "PayPal로 결제하려면 PayPal 계정이 필요합니다.",
  "text_confirm_credit_card": "계속",
  "text_paypay_official_description_01": "주문 완료 후 주문완료 화면에서 1시간 이내에 PayPay(잔액결제)로 결제를 완료해 주시기 바랍니다.",
  "text_paypay_payment_instruction_01": "주문 후 주문 완료 화면에서 결제 진행해주세요.",
  "text_purchase_history_item_count": "{count}건",
  "text_store_inventory_purchase_information_main_description_01": "매장 재고를 온라인에서 구입 후 1시간 안에 수령 가능",
  "text_kcp_payment_completed_description": "30분 이내에 결제를 완료해주세요. 결제 완료 후 교환 절차를 진행해 드립니다.",
  "text_alteration_details": "수선",
  "text_bancontact_add_card": "Bancontact 추가",
  "text_bancontact_place_order": "Bancontact 주문",
  "text_bancontact_place_order_note": "Bancontact 주문",
  "text_error_invalid_cvv": "입력한 보안 코드가 올바르지 않습니다. 다시 시도해 주세요.",
  "text_card_number": "신용카드 번호",
  "text_credit_card_name": "이름",
  "text_cvv_input_request_reason01": "신용카드를 사용하려면 CVV가 필요합니다.",
  "text_input_security_code": "CVC 번호(카드 뒷면 숫자 3자리)",
  "text_ph_credit_card_expiration_date": "MM/YY",
  "text_ph_credit_card_holder_example": "HONG GIlDONG",
  "text_security_code": "보안 코드",
  "text_payment_credit_card": "신용카드",
  "text_payment_method": "결제 수단",
  "text_pre_order_sales_conditions": "판매조건",
  "text_pre_order_terms_and_conditions_agreement_check_box": "이용약관과 판매조건에 동의",
  "text_pre_order_terms_and_conditions_agreement_description_01": "이 주문은 예약판매 제품이 포함되어 있습니다. 이용약관 및 판매조건의 동의가 필요합니다.",
  "text_payment_use_another_credit_card": "다른 카드를 이용해 주세요.",
  "text_shipping_speed_option": "배송 속도 옵션",
  "text_postage_free": "무료",
  "text_estimated_time": "예상 배송 날짜",
  "text_delivery_date_range": "2~6영업일",
  "text_shipping_speed_option_express": "감탄! 빛배송",
  "text_store_pickup": "매장으로 배송",
  "text_postage": "배송비",
  "text_shipping_speed_option_standard": "표준",
  "text_shipping_speed_option_two_days": "우선",
  "text_ideal": "iDeal",
  "text_cvs_pickup": "편의점 픽업",
  "text_delivery_exception": "(도서산간지역 제외)",
  "text_delivery_planning_date": "{mini}~{max}",
  "text_unattended_delivery_settings_turn_on": "위탁장소 지정 배송이용",
  "text_unattended_delivery_location": "위탁장소 지정 장소",
  "text_apple_pay": "Apple Pay",
  "text_d_pay": "d수단",
  "text_google_pay": "Google pay",
  "text_klarna": "klarna",
  "text_paypal": "PayPal",
  "text_paypay": "PayPay",
  "text_payment_handling_fee": "취급 수수료",
  "text_pay_later": "NP 나중에 결제하기",
  "text_cashon_delivery": "배달 후 결제",
  "text_all_order_total": "총 결제 금액",
  "text_apple_pay_message_01": "[Apple Pay로 결제하기]를 클릭하면 Apple Pay로 결제가 완료됩니다.",
  "text_change_payment_option": "수정",
  "text_credit_debit_card_kcp_order_note": "[결제하기] 를 눌러 진행해 주세요. 결제 완료 전까지 결제 페이지를 이탈하거나 웹사이트를 신규로 생성하지 않도록 주의해 주세요.",
  "text_credit_debit_card_kcp_place_order": "결제하기",
  "text_d_pay_payment_instruction_02": "주문 후 d결제 진행해주세요.",
  "text_edit_gift_card_description01": "기프트 카드가 적용되면 적용된 결제 수단이 재설정됩니다. 신용카드, PayPal, Apple Pay는 기프트 카드와 합산 결제가 가능합니다.",
  "text_edit_gift_card_title": "기프트 카드 추가",
  "text_error_amount_exceeded_for_payment_method_including_tax": "주문 합계가 {order_amount_post_tax}를 초과하면 선택하신 결제수단으로 진행할 수 없습니다. 결제수단을 변경해 주세요.",
  "text_error_gift_card_payment_amount_unmatch": "결제 금액이 주문과 일치하지 않습니다. 기프트 카드 금액을 업데이트하거나 결제 방법을 변경하세요.",
  "text_error_pre_order_terms_and_conditions_agreement_required": "예약판매 제품은 이용약관 및 판매조건의 동의가 필요합니다.",
  "text_gift_card_not_require_additional_payment_method": "기프트 카드 금액으로 주문 합계를 결제합니다.",
  "text_google_pay_payment_description_02": "Google pay 결제수단",
  "text_gstin": "GSTIN 입력 양식",
  "text_ideal_payment_description_02": "iDeal 결제수단",
  "text_ideal_place_order": "iDeal 주문",
  "text_ideal_place_order_note": "iDeal 주문",
  "text_issue_official_receipt": "영수증 발행",
  "text_klarna_payment_description_02": "klarna 결제수단",
  "text_klarna_place_order_note": "klarna 주문",
  "text_no_payment": "결제 안 됨",
  "text_np_pay_later_invoice_separated_description": "text_np_pay_later_invoice_description",
  "text_pay_later_amount_restriction": "쿠폰을 삭제하면 선택 중인 결제 방법을 사용할 수 없게 될 수 있습니다.주의 부탁 드립니다.",
  "text_pay_later_maximum_amount": "NP 나중에 결제하기 최대 금액은 ¥55,000입니다. 적용된 쿠폰을 수정하거나 삭제하시면 NP 나중에 결제하기를 이용할 수 있습니다.",
  "text_paypal_payment_description2": "계속하려면 PayPal 버튼을 클릭하세요.",
  "text_paypay_payment_instruction_02": "주문 후 PayPay로 결제 진행해주세요.",
  "text_provide_gstin": "인도 현지 요구 사항 GSTIN 확인란 레이블",
  "text_review_order_online_purchase_certification_description": "결제 방법에 따라 발급 절차가 다릅니다. 온라인으로 발급 가능한 경우 구매내역(온라인구매) 주문상세에서 발급 가능합니다.",
  "text_review_order_purchase_certification_title": "영수증 관련",
  "text_sales_discontinued": "이 제품은 품절되었습니다. 장바구니로 돌아가려면 확인을 클릭하세요.",
  "text_sales_discontinued_title": "품절된 상품입니다.",
  "text_edit_coupon": "쿠폰 수정",
  "text_edit_coupon_confirmation": "쿠폰을 수정하시겠습니까?",
  "text_remove_coupon": "쿠폰 삭제",
  "text_remove_coupon_confirmation": "주문에서 이 쿠폰을 삭제하시겠습니까?",
  "text_credit_debit_card_kcp_order_info_note": "주문 내역 확인후 신용카드 / 직불카드로 결제 진행.",
  "text_checkout_pickup_order_date_after_receive_email_description": "text_checkout_pickup_order_date_after_receive_email_description",
  "text_select_store_pickup_mail_notification_description": "제품이 준비되면, 실제 픽업 가능 일자는 메일로 안내드리겠습니다.",
  "text_change_checkout_information": "편집",
  "text_billing_address": "청구지 주소",
  "text_cash_on_delivery_payment_fee_description": "대금 상환에는 지불 수수료가 부과됩니다.상 품 대금과 함께 수령 시 결제해주세요.",
  "text_cashon_delivery_description": "배달 후 결제 수수료는 없습니다. 주문하신 제품이 배송될 때 결제해 주시기 바랍니다.",
  "text_uq_gift_card_payment_amount": "결제 금액",
  "text_payin_store": "매장 결제",
  "text_place_order": "주문하기",
  "text_review_order": "주문 확인",
  "text_review_order_note": "[결제하기]를 눌러 주문을 완료해 주세요.",
  "text_order_including_pre_order_item": "이 주문은 예약판매 제품을 포함하고 있습니다.",
  "text_common_ship_by_mail": "우편함 수취",
  "text_ship_by_mail": "우편으로 배송",
  "text_shipment_count": "배송 그룹{shipment_count}",
  "text_update_confirmation_title": "주문 설정 변경(배송 / 결제)",
  "text_update_confirmation": "설정을 변경 하시겠습니까?",
  "text_change_delivery_option": "수정",
  "text_recipient_home": "지정 주소로 배송",
  "text_delivery_method": "배송 방법",
  "text_split_delivery_annotation": "이 주문은 분할 배송됩니다. 각 배송에 대한 주문 알림을 받게 됩니다.",
  "text_credit_debit_card_kcp": "신용카드/직불카드",
  "text_apple_pay_payment_description": "결제 수단에서 \"Apple Pay\"를 클릭해 주세요.",
  "text_canada_post_office_box_unavailable_notes01": "캐나다 운송 회사 업데이트 참고 사항. 우체국 임대 상자를 더 이상 사용할 수 없습니다",
  "text_gift_card_additional_payment_credit_card": "잔액은 {remaining_amount}입니다. 결제 수단을 선택하세요. 잔액에는 세금 조정 금액이 포함됩니다.",
  "text_delivery_planning_time_and_date_range": "{timeFrom}~{timeTo}({date} 이후)",
  "text_delivery_restriction_message_01": "배송제한",
  "text_error_delivery_date_and_time_not_select": "배송일시를 설정해주세요.",
  "text_delivery_date": "배송일",
  "text_delivery_time": "배송시간",
  "text_edit_delivery_date": "배송 예정일 변경",
  "text_longest_delivery_date": "{delivery_date}까지 배송 예정",
  "text_next_day_delivery_availability": "익일 배송은 12:00까지 가능합니다.",
  "text_next_day_delivery_details_link": "익일 배송을 선택할 수 없는 경우",
  "text_not_select_delivery_date": "배송일 미지정",
  "text_not_select_delivery_time": "배송시간 미지정",
  "text_not_specified_delivery": "배송일정 미지정",
  "text_scheduled_delivery": "배송일정 지정 배송",
  "text_submit_delivery_date": "계속",
  "text_gift_card": "기프트 카드",
  "text_combined_shipment": "묶음 배송",
  "text_shipping_type": "배송 유형",
  "text_split_delivery": "분할 배송",
  "text_split_delivery_available_description01": "이 주문은 분할 배송이 가능합니다.",
  "text_split_delivery_available_description02": "제품을 더 빨리 받고 싶다면 분할 배송을 선택해 주세요. 분할 배송을 선택해도 추가 비용은 없습니다.",
  "text_split_delivery_coupon_unavailable_reason": "배송 유형이 분할 배송인 경우 쿠폰을 적용할 수 없습니다.",
  "text_split_delivery_only_available_notes01": "주문하신 제품의 배송일이 다르기 때문에 분할 배송만 가능합니다.",
  "text_split_delivery_payment_condition": "신용카드는 분할 배송에만 사용할 수 있는 결제 수단입니다.",
  "text_invalid_shipping_address": "유효한 배송 주소와 전화번호를 입력하세요.",
  "text_edit_address_title": "배송 주소 수정",
  "text_error_unattended_delivery_settings_happened": "신규 주소의 등록·주소의 변경이 있어 지정위치 배송이 초기화되었습니다. 위탁장소 배송 사용할 때는 다시 설정해 주세요.",
  "text_delete_address": "선택한 주소를 삭제하시겠습니까?",
  "text_submit_delivery_method": "계속",
  "text_unattended_delivery_description_01": "재배달 삭감에 의한 배송 직원의 부담 경감, 배송 차량에 의한 CO2 배출의 삭감을 목적으로, 지정위치 배송 방법으로 설정을 권장 드리며, 초기 설정으로 하고 있습니다.",
  "text_unattended_delivery_terms_and_conditions_description_01": "위탁 장소 선택 시 {terms_and_conditions}에 동의하게 됩니다.",
  "text_unattended_delivery_terms_and_conditions_link": "위탁장소 지정 배송 규약",
  "text_register_new_address": "새로운 주소 등록하기",
  "text_unattended_delivery_settings": "위탁장소 지정",
  "text_delivery_method_not_selected_description": "배송 방법을 먼저 선택해 주세요.",
  "text_num_2": "2.",
  "text_num_1": "1.",
  "text_shipping_items": "주문 제품",
  "text_shipping_speed_option_express_entrance_password": "공동현관 비밀번호",
  "text_shipping_speed_option_express_input_password": "비밀번호 입력",
  "text_shipping_speed_option_unavailable_description_01": "서비스 이용불가 지역인 경우, 감탄! 빛배송 이용이 불가합니다. 단, 수도권 지역임에도 감탄! 빛배송 서비스 이용 불가 시 주소지를 다시 등록하시고 시도해 주세요.",
  "text_shipping_speed_option_unavailable_description_02": "평일 및 토요일 오후 5시 이후 주문 시 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_03": "공휴일 주문 시 감탄! 빛배송 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_04": "주문 금액이 30,000원 미만의 경우 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_05": "수선 대상 제품이 포함되어 있는 경우에는 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_06": "출고가 오래걸리는 제품이 포함되어 있는 경우에는 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_07": "기타 회사의 사정에 의해 일시적으로 서비스를 중단한 경우에는 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_shipping_speed_option_unavailable_description_08": "현재 감탄! 빛배송 서비스는 제공되지 않습니다.",
  "text_shipping_speed_option_unavailable_description_09": "예약판매 제품이 포함되어 있는 경우에는 감탄! 빛배송 서비스 이용이 불가합니다.",
  "text_submit_shipping_speed_option": "계속",
  "text_error_add_credit_card": "시스템 오류가 발생했습니다. 다시 시도 혹은 입력 정보 재확인 부탁드립니다. 지속적으로 발생 시 나중에 다시 방문해 주세요.",
  "text_kcp_payment_completed": "처음에 주문하신 교환대상제품은 반품으로 진행됩니다. 원활한 반품 진행을 위해 반송 박스 안에 '주문확인서' 또는 '반품번호'를 동봉해 주세요.  자세한 반품 정책 및 반송 방법은 해당 제품의 교환/반품 이력에서 확인하실 수 있습니다.",
  "text_kcp_payment_not_completed": "요청이 완료되지 않았습니다.",
  "text_kcp_request_not_completed": "귀하의 요청이 생성되었지만 아직 지불되지 않았습니다",
  "text_kcp_request_not_completed_note": "30분 이내에 결제가 완료되지 않으면 해당 요청은 자동으로 취소됩니다.",
  "text_kcp_payment_option_description": "30분 이내에 카드로 결제를 완료해 주세요. 결제가 완료되지 않을 경우 본 주문건은 취소됩니다.",
  "text_kcp_payment_due_time": "30분 이내에 결제를 완료해 주세요.",
  "text_about_cancellation": "주문 취소 관련 안내",
  "text_complete_order_thanks": "감사합니다.",
  "text_kcp_button_label": "결제하기",
  "text_order_cancelled_externalpayment_title": "주문이 취소되었습니다",
  "text_error_selected_delivery_date_unavailable": "죄송합니다. 선택한 배달일/시간을 이용할 수 없습니다. 다른 날짜/시간을 선택하세요.",
  "text_update": "업데이트",
  "text_apple_payment_unavailable_description_01": "text_apple_payment_unavailable_description_01",
  "text_bancontact_unavailable_description_01": "Bancontact 선택불가",
  "text_cancelation_imark_description1": "주문 내역 메뉴에서 '이 주문 취소' 버튼이 있는 경우 주문을 취소하실 수 있습니다.",
  "text_cancelation_imark_description2": "주문을 부분적으로 취소하거나, 개별 주문을 결합하거나, 배송일 또는 시간을 수정할 수 없습니다.",
  "text_cancelation_imark_description3": "주문 취소는 주문번호 생성시간으로부터 30분 간 가능하며, 주문내용의 변경(부분취소, 배송지 변경 등)은 불가합니다.",
  "text_cashon_delivery_unavailable_reason_02": "위탁장소 지정 배송시, 대금 상환을 이용할 수 없습니다.",
  "text_cashon_delivery_unavailable_reason01": "CVS 픽업 또는 클릭 앤 콜렉트를 선택한 경우에는 배달 후 결제를 할 수 없습니다.",
  "text_checkout_and_order_detail_retail_delivery_fee_information_message": "text_checkout_and_order_detail_retail_delivery_fee_information_message",
  "text_checkout_purchase_certification_imark_description_01": "NP후불/대금 상환에 수신인명이나 단서의 변경이 필요한 경우, {link}를 확인해 주십시오.",
  "text_common_cashon_delivery_unavailable_reason01": "편의점 수취·점포 수취·우편함 수령을 선택한 경우는 대금 상환을 사용할 수 없습니다",
  "text_common_pay_later_unavailable_reason02": "매장수령, 우편함 수령, 편의점수령, 위탁장소 지정 선택하신 경우 NP후불을 사용하실 수 없습니다",
  "text_common_ship_by_mail_unavailable_reason01": "주문을 우편함 수령시, 규정 크기를 초과하기 때문에 우편함 수령은 이용할 수 없습니다.",
  "text_coupon_imark_description1": "쿠폰을 선택하고 적용을 클릭해 주세요.",
  "text_coupon_imark_description2": "주문당 1개의 쿠폰만 적용 가능합니다.",
  "text_coupon_imark_description3": "주문이 취소된 후, 사용된 쿠폰은 주문 계정으로 복구됩니다.",
  "text_coupon_imark_description4": "유니클로 APP > 회원정보 > 쿠폰에서 보유 중인 쿠폰을 확인해 주세요.",
  "text_coupon_imark_description7": "유니클로 APP 로그인에 대하여",
  "text_coupon_imark_description8": "쿠폰이 보이지 않는 경우에는 유효기간이 종료로 소멸되었거나 이전 주문에 적용되었을 수 있습니다. 주문을 취소할 경우 쿠폰은 복구됩니다.",
  "text_credit_card_imark_description1": "다음 신용카드로 결제할 수 있습니다:",
  "text_credit_card_imark_description2": "Visa, Mastercard, American Express, JCB, Discover.",
  "text_credit_card_imark_description4": "일회성 결제만 허용됩니다.",
  "text_credit_card_imark_description5": "거래일은 주문이 창고에서 배송되는 날짜를 말합니다.",
  "text_credit_card_imark_description6": "주문 합계 금액은 결제일에 신용카드로 청구됩니다.",
  "text_credit_card_imark_description7": "카드 소유자의 이름은 계정 소유자의 이름과 일치해야 합니다.",
  "text_credit_card_imark_description8": "직불카드 구매의 경우 당좌 예금 계좌에서 합계 금액이 구매 시 차감됩니다. 주문 취소 및 반품 시에는 환불 처리에 다소 시간이 소요됩니다.",
  "text_credit_card_imark_title": "신용카드 결제 약관",
  "text_cvv_imark_description1": "CVV 번호로 알려진 보안 코드는 사기 및 도난으로부터 사용자를 보호하기 위한 보안 인증 방법으로 사용됩니다.",
  "text_cvv_imark_description2": "카드 뒷면의 3자리 또는 4자리 숫자에 해당합니다(SAISON AMERICAN EXPRESS®의 경우 카드 앞면에 있습니다).",
  "text_cvv_imark_description3": "아래 이미지의 신용카드에 동그라미로 표시된 숫자가 보안 코드입니다.",
  "text_cvv_imark_description4": "보안 코드가 없는 신용카드도 있습니다.",
  "text_cvv_imark_description5": "신용카드에 보안 코드가 없거나 번호를 찾을 수 없는 경우 신용카드 회사에 문의하세요.",
  "text_cvv_imark_title": "보안 코드 설명",
  "text_d_pay_unavailable_reason_01": "개별 발송 선택 또는 예약판매 제품을 포함한 주문에는 d지불로 결제할 수 없습니다.",
  "text_d_pay_unavailable_reason_02": "선택된 결제 방법은 60,000원을 초과한 주문에는 사용할 수 없습니다.",
  "text_delivery_schedule_imark_description02": "주문이 완료된 시간, 수선 및 기프트박스 선택 유무, 배송지에 따라 달라집니다. 배송 예정일은 주문 절차를 진행시 '주문 내용 확인' 화면에 표시됩니다.",
  "text_delivery_schedule_imark_description03": "배송 날짜에 대한 자세한 내용은 {link}",
  "text_delivery_schedule_imark_description04": "익일배송 조건{link}",
  "text_delivery_schedule_imark_description1": "주문에는 이동중 주문 제품이 포함됩니다. 이동중 주문 제품은 재입고 후 3~7일 후에 배송됩니다.",
  "text_delivery_schedule_imark_description2": "배송일정은 주문 시간대, 수선 서비스 유무, 배송지에 따라 달라집니다.",
  "text_delivery_schedule_imark_description5": "익일 배송 요건을 충족하는 경우 '지정일'로 선택하십시오.",
  "text_general_payment_method_unavailable": "이 결제 수단은 이 주문에 사용할 수 없습니다.",
  "text_gift_card_description01": "주문당 1개의 기프트 카드를 사용할 수 있습니다.",
  "text_gift_card_description02": "합계 금액이 기프트 카드 잔액보다 큰 경우 나머지 주문 잔액은 다른 결제 수단(예: 신용카드, PayPal, Apple Pay)으로 결제해야 합니다.",
  "text_gift_card_payment_combination_unavailable": "이 결제 방법은 기프트 카드 결제와 함께 사용할 수 없습니다.",
  "text_google_pay_unavailable_description_01": "Google pay 선택 불가",
  "text_ideal_unavailable_description_01": "iDeal 선택불가",
  "text_issue_receipt_instruction01": "영수증은 결제 수단이 신용카드 또는 기프트 카드인 경우에만 가능합니다. 다른 결제 수단에 대해서는 아래 링크를 확인하세요.",
  "text_issue_receipt_restriction01": "영수증은 결제수단이 신용카드 또는 기프트 카드인 경우에만 가능합니다. 다른 결제 수단에 대해서는 아래 링크를 확인하세요.",
  "text_klarna_pay_later_unavailable_description_01": "text_klarna_pay_later_unavailable_description_01",
  "text_klarna_pay_now_unavailable_description_01": "text_klarna_pay_now_unavailable_description_01",
  "text_klarna_unavailable_description_01": "klarna 결제 종료 시간 임박",
  "text_next_day_delivery_unavailable_reason01": "이 주문은 익일 배송 대상이 아닙니다.",
  "text_np_pay_later": "NP후불 결제",
  "text_pay_at_store": "매장에서 결제",
  "text_pay_later_official_site": "NP 나중에 결제하기 세부정보",
  "text_pay_later_terms_and_policy_link": "NP 후불 이용 조건 및 회사의 개인정보 정책",
  "text_pay_later_unavailable_reason01": "NP 나중에 결제하기는 주문 금액이 ¥55,000(세금 제외)을 초과하는 경우 이용할 수 없습니다.",
  "text_pay_later_usage": "NP 나중에 결제하기 설명",
  "text_pay_later_usage_notes": "비고",
  "text_pay_later_usage_notes_04": "후불에는 여신심사가 있습니다.주문이 일시 보류되고 승인 후 확정됩니다.여신이 불가한 경우에는 주문 취소됩니다.",
  "text_pay_later_usage_notes01": "유니클로 매장수령 또는 편의점수령은 일정조건을 충족한 고객님만 이용 가능합니다.",
  "text_pay_later_usage_notes02": "후불 주문에는 주식회사 넷프로텍션스의 후불 서비스가 적용되어 당사에 대금채권을 양도합니다.\nNP 후불 이용 약관 및 회사의 개인정보 정책에 동의하고 후불 서비스를 선택해주세요",
  "text_pay_later_usage01": "상품 도착 확인후, 「편의점」 「우체국」 「은행」 「LINE Pay」에서 후불로 결제 할수 있어서 안심·간단한 결제 방법입니다. 청구서는 상품과 별도로 우편으로 발송되므로 발행 후 14일 이내에 지불해 주시기 바랍니다.",
  "text_payments_issuable_purchase_certification": "신용카드 / PayPay / d결제 / UNIQLO Pay / 기프트카드",
  "text_paypal_payment_unavailable_description_01": "text_paypal_payment_unavailable_description_01",
  "text_paypay_unavailable_reason_01": "개별 발송 선택 또는 예약판매 제품을 포함한 주문에는 PayPay로 결제할 수 없습니다.",
  "text_paypay_unavailable_reason_02": "선택된 결제 방법은 60,000원을 초과한 주문에는 사용할 수 없습니다.",
  "text_plst_cash_on_delivery_restriction_notes": "현금결제 배송제한",
  "text_review_order_cash_on_delivery_purchase_certification_description": "대금 상환 영수증을 영수증으로 이용해 주세요",
  "text_review_order_np_pay_later_purchase_certification_description": "이체영수증 또는 입금표를 영수증으로 사용해주세요",
  "text_review_order_pay_at_store_purchase_certification_description": "결제 매장에서 발행 합니다.",
  "text_ship_by_mail_imark_description01": "배송비는 일반 배송비보다 저렴합니다.",
  "text_ship_by_mail_imark_description02": "수취인의 자택 등의 우편함에 보관하므로 부재 시에도 상품을 받아 볼수 있습니다.",
  "text_ship_by_mail_unavailable_reason01": "주문이 우체국 규정 사이즈를 초과하기 때문에 우체국은 이용할 수 없습니다.",
  "text_shipping_speed_option_delivery_to_remote_area": "서비스 이용불가 지역이거나 기상 악화 등 정상적인 서비스 제공이 어려울 경우",
  "text_shipping_speed_option_detail_infromation_link": "세부정보 확인 {link}",
  "text_shipping_speed_option_express_unavailable_message_01": "오후 5시 이후에 주문하신 경우",
  "text_shipping_speed_option_express_unavailable_message_02": "공휴일에 주문하시는 경우",
  "text_shipping_speed_option_express_unavailable_message_03": "제품의 총 결제금액이 3만원 미만일 경우",
  "text_shipping_speed_option_express_unavailable_message_04": "수선 대상 상품이 포함되어 있습니다.",
  "text_shipping_speed_option_express_unavailable_message_05": "기프트 옵션이 포함되어 있습니다.",
  "text_shipping_speed_option_express_unavailable_message_06": "주문하신 제품의 배송이 지연될 수 있습니다.",
  "text_shipping_speed_option_express_unavailable_message_07": "예약판매 제품이 포함되어 있는 경우",
  "text_shipping_speed_option_unavailable_case_message_01": "다음의 경우 '일반 배송'으로만 진행되며, 감탄! 빛배송으로 배송 옵션의 변경이 불가합니다.",
  "text_split_delivery_restriction_cash_on_delivery_payment": "분할 배달을 선택하면 배달 후 결제를 할 수 없습니다.",
  "text_split_delivery_restriction_gift_card_payment": "분할 배달을 선택하면 기프트 카드를 사용할 수 없습니다.",
  "text_split_delivery_restriction_pay_at_store_payment": "분할 배송을 선택하면 매장 결제를 할 수 없습니다.",
  "text_store_pickup_unavailable_reason_01": "주문하신 내역에 [매장으로 배송] 선택이 불가능한 제품이 포함되어 있습니다.",
  "text_unattended_delivery_imark_description_01": "위탁장소 지정 배송이란, 현관문 앞이나 택배 박스 등 지정된 장소에 상품을 두는 배송 방법입니다.자세한 내용은 {link}",
  "text_cvs_pickup_family_mart_unavailable_reason01": "기프트박스 선택 시 편의점 픽업이 불가합니다.",
  "text_cvs_pickup_unavailable_reason01": "이러한 대형 주문에는 편의점 픽업을 할 수 없습니다.",
  "text_link_label_here": "여기",
  "text_error_pre_order_and_normal_item_in_cart_unavailable_checkout": "일반 상품과 예약 상품이 같이 장바구니에 등록 되어 있어 결제 진행이 어렵습니다. 일반 상품만 장바구니에 저장후 결제 진행 부탁 드립니다.",
  "text_error_pre_order_item_unavailable_checkout": "이 상품은 예약 상품으로 일반 상품과 동시 주문이 불가능 합니다.",
  "text_error_pre_order_require_temrs_and_conditions_agreement": "해당주문은 이용약관과 판매조건에 대한 동의가 필요합니다.",
  "text_pre_order_credit_card_require_at_least_one_year_expiration_date": "유효기간이 1년 이상인 신용카드로 결제 부탁드립니다.",
  "text_pre_order_only_credit_card_available_payment_method": "예약 상품 구매는 [신용카드]만 선택할 수 있습니다.",
  "text_pre_order_only_ship_to_home_available_delivery_method": "예약 상품 구매는 [지정 주소 수령]만 선택할 수 있습니다.",
  "text_pre_order_require_temrs_and_conditions_agreement": "해당주문은 예약 상품 대상 상품이 포함되어 있습니다. 이용 약관과 판매 조건을 확인해주세요",
  "text_pre_order_unavailable_select_delivery_date_and_time": "예약 상품의 구입은 [배송 일시 미지정]만 선택할 수 있습니다.",
  "text_apple_pay_available_credit_card_title": "Apple Pay 제휴 신용카드:",
  "text_apple_pay_available_credit_card01": "JCB, Mastercard 및 American Express.",
  "text_apple_pay_contact": "연락처",
  "text_apple_pay_contact_abroad": "해외:",
  "text_apple_pay_contact_abroad_tel": "(XX)X-XXXX-XXXX",
  "text_apple_pay_contact_domestic": "국내:",
  "text_apple_pay_contact_domestic_tel": "XXX-XXX-XXXX",
  "text_apple_pay_details_title": "Apple Pay 세부정보",
  "text_apple_pay_details01": "Apple Pay 세부정보",
  "text_apple_pay_details02": "사용 가능한 iOS 버전 및 기기를 알고 싶다면 Apple 공식 사이트를 방문하세요.",
  "text_apple_pay_faq_link": "Apple Pay에 대한 FAQ",
  "text_apple_pay_official_site": "Apple 공식 사이트",
  "text_apple_pay_usage_title": "Apple Pay 설명",
  "text_apple_pay_usage01": "Apple Pay는 UNIQLO.com 및 유니클로 APP에서 사용할 수 있습니다.",
  "text_checkout_with_apple_pay_description": "text_checkout_with_apple_pay_description",
  "text_bancontact_payment_description_01": "Bancontact 결제수단",
  "text_bancontact_payment_description_02": "Bancontact 결제수단",
  "text_edit_billing_address_completed": "청구지",
  "text_edit_billing_address_completed_note_01": "청구지 주소",
  "text_edit_billing_address_completed_note_02": "청구지 주소",
  "text_edit_billing_address_completed_note_03": "청구지 주소",
  "text_error_invalid_billing_address_details": "text_error_invalid_billing_address_details",
  "text_consent_notice_for_terms_and_condition_by_proceed_checkout": "장바구니",
  "text_error_checkout_cart_exceed_maximum_quantity_limit": "장바구니 최대 수량 한도",
  "text_error_checkout_cart_over_maximum_amout_limit": "장바구니 최대 구매 한도",
  "text_error_checkout_cart_under_minimum_amout_limit": "장바구니 최소 구매 한도",
  "text_error_shipping_address_country_invalid": "배송 주소가 정확하지 않습니다. 배송 주소를 확인 및 수정해 주세요.",
  "text_error_shipping_address_value_invalid": "배송 주소가 정확하지 않습니다. 배송 주소를 확인 및 수정해 주세요.",
  "text_bancontact_payment_amount": "Bancontact 결제",
  "text_bank_transfer_payment": "은행이체 결제",
  "text_bank_transfer_payment_expiry_date": "은행이체 결제 만료일자",
  "text_bank_transfer_payment_instruction_01": "은행이체 관련",
  "text_bank_transfer_payment_instruction_02": "은행이체 관련",
  "text_bank_transfer_payment_read_instruction": "은행이체 관련",
  "text_bank_transfer_payment_virtual_account_number": "은행이체 결제",
  "text_cash_on_delivery_restriction_01": "현글결제 배송 서비스 제한",
  "text_cash_on_delivery_restriction_detail_link": "현글결제 배송 서비스 제한",
  "text_change_delivery_method": "배송 방법 변경",
  "text_change_delivery_method_and_payment_method": "배송・지불 방법 변경",
  "text_change_payment_method": "결제 수단 변경",
  "text_checkout_proceed_to": "결제 진행",
  "text_click_and_collect_delivery_note": "주문 완료시 메일로 수령 예정일을 알려드리겠습니다.",
  "text_credit_card_holder_hint_text": "카드에 기재되어 있는 명의인의 이름을 영문으로 입력해 주세요.",
  "text_credit_card_imark_description_09": "신용카드 imark",
  "text_d_pay_payment_complete_meta_title": "d수단 결제 완료",
  "text_d_pay_payment_failed_meta_title": "d수단 결제 실패",
  "text_d_pay_payment_gateway_redirect_meta_title": "d수단 재연결",
  "text_delivery_delay_notes01": "PH 잠금 배달 지연",
  "text_delivery_delay_notes02": "",
  "text_delivery_unavailable_selected_address_message01": "배송 선택 불가",
  "text_delivery_unavailable_selected_address_title": "배송 선택 불가",
  "text_detail_information_link": "정보확인",
  "text_divided_delivery_turned_off_by_admin_description": "죄송합니다.현재 개별적으로 배송을 사용할 수 없어서 이번 주문을 묶음배송으로 변경했습니다.",
  "text_divided_delivery_turned_off_by_admin_title": "개별 배송이 불가 합니다.",
  "text_edit_membership_address_notes": "(회원정보의 편집)",
  "text_enter_different_pincode": "다른 PIN 코드를 입력하십시오.",
  "text_enter_gstin": "GSTIN 공란",
  "text_error_amount_exceeded_for_payment_method": "주문당 최대 금액이 고액, 최고가격{order_amount_pre_tax}이므로 선택한 결제 수단을 사용할 수 없습니다.",
  "text_error_basket_discrepancy_description_01": "주문 처리 중 일시적인 시스템 오류가 발생했습니다.\n “주문 내역“에서 주문 상태를 확인해 주세요.\n 주문 내역이 확인 되지 않을 경우 주문을 다시 시도해 주세요.",
  "text_error_basket_discrepancy_title": "시스템 오류",
  "text_error_basket_refresh_required_message01": "오류가 발생했습니다. 죄송합니다만 다시 한번 결제 진행을 부탁드립니다. 상품 이외의 입력하신 정보는 삭제됩니다.",
  "text_error_checkout_failed_to_get_product_information_description": "text_error_checkout_failed_to_get_product_information_description",
  "text_error_checkout_failed_to_get_product_information_title": "text_error_checkout_failed_to_get_product_information_title",
  "text_error_credit_card_expire_soon": "이 신용카드는 곧 유효기간이 만료되기 때문에 결제에 사용할 수 없습니다.다른 카드를 사용하십시오.",
  "text_error_d_pay_payment_unavailable_new_order_required_description_01": "주문에 일시적 오류가 발생 하였습니다. 번거로우시겠지만 다시 주문을 진행 부탁 드립니다.",
  "text_error_d_pay_payment_unavailable_new_order_required_title": "주문에 일시적 오류가 발생 하였습니다.",
  "text_error_d_pay_payment_unavailable_order_processing_description_01": "이 주문은 현재 준비 중입니다. 시간을 두고 다시 시도해 주세요",
  "text_error_d_pay_payment_unavailable_order_processing_title": "주문 준비중",
  "text_error_d_pay_redirect_to_order_history_description_01": "일시적으로 시스템 오류가 발생했습니다. 주문내용은 구매내역에서 확인해주세요.",
  "text_error_d_pay_redirect_to_order_history_title": "시스템 에러",
  "text_error_d_pay_try_payment_again_later": "현재 결제를 진행할 수 없습니다. 5분 후에 다시 시도해주세요",
  "text_error_d_pay_unavailable_new_order_required_with_new_payment_method_title": "d수단 결제를 이용할 수 없습니다.",
  "text_error_d_pay_unavailable_required_new_order_required_with_new_payment_method_description_01": "d수단으로 결제할 수 없습니다.d수단 이외의 결제 방법을 사용하여 다시 주문을 진행하십시오.",
  "text_error_delivery_unavailable_delivery_pincode_shipping_address": "주소가 정확하지 않습니다. PIN 코드를 다시 입력하십시오.",
  "text_error_divided_ddelivery_store_credit_card_option_not_set": "신용카드로 분할 배송 방법을 이용하려면 카드 정보를 저장해야 합니다. [이 카드 정보 저장 또는 업데이트]를 확인하세요.",
  "text_error_divided_delivery_coupon_unavailable_description": "판매일이 다른 제품을 동시에 구매하는 경우에는 쿠폰 적용을 할 수 없습니다. 쿠폰을 적용하지 않거나, 장바구니의 제품을 변경해 주세요.",
  "text_error_divided_delivery_coupon_unavailable_title": "쿠폰을 사용할 수 없습니다.",
  "text_error_divided_delivery_unavailable_config_update": "이 주문은 분할 배송을 선택할 수 없습니다.",
  "text_error_divided_delivery_unavailable_coupon_applied": "쿠폰 적용 시 분할 배송을 선택할 수 없습니다.",
  "text_error_divided_delivery_unavailable_description01": "상품 준비에 시간이 걸리는 상품이 포함되어 있어, 선택하신 배송 방법은 사용할 수 없습니다. 장바구니에서 관련 상품을 삭제해 주세요.",
  "text_error_divided_delivery_unavailable_general_reason_on_cart": "상품 준비에 시간이 걸리는 상품이 포함되어 있어, 결제를 진행할 수 없습니다. 장바구니에서 관련 상품을 삭제하시거나 {faq_link}에서 상세조건을 확인하신 후 다시 결제를 진행해 주세요.",
  "text_error_divided_delivery_unavailable_gift_card_applied": "기프트 카드가 결제 수단으로 적용된 경우 분할 배달을 선택할 수 없습니다.",
  "text_error_divided_delivery_unavailable_gift_option_applied": "기프트박스가 적용된 경우 분할 배송을 선택할 수 없습니다.",
  "text_error_divided_delivery_unavailable_multi_buy": "분할 배송 불가능한 상품이 포함되어 있어, 선택한 배송 방법으로 배송이 불가능합니다.",
  "text_error_divided_delivery_unavailable_shipping_fee": "이 주문은 분할 배송을 선택할 수 없습니다.",
  "text_error_divided_delivery_unavailable_title": "일부 배송 방법을 사용할 수 없습니다.",
  "text_error_force_divided_delivery_unavailable_description01": "주문에 분할 배송이 불가능한 제품 또는 옵션이 포함되어 있습니다. 장바구니에서 관련 제품 및 적용된 옵션을 확인해 주세요.",
  "text_error_force_divided_delivery_unavailable_general_reason_on_cart": "분할 배송 방식을 이용하여 해당 주소로 주문이 배송됩니다. 쿠폰을 적용하거나 기프트박스를 선택할 수 없습니다. 분할 배송에 대한 자세한 내용은 {faq_link}에서 확인해 주세요.",
  "text_error_force_divided_delivery_unavailable_title": "분할 배송 불가",
  "text_error_gift_card_payment_combination_unavailable": "선택한 결제 수단은 기프트 카드 결제와 함께 사용할 수 없습니다. 다른 결제 수단을 선택하세요.",
  "text_error_invalid_gstin": "GSTIN 형식",
  "text_error_invalid_gstin_02": "오류 발생",
  "text_error_invalid_pincode_address_combination": "주소가 정확하지 않습니다. PIN 코드를 다시 입력하십시오.",
  "text_error_invalid_pincode_membership_address_combination": "주소가 정확하지 않습니다. PIN 코드를 다시 입력하십시오.",
  "text_error_not_supported_character_in_selected_shipping_address_submitted": "죄송합니다. 선택한 배송 주소에 입력 불가한 문자가 포함되어 있습니다. 특수문자 등 부호 사용 없는지 확인 부탁드립니다.",
  "text_error_not_supported_character_submitted": "죄송합니다. 입력 불가한 문자가 포함되어 있습니다. 입력 내용을 수정해 주세요.",
  "text_error_not_supported_character_title": "입력 불가한 문자가 포함되어 있습니다.",
  "text_error_order_canceled_payment_timeout_redirect_to_order_history_description_01": "시간초과 주문취소",
  "text_error_paypay_payment_unavailable_new_order_required_description_01": "주문에 일시적 오류가 발생 하였습니다. 번거로우시겠지만 다시 주문을 진행 부탁 드립니다.",
  "text_error_paypay_payment_unavailable_new_order_required_title": "주문에 일시적 오류가 발생 하였습니다.",
  "text_error_paypay_payment_unavailable_order_processing_description_01": "이 주문은 현재 준비 중입니다. 시간을 두고 다시 시도해 주세요",
  "text_error_paypay_payment_unavailable_order_processing_title": "주문 준비중",
  "text_error_paypay_redirect_to_order_history_description_01": "일시적인 시스템 오류가 발생하였습니다.\n 주문 상태는 주문 내역에서 확인해 주세요.",
  "text_error_paypay_redirect_to_order_history_title": "시스템 에러",
  "text_error_paypay_try_payment_again_later": "현재 결제를 진행할 수 없습니다. 5분 후에 다시 시도해주세요",
  "text_error_paypay_unavailable_new_order_required_with_new_payment_method_title": "PayPay를 이용할 수 없습니다.",
  "text_error_paypay_unavailable_required_new_order_required_with_new_payment_method_description_01": "PayPay로 결제할 수 없습니다.PayPay 이외의 결제 방법을 사용하여 다시 주문을 진행하십시오.",
  "text_error_pre_order_divided_delivery_delivery_payment_unavailable_description": "장바구니에 예약 제품이 있으므로 선택한 배송 방법과 결제 방법을 사용할 수 없습니다. 장바구니로 돌아가서 예약 판매 제품을 장바구니에서 삭제하거나 배송 방법 및 결제 방법을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_delivery_payment_unavailable_title": "선택하신 배송 및 결제 방법은 사용할 수 없습니다.",
  "text_error_pre_order_divided_delivery_delivery_unavailable_description": "장바구니에 예약 판매 제품이 있으므로 선택한 배송 방법을 사용할 수 없습니다. 장바구니로 돌아가서 예약판매 제품을 장바구니에서 삭제하거나 배송 방법을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_delivery_unavailable_title": "선택하신 배송 방법은 사용할 수 없습니다.",
  "text_error_pre_order_divided_delivery_gift_coupon_unavailable_description": "장바구니에 예약 판매 제품이 있으므로 선물 옵션 및 쿠폰 적용이 불가능합니다. 선물 옵션 및 쿠폰 적용을 취소하거나 장바구니의 제품을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_gift_coupon_unavailable_title": "기프트 박스 및 쿠폰은 사용할 수 없습니다.",
  "text_error_pre_order_divided_delivery_gift_unavailable_description": "장바구니에 예약 판매 제품이 있으므로 선물 옵션을 적용한 채로 구매를 진행할 수 없습니다. 선물 옵션을 적용하지 않거나 장바구니의 제품을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_gift_unavailable_title": "기프트 박스는 사용할 수 없습니다.",
  "text_error_pre_order_divided_delivery_payment_unavailable_description_01": "장바구니에 예약 판매 제품이 있어 선택하신 결제 방법은 사용할 수 없습니다. 장바구니로 돌아가 예약 판매 제품을 삭제하시거나 결제 방법을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_payment_unavailable_description_02": "판매일이 다른 제품을 동시에 구매하는 경우에는 선택한 결제 옵션을 적용 할 수 없습니다. 장바구니의 제품을 변경해 주세요.",
  "text_error_pre_order_divided_delivery_payment_unavailable_title": "선택하신 결제 방법은 사용할 수 없습니다.",
  "text_error_pre_order_gift_card_payment_unavailable_message_01": "예약판매 제품을 포함한 주문에는 기프트 카드로 결제할 수 없습니다.",
  "text_error_pre_order_gift_option_unavailable_message_01": "예약판매 제품을 포함한 주문에는 기프트 옵션을 사용할 수 없습니다.",
  "text_error_pre_order_unavailable_delivery_date_and_time_selected_message_01": "예약판매 제품을 포함한 주문은 배송일자를 지정할 수 없습니다.",
  "text_error_pre_order_unavailable_delivery_method_selected_message_01": "예약판매 제품이 포함되어 현재 선택하신 배송 방법으로 주문진행이 불가합니다. 배송 방법을 변경해 주세요.",
  "text_error_pre_order_unavailable_payment_method_selected_message_01": "예약판매 제품이 포함되어 현제 선택하신 결제 방법으로 주문진행이 불가합니다. 결제 방법을 변경해 주세요.",
  "text_error_request_contact_customer_service": "고객센터 문의 오류",
  "text_error_store_inventory_purchase_invalid_address": "죄송합니다. 사용할 수 없는 문자가 등록된 회원 주소에 포함되어 있습니다. 배송지 목록에서 회원 주소를 확인해 주세요.",
  "text_error_store_inventory_purchase_invalid_address_title": "주소에 사용할 수 없는 문자가 포함되어 있습니다.",
  "text_error_store_inventory_purchase_lack_of_inventory": "죄송합니다. 원하시는 제품이 매장에 없습니다. 다른 매장 혹은 온라인 스토에서 구매 부탁드립니다.",
  "text_error_store_inventory_purchase_lack_of_inventory_title": "재고 부족",
  "text_error_store_inventory_purchase_unavailable_item_in_cart": "죄송합니다. ORDER & PICK (당일픽업)으로 구매할 수 없습니다. \n온라인 스토어에서 구매해 주시기 바랍니다.",
  "text_error_store_inventory_purchase_unavailable_item_in_cart_title": "구매 불가능한 제품",
  "text_error_tax_calculation_failed_message_01": "세금 계산 오류",
  "text_error_tax_calculation_failed_title": "세금 계산 오류",
  "text_google_pay_payment_amount": "Google Pay 결제금액",
  "text_id_pay_in_store_additional_notes_for_covid19_01": "매장내 결제 추가 안내_코로나",
  "text_id_pay_in_store_additional_notes_for_covid19_02": "매장내 결제 추가 안내_코로나",
  "text_id_pay_in_store_additional_notes_for_covid19_03": "매장내 결제 추가 안내_코로나",
  "text_ideal_payment_amount": "ideal 결제",
  "text_inclusive_all_tax": "세금포함",
  "text_international_card_payment_unavailable": "해외 카드 결제 불가",
  "text_maestro": "Maestro",
  "text_migrated_address_message01": "3단계 형식이 아닌 경우 ASEAN 마이그레이션 배송 주소",
  "text_mrp": "mrp",
  "text_net_banking_payment_description_01": "NetBanking 결제 방법을 계속 진행하려면 클릭하십시오. 주문 세부 정보를 확인하면 결제 페이지로 이동 됩니다.",
  "text_order_settings_update_completed_message_01": "주문설정이 변경되었습니다. 변경된 정보는 회원정보에서 확인하실 수 있습니다.",
  "text_order_settings_update_completed_title": "주문설정이 변경됨",
  "text_pay_in_store_additional_notes01": "매장내 결제 추가",
  "text_pay_in_store_additional_notes02": "매장내 결제 추가",
  "text_payment_externalpayment_complete_meta_title": "text_payment_externalpayment_complete_meta_title",
  "text_payment_externalpayment_complete_order_not_created_meta_title": "text_payment_externalpayment_complete_order_not_created_meta_title",
  "text_payment_externalpayment_complete_order_unkown_meta_title": "text_payment_externalpayment_complete_order_unkown_meta_title",
  "text_payment_failed_externalpayment_meta_title": "text_payment_failed_externalpayment_meta_title",
  "text_payment_method_net_banking": "NetBanking",
  "text_payment_method_upi": "UPI",
  "text_paypay_payment_complete_meta_title": "PayPay로 결제 완료",
  "text_paypay_payment_failed_meta_title": "PayPay로 결제 실패",
  "text_paypay_payment_gateway_redirect_meta_title": "PayPay로 재연결",
  "text_place_order_with_paypal": "PayPal로 결제",
  "text_return_to_cart": "장바구니로 돌아가기",
  "text_return_to_registered_credit_card_list": "편집",
  "text_rupay": "RuPay",
  "text_ship_date": "발송일",
  "text_shippingfee": "배송비",
  "text_state_auto_populate_based_on_pincode": "입력한 PIN 코드를 기준으로 상태가 채워집니다.",
  "text_store_inventory_purchase_lead_time_not_fixed_message": "주문이 완료되면 픽업 예정일을 메일로 안내드리겠습니다.",
  "text_store_inventory_purchase_order_complete_message_03": "※재고 상황에 따라 등록하신 전화번호로 매장에서 연락을 드릴 수 있습니다.",
  "text_submit_registered_credit_card": "계속",
  "text_two_days": "이틀",
  "text_ueset_gift_option": "기프트 옵션 제외",
  "text_ueset_gift_option_and_coupon": "기프트 박스・쿠폰 제외",
  "text_unattended_delivery_description_02": "위탁장소 지정 배송으로 지정 하면 대금 상환을 이용할 수 없습니다.",
  "text_unattended_delivery_location_bicycle_basket": "기타(택배기사 연락 시 직접 안내 부탁드립니다)",
  "text_unattended_delivery_location_delivery_box": "무인택배함",
  "text_unattended_delivery_location_front_door": "현관 앞",
  "text_unattended_delivery_location_garage": "차고",
  "text_unattended_delivery_location_meter_box": "우편함",
  "text_unattended_delivery_location_reception": "경비실",
  "text_unattended_delivery_location_storage": "창고",
  "text_unattended_delivery_settings_checkbox": "위탁장소 지정 배송 규약 동의, 배송장소위치 지정",
  "text_unset_coupon": "쿠폰 제외",
  "text_upi_payment_description_01": "UPI 지불 방법을 계속 진행하려면 클릭하십시오. 주문 세부 정보를 확인하면 결제 페이지로 이동 됩니다.",
  "text_uqpay_unavailable_reason_upper_limit_per_day": "UNIQLO Pay는 하루에 ¥50,000엔을 초과하여 결제할 수 없습니다. 다른 결제 수단을 선택하세요.",
  "text_billing_address_notes01": "청구지 주소를 입력하세요.",
  "text_color_size": "컬러 / 사이즈:",
  "text_coupon_already_applied": "쿠폰이 적용되었습니다.",
  "text_coupon_code_error1": "잘못된 쿠폰 코드입니다.",
  "text_coupon_code_error2": "쿠폰코드 입력해주세요",
  "text_coupon_imark_description5": "쿠폰을 사용하려면 [앱]과 [온라인 스토어]의 회원 연결이 필요합니다. \n\n-민혁-\nAPP⋅온라인 스토어 회원 정보 연결 후 쿠폰을 사용하세요",
  "text_coupon_imark_description6": "온라인 스토어 계정과 UNIQLO앱이 연결되어야지 쿠폰 사용이 가능합니다. \n\nAPP⋅온라인 스토어 회원 정보 연결 후 쿠폰 사용이 가능합니다",
  "text_coupon_unavailable_amount": "선택한 쿠폰은 주문 합계에 적용할 수 없습니다.",
  "text_coupon_unavailable_discount": "쿠폰 값은 주문 소계를 초과할 수 없습니다.",
  "text_error_coupon_code_expired": "text_error_coupon_code_expired",
  "text_error_coupon_code_invalid": "text_error_coupon_code_invalid",
  "text_error_coupon_usage_limit_reached": "text_error_coupon_usage_limit_reached",
  "text_expired_coupon": "선택한 쿠폰이 만료되었습니다.",
  "text_expired_coupon_applied": "쿠폰을 적용할 수 없으며 삭제되었습니다. 다시 주문해 주세요.",
  "text_fail_add_coupon": "이 쿠폰을 리스트에 추가할 수 없습니다.",
  "text_failed_apply_coupon": "선택한 쿠폰을 이 주문에 적용할 수 없습니다.",
  "text_failed_apply_per_item_coupon": "쿠폰 적용 대상 제품이 장바구니에 없기 때문에 선택한 쿠폰을 사용할 수 없습니다.",
  "text_card_delete_comfirm": "신용카드를 삭제하시겠어요?",
  "text_card_expirationdate": "만료일",
  "text_card_name_format": "대문자와 숫자만 입력하세요.",
  "text_card_number_digit": "유효한 신용카드 번호를 입력하세요.",
  "text_credit_card_imark_description_11": "text_credit_card_imark_description_11",
  "text_credit_card_imark_description3": "American Express 사용은 불가합니다. 보안상의 이유로 일본에서 발행된 신용카드만 사용할 수 있습니다.",
  "text_enter_credit_card_expiration_date": "만료일을 입력하세요.",
  "text_enter_credit_card_name": "카드 소유자 이름을 입력하세요.",
  "text_error_adyen_credit_card_expiration_date_too_far_in_the_future": "더 최근 날짜를 입력하세요.",
  "text_error_adyen_credit_card_generic_incomplete_message": "제품을 정확하게 입력하세요.",
  "text_error_credit_card_expiration_date_incomplete": "유효한 만료일을 입력하세요.",
  "text_error_credit_card_unavailable_applied_divided_delivery": "text_error_credit_card_unavailable_applied_divided_delivery",
  "text_error_expiration_date": "만료된 신용카드입니다.",
  "text_error_invalid_credit_card_expiration_date": "유효한 만료일을 입력하세요.",
  "text_error_past_credit_card_expiration_date_input": "유효한 만료일을 입력하세요.",
  "text_error_security_code": "잘못된 보안 코드입니다.",
  "text_error_submit_credit_card": "입력한 정보가 유효하지 않습니다. 신용카드 정보를 확인하고 다시 시도하세요.",
  "text_error_symbol_input_credit_card_holder_name": "기호나 숫자를 입력하지 마세요.",
  "text_failed_delete_credit": "신용카드를 삭제하지 못했습니다. 다시 시도해 주세요.",
  "text_failed_register_credit_information": "신용카드를 등록하지 못했습니다. 다시 시도해 주세요.",
  "text_invalid_card_name": "이름과 성 사이에 공백을 넣어주세요.",
  "text_invalid_expiration_date": "유효한 만료일을 입력하세요.",
  "text_save_card_imark_description1": "5개의 신용카드를 저장할 수 있습니다.",
  "text_save_card_imark_description2": "선택하면 이전에 저장된 정보가 무시됩니다.",
  "text_security_code_digit": "3자리 또는 4자리 보안 코드를 입력하세요.",
  "text_select_expiration_date": "만료일을 선택하세요.",
  "text_select_valid_credit_card_message_01": "아래에서 90일 이상 유효한 카드를 선택해 주세요.",
  "text_unavailable_card": "결제 과정에서 문제가 발생했습니다. 결제수단을 변경해서 다시 시도해주세요. 문제가 지속되거나 세부정보를 확인하기 원하시는 경우 고객센터로 연락바랍니다.",
  "text_unavailable_card_brand": "허용되는 신용카드 회사를 입력하세요.",
  "text_all_removed": "모든 제품이 삭제되었습니다.",
  "text_china_union_pay": "UnionPay",
  "text_cvs_change_selected_pickup_location": "픽업 위치 변경",
  "text_cvs_pickup_app_notes": "유니클로 APP을 이용하시려면 최신 버전으로 업데이트하세요",
  "text_cvs_pickup_details_link": "편의점 픽업 세부정보",
  "text_cvs_pickup_notes": "편의점 픽업 선택 시 배달 후 결제를 이용할 수 없습니다.",
  "text_cvs_pickup_store_select_subtitle": "픽업 매장 선택",
  "text_error_selected_cvs_unavailable_pickup": "오류가 발생했습니다. 다른 픽업 매장을 선택하세요.",
  "text_select_new_cvs": "새 위치 선택",
  "text_delivery_delay_message": "피지못할 사정으로 인해 배송이 지연될 수 있습니다.",
  "text_next_day_delivery_unavailable": "현재 익일 배송 서비스는 이용하실 수 없습니다.",
  "text_non_delivery_area_note": "배달불가 지역",
  "text_delivery_date_range_order_date": "주문일 + 2~6영업일",
  "text_next_day_delivery": "익일 배송",
  "text_not_selected": "미선택",
  "text_select_delivery_date": "배송일을 선택해 주세요.",
  "text_select_delivery_time": "배송 시간을 선택해 주세요.",
  "text_delivery_schedule_imark_description3": "배송 가능",
  "text_delivery_schedule_imark_description4": "익일 배송이 가능합니다.",
  "text_delivery_schedule_imark_description6": "※ 최초 주문 고객에 대해서는, 30,000원 미만의 경우, 배송 방법은 주소지 배송만 가능하며 매장 수령은 이용하실 수 없습니다.",
  "text_delivery_schedule_imark_title": "배송일 정보",
  "text_delivery_specific_area_delivery_date": "배송 특정 지역 배송 날짜",
  "text_express_checkout_force_divided_delivery_applied_message_01": "이 주문에 포함된 상품의 배송 시간이 다르기 때문에 개별적으로 배송됩니다.배송방법을 선택해주세요.",
  "text_express_checkout_force_divided_delivery_applied_title": "개별배송만 주문",
  "text_order_item_count": "총 {count}개 제품",
  "text_split_delivery_date_notes01": "이 주문은 분할 배송됩니다. 배송 날짜 및 시간은 각 주문을 확인하세요.",
  "text_split_delivery_restriction_apple_pay_payment": "분할 배송을 선택하면 Apple Pay를 이용할 수 없습니다.",
  "text_split_delivery_restriction_pay_later_payment": "분할 배달을 선택하면 NP 나중에 결제하기를 할 수 없습니다.",
  "text_split_delivery_restriction01": "기프트박스 또는 쿠폰이 적용된 경우 분할 배송이 불가능 합니다.",
  "text_split_delivery_unavailable_reason": "쿠폰 또는 기프트박스 선택을 적용한 경우 분할 배송이 불가능합니다.",
  "text_error_checkout_basket_settings_delete_happened_message_01": "죄송합니다. 결제 과정에서 일시적 오류가 발생했습니다. 오류를 수정을 위해 결제 정보가 삭제됩니다. 다시 결제를 진행 부탁 드립니다.",
  "text_error_checkout_basket_settings_delete_happened_title": "결제가 완료 되지 못했습니다. 다시 진행 부탁 드립니다.",
  "text_error_description_retry_required_payment": "일시적인 시스템 오류가 발생하였습니다. \n 결제 수단 선택 후 다시 시도해 주세요.",
  "text_error_unavailable_applied_coupon_retry_required": "선택한 쿠폰은 주문에 적용 할수 없습니다. 주문에서 쿠폰이 삭제되므로,다시 시도 부탁 드립니다.",
  "text_enter_uq_gift_card_above_amount_range": "$0~{order_amount} 사이의 결제 금액을 입력하세요.",
  "text_enter_uq_gift_card_payment_amount": "결제 금액이 없습니다. 결제 금액을 입력하세요.",
  "text_error_uq_gift_card_have_expired": "이 기프트 카드는 만료되었습니다.",
  "text_error_uq_gift_card_no_balance": "이 기프트 카드의 잔액은 $0입니다.",
  "text_error_uq_gift_card_number_pin_unmatch": "기프트 카드 번호 또는 PIN이 유효하지 않습니다. 확인하고 다시 시도해 주세요.",
  "text_error_uq_gift_card_unavailable": "기프트 카드 번호 및/또는 입력한 PIN에 문제가 있습니다. 카드 세부정보를 확인하고 다시 시도해 주세요.",
  "text_gift_card_additional_payment_method": "결제 금액이 {remaining_amount} 부족합니다. 잔액을 결제하려면 신용카드 또는 다른 기프트 카드를 입력하세요.",
  "text_gift_card_payment_amount": "기프트 카드",
  "text_invalid_uq_gift_card_number_format": "유효한 기프트 카드 번호를 입력하세요.",
  "text_invalid_uq_gift_card_pin_format": "유효한 PIN을 입력하세요.",
  "text_ph_gift_card_number": "기프트 카드 번호를 입력하세요.",
  "text_ph_gift_card_pin": "기프트 카드 PIN을 입력하세요.",
  "text_unavailable_gift_card": "오류가 발생했습니다. 적용된 기프트 카드를 삭제하고 다시 시도하세요.",
  "text_uq_gift_card_remaining_balance": "카드 잔액",
  "text_uq_gift_card_remaining_payment_due": "남은 결제 기한",
  "text_error_gift_options_unavailable_message": "기프트박스 선택 불가",
  "text_ph_message_form_line_01": "메시지 입력 양식",
  "text_ph_message_form_line_02": "메시지 입력 양식",
  "text_ph_message_form_line_03": "메시지 입력 양식",
  "text_gopay_confirmation_message_01": "text_gopay_confirmation_message_01",
  "text_gopay_confirmation_message_02": "text_gopay_confirmation_message_02",
  "text_gopay_download_qr_code": "text_gopay_download_qr_code",
  "text_gopay_payment_description_01": "text_gopay_payment_description_01",
  "text_gopay_payment_description_02": "text_gopay_payment_description_02",
  "text_gopay_payment_description_03": "text_gopay_payment_description_03",
  "text_gopay_payment_description_04": "text_gopay_payment_description_04",
  "text_gopay_payment_description_05": "text_gopay_payment_description_05",
  "text_gopay_redirection_confirmation_message": "text_gopay_redirection_confirmation_message",
  "text_gopay_transaction_status_denied_01": "text_gopay_transaction_status_denied_01",
  "text_gopay_transaction_status_denied_02": "text_gopay_transaction_status_denied_02",
  "text_gopay_transaction_status_expired_01": "text_gopay_transaction_status_expired_01",
  "text_gopay_transaction_status_expired_02": "text_gopay_transaction_status_expired_02",
  "text_gopay_transaction_status_pending_01": "text_gopay_transaction_status_pending_01",
  "text_gopay_transaction_status_pending_02": "text_gopay_transaction_status_pending_02",
  "text_payment_method_gopay": "text_payment_method_gopay",
  "text_spa_gopay_payment_description_03": "text_spa_gopay_payment_description_03",
  "text_go_login_page": "로그인하려면 클릭해 주세요.",
  "text_relogin": "기간이 만료되었습니다. 다시 로그인하세요.",
  "text_relogin_tile": "결제 시간이 초과되었습니다.",
  "text_credit_debit_card_kcp_check_order_history": "구매이력에서 상세 내역 확인 부탁 드립니다.",
  "text_credit_debit_card_kcp_payment_completed_note": "신용카드/직불카드 결제 완료",
  "text_payment_failed_meta_title": "결제 실패",
  "text_payment_kcp_complete_meta_title": "결제 완료",
  "text_payment_kcp_complete_order_not_created_meta_title": "주문 오류",
  "text_payment_kcp_complete_order_unkown_meta_title": "주문 상태 확인",
  "text_klarna_pay_later_payment_amount": "klarna 결제 금액",
  "text_klarna_pay_later_payment_description_01": "klarna 추후 결제",
  "text_klarna_pay_now_payment_amount": "klarna 결제 금액",
  "text_klarna_pay_now_payment_description_01": "klarna 결제수단",
  "text_klarna_pay_over_time": "klarna 결제 시간 초과",
  "text_klarna_pay_over_time_payment_amount": "klarna 결제 금액",
  "text_klarna_pay_over_time_payment_description_01": "klarna 결제 시간 초과",
  "text_klarna_place_order": "klarna 선택 불가",
  "text_store_inventory_purchase_employee_sales_unavailable_message_01": "ORDER & PICK (당일픽업)은 직원의 계정으로 주문할 수 없습니다.",
  "text_store_inventory_purchase_employee_sales_unavailable_title": "매장 재고 구매 불가",
  "text_error_selected_pickup_store_unavailable": "선택한 매장을 이용하실 수 없습니다. 다른 매장을 선택해 주세요.",
  "text_complete_order": "주문 완료",
  "text_d_pay_payment_complete_thanks": "감사합니다.",
  "text_payin_store_notes1": "매장 영업시간 중에 결제하기로 선택한 매장에서 이 바코드를 보여주세요.",
  "text_paypay_payment_complete_thanks": "감사합니다.",
  "text_find_a_store": "매장 찾기",
  "text_pay_at_store_selected_payment_store": "결제 매장",
  "text_payin_store_details1": "기기에서 주문 확인 후 60분 이내에 결제해 주시기 바랍니다.",
  "text_payin_store_details2": "주문을 확인했으면 계산대 직원에게 Pay in Store 바코드를 보여줍니다. 신용 카드를 사용하여 거래를 완료합니다. 카드결제 이외에 다른 결제 방법은 이용하실 수 없습니다.",
  "text_payin_store_details3": "바코드 제시",
  "text_payin_store_instruction1": "UNIQLO 매장에서 “주문 완료” 페이지의 바코드를 보여주세요.",
  "text_payin_store_instruction2": "UNIQLO 매장에서 1시간 이내에 결제를 완료하세요.",
  "text_payin_store_title3": "매장에서 결제",
  "text_payment_store_selection": "결제 매장을 선택해주세요.",
  "text_register_contact_information": "등록",
  "text_select_payment_store": "매장 선택",
  "text_backto_payin_store": "매장 결제로 돌아가기",
  "text_closed_now": "닫힘",
  "text_about_np_pay_later": "나중에 결제하기 설명",
  "text_change_payment_method_required": "다른 결제 수단을 선택하세요.",
  "text_error_pay_later_unavailable_amount": "주문이 최대 결제 한도를 초과하여 NP 나중에 결제하기를 이용할 수 없습니다.",
  "text_np_pay_later_description": "text_np_pay_later_description",
  "text_np_pay_later_invoice_description": "text_np_pay_later_invoice_description",
  "text_pay_later_handling_fee": "나중에 결제하기 취급 수수료: $0",
  "text_pay_later_notes01": "반품 및 교환을 원하실 경우 사전에 NP 나중에 결제하기 결제를 완료해 주시기 바랍니다.",
  "text_pay_later_notes05": "text_pay_later_notes05",
  "text_pay_later_unavailable_reason02": "배달 옵션으로 매장수령, 클릭 앤 콜렉트, 위탁장소 지정을 선택한 경우 NP 나중에 결제하기를 이용할 수 없습니다.",
  "text_pay_later_usage_notes03": "후불결제 수수료는 무료 입니다.",
  "text_store_pickup_restriction_pay_later_payment": "배달 옵션으로 클릭한 후 수정하기로 선택한 경우에는 NP 나중에 결제하기를 할 수 없습니다.",
  "text_waiting_payment_response_message01": "결제수단 선택",
  "text_waiting_payment_response_title": "결제수단 선택",
  "text_error_paypal_checkout_message": "PayPal 결제에 문제가 있습니다. 세부정보를 확인하고 다시 시도해 주세요.",
  "text_paypal_checkout_instruction01": "PayPal Smart 버튼을 클릭하고 PayPal 팝업에 따라 결제를 진행하세요.",
  "text_paypal_checkout_instruction02": "PayPal을 사용하여 구매를 완료하려면 PayPal Smart 버튼을 클릭하세요.",
  "text_app_error_scan_failed_addcart": "이 제품은 추가할 수 없습니다.",
  "text_error_personal_checkout_failed_to_add_to_cart_uq_pay_disabled_or_blocked": "UNIQLO Pay의 정지 또는 제한으로 인해 구매를 처리할 수 없습니다. UNIQLO Pay 설정을 확인하세요.",
  "text_payment_method_qris": "text_payment_method_qris",
  "text_issue_receipt": "영수증 발행",
  "text_place_order_paypal": "PayPal로 주문하기",
  "text_receiving_method": "수취 방법",
  "text_delivery_schedule_imark_description01": "배송일 기준에 대하여",
  "text_delivery_schedule_imark_description05": "익일배송 조건에 충족 못하는 경우,[지정일배송]을 선택해 주세요",
  "text_delivery_schedule_imark_description06": "※ 최초 주문 고객에 대해서는, 30,000원 미만의 경우, 배송 방법은 주소지 배송만 가능하며 매장 수령은 이용하실 수 없습니다.",
  "text_error_expired_date": "유효한 만료일을 입력하세요.",
  "text_expired_credit_card": "미정",
  "text_input_city": "시를 입력하세요.",
  "text_select_address": "주소 선택",
  "text_ship_to_address": "이 주소로 배송",
  "text_input_addressline1": "첫 번째 열에 주소를 입력하세요.",
  "text_shipping_speed_option_express_static_delivery_lead_time_range": "영업일 기준 2~3일 이내 배송",
  "text_shipping_speed_option_standard_static_delivery_lead_time_range": "영업일 기준 5~7일 이내 배송",
  "text_shipping_speed_option_two_days_static_delivery_lead_time_range": "영업일 기준 3~4일 이내 배송",
  "text_edit_shipping_speed_option": "배송 옵션 편집",
  "text_error_shipping_speed_option_unselected": "배송 속도 옵션을 선택하세요.",
  "text_shipping_speed_option_description": "text_shipping_speed_option_description",
  "text_shipping_speed_option_description_01": "배송 속도 옵션을 선택하세요.",
  "text_free_shipping_description": "30,000원 이상 주문시 무료배송(세금포함)",
  "text_selected_pickup_store": "선택한 매장",
  "text_store_pickup_inventory_allocation": "주문한 제품이 매장에 있는 경우에는 해당 매장의 재고를 이용합니다.",
  "text_edit_delivery_notes": "결제 시 배송 방법을 선택하세요.",
  "text_edit_payment_notes": "결제 시 결제수단을 선택하세요.",
  "text_error_invalid_delivery_method_date_applied": "사용할 수 없는 배송 방법 또는 날짜/시간이 적용되었습니다. 배송 방법을 다시 선택해 주세요.",
  "text_error_invalid_delivery_method_date_applied_title": "사용할 수 없는 배송 방법 또는 날짜",
  "text_no_product_search_result": "이 카테고리에 제품이 없습니다.",
  "text_quotation_mark-1": "“",
  "text_quotation_mark-2": "”",
  "text_store_brand_type": "UNIQLO",
  "text_checkout_title": "결제하기",
  "text_d_pay_order_complete_payment_modal_not_completed_yet": "주문이 완료 되지 않았습니다.",
  "text_d_pay_payment_modal_due_time_desciription_order_complete": "60분 이내에 d수단 결제 완료해주세요. 결제가 완료되지 않으면 이 주문은 취소됩니다.※ 구매 내역에서도 결제 하실 수 있습니다.",
  "text_paypay_order_complete_payment_modal_not_completed_yet": "주문이 완료 되지 않았습니다.",
  "text_paypay_payment_modal_due_time_desciription_order_complete": "60분 이내에 PayPay 결제 완료해주세요. 결제가 완료되지 않으면 이 주문은 취소됩니다.※ 구매 내역에서도 결제 하실 수 있습니다.",
  "text_view_product_details_button_label": "제품 보기",
  "text_ranking": "순위",
  "text_recentlyviewed_title": "최근에 본 제품",
  "text_similar_product": "유사한 제품",
  "text_alsobought_title": "자주 함께 구매하는 제품",
  "text_find_similar_product": "유사 제품 찾기",
  "text_recomm_features": "특별 제품",
  "text_searchbycat": "카테고리로 검색",
  "text_shop_now": "지금 쇼핑하기",
  "text_country_selector_my_country_website_continue_button": "text_country_selector_my_country_website_continue_button",
  "text_country_selector_my_country_website_description_01": "text_country_selector_my_country_website_description_01",
  "text_country_selector_my_country_website_description_02": "text_country_selector_my_country_website_description_02",
  "text_country_selector_my_country_website_description_03": "text_country_selector_my_country_website_description_03",
  "text_country_selector_my_country_website_title": "text_country_selector_my_country_website_title",
  "text_country_selector_my_country_website_transition_button": "text_country_selector_my_country_website_transition_button",
  "text_dashlink": "text_dashlink",
  "text_doordash": "도어대시",
  "text_go_to_top": "HOME으로",
  "text_apply": "적용",
  "text_hide": "숨기기",
  "text_fullwidth_vertical_line": "｜",
  "text_continue": "계속",
  "text_go_to_top_uq": "UNIQLO 홈",
  "text_go_to_receipt_details": "세부정보",
  "text_go_to_top_gu": "GU 홈",
  "text_flag_separator": ",",
  "text_slash": "/",
  "text_error_failed_get_location": "현재 위치를 가져오지 못했습니다.",
  "text_mandatoryfields_asterisk": "*",
  "text_enewsletter_confirmation_mail_description_01": "※ 제품 추천, 이벤트 정보, 혜택 알림 등 광고성 정보 전송을 위해서 이메일을 동의 철회 시까지 이용합니다.",
  "text_enewsletter_confirmation_mail_description_02": "본 동의사항은 선택사항으로 거부할 수 있으며, 거부하더라도 온라인스토어 이용에 제한은 없습니다. 단, 제품 추천, 이벤트 정보, 혜택 알림 등 맞춤형 서비스를 제공받을 수 없습니다.",
  "text_enewsletter_marketing_opt_in": "이메일 뉴스레터 수신 동의 (선택)",
  "text_new_registration_concent_collection_and_personal_information_label_02": "[개인정보 수집 및 이용 동의] (선택)",
  "text_new_registration_concent_description": "서비스 이용 약관과 개인정보 수집 및 이용을 확인하시고, 만 14세 이상임에 동의하신 후 미리 보기 화면으로 이동하시기 바랍니다.",
  "text_new_registration_concent_overseas_transfer_personal_information_label": "[개인정보 국외이전 동의] (선택)",
  "text_new_registration_concent_third_parties_personal_information_label": "[개인정보 제3자 제공 동의] (선택)",
  "text_new_registration_consent_presonal_information_and_provision": "[개인정보 국외이전 및 제3자 제공 동의] (선택)",
  "text_consent_agree_collection_and_personal_information_note": "온 / 오프라인 회원정보 통합을 위해 개인정보 이용에 동의합니다. (필수)",
  "text_new_registration_consent_detail_termsof_use": "상세 보기",
  "text_kcp_consent_to_order_agreement_note": "주문할 제품의 제품명, 제품 가격, 배송 정보를 확인하였으며, 구매에 동의하시겠습니까?(전자상거래 법 제8조 제2항)",
  "text_kcp_order_consent_title": "주문 동의",
  "text_new_registration_concent_agree_all_terms_label": "모든 항목에 동의합니다.",
  "text_new_registration_concent_collection_and_personal_information_label_01": "[개인정보 수집 및 이용 동의] (필수)",
  "text_new_registration_concent_terms_of_service_label": "[서비스 이용약관] (필수)",
  "text_new_registration_consent_over_age": "만 14세 이상입니다. (필수)",
  "text_app_termsof_use_agreement_and_condition": "이용약관에 동의합니다(필수)",
  "text_app_termsof_use_agreement_description": "유니클로 APP을 이용하시려면 이용약관에 동의해 주세요",
  "text_app_termsof_use_uncheck_error_message": "유니클로 APP을 이용하시려면 이 곳에 체크를 해주세요",
  "text_error_app_onboarding_push_notifications_description_01": "APP 알림설정에서 뒤로가기 또는 미동의로 설정하실지라도 정상적인 서비스 이용이 가능하십니다.",
  "text_error_app_onboarding_push_notifications_description_02": "최신 뉴스를 받으려면 알림을 켜주세요.\n신제품 및 할인 소식, 다양한 이벤트 혜택을 알림을 통해 받으실 수 있습니다.",
  "text_app_ads_consent_confirmation_description_optin": "광고성 정보 수신 동의가 처리되었습니다. (UNIQLO KR {date})",
  "text_app_ads_consent_confirmation_description_optout": "광고성 정보 수신 거부가 처리되었습니다. (UNIQLO KR {date})",
  "text_app_ads_consent_confirmation_notification_title": "APP 알림 설정",
  "text_app_onboarding_push_notifications_consent_description": "ON으로 설정 시 APP을 통한 정보 수신이 가능합니다.",
  "text_app_onboarding_push_notifications_consent_title": "APP을 통한 알림 수신에 동의하시겠습니까?",
  "text_app_onboarding_push_notifications_consent_toggle": "APP 알림 설정",
  "text_consent_collection_and_personal_information": "개인정보 수집 및 이용 동의(선택)",
  "text_consent_agree_shipping_information_collection": "배송정보 수집 및 이용에 동의 합니다.",
  "text_consent_various_benefit_infomation_note": "유니클로의 다양한 할인 혜택과 온라인스토어 및 오프라인 매장에서의 구매 내역을 한번에 편리하게 조회할 수 있는 서비스를 이용해 보세요. \n통합회원 설정을 하면 더욱 다양한 정보를 받을수 있습니다.",
  "text_consent_various_benefit_information_title": "유니클로의 다양한 혜택을 누려보세요!",
  "text_error_invalid_birthday_age_limitation_message": "만 14세 미만 사용자는 회원 서비스의 이용이 불가 합니다. 자세한 내용은 이용약관에서 확인하실 수 있습니다.",
  "text_submit_membership_setting": "통합회원 설정",
  "text_app_termsof_use_agree": "다음",
  "text_app_termsof_use_title": "유니클로 어플리케이션 이용약관",
  "text_contextual_menu_item_search_title": "text_contextual_menu_item_search_title",
  "text_contextual_menu_membership_title": "text_contextual_menu_membership_title",
  "text_contextual_menu_order_history_title": "text_contextual_menu_order_history_title",
  "text_contextual_menu_store_locator_title": "text_contextual_menu_store_locator_title",
  "text_credit_card": "신용카드",
  "text_error_failed_to_register_adyen_credit_card": "신용카드를 등록하지 못했습니다. 다시 시도해 주세요.",
  "currency_format": "{price}원",
  "text_breadcrumb_custom_order_jacket": "맞춤주문 재킷",
  "text_breadcrumb_custom_order_shirt": "맞춤주문 셔츠",
  "text_breadcrumb_custom_order_top": "유니클로 맞춤 주문",
  "text_cashon_delivery_description_01": "현금결제 배송",
  "text_cashon_delivery_description_02": "현금결제 배송",
  "text_delivery_information": "text_delivery_information",
  "text_return_form_details_button": "반품",
  "text_invoice_regulation_receipt_in_preparation_description_01": "지금 구매 내역서를 준비 중입니다.",
  "text_invoice_regulation_receipt_in_preparation_description_02": "죄송합니다. 잠시 후, 다시 시도해 주시기 바랍니다.",
  "text_invoice_regulation_receipt_in_preparation_title": "구매 내역서를 준비 중입니다",
  "text_return_details_cod_return_shipping_fee_message_01": "상품불량으로 인한 반품은 반품배송비는 부과 되지 않습니다.",
  "text_return_details_how_to_return_03_prepaid_or_cod_shipping_fee": "고객부담 혹은 착불(당사부담)로 반송",
  "text_return_details_prepaid_return_shipping_fee_message_01": "고객 사유로 인한 반품은 반품배송비가 환불금액에서 차감 됩니다.",
  "text_return_details_refund_bank_account_failed_registration_attention": "환불 절차를 진행 하지 못했습니다.",
  "text_return_details_refund_bank_account_failed_registration_message_01": "등록하신 메일 주소로 자세한 방법을 안내 드리고 있습니다. 해당 메일을 확인 부탁 드립니다.",
  "text_return_details_refund_bank_account_failed_registration_message_02": "환불절차와 관련하여 문의사항이 있을 경우 아래에서 확인하시기 바랍니다.",
  "text_return_details_refund_bank_account_gmo_external_page_notes": "※「환불계좌 입력하기」버튼을 선택하면 계좌입력화면(GMO 페이먼트 게이트웨이사의 페이지)으로 이동합니다.",
  "text_return_details_refund_bank_account_registered_sub_status": "환불계좌 입력완료",
  "text_return_details_refund_bank_account_registration_attention": "환불받을 계좌를 입력해주세요.",
  "text_return_details_refund_bank_account_registration_attention_sub_description": "[환불계좌 입력하기] 버튼에서 환불용 은행계좌 정보를 입력해주세요.",
  "text_return_details_refund_bank_account_registration_button": "환불 계좌를 입력",
  "text_return_details_refund_bank_account_registration_message_01": "환불받을 금융기관 계좌를 입력해주세요.",
  "text_return_details_refund_bank_account_registration_message_02": "주문 시 회원정보의 성명과 동일 명의의 계좌에만 환불이 가능합니다.",
  "text_return_details_refund_bank_account_registration_procedure_review_sub_status": "진행 방법 확인",
  "text_return_details_refund_bank_account_unregistered_sub_status": "환불계좌 미입력",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_unpaid_description_02": "청구서가 아직 도착하지 않은 경우 청구서 동봉은 불필요합니다.",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_unpaid_title": "NP후불결제 - 결제 전인 경우:",
  "text_return_details_date_of_return_received": "검수 시작 일자",
  "text_return_details_refund_issued_status": "환불 완료",
  "text_return_details_refund_period_after_return_completed_message": "제품이 물류센터 도착후, 다음날부터 영업일 기준 검수기간 1-3일 후 반품이 완료 됩니다.",
  "text_return_details_refund_term_link": "환불 기간 자세히 보기",
  "text_return_details_return_completed_status": "반품 완료",
  "text_return_details_back_to_details_button": "반품 세부정보로 돌아가기",
  "text_return_details_cancel_return_request": "반품 취소",
  "text_return_details_cancel_return_request_button": "반품 요청 취소",
  "text_return_details_check_return_instructions_link": "반품 정책 및 반송 방법 확인",
  "text_return_details_confirmation_of_canceling_return_request": "반품 요청을 취소하시겠습니까?",
  "text_return_details_date_of_return_requested": "반품 신청 일자",
  "text_return_details_forced_date_of_refund_requested": "환불 요청됨",
  "text_return_details_forced_refund_in_process_status": "환불 처리 중",
  "text_return_details_forced_refund_issued_status": "환불됨",
  "text_return_details_outline_return_procedure_message": "아래 단계에 따라 반품 제품 반송을 진행 부탁 드립니다.",
  "text_return_details_refund_process_in_progress_status": "환불 처리 중",
  "text_return_details_return_by_message_01": "{yyyy/mm/dd} 까지 제품을 반송해 주세요.",
  "text_return_details_return_id_accordion_message": "반품시 주문내역서내 반품상품 체크후, 박스에 상품과 같이 주문내역서 동봉하여 반송하여 주시기 바랍니다.",
  "text_return_details_return_id_accordion_title": "반품 신청 번호 ・ 배송 번호",
  "text_return_details_return_not_eligible_status": "반품 대상 아님",
  "text_return_details_return_processing_status": "반품 검수 중",
  "text_return_details_return_requested_status": "반품 신청 완료",
  "text_return_details_unavailable_canceling_return_request_message": "이미 제품을 반송한 경우 반품 요청을 취소할 수 없습니다.",
  "text_return_details_view_return_slip_button": "반품 양식 보기",
  "text_return_form_certification_number_label": "확인번호",
  "text_return_form_return_application_number_label": "반품신청번호",
  "text_return_form_no_reply_message_hint": "* 회사 귀책의 경우 제품에 대한 사유를 상세히 입력해 주세요. 선택 사유와 실물 검품 시 내용이 상이한 경우 반품 배송비가 청구 될 수 있습니다.",
  "text_return_form_return_reason_word_limit_hint": "최대 입력 문자 수: 300단어",
  "text_return_form_return_reason_title": "반품 사유",
  "text_return_form_select_score_and_reason_description_01": "반품 제품의 수량과 사유를 선택해 주세요.",
  "text_return_form_about_return_accordion": "반품 설명",
  "text_return_form_canceling_return_button": "반품 신청 취소",
  "text_return_form_canceling_return_message_01": "이 제품의 반품 신청을 취소하시겠습니까?",
  "text_return_form_canceling_return_message_02": "“반품 신청 취소” 선택후 재차 반품 접수를 진행 부탁 드립니다.",
  "text_return_form_check_return_details_message": "반품 / 교환 이력에서 신청 이력 및 환불 진행 상태를 확인할 수 있습니다.",
  "text_return_form_prevent_multiple_request_same_item_description_01": "나머지 제품은 이전의 반품 요청이 완료된 후에 반품을 요청할 수 있습니다.",
  "text_return_form_return_details_link": "반품 세부정보",
  "text_return_form_return_other_items_message": "다른 제품을 반품하려면 이 페이지에서 계속해서 제품을 선택하세요.",
  "text_return_form_return_policy_accordion_message_01": "반품을 신청하기 전에 아래 반품 정책을 확인해 주세요. 조건에 맞지 않는 경우 반품이 불가할 수 있습니다.",
  "text_return_form_return_quantity_title": "총 선택 수량",
  "text_return_form_select_item_to_be_returned": "반품하실 제품을 선택하세요.",
  "text_return_form_quantity": "수량",
  "text_return_form_end_of_step_1_message": "반송 박스 안에 ‘주문확인서’ 또는 ‘반품번호’를 동봉해 주세요.\n확인되지 않을 경우, 보내주신 제품이 반송될 수 있습니다.",
  "text_return_form_return_application_title": "반품 / 교환 신청 하기",
  "text_return_form_go_to_details_button": "반품 세부정보로 이동",
  "text_return_form_method_printer_description_01": "‘다운로드’ 버튼을 클릭하여 아래의 정보를 인쇄 후 반품 제품과 함께 박스에 동봉해 주세요.",
  "text_return_form_printing_method_link": "인쇄 방법에 대한 자세한 내용 보기",
  "text_return_form_return_slip_caution_description_01": "반품 정보가 확인되지 않는 제품은 고객님께 반송되므로, 반품 양식 동봉을 잊으시거나 오기재하지 않도록 주의해 주시기 바랍니다.",
  "text_return_form_return_slip_caution_title": "반품 양식 없이 반품",
  "text_return_form_about_refund_link": "환불에 대한 자세한 내용 보기",
  "text_return_form_about_shipping_fee_for_return_link": "반품 배송비에 대한 자세한 내용 보기",
  "text_return_form_how_to_return_03_description_01": "물류센터에 도착한 다음날로부터 반품 완료까지 최대 3일이 소요됩니다.\n반품이 완료되면 이메일이 전송됩니다. 반품이 불가할 경우 제품이 반송될 수 있습니다.",
  "text_return_form_notes_description_01": "나누어서 제품을 반송하는 경우, 반품 신청 번호・인증 번호를 각각의 반송 제품에 동봉해 주세요.",
  "text_return_form_notes_description_04": "온라인 매장에서 구매한 제품은 매장에서 반품하실 수 없습니다.",
  "text_return_form_recheck_return_slip_link": "반품 양식 다운로드로 돌아가기",
  "text_return_form_reminder_before_send_item_back": "반품 전 아래 내용을 다시 한 번 확인하세요.",
  "text_return_form_continue_button": "계속",
  "text_return_form_return_slip_description_01": "반품 신청이 완료되었습니다. 제품과 함께 아래 양식 중 1가지를 동봉해 주세요.",
  "text_return_form_about_refund_description_01": "제품이 물류센터에 도착한 다음날로부터 반품 완료까지 최대 3일이 소요됩니다.",
  "text_return_form_about_refund_title": "환불 설명",
  "text_return_form_confirm_return_conditions_title": "반품 정책",
  "text_return_form_how_to_return_03_return_by_message": "{yyyy/mm/dd}까지 제품을 반품해 주세요.",
  "text_return_form_notes_description_02": "반품 배송비는 문제가 되지 않는 한 반품 합계 금액에서 차감됩니다.",
  "text_return_form_notes_title": "비고",
  "text_return_form_return_slip_title": "반품 양식",
  "text_return_form_end_of_step_2_message": "다음 페이지의 반송 절차에 따라서, 기한 내에 주문확인서, 메모 혹은 반품요청서 중 한가지를 제품과 함께 반송해 주세요.",
  "text_return_form_end_of_step_3_message": "반품 절차가 완료되었습니다. 반품 진행 상태는 주문 내역 > 주문번호옆 반품 / 교환 선택 > 반품 세부 정보 통해서 상태를 확인할 수 있습니다.",
  "text_return_form_return_condition_01": "가격 택 또는 제품 패키지가 훼손된 경우 반품이 불가할 수 있습니다.\n(단, 제품의 내용을 확인하기 위하여 포장을 개봉한 경우에는 반품・교환이 가능합니다.)",
  "text_return_form_return_condition_02": "시착 또는 사용등 고객님의 책임이 있는 사유로 제품의 가치가 훼손된 경우 반품이 불가할 수 있습니다.",
  "text_return_form_return_condition_03": "고객님의 단순 변심으로 인한 반품・교환 요청이 제품 주문일로부터 30일을 경과한 경우 반품이 불가할 수 있습니다.",
  "text_return_form_return_condition_link": "반품 정책 상세 내용",
  "text_return_form_return_policy_accordion_other_message_01": "반품 정책에 부합하지 못한 경우 제품은 반송됩니다.",
  "text_return_form_return_application_stepper_1": "반품 신청",
  "text_return_form_return_procedure_stepper_3": "반품 절차",
  "text_return_form_return_slip_stepper_2": "반품 양식",
  "text_return_form_how_to_return_02_sub_description_01": "※ 회사귀책사유로 인정되는 경우 반송비는 당사가 부담합니다.\n※ 회사귀책이 인정되지 않는 경우 반송비가 부과될 수 있습니다.",
  "text_return_form_how_to_return_03_prepaid_shipping_fee_fedex": "$7 선불 배송 라벨을 만들고 FedEx 또는 USPS를 통해 주문 제품을 반송하세요.",
  "text_return_form_shippment_number_required_for_fedex_message": "참고: 배송 라벨을 만들려면 이 배송 번호가 필요합니다.",
  "text_return_form_return_conditions_title": "반품 정책",
  "text_return_form_return_policy_accordion_other_message_02": "",
  "text_return_form_return_slip_description_02": "text_return_form_return_slip_description_02",
  "text_return_form_about_refund_description_02": "반품 완료 후 결제 수단으로 환불되며, 환불 수단에 따라 최대 5일이 소요될 수 있습니다.",
  "text_return_form_about_refund_description_03": "환불에 대한 자세한 내용은 아래에서 확인해 주세요.",
  "text_return_form_how_to_return_02_sub_description_np_pay_later": "NP 후불결제 영수증 혹은 청구서도 반드시 동봉",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_paid_by_line_description": "LINE Pay로 결제하실 경우 결제영수증 동봉이 필요 없습니다.",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_paid_with_receipt_description": "결제영수증(결제를 증명할 수 있는 명세서)를 동봉해 주십시오. 결제영수증은 결제처에 따라 상이합니다.",
  "text_return_form_method_no_printer_description_01": "아래 정보를 메모(종이)에 기입 후 반품 제품과 함께 박스에 동봉해 주세요.",
  "text_return_form_method_no_printer_title": "반품 번호를 메모에 직접 기입하여 동봉",
  "text_return_form_method_printer_title": "반품 번호 인쇄",
  "text_return_form_notes_description_03": "자세한 내용은 아래 내용 확인해 주세요",
  "text_return_form_return_slip_caution_description_02": "",
  "text_return_form_return_slip_preparation_methods_message": "반송 박스 안에 ‘주문확인서’ 또는 ‘반품번호’를 동봉해 주세요.\n확인되지 않을 경우, 보내주신 제품이 반송될 수 있습니다.",
  "text_return_form_using_np_pay_later_link": "NP후불결제 이용관련",
  "text_return_form_return_condition_04": "기타, '전자상거래 등에서의 소비자보호에 관한 법률'이 정하는 청약철회 제한 사유에 해당되는 경우 반품이 불가할 수 있습니다.",
  "text_return_form_how_to_return_03_cod_shipping_fee": "착불(유니클로부담)으로 반송",
  "text_return_form_how_to_return_03_cod_shipping_fee_description_01": "해당 반품 진행시,유니클로의 귀책으로 반송비는 환불시 차감되지 않습니다.",
  "text_return_form_how_to_return_03_prepaid_shipping_fee_description_01": "해당 반품 진행시,반송비는 환불금액에서 차감 됩니다.",
  "text_return_form_how_to_return_03_prepaid_shipping_fee": "물류센터에 도착한 제품은 검수 후 환불처리 진행됩니다.",
  "text_error_failed_copy": "복사하지 못했습니다. 다시 시도해 주세요.",
  "text_error_return_details_failed_to_get_gmo_information_message_01": "죄송합니다. 오류가 발생했습니다. 잠시 후 페이지를 새로고침하세요.",
  "text_error_return_details_failed_to_get_some_information": "일부 정보를 검색할 수 없습니다.",
  "text_return_form_back_to_return_form_button": "반품 신청 페이지로 돌아가기",
  "text_return_form_create_fedex_label_button": "라벨 생성",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_paid_title": "NP후불결제 - 결제하신 경우",
  "text_return_form_how_to_return_02_sub_description_np_pay_later_unpaid_description_01": "결제 하지 마시고, 청구서를 동봉해 주세요.",
  "text_return_form_reason_customer_reason_label": "고객 변심",
  "text_return_form_reason_our_defect_label": "회사 귀책",
  "text_return_form_return_requested": "반품 요청됨",
  "text_return_form_selected_return_reason_label": "반품 사유",
  "text_return_form_word_limit_hint": "최대 입력 문자 수: 300단어",
  "text_newsletter_confirm_subscription_button": "text_newsletter_confirm_subscription_button",
  "text_newsletter_confirm_subscription_description": "text_newsletter_confirm_subscription_description",
  "text_newsletter_confirm_subscription_subtitle": "text_newsletter_confirm_subscription_subtitle",
  "text_edit_enewsletter_setting_instruction_02": "구독을 취소하려면, 체크 박스 선택을 해제하세요.",
  "text_edit_enewsletter_setting_instruction_01": "마케팅 수신 동의 선택 변경을 원하는 경우 체크박스 상태 확인해주세요.",
  "text_edit_enewsletter_setting_instruction_03": "이메일 뉴스레터 수신 동의 및 변경, 해지 등에 대해",
  "text_error_credit_card_information_saving_for_order_setting_checkbox_unchecked": "이 신용카드 정보를 저장하지 않으면 이 신용카드를 주문설정으로 설정할 수 없습니다.",
  "text_error_failed_get_store_list_description": "「매장변경」을 통하여 선택 매장을 변경해 주세요.",
  "text_error_failed_get_store_list_title": "선택 매장의 재고를 확인할 수 없습니다.",
  "text_error_notifications_toggle_setting": "오류가 발생하여 구성을 변경할 수 없습니다. 다시 시도해 주세요.",
  "text_error_checkout_unavailable_pre_order_item_on_cart": "예약판매 제품이 주문에 포함되어 있어 결제 진행이 불가합니다.",
  "text_error_failed_save_credit_card_description_01": "신용카드 등록하지 못했습니다. 다시 시도해 주세요.",
  "text_error_failed_save_credit_card_title": "신용카드 등록하지 못했습니다.",
  "text_error_order_terms_and_conditions_agreement": "주문 내용 확인 후 주문동의하셔야 구매가 가능합니다.",
  "text_error_divided_delivery_unavailable_gift_option_applied_on_cart": "이 주문은 분할 배송되어, 선물 포장 서비스를 이용할 수 없습니다. 선물포장을 삭제해 주세요.",
  "text_error_no_street1_options": "text_error_no_street1_options",
  "text_error_order_created_instruction_01": "주문 생성시 오류",
  "text_error_order_created_instruction_02": "주문 생성시 오류",
  "text_error_review_emoji_not_supported_in_nickname": "text_error_review_emoji_not_supported_in_nickname",
  "text_access_denied_message_01": "이 페이지에 액세스할 수 없습니다.",
  "text_access_denied_message_02": "유니클로 처음 화면으로 이동해 주세요",
  "text_access_denied_title": "접근이 거부 되었습니다.",
  "text_android12_unsupported_annotation": "현재 APP버전은 Android 12를 지원하지 않습니다. 지원되는 버전이 출시될 때까지 기다려 주시기 바랍니다. 그동안 Android 12 사용자는 웹 브라우저를 사용하여 온라인 스토어를 방문하거나 바코드를 스캔할 수 있습니다. 불편을 끼쳐드려 죄송합니다. 양해에 감사드립니다.",
  "text_exchange_form_edit_delivery_option_and_delivery_date": "배송방법 및 배송예정일의 변경",
  "text_exchange_form_failed_to_get_original_delivery_information": "배송정보를 가져오지 못했습니다. 배송방법을 다시 선택해 주세요.",
  "text_exchange_form_exchange_item_delivery_option_and_delivery_date": "교환 제품 배송 방법",
  "text_exchange_application_requested_notification": "교환 신청 완료 (가지고 계신 제품은 반송해 주세요.)",
  "text_exchange_application_requested_originally_ordered_item_return_due_date": "반품 상품 도착기한 : {YYYY/MM/DD}",
  "text_exchange_and_return_application": "반품 / 교환",
  "text_exchange_application_requested_exchange_item": "교환 상품",
  "text_exchange_order_status_accept": "교환 주문 접수 완료",
  "text_exchange_order_status_order_confirmation": "교환 주문 접수 완료",
  "text_exchange_order_status_ship_pending": "교환 주문 접수 완료",
  "text_exchange_order_status_store_order_order_confirmation": "교환 주문 접수 완료",
  "text_exchange_order_status_store_pickup_order_acceptance": "교환 주문 접수 완료",
  "text_exchange_order_status_store_pickup_shipment_pending": "교환 주문 접수 완료",
  "text_exchange_order_status_bar_shippng_status_01": "교환 주문 완료",
  "text_exchange_details_cancel_exchange": "교환 신청 취소",
  "text_return_and_exchange_application_prepare_return_slip_with_item": "반품 요청서 인쇄 또는 반품신청번호를 메모하여, 반드시 제품 반송 시 동봉하여 주세요.",
  "text_return_form_return_detail_faq": "text_return_form_return_detail_faq",
  "text_return_form_return_details_information": "text_return_form_return_details_information",
  "text_return_form_return_instruction01": "text_return_form_return_instruction01",
  "text_return_form_return_instruction02": "text_return_form_return_instruction02",
  "text_return_form_return_instruction03": "text_return_form_return_instruction03",
  "text_exchange_and_return_status_exchange_completed": "교환 반품 완료",
  "text_exchange_and_return_details_date_of_exchange_requested": "교환 신청 일자",
  "text_exchange_and_return_status_exchange_not_eligible_status": "반품가능기한 초과",
  "text_exchange_and_return_status_exchange_processing": "교환 반품 처리 중",
  "text_exchange_and_return_status_exchange_requested": "교환 신청 완료",
  "text_exchange_details_cancel_exchange_request": "교환 요청 취소",
  "text_exchange_details_cancel_exchange_request_button": "교환 요청 취소",
  "text_exchange_details_confirmation_of_canceling_exchange_request": "교환 요청을 취소하시겠습니까?",
  "text_exchange_details_unavailable_canceling_return_exchange_message": "이미 상품을 반송하신 경우에는 교환 요청을 취소할 수 없습니다.",
  "text_return_detail_print_return_label": "반품 라벨 인쇄",
  "text_return_detail_print_return_label_button": "반품 라벨 인쇄",
  "text_return_method_print_label_download_shipping_label": "반송 내역서 인쇄",
  "text_return_form_return_method_print_label_description": "Print a return label and drop-off your return to the drop-off location below.",
  "text_return_detail_fedex_qr_code": "QR Code",
  "text_return_detail_fedex_tracking_number": "FedEx Return Tracking ID",
  "text_return_detail_view_fedex_qr_code_button": "QR code",
  "text_return_instruction_return_by_message_return_to_return_detail": "{link}의 각 반송 요청 상태에서 QR 코드를 받을 수 있습니다.",
  "text_return_instruction_return_by_message_return_to_return_detail_link": "반품 상세 정보",
  "text_exchange_and_return_application_accepted_prepare_to_return": "반품 양식 자세히 보기",
  "text_exchange_and_return_application_accepted_sub_title": "주문 정보 동봉 안내",
  "text_exchange_and_return_application_accepted_title": "신청이 완료되었습니다",
  "text_exchange_and_return_application_confirmation_order_detail": "신청내용 확인",
  "text_exchange_and_return_confirm_application": "신청 확정",
  "text_exchange_application_about_total_amount": "교환 제품의 결제 금액에 대해",
  "text_exchange_application_about_total_amount_description_01": "교환 받으실 제품은 최초 구매 제품과 동일한 금액으로 결제가 진행됩니다.",
  "text_exchange_application_about_total_amount_description_02": "부가세 10% 포함",
  "text_exchange_application_note": "교환 신청 시 유의사항",
  "text_exchange_application_note_01": "교환 신청 완료를 위해서는 교환 요청 제품의 결제가 필요합니다.",
  "text_exchange_application_note_02": "교환 제품의 결제 취소는 결제 후 30분 이내에 주문 내역 페이지에서 가능합니다.",
  "text_exchange_application_note_03": "최초 구매하신 제품은 반송되는 대로 검품 후 환불 처리됩니다.",
  "text_exchange_application_original_ordered_item_return_due_date": "반품 제품 도착 기한",
  "text_exchange_application_total_amount_exclusive_tax": "교환 상품 합계",
  "text_exchange_application_total_amount_inclusive_tax": "교환 제품 합계",
  "text_exchange_confirmation_delivere_exchange_item_total_number": "배송받으실 교환 제품",
  "text_exchange_confirmation_exchange_item_number": "교환 수량",
  "text_return_confirmation_return_item_number": "반품 수량",
  "text_return_confirmation_return_item_total_number": "반송이 필요한 제품",
  "text_error_exchange_form_not_selected_exchange_item": "교환 받으실 상품의 색상, 사이즈, 수량을 선택해 주세요.",
  "text_error_exchange_form_selected_exchange_item_same_with_originally_ordered_item": "구매 제품과 동일한 색상과 사이즈는 선택할 수 없습니다.",
  "text_exchange_and_return_item_return_due_date": "반품 기한 : {YYYY/MM/DD}",
  "text_exchange_form_about_exchange_application": "교환 방법",
  "text_exchange_form_about_exchange_application_description": "교환 절차 진행 방법은 교환 요청 제품을 주문 및 결제 후 최초 주문 제품을 반품하는 형태로 진행이 됩니다.",
  "text_exchange_form_about_exchange_application_refund_description_01": "교환 제품의 발송을 위해, 제품에 대한 결제가 먼저 진행되며, 결제 완료 후 최초 구매 제품의 반품신청 절차가 진행 됩니다.",
  "text_exchange_form_about_exchange_application_refund_description_02": "최초 구매 제품은 검수 후 환불처리 됩니다.",
  "text_exchange_form_add_another_exchange_item": "그 외 수량 교환 추가",
  "text_exchange_form_available_exchange_item_description": "동일한 제품번호 안에서 색상 및 사이즈 변경만 신청 가능합니다.",
  "text_exchange_form_available_payment_method_description": "결제는 신용카드만 가능합니다.",
  "text_exchange_form_exchange_application": "교환 신청",
  "text_exchange_form_exchange_item_information": "교환 받으실 새 제품",
  "text_exchange_form_exchange_reason_title": "교환 이유",
  "text_exchange_form_number_of_rest_item_total_quantity": "합계",
  "text_exchange_form_original_item_information": "구매하신 제품",
  "text_exchange_form_other_exchange_reason_view_information": "수령하신 상품에 문제가 있거나, 기타 교환조건의 확인은 여기를 눌러 주세요.",
  "text_exchange_form_please_select_exchnge_reason": "교환 이유를 선택해 주세요",
  "text_exchange_form_proceed_exchange_application": "교환 제품 및 사유 선택",
  "text_exchange_form_select_exchange_item": "색상 및 사이즈 선택",
  "text_exchange_form_select_exchange_item_detail": "교환 받으실 제품의 색상, 사이즈, 수량을 선택해 주세요.",
  "text_exchange_form_unavailable_exchange_item_description": "죄송합니다. 이 상품은 현재 교환 가능한 재고가 없습니다.",
  "text_exchange_form_unavailable_exchange_item_description_return_application": "다른 상품으로 교환을 원하시는 경우 반품 후 신규로 구매해 주시기 바랍니다.",
  "text_exchange_form_unavailable_exchange_item_image_description": "교환 가능한 색상 또는 사이즈가 없습니다",
  "text_exchange_form_unavailable_exchange_item_request_return_application": "이 제품을 반품 / 교환",
  "text_exchange_form_unavailable_exchange_item_view_faq": "질문 혹은 어려운 부분 있으시면 여기를 클릭하여 문의하여 주시기 바랍니다",
  "text_warning_exchange_form_not_selected_exchange_item": "교환 받으실 제품의 색상, 사이즈를 선택해 주세요.",
  "text_warning_exchange_form_selected_exchange_item_same_with_originally_ordered_item": "구매 제품과 동일한 색상과 사이즈는 선택할 수 없습니다.",
  "text_exchange_and_return_form_back_to_previous": "뒤로",
  "text_exchange_and_return_form_error_exchange_multibuy_description": "세트 할인 제품은 반품과 교환을 동시에 신청할 수 없습니다. 자세한 내용은 FAQ를 확인해 주세요.",
  "text_exchange_and_return_form_unavailable_application_mutibuy_items": "세트할인제품의 반품 / 교환에 대해",
  "text_return_form_check_selection_details_button": "선택내용 확인",
  "text_exchange_and_return_form_exchange_requested_item_return_customer_reason": "고객변심일 경우",
  "text_exchange_and_return_form_exchange_requested_item_return_customer_reason_button": "이 상품을 반품",
  "text_exchange_and_return_form_exchange_requested_item_return_customer_reason_description": "「이 상품을 반품」을 선택하신 후 다음 페이지에서 수량을 선택해 주세요.",
  "text_exchange_and_return_form_exchange_requested_item_return_fault_in_service": "상품에 문제가 있을 경우(오염 등)",
  "text_exchange_and_return_form_exchange_requested_item_return_fault_in_service_button": "상품에 문제가 있는 경우 문의",
  "text_exchange_and_return_form_exchange_requested_item_return_fault_in_service_description": "상품의 얼룩, 배송 지연 등의 문제로 인한 반품의 경우 아래 링크로 연락 부탁드립니다.",
  "text_exchange_and_return_form_exchange_requested_item_return_item_number_description": "반품 상품을 선택 후, 반품 요청을 진행합니다.",
  "text_return_form_about_return_application": "반품 신청 진행",
  "text_return_form_about_return_application_description": "다음 페이지에서 반품 수량 및 사유를 선택해 주세요.",
  "text_return_form_proceed_return_application": "반품 제품 및 사유 선택",
  "text_exchange_and_return_check_application_detail": "다음 단계로",
  "text_exchange_and_return_form_coupon_restriction_alternative_exchange": "쿠폰 적용 제품의 교환 신청 방법 안내",
  "text_exchange_and_return_form_error_message_confirm_exchange_application": "죄송합니다. 쿠폰이 적용된 상품의 결제가 포함되어, 이 화면에서는 교환 신청이 불가합니다.",
  "text_exchange_and_return_form_error_message_contact_customer_support_center": "쿠폰이 적용된 상품의 교환 신청 방법에 대해서는 아래 버튼을 통해 확인 부탁드립니다.",
  "text_exchange_and_return_form_error_messsage_apply_exchange": "이 화면에서는 교환 신청이 불가합니다.",
  "text_exchange_and_return_form_exchange_item_already_added_message": "남은 수량을 추가로 선택하시는 경우 선택내역을 취소하신 후 다시 신청해 주시기 바랍니다.",
  "text_exchange_and_return_form_exchange_item_already_added_message_title": "교환 대상 상품 이미 선택되었습니다.",
  "text_exchange_and_return_form_incomplete_application": "[반품 / 교환] 진행 중인 주문 확인",
  "text_exchange_and_return_form_incomplete_application_description_01": "아래 주문번호의 [반품/교환] 신청이 완료되지 않았습니다.",
  "text_exchange_and_return_form_incomplete_application_description_02": "[반품 / 교환] 신청 중인 주문 건이 있습니다.",
  "text_exchange_and_return_form_incomplete_application_title": "[반품 / 교환] 신청 중인 주문 건이 있습니다",
  "text_exchange_and_return_form_request_additional_exchange_and_return_description": "추가로 제품의 반품 또는 교환을 희망하시는 경우, 이 페이지에서 계속해서 제품을 선택해 주세요.",
  "text_exchange_and_return_form_return_item_already_added_message": "남은 수량을 추가로 선택하시는 경우 선택내역을 취소하신 후 다시 신청해 주시기 바랍니다.",
  "text_exchange_and_return_form_return_item_already_added_message_title": "해당 상품은 이미 반품 선택 되어 있습니다.",
  "text_exchange_and_return_form_unavailable_application_alternative_requests": "그외 신청방법에 대해",
  "text_exchange_and_return_form_unavailable_application_following_reason": "다음과 같은 이유일 수 있습니다.",
  "text_exchange_and_return_form_unavailable_application_please_contact_customer_service": "고객센터로 문의해 주시기 바랍니다.",
  "text_exchange_and_return_form_unavailable_exchange_application_reason_01": "세트구매 상품은 한 번만 교환 및 반품이 가능합니다.",
  "text_exchange_and_return_form_unavailable_exchange_application_reason_02": "이미 교환하신 상품은 추가로 교환 신청이 불가합니다.",
  "text_exchange_and_return_form_unavailable_exchange_application_reason_03": "수선상품은 신청이 불가합니다.",
  "text_exchange_and_return_form_unavailable_exchange_application_reason_04": "이미 재출고된 상품은 신청이 불가합니다.",
  "text_exchange_and_return_form_unavailable_exchange_application_reason_05": "제품결함의 이유로 반품을 선택 중",
  "text_exchange_and_return_form_unavailable_return_application_reason_01": "세트구매 상품은 한 번만 교환 및 반품이 가능합니다.",
  "text_exchange_and_return_form_unavailable_return_application_reason_02": "이미 교환하신 상품은 추가로 교환 신청이 불가합니다.",
  "text_exchange_and_return_form_unavailable_return_application_reason_03": "세트할인 적용된 상품중 이미 교환,반품 완료된 경우 반품진행이 불가합니다.",
  "text_exchange_form_canceling_exchange_button": "교환접수취소",
  "text_exchange_form_canceling_exchange_message_01": "이 상품의 교환을 취소하시겠습니까?",
  "text_exchange_form_canceling_exchange_message_02": "취소 시 입력하신 정보가 삭제됩니다.",
  "text_exchange_form_exchanged_item": "교환 상품",
  "text_exchange_form_quantity": "교환 수량",
  "text_exchange_form_unavailable_exchange_application": "이 화면에서는 교환 신청을 할 수 없습니다",
  "text_return_form_unavailable_return_application": "이 화면에서는 반품 신청이 불가합니다.",
  "text_exchange_form_cancel_exchange": "선택 해제",
  "text_exchange_form_exchange_item_count": "교환 받으실 제품: {num} 개",
  "text_exchange_and_return_form_error_message_item_out_of_stock_01": "죄송합니다. 일부 품절 제품이 있습니다.",
  "text_exchange_and_return_form_error_message_item_out_of_stock_02": "죄송합니다. 현재 교환 가능한 재고가 없습니다. 제품을 삭제해 주세요.",
  "text_exchange_and_return_form_unavailable_application_alternative_return": "반품관련 FAQ",
  "text_exchange_form_exchange_reason": "교환 이유",
  "text_exchange_and_return_form_select_application_detail": "신청내용을 선택",
  "text_exchange_and_return_form_select_exchange_application": "교환",
  "text_exchange_and_return_form_select_return_application": "반품",
  "text_exchange_and_return_form_exchange_requested_item_return_item_number": "반품 수량",
  "text_return_form_return_label_send_to_registered_email_description": "반품 확인용 이메일에도 QR 코드는 포함되어 있습니다:{emailAddress}",
  "text_return_method_print_label_return_instruction_01": "반품 라벨 다운로드 후 인쇄",
  "text_return_method_print_label_return_instruction_02": "상품과 주문확인서를 동봉하여 박스에 포장",
  "text_return_method_print_label_return_instruction_02_sub_description_01": "상품의 상태는 최초 포장된 상태및 Tag 미제거",
  "text_return_method_print_label_return_instruction_03": "Put the shipping label on the box and send it back with FedEx or USPS.",
  "text_return_form_return_method_print_label_title": "Print label (FedEx & USPS drop-off)",
  "text_return_form_confirm_return_method": "반송 방법 확인",
  "text_return_method_print_label_return_instruction_03_sub_description_01": "반품배송비 3,000원은 환불 금액에서 차감됩니다.",
  "text_return_form_confirm_how_to_return": "반송 방법 확정",
  "text_return_form_prepare_by_handwriting": "메모 직접 기입",
  "text_return_form_print_and_prepare": "반품 번호 인쇄",
  "text_exchange_and_return_form_item_return_due_date": "반송 기한",
  "text_return_form_confirmation_before_exchange_and_return": "반품 전 확인",
  "text_returns_and_exchanges_title": "반품 / 교환",
  "text_return_form_return_method_fedex_qr_code_button": "QR code (FedEx drop-off only)",
  "text_return_method_print_label_download_shipping_label_description": "반품 라벨 다운로드 및 인쇄",
  "text_fedex_drop_off_service": "FedEx - Drop off service",
  "text_fedex_qr_code_easy_return": "FedEx - QR code easy return",
  "text_participating_fedex_ship_center": "Participating FedEx location\n(Walgreens, etc.)",
  "text_return_application_in_store_purchase_faq_link": "매장 구매 상품의 반품에 대해",
  "text_return_form_fedex_find_location": "Find FedEx locations",
  "text_return_form_fedex_find_location_description": "Please select \"Drop off\" for a drop-off location.",
  "text_return_form_fedex_qr_code_send_to_registered_email_description": "The QR code is also attached and send to your registered email address\n: {eMailAddress}",
  "text_return_form_find_fedex_location_qr_code_easy_return": "Find FedEx - QR code easy return locations",
  "text_return_form_return_method_fedex_qr_code_description": "Bring the QR code and only all your items to a FedEx. The FedEx store will pack, label and ship your items.",
  "text_return_form_return_method_fedex_qr_code_title": "QR code (FedEx drop-off)",
  "text_return_form_usps_find_location": "Find USPS locations",
  "text_return_method_fedex_qr_code_return_instruction_01": "Save the QR code below on your mobile phone.",
  "text_return_method_fedex_qr_code_return_instruction_02": "Gather all your items together.",
  "text_return_method_fedex_qr_code_return_instruction_02_sub_description_01": "Including the original product packaging and tags.",
  "text_return_method_fedex_qr_code_return_instruction_03": "Bring the QR code and your items to a Fedex store. The FedEx store will pack, label, and ship your items.",
  "text_return_method_fedex_qr_code_return_instruction_03_sub_description_01": "Your prepaid label costs $7 (deducated from your return's total).",
  "text_return_form_return_method_print_label_button": "Print label (FedEx & USPS drop-off)",
  "text_return_form_select_return_method": "반송 방법을 선택해 주세요",
  "text_exchange_and_return_form_remove_out_of_stock_product": "교환 가능한 재고가 없는 제품을 삭제했습니다.",
  "text_exchange_and_return_form_remove_selected_product": "선택제품을 삭제했습니다.",
  "text_exchange_and_return_form_multibuy_note_01": "세트할인된 제품입니다",
  "text_exchange_and_return_form_multibuy_note_02": "세트할인제품은 반품 또는 교환 신청 후, 재차 반품 / 교환이 불가합니다.",
  "text_exchange_and_return_form_multibuy_note_03": "세트할인제품은 반품과 교환을 동시에 신청할 수 없습니다.",
  "text_exchange_form_select_exchange_item_note": "‐ 교환 가능한 색상 및 사이즈만 표시됩니다.\n- 품절된 경우, 반품만 가능합니다.\n- 제품 불량의 경우 반품 후 재구매 부탁드립니다.",
  "text_return_form_return_label_send_to_registered_email_address_note": "구매 시점 이메일 주소로, 반품 확인 안내 메일이 전송됩니다.",
  "text_error_return_form_backto_request_form_button": "신청화면으로 돌아가기",
  "text_error_return_form_return_item_coupon_unavailable_amount_message": "쿠폰적용조건을 벗어나므로 반품신청이 불가합니다. 관련 문의는 고객센터로 연락 주시기 바랍니다.",
  "text_error_return_form_unavailable_return_request_title": "반품을 신청할 수 없습니다.",
  "text_return_form_alterations_note": "text_return_form_alterations_note",
  "text_select_category": "카테고리",
  "text_select_class": "등급",
  "text_select_gender": "성별",
  "text_storesearch_sampletext": "매장명, 지역, 주소",
  "text_new_color_pattern": "컬러, 패턴",
  "text_special_price": "기간 한정",
  "text_flower_summer_delivery_note_product_details": "text_flower_summer_delivery_note_product_details",
  "text_app_flower_delivery_area_message_01": "text_app_flower_delivery_area_message_01",
  "text_flower_summer_delivery_notes_cart": "text_flower_summer_delivery_notes_cart",
  "text_flower_about_uniqlo_flower_delivery_link": "text_flower_about_uniqlo_flower_delivery_link",
  "text_flower_summer_delivery_notes_add_to_cart": "text_flower_summer_delivery_notes_add_to_cart",
  "text_flower_summer_delivery_notes_product_details_notes": "text_flower_summer_delivery_notes_product_details_notes",
  "text_flower_summer_delivery_notes_review_order": "text_flower_summer_delivery_notes_review_order",
  "text_error_flower_agreement_required": "text_error_flower_agreement_required",
  "text_flower_agreement_check_box": "text_flower_agreement_check_box",
  "text_flower_agreement_check_box_failed_season_information": "text_flower_agreement_check_box_failed_season_information",
  "text_flower_unattended_delivery_applied_message": "text_flower_unattended_delivery_applied_message",
  "text_flower_unattended_delivery_settings_turn_on": "text_flower_unattended_delivery_settings_turn_on",
  "text_flower_summer_delivery_notes_unattended_delivery": "text_flower_summer_delivery_notes_unattended_delivery",
  "text_flower_unattended_specify_delivery_message": "text_flower_unattended_specify_delivery_message",
  "text_app_flower_purchese_restriction_delivery_area_message_01": "text_app_flower_purchese_restriction_delivery_area_message_01",
  "text_app_flower_notes_message_04": "text_app_flower_notes_message_04",
  "text_fr": "프랑스",
  "text_displayed_based_on_act_of_specified_commecial_transaction": "특정 상거래법에 따른 표시",
  "text_do_not_sell_personal_info_link": "쿠키 설정",
  "text_return_policy": "반품 정책",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. All rights reserved.",
  "text_copyright_gu": "Copyright © G.U. CO., Ltd. 모든 권한 보유.",
  "text_fi": "text_fi",
  "text_ca": "캐나다",
  "text_be": "text_be",
  "text_de": "독일",
  "text_dk": "덴마크",
  "text_es": "스페인",
  "text_it": "이탈리아",
  "text_lu": "text_lu",
  "text_nl": "네덜란드",
  "text_pl": "text_pl",
  "text_se": "스웨덴",
  "text_uk": "영국",
  "text_copyright_uq": "Copyright © UNIQLO Co., Ltd. 모든 권한 보유.",
  "text_careers": "채용 정보",
  "text_company_info": "기업 정보",
  "text_company_registartion": "text_company_registartion",
  "text_group_companies": "그룹사",
  "text_sustainability": "지속 가능성",
  "text_terms_of_service": "서비스 약관",
  "text_termsofuse": "이용약관",
  "text_UQ_webnews": "UNIQLO 소식",
  "text_at": "text_at",
  "text_au": "호주",
  "text_bg": "text_bg",
  "text_cn": "중국",
  "text_cz": "text_cz",
  "text_ee": "text_ee",
  "text_eu": "EU",
  "text_gr": "text_gr",
  "text_hk": "홍콩 및 마카오",
  "text_hr": "text_hr",
  "text_hu": "text_hu",
  "text_id": "인도네시아",
  "text_ie": "text_ie",
  "text_jp": "일본",
  "text_kr": "한국",
  "text_lt": "text_lt",
  "text_lv": "text_lv",
  "text_my": "말레이시아",
  "text_ph": "필리핀",
  "text_pt": "text_pt",
  "text_ro": "text_ro",
  "text_ru": "러시아",
  "text_sg": "싱가포르",
  "text_si": "text_si",
  "text_sk": "text_sk",
  "text_th": "태국",
  "text_tw": "대만",
  "text_us": "미국",
  "text_personalization_for_you_title": "text_personalization_for_you_title",
  "text_device_version": "기기가 완전히 지원되지 않을 수 있습니다.",
  "text_backto_top": "HOME으로",
  "text_close": "닫기",
  "text_login_required": "로그인 필요",
  "text_vat_included": "text_vat_included",
  "text_cancel": "취소",
  "text_error_code": "오류 코드",
  "text_error_id": "오류 ID",
  "text_loading_translation": "text_loading_translation",
  "text_sort": "정렬 기준",
  "text_sort_clearfilters": "모두 지우기",
  "text_color_beige": "Beige",
  "text_color_black": "Black",
  "text_color_brown": "Brown",
  "text_color_green": "Green",
  "text_color_orange": "Orange",
  "text_color_pink": "Pink",
  "text_color_purple": "Purple",
  "text_color_red": "Red",
  "text_color_white": "White",
  "text_color_yellow": "Yellow",
  "text_deals": "판매 유형",
  "text_filter_price_range01": "10,000원 미만",
  "text_filter_price_range02": "10,000원 - 30,000원",
  "text_filter_price_range03": "30,000원 - 50,000원",
  "text_filter_price_range04": "50,000원 - 70,000원",
  "text_filter_price_range05": "70,000원 - 100,000원",
  "text_filter_price_range06": "100,000원 이상",
  "text_filter_price_range07": "10,000원 - 30,000원",
  "text_filter_price_range08": "30,000원 - 50,000원",
  "text_filter_price_range09": "50,000원 - 70,000원",
  "text_filter_price_range10": "70,000원 - 100,000원",
  "text_filter_price_range11": "100,000원 이상",
  "text_filter_price_range12": "금액 기준",
  "text_filter_price_range13": "금액 기준",
  "text_price": "가격",
  "text_sort_byadded_new": "최신순",
  "text_sort_byadded_old": "등록순",
  "text_locale_en": "English",
  "text_locale_fr": "Français",
  "text_cart": "장바구니",
  "text_gender_top": "{Gender} 가장 위 페이지",
  "text_menu": "Menu",
  "text_open_app": "APP으로 보기",
  "text_logout": "로그아웃",
  "text_wishlist": "위시리스트",
  "text_color": "컬러",
  "text_size": "사이즈",
  "text_multibuy": "세트할인",
  "text_locale_da": "Dansk",
  "text_locale_de": "Deutsch",
  "text_locale_es": "Español",
  "text_locale_it": "Italiano",
  "text_locale_nl": "Nederlands",
  "text_try_again": "다시 시도",
  "text_edit": "편집",
  "text_privte_mode_alert": "시크릿 모드를 통합 사이트 접속시 일부 서비스를 사용하지 못할 수 있습니다.",
  "text_no_image": "이미지 없음",
  "text_please_select": "선택하세요.",
  "text_next": "다음",
  "text_search": "검색",
  "text_country_switcher_en": "text_country_switcher_en",
  "text_country_switcher_ja": "text_country_switcher_ja",
  "text_langsettings": "언어",
  "text_apply_sort": "정렬 기준",
  "text_styling_promotion_hashtag": "프로모션",
  "text_color_blue": "Blue",
  "text_color_gray": "Gray",
  "text_color_other": "Other",
  "text_country_uqworldwide": "World of UNIQLO",
  "text_app_error_excessive_access_caption": "현재 접속량이 많습니다. 사이트 이용에 불편을 드려 죄송합니다. 잠시 후 다시 접속 부탁드리겠습니다.",
  "text_coupon_already_earned": "쿠폰이 이미 적용되었습니다.",
  "text_error_cart_merge": "일시적인 시스템 오류가 발생하였습니다. \n 결제 진행을 원하시면 [다시 시도]를 클릭해 주세요.",
  "text_error_cart_merge_description": "죄송합니다. 회원 등록이 완료되었지만 로그인하지 못했습니다. 다시 로그인 진행 부탁 드리겠습니다.",
  "text_error_cart_merge_title": "장바구니에 제품을 추가하지 못했습니다.",
  "text_error_credit_card_encryptionkey": "시스템 오류가 발생하였습니다. \n 신용카드 정보 재확인 또는 다른 신용카드를 사용해 주세요.",
  "text_error_credit_card_encryptionkey_field": "이 필드에는 오류가 있습니다. 수정하세요.",
  "text_error_excessive_access_message": "잠시 후 다시 시도하세요.",
  "text_login_request": "로그인 페이지로 이동하세요.",
  "text_maintenance_description": "불편을 드려 죄송합니다. 현재 점검 작업을 진행하고 있습니다. 최대한 빨리 복구하기 위해 노력하고 있습니다.",
  "text_maintenance_title": "곧 이용 가능합니다!",
  "text_oops": "죄송합니다!",
  "text_reload_page": "페이지를 새로고침하세요.",
  "text_system_error": "시스템 오류",
  "text_validation_error": "유효한 {column_name}을(를) 입력하세요.",
  "text_app_price_0": "0",
  "text_app_price_1990": "20",
  "text_app_price_2990": "30",
  "text_app_price_3990": "40",
  "text_app_price_490": "5",
  "text_app_price_4990": "50",
  "text_app_price_5990": "60",
  "text_app_price_6990": "70",
  "text_app_price_7990": "80",
  "text_app_price_8990": "90",
  "text_app_price_990": "10",
  "text_app_price_max": "최대",
  "text_class": "등급",
  "text_extendedsizes": "특별 사이즈",
  "text_filter_byothers": "다른 조건",
  "text_newitems": "NEW",
  "text_online_special": "온라인 단독",
  "text_online_store_inventory": "온라인스토어 재고",
  "text_show_out_of_stock_items": "품절 제품 표시",
  "text_sort_byhightprice": "가격 : 높은 순",
  "text_sort_bylowprice": "가격 : 낮은 순",
  "text_sort_bynew": "신상품 순",
  "text_sort_byrecommend": "추천 순",
  "text_style": "스타일",
  "text_sub_category": "하위 카테고리",
  "text_view_searchresult": "적용",
  "text_am": "오전",
  "text_brand_gu": "text_brand_gu",
  "text_brand_uq": "UNIQLO",
  "text_change01": "수정",
  "text_change1": "수정",
  "text_change2": "수정",
  "text_currency_name": "미국 달러",
  "text_deleted": "삭제됨",
  "text_error_location_service_unavailable": "위치 서비스가 비활성화되었습니다. 기기 설정에서 위치 서비스를 활성화하세요.",
  "text_goto_settings": "설정하기",
  "text_internet_connected": "인터넷에 연결됨",
  "text_loading": "불러오는 중…",
  "text_no_internet_connection": "인터넷에 연결되지 않음",
  "text_pm": "오후",
  "text_retry": "다시 시도",
  "text_use_my_location": "내 위치 정보 사용",
  "text_continue_email_verification": "이메일 주소 확인",
  "text_login_with_another_account": "다른 계정으로 로그인",
  "text_coming_soon": "판매예정",
  "text_promotion": "프로모션",
  "text_country_austria_english": "Austria",
  "text_country_belgium_dutch": "België",
  "text_country_belgium_english": "Belgium",
  "text_country_belgium_french": "Belgique",
  "text_country_bulgaria_english": "Bulgaria",
  "text_country_croatia_english": "Croatia",
  "text_country_czech_republic_english": "Czech Republic",
  "text_country_denmark_english": "Denmark",
  "text_country_estonia_english": "Estonia",
  "text_country_finland_english": "Finland",
  "text_country_france_english": "France",
  "text_country_france_french": "France",
  "text_country_germany_english": "Germany",
  "text_country_germany_german": "Deutschland",
  "text_country_greece_english": "Greece",
  "text_country_hungary_english": "Hungary",
  "text_country_ireland_english": "Ireland",
  "text_country_italy_english": "Italy",
  "text_country_italy_italian": "Italia",
  "text_country_latvia_english": "Latvia",
  "text_country_lithuania_english": "Lithuania",
  "text_country_luxembourg_english": "Luxembourg",
  "text_country_netherlands_dutch": "Nederland",
  "text_country_netherlands_english": "Netherlands",
  "text_country_poland_english": "Poland",
  "text_country_portugal_english": "Portugal",
  "text_country_romania_english": "Romania",
  "text_country_slovakia_english": "Slovakia",
  "text_country_slovenia_english": "Slovenia",
  "text_country_spain_english": "Spain",
  "text_country_spain_spanish": "España",
  "text_country_sweden_english": "Sweden",
  "text_country_united_kingdom_english": "United Kingdom",
  "text_locale_ca": "Català",
  "text_locale_ja": "日本語",
  "text_locale_jp": "日本語",
  "text_locale_ko": "한국어",
  "text_locale_kr": "한국어",
  "text_locale_sp_zh": "中文 (简体)",
  "text_locale_sv": "Svenska",
  "text_locale_th": "ไทย",
  "text_locale_tw_zh": "中文 (繁體)",
  "text_locale_zh": "中文",
  "text_select_country_and_language": "국가/지역 및 언어 선택",
  "text_locale_id": "Bahasa Indonesia",
  "text_locale_vi": "Tiếng Việt",
  "text_ticker1": "신규 고객을 위한 첫 주문 무료 배송!",
  "text_ticker2": "재구매 고객 30,000원 이상 구매 시 무료배송",
  "text_share_facebook": "Facebook에 공유",
  "text_share_twitter": "Twitter에 공유",
  "text_sns_accounts": "공식 SNS 계정",
  "text_error_ph_guest_checkout_guest_id": "text_error_ph_guest_checkout_guest_id",
  "text_guest_checkout_backto_cart_button": "text_guest_checkout_backto_cart_button",
  "text_guest_checkout_backto_edit_email_button": "text_guest_checkout_backto_edit_email_button",
  "text_guest_checkout_continue_button": "text_guest_checkout_continue_button",
  "text_guest_checkout_enter_guest_email_description": "text_guest_checkout_enter_guest_email_description",
  "text_guest_checkout_order_status_description": "text_guest_checkout_order_status_description",
  "text_guest_checkout_order_status_title": "text_guest_checkout_order_status_title",
  "text_guest_checkout_preview_button": "text_guest_checkout_preview_button",
  "text_guest_checkout_preview_description_01": "text_guest_checkout_preview_description_01",
  "text_guest_checkout_preview_description_02": "text_guest_checkout_preview_description_02",
  "text_guest_checkout_preview_subtitle": "text_guest_checkout_preview_subtitle",
  "text_guest_checkout_registration_completed_description": "text_guest_checkout_registration_completed_description",
  "text_guest_checkout_registration_completed_title": "text_guest_checkout_registration_completed_title",
  "text_guest_checkout_title": "text_guest_checkout_title",
  "text_ph_guest_checkout_guest_id": "text_ph_guest_checkout_guest_id",
  "text_ph_guest_checkout_guest_id_hint_text": "text_ph_guest_checkout_guest_id_hint_text",
  "text_guest_checkout_guest_id_title": "text_guest_checkout_guest_id_title",
  "text_guest_checkout_order_completed_description": "text_guest_checkout_order_completed_description",
  "text_guest_checkout_order_completed_membership_benefit_description_01": "text_guest_checkout_order_completed_membership_benefit_description_01",
  "text_guest_checkout_order_completed_membership_benefit_description_02": "text_guest_checkout_order_completed_membership_benefit_description_02",
  "text_guest_checkout_order_completed_membership_benefit_description_03": "text_guest_checkout_order_completed_membership_benefit_description_03",
  "text_guest_checkout_order_completed_new_registration_button": "text_guest_checkout_order_completed_new_registration_button",
  "text_guest_checkout_order_completed_new_registration_description": "text_guest_checkout_order_completed_new_registration_description",
  "text_guest_checkout_order_completed_new_registration_title": "text_guest_checkout_order_completed_new_registration_title",
  "text_error_guest_checkout_cart_merge": "text_error_guest_checkout_cart_merge",
  "text_error_guest_checkout_guest_id": "text_error_guest_checkout_guest_id",
  "text_uqlogo": "UQ 로고",
  "text_image_search_outfit_filter_height_021": "175cm 이상",
  "text_image_search_change_image_link": "이미지를 변경하고 다시 검색",
  "text_image_search_image_upload_button": "이미지 업로드",
  "text_image_search_item_tab": "제품",
  "text_image_search_message_01": "업로드한 이미지와 유사한 제품이나 아웃핏을 검색할 수 있습니다.",
  "text_image_search_no_result_check_uploaded_image": "개인정보등이 포함된 이미지는 첨부되지 않도록 전송전 확인 부탁 드립니다.",
  "text_image_search_no_result_request_to_send_uploaded_image": "“서비스 개선“을 위해 협조 부탁 드립니다",
  "text_image_search_no_result_request_to_send_uploaded_image_description": "“이미지 검색 서비스“ 개선을 위해 이미지 제공이 가능하시며, 이미지 전송 부탁 드립니다.",
  "text_image_search_no_result_send_uploaded_image": "이미지 전송",
  "text_image_search_no_result_terms_of_use": "{link} 통하여 보다 자세한 정보 확인 가능 하십니다.",
  "text_image_search_no_results_message_01": "이미지 검색 결과가 없습니다.",
  "text_image_search_no_search_result_tips01": "전체 제품이 사진에 있는지 확인하세요.",
  "text_image_search_no_search_result_tips02": "제품이 명확하게 보이는지 확인하세요.",
  "text_image_search_no_search_result_tips03": "다른 사진을 사용해 보세요.",
  "text_image_search_outfit_tab": "아웃핏",
  "text_image_search_result_number": "{count}개 제품",
  "text_image_search_no_result_send_uploaded_image_complete_thanks": "이미지를 전송했습니다. 감사합니다.",
  "text_image_search_description_01": "이미지로 제품을 검색할 수 있습니다.",
  "text_error_image_search_upload_description": "죄송합니다. 시스템 일시적 오류가 발생했습니다. 다른 사진을 통해서 확인 부탁 드립니다.",
  "text_image_search_category_accessories": "액세서리",
  "text_image_search_category_bags": "가방",
  "text_image_search_category_bottoms": "하의",
  "text_image_search_category_dress": "드레스",
  "text_image_search_category_eyewear": "안경",
  "text_image_search_category_hats": "모자",
  "text_image_search_category_outerwears": "겉옷",
  "text_image_search_category_sandal": "샌들",
  "text_image_search_category_shoes": "신발",
  "text_image_search_category_skirts": "스커트",
  "text_image_search_category_tops": "상의",
  "text_image_search_outfit_filter_height_001": "60cm 이하",
  "text_image_search_outfit_filter_height_002": "60cm - 70cm",
  "text_image_search_outfit_filter_height_003": "70cm - 80cm",
  "text_image_search_outfit_filter_height_004": "80cm - 90cm",
  "text_image_search_outfit_filter_height_005": "90cm - 100cm",
  "text_image_search_outfit_filter_height_006": "100cm - 110cm",
  "text_image_search_outfit_filter_height_007": "110cm - 120cm",
  "text_image_search_outfit_filter_height_008": "120cm - 130cm",
  "text_image_search_outfit_filter_height_009": "130cm - 140cm",
  "text_image_search_outfit_filter_height_010": "140cm - 150cm",
  "text_image_search_outfit_filter_height_011": "150cm - 155cm",
  "text_image_search_outfit_filter_height_012": "155cm - 160cm",
  "text_image_search_outfit_filter_height_013": "160cm - 165cm",
  "text_image_search_outfit_filter_height_014": "165cm - 170cm",
  "text_image_search_outfit_filter_height_015": "170cm - 175cm",
  "text_image_search_outfit_filter_height_016": "175cm - 180cm",
  "text_image_search_outfit_filter_height_017": "180cm - 185cm",
  "text_image_search_outfit_filter_height_018": "185cm 이상",
  "text_image_search_outfit_filter_height_019": "150cm 이하",
  "text_image_search_outfit_filter_height_020": "160cm 이하",
  "text_image_search_outfit_filter_height_022": "160cm 이상",
  "text_image_search_sort_latest": "NEW",
  "text_image_search_sorting_similarity": "유사성 우선",
  "text_image_search_meta_title": "이미지 검색｜UNIQLO",
  "text_image_search_searchbykeyword": "키워드로 검색",
  "text_image_search_search_tips": "검색 도움말",
  "text_image_search_meta_description": "제품과 아웃핏을 이미지로 검색할 수 있습니다. 이미지와 유사한 제품이나 아웃핏을 찾을 수 있습니다. 카테고리, 사이즈 또는 키와 같은 필터가 준비되어 있습니다.",
  "text_image_search_result_meta_description": "제품과 아웃핏을 이미지로 검색할 수 있습니다. 이미지와 유사한 제품이나 아웃핏을 찾을 수 있습니다. 카테고리, 사이즈 또는 키와 같은 필터가 준비되어 있습니다.",
  "text_image_search_result_meta_title": "이미지 검색 결과",
  "text_image_search_no_result_please_feedback": "고객님 요청에 대하여 답변드릴수 있도록, 자세한 설명으로 의견을 부탁드립니다.",
  "text_image_search_no_result_please_feedback_view_feedback_form": "의견 요청",
  "text_iq_chat_inquiry": "채팅 문의",
  "text_app_iq_chat_default_wording": "무엇을 도와드릴까요?",
  "text_address_book_address_search": "주소검색",
  "text_address_book_address_search_description": "주소 등록을 위해, 아래에서 주소를 검색해주세요.",
  "text_address_book_address_search_title": "주소검색",
  "text_address_book_search_again": "재검색",
  "text_error_address_search_message": "주소 불러오기 오류가 발생 했습니다. 주소지를 변경 부탁 드립니다.",
  "text_product_detail_kids_kc_mark_description": "본 제품은 공급자 적합성 확인대상 어린이 제품으로서 안전기준에 적합함을 확인했습니다.",
  "text_product_detail_baby_kc_mark_description": "본 제품은 안전 확인대상 어린이 제품으로서 안전기준에 적합함을 확인했습니다.",
  "text_app_home_navigation_description": "메뉴 / 제품\\n검색",
  "text_home_navigation_description": "메뉴 / 제품\\n검색",
  "text_cookie_usage_description": "UNIQLO.com에 액세스하고 자신의 정보를 수정하지 않고 탐색하면 고객은 쿠키 또는 유사한 기술의 사용을 수락하게 됩니다. 이에 따라 당사는 관심사에 맞는 최적의 서비스와 제안을 제공할 수 있지만, 무엇보다 당사 웹사이트에서 더 안전한 경험을 고객에게 제공할 수 있게 됩니다. 자세한 내용은 개인정보 처리방침을 확인하세요.",
  "text_cookie_usage": "쿠키 사용",
  "text_l1_tab_baby": "BABY",
  "text_l1_tab_home": "HOME",
  "text_l1_tab_kids": "KIDS",
  "text_l1_tab_men": "MEN",
  "text_l1_tab_women": "WOMEN",
  "text_app_welcome_coupon_description": "지금 온라인 스토어 가입까지 완료하면 쿠폰이 기다리고 있어요\n *신규 회원에 한하며, APP 기존 설치 이력 있을 시 제외",
  "text_app_welcome_coupon_login": "로그인하고 쿠폰 받기",
  "text_app_welcome_coupon_skip": "건너뛰기",
  "text_app_welcome_coupon_title": "신규 회원에게 드리는 특별한 쿠폰 혜택!",
  "text_app_home_membership_description": "마이 페이지ㆍ\\n구매 내역",
  "text_view_featuredcollections": "모든 특별 제품",
  "text_wishlist_recently_viewed_app_membership_limited_offer_list_title": "APP회원 전용 특별 가격으로 제공되는 제품",
  "text_item_preorder": "예약판매",
  "text_item_preorder_and_resale": "재입고 예약판매",
  "text_item_preorder_color_size_only": "예약판매 (일부컬러/사이즈)",
  "text_item_resale": "재입고",
  "text_item_resale_color_size_only": "재입고 예약판매 (일부컬러/사이즈)",
  "text_kids": "KIDS",
  "text_women": "WOMEN",
  "text_unable_purchase_product_note": "현재 구매한 제품과 비교 기능을 표시할 수 없습니다. 불편을 끼쳐 죄송합니다.",
  "text_limitedoffers": "기간 한정 가격",
  "text_limitedoffers_description": "인기 아이템이 기간한정 할인 행사중! 지금 경제적 가격으로 제품을 구입 가능 하십니다.",
  "text_limitedoffers_recommend": "추천 제품",
  "text_thisweek_markdown_items": "주간 할인",
  "text_no_multibuy": "현재 세트할인이 없습니다.",
  "text_weekly_newarrivals": "이번 주 신제품:",
  "text_app_home_videobutton_description": "영상 재생ㆍ\\n정지",
  "text_topselling_ranking": "최고 판매 순위",
  "text_overview": "제품 설명",
  "text_product_detail": "제품 상세",
  "text_remarks": "비고",
  "text_shipping_without_tax": "배송비",
  "text_size_compare_with_purchase_product": "사이즈 차트 / 비교",
  "text_viewsizechart": "사이즈 차트",
  "text_rating": "평점",
  "text_storesearch_results": "검색 결과",
  "text_product_detail_supply_information": "배송 / 결제 정보",
  "text_product_detail_return_and_exchange": "교환 / 반품 안내",
  "text_product_detail_check_functionality_test_method_link": "기능성 시험방법 확인",
  "text_customer_service_phone_number": "1544-3178",
  "text_item_company_name": "에프알엘코리아 주식회사",
  "text_item_quality_assurance_standard_note_01": "· 본 제품은 철저한 품질관리와 공정관리를 거쳐 생산되었으며, 엄격한 검사에 합격한 제품입니다.",
  "text_item_quality_assurance_standard_note_02": "· 제품에 표시되어 있는 섬유 혼용율, 치수, 세탁법을 착용 전에 반드시 확인해 주십시오.",
  "text_item_quality_assurance_standard_note_03": "· 만약 품질에 이상이 있어 피해보상을 원하실 때는 유니클로 고객센터로 연락하여 주십시오.",
  "text_item_quality_assurance_standard_note_04": "· 본 제품의 품질보증기간은 구입일로부터 1년입니다.",
  "text_product_detail_check_detail_information_description": "상세 정보는 각 링크에서 확인 부탁 드립니다.",
  "text_product_detail_check_my_size": "사이즈 확인하기",
  "text_product_detail_safety_confirmation_report_label": "안전확인 신고확인증 번호:{ItemNumber}",
  "text_about_alterations": "수선에 대하여",
  "text_error_quantity_limit_item_added": "구매 수량 제한으로 인해 장바구니에 제품을 추가할 수 없습니다. 수량을 확인하세요.",
  "text_item_manufacture_month_and_year": "제조연월",
  "text_order_and_pick_receive_soon_at_store_link": "ORDER & PICK (당일픽업)",
  "text_product_description": "제품 상세 설명",
  "text_subtotal_without_tax": "합계",
  "text_top_display": "상단표시",
  "text_quantity": "수량",
  "text_purchase_quantity_limit_color": "이 제품은 컬러별 {color_upper_limit}개까지 구매 가능합니다.",
  "text_purchase_quantity_limit_product": "이 제품은 총{product_upper_limit}개까지 구매 가능합니다.",
  "text_purchase_quantity_limit_product_color": "이 제품은 컬러별 {color_upper_limit}개, 총{product_upper_limit}개까지 구매 가능합니다.",
  "text_alteration_position": "({position}) 수선서비스 신청",
  "text_viewmore": "더 보기",
  "text_requireditem": "필수 항목",
  "text_newer_items_title": "NEW 시즌 제품",
  "text_yes": "예",
  "text_notshow_again": "이 메시지를 다시 표시하지 않음",
  "text_search_faq": "고객센터",
  "text_search_image": "이미지검색",
  "text_search_store": "매장 찾기",
  "text_no_review_search_result": "검색과 일치하는 결과가 없습니다.",
  "text_search_annotation1": "위치 서비스를 활성화한 후 페이지를 새로고침하세요.",
  "text_search_annotation2": "위치 서비스를 사용할 수 없는 경우 키워드, 우편번호를 입력하거나 리스트에서 주를 선택하여 매장을 검색하세요.",
  "text_sizechart": "사이즈 차트",
  "text_sleeve_alteration": "슬리브 수선",
  "text_outofstock": "품절",
  "text_back_order_may_happen": "이 제품의 배송은 최대 1주일 지연될 수 있습니다.",
  "text_nickname": "별명",
  "text_ph_choose": "선택되지 않음",
  "text_residence": "위치",
  "text_ph_review_title": "제목을 입력해주세요.",
  "text_other": "기타",
  "text_weight": "몸무게",
  "text_purchased_size": "구매 사이즈",
  "text_4outof5": "별 5 개 중 4 개",
  "text_tight": "작다",
  "text_truetosize": "딱맞다",
  "text_write_review": "리뷰 작성",
  "text_returnto_pdp": "제품 페이지로 돌아가기",
  "text_list_of_product_add_to_cart_area_styling_of_this_item": "이 제품의 스타일링",
  "text_back_order_will_happen": "이 제품의 배송은 최대 1주일 지연될 예정입니다.",
  "text_nearest_store_inventory": "가장 가까운 매장 재고",
  "text_search_annotation3": "매장 검색",
  "text_storenews_distribute": "매장 소식 리스트",
  "text_storesearchbycriteria": "키워드 또는 주 입력",
  "text_storesearchbycriteria_ca": "키워드 또는 주 입력",
  "text_description_availability": "5~10일 이내에 매장에서 사용 가능합니다.",
  "text_inseam_alteration": "안쪽 솔기 수선",
  "text_length_feeling": "길이감",
  "text_outofcolor_size": "죄송합니다. 이 제품의 모든 컬러와 사이즈가 품절되었습니다.",
  "text_quantity:": "수량:",
  "text_recommendtitle_youmaylike": "함께 본 제품",
  "text_return_refund_exchange": "반품 / 교환 / 환불",
  "text_returnto_search": "검색으로 돌아가기",
  "text_sewingmachine": "기계 스티치",
  "text_showingreviews": "{count}개 리뷰",
  "text_skirt_length": "스커트: 길이 조절",
  "text_sleevelength": "슬리브 길이:",
  "text_title_instagram": "Instagram에 게시",
  "text_view360": "360° 보기",
  "text_viewall": "모두",
  "text_viewstyling": "스타일링 제안",
  "text_order_and_pick_receive_soon_at_store_message_01": "{link} 주문 시 최단 1시간 안에 제품을 받아보실 수 있습니다.",
  "text_customer_service_phone_number_title": "고객센터 전화번호",
  "text_item_manufacturer_or_importer": "제조사/수입자",
  "text_item_quality_assurance_standard": "품질보증기준",
  "text_filter_search_results_review": "결과: {count}개 리뷰",
  "text_nickname_infoicon": "별명은 코멘트와 함께 자동으로 표시됩니다. 별명은 20자 이하여야 합니다. 공란으로 두면 별명이 표시되지 않습니다.",
  "text_no": "아니요",
  "text_ph_location": "시 또는 구",
  "text_purchasedsize": "구매 사이즈",
  "text_recommend_item": "이 제품을 추천하시겠습니까?",
  "text_regulation_texts": "사용 가능한 문구에 대한 규정은 여기를 참조하세요.",
  "text_reset": "재설정",
  "text_sort_bycriteria": "정렬 기준",
  "text_sort_bypostdate": "날짜로 필터링",
  "text_sort_byuseful": "유용한 리뷰로 필터링",
  "text_sort_byweight": "몸무게",
  "text_weight_over": "90kg 이상",
  "text_weight_under": "5kg 미만",
  "text_product_details_select_store_meta_description": "매장을 지정하면 해당 매장의 재고 확인이 가능합니다.",
  "text_login_guest_account_button": "text_login_guest_account_button",
  "text_login_guest_account_description": "text_login_guest_account_description",
  "text_login_guest_account_title": "text_login_guest_account_title",
  "text_login_guest_checkout_button": "text_login_guest_checkout_button",
  "text_login_guest_checkout_description": "text_login_guest_checkout_description",
  "text_login_guest_checkout_title": "text_login_guest_checkout_title",
  "text_ph_room_num": "상세주소(건물명 / 호)",
  "text_ph_street": "거리와 번호, 우편 사서함, c/o.",
  "text_memberinfo_edit": "회원정보 변경",
  "text_hint_about_house_number_notes": "text_hint_about_house_number_notes",
  "text_account": "회원정보",
  "text_onlinestore_orderhistory": "주문 내역",
  "text_memberinfo_profilesettings": "회원정보 설정",
  "text_memberinfo_detail": "회원 정보",
  "text_wishto_withdraw": "회원 탈퇴",
  "text_readmore": "더 읽어보기",
  "text_phone": "집 전화",
  "text_products": "제품",
  "text_styling": "스타일링",
  "text_city": "시",
  "text_creditcard_edit": "저장된 신용카드",
  "text_for_guappusers": "지유앱 사용하시는 분",
  "text_for_scandechance": "유니클로 온라인 스토어에서의 쇼핑은 대상에서 제외됩니다",
  "text_fullname": "이름, 성",
  "text_furigana": "후리가나",
  "text_prefecture": "주",
  "text_recent_orders": "최근 주문",
  "text_recent_purchase": "최근 구매",
  "text_recently_added_wishlist": "최근 위시리스트에 추가된 제품",
  "text_street": "주소 열 1",
  "text_edit_pw_link": "내 비밀번호 변경",
  "text_error_failed_add_wishlist": "위시리스트에 제품을 추가하지 못함",
  "text_error_failed_remove_wishlist": "위시리스트에서 제품을 삭제하지 못함",
  "text_error_wishlist_failed_product_info": "일시적인 오류",
  "text_error_wishlist_max": "제품 개수가 최대 한도인 999개에 초과했습니다. 이 제품을 추가하려면 위시리스트를 편집하세요.",
  "text_error_wishlist_product_unavailable": "일시적인 시스템 오류가 발생하였습니다.",
  "text_privte_mode_alert_wishlist": "시크릿 모드를 사용 중인 경우 위시리스트에 제품을 추가하지 못할 수 있습니다.",
  "text_remove_address": "주소 삭제",
  "text_select": "선택",
  "text_change_default_address_description": "기본 주소를 변경하시겠습니까?",
  "text_membership_home": "Home",
  "text_pickup_store": "픽업매장",
  "text_selected_coupon_redeem": "선택한 쿠폰을 사용하시겠습니까?",
  "text_apply_selected_store_coupons": "선택한 쿠폰 적용",
  "text_redeem_coupon_manually": "수동으로 쿠폰 사용(직원용)",
  "text_usecoupon_barcode_description": "쿠폰 사용을 원하시는 경우 결제 시 직원에게 회원 바코드를 제시해 주세요",
  "text_usecoupon_title": "쿠폰 사용",
  "text_usage_note": "주의 사항",
  "text_membership_edit_complete": "회원정보가 업데이트가 완료되었습니다.",
  "text_membership_edit_description": "회원정보가 업데이트 되었습니다.",
  "text_membership_edit_preview": "미리 보기",
  "text_membership_edit_update": "회원정보 업데이트",
  "text_common_menu_description": "해당 정보를 수정하시면 회원 정보가 업데이트됩니다.",
  "text_name": "이름",
  "text_membership_edit_submit": "제출",
  "text_filter_not_spefified": "모두",
  "text_size:": "사이즈:",
  "text_color:": "컬러:",
  "text_membership_info": "MY PAGE",
  "text_2nd_phone_number": "예비 전화번호",
  "text_canada_post": "Canada Post",
  "text_fedex_corporation": "FedEx",
  "text_japan_post": "Japan Post",
  "text_loginet_japan": "Loginet Japan",
  "text_lotte_global_logistics": "롯데택배",
  "text_sagawa_express": "Sagawa Express",
  "text_yamato_transport": "Yamato Transport",
  "text_productid_colon": "제품 번호:",
  "text_order_check": "장바구니 보기",
  "text_verification_two_factor_authentication": "2단계 인증",
  "text_error_verification_authentication_failed": "text_error_verification_authentication_failed",
  "text_error_verification_reissue_limit": "text_error_verification_reissue_limit",
  "text_deliveryticketid": "송장번호",
  "text_order_date": "주문일",
  "text_shipping_company": "배송업체",
  "text_total_includingtax": "총 결제 금액",
  "text_barcode_unavailable_description": "처리할 수 없습니다. 나중에 다시 시도하세요.",
  "text_barcode_unavailable_title": "바코드를 가져오지 못함",
  "text_browser_colon": "text_browser_colon",
  "text_date_colon": "text_date_colon",
  "text_device_colon": "text_device_colon",
  "text_ip_address_colon": "text_ip_address_colon",
  "text_membership_barcode": "매장에서 결제 시, 회원 바코드를 스캔해 주세요.",
  "text_membership_login_history": "text_membership_login_history",
  "text_membership_login_history_description": "text_membership_login_history_description",
  "text_membership_login_history_detail": "text_membership_login_history_detail",
  "text_provider_colon": "text_provider_colon",
  "text_removelinkage": "회원정보 연결 해제",
  "text_uq_gift_card_balance_expire_date_check": "UNIQLO 기프트 카드 잔액 확인",
  "text_addressbook_edit": "배송지",
  "text_membership_title_barcode": "회원 바코드",
  "text_mobilephone_number": "휴대폰",
  "text_receipt_store": "픽업 매장",
  "text_cancel_order": "이 주문 취소",
  "text_d_pay_order_cancelation_payment_not_complete": "{time}까지 결제가 완료되지 않으면 주문이 자동으로 취소됩니다.",
  "text_family_mart_pickup_notes01": "패밀리마트에서 패키지를 픽업하려면 픽업 및 인증 코드가 필요합니다.",
  "text_order_cancel_confirmation": "아래 주문을 취소하시겠습니까?",
  "text_order_cancel_confirmation_divided_delivery": "이 배송은 부분 주문입니다. 이 배송을 취소하면 나머지 주문도 취소됩니다.",
  "text_order_cancel_title": "주문 취소",
  "text_order_cancelled_description": "주문이 취소되었습니다.",
  "text_order_cancelled_title": "주문 취소",
  "text_order_history_check_delivery_status": "배송 조회",
  "text_orderhistory_results": "총 {total}개 주문 건 중 {count}개 표시됨",
  "text_pay_in_store_payment_completed": "결제 완료됨",
  "text_paypay_order_cancelation_payment_not_complete": "{time}까지 결제가 완료되지 않으면 주문이 자동으로 취소됩니다.",
  "text_pickup_lawson_ministop_notes03": "2. Loppi에 픽업 코드와 인증 코드를 입력하면 픽업 티켓이 발급됩니다.",
  "text_seven_eleven_pickup_notes01": "세븐일레븐에서 패키지를 픽업하려면 픽업 코드가 필요합니다.",
  "text_store_pickup_instruction01": "제품 수령 시 매장 직원에게 회원 바코드 또는 주문 번호를 제시해 주세요",
  "text_store_pickup_instruction02": "주문 내역 또는 안내 이메일에서 주문번호 확인이 가능합니다.",
  "text_no_orderhistory": "현재 구매 내역이 없습니다.",
  "text_order_cancel": "온라인스토어 주문 후 30분 이내만 주문 취소만 가능 합니다. 그 후 주문 취소는 불가하며, 제품 수령 후 반품으로 접수 부탁드립니다.",
  "text_returnto_order_history": "구매 내역으로 돌아가기",
  "text_orderhistory_detail": "주문 내역 세부정보",
  "text_orderhistory_details": "세부정보",
  "text_pay_at_store_payment_due_time": "결제 기한",
  "text_pay_in_store_payment_instruction01": "선택한 매장에서 이 바코드를 아래 시간까지 보여주고 결제를 완료하세요.",
  "text_pre_order_transaction_email_description_01": "이 주문은 예약판매 제품을 포함하고 있습니다. 제품 출고 시 메일로 안내드립니다.",
  "text_howto_pickup_family_mart": "패밀리마트에서 픽업하는 방법:",
  "text_howto_pickup_lawson_ministop": "로손/미니스톱에서 픽업하는 방법:",
  "text_howto_pickup_seven_eleven": "세븐일레븐에서 픽업하는 방법:",
  "text_order_settings_delivery_address_label": "지정 주소",
  "text_edit_address": "주소 수정",
  "text_registered_credit_card": "등록된 신용카드",
  "text_registered_credit_card_number": "{registered_credit_card} 신용카드",
  "text_payment_adjustment_amount": "조정 금액",
  "text_airfreight_2100_inc": "Airfreight 2100 Inc.",
  "text_australia_post": "Australia Post",
  "text_bpost": "text_bpost",
  "text_correos": "text_correos",
  "text_delivery_date_empty_notes": "배송일을 확인하려면 이메일을 확인하세요.",
  "text_delivery_date_not_fixed_message": "배송일 미정",
  "text_dhl": "text_dhl",
  "text_dhl_pl": "text_dhl_pl",
  "text_fastretailing_in_house_delivery": "유니클로/지유",
  "text_gd_express": "GD Express",
  "text_hived": "text_hived",
  "text_including_novelty": "신제품 포함",
  "text_la_poste": "text_la_poste",
  "text_lasership": "LaserShip",
  "text_ninja_van": "Ninja Van",
  "text_order_history_details_divided_delivery_notes": "이 주문은 복수 배송입니다.",
  "text_order_history_list_divided_delivery_notes": "이 주문은 단일 주문의 일부입니다.",
  "text_order_status_accept": "주문 완료",
  "text_order_status_canceled": "주문 취소됨",
  "text_order_status_delivery_complete": "배송 완료",
  "text_order_status_order_confirmation": "주문 완료",
  "text_order_status_partly_received_complete": "부분 배송됨",
  "text_order_status_partly_returning_item_complete": "취소됨",
  "text_order_status_partly_returning_item_pickup": "취소됨",
  "text_order_status_ship_confirmed": "출고 준비 중",
  "text_order_status_ship_pending": "주문 완료",
  "text_order_status_ship_wait": "주문 완료",
  "text_order_status_shipped": "출고 완료",
  "text_order_status_store_order_order_confirmation": "주문 완료",
  "text_order_status_store_payment": "결제 대기 중",
  "text_order_status_store_pickup_order_acceptance": "주문 완료",
  "text_order_status_store_pickup_shipment_order_wait": "배송 준비 중",
  "text_order_status_store_pickup_shipment_ordered": "출고 준비 중",
  "text_order_status_store_pickup_shipment_pending": "주문 완료",
  "text_postat": "text_postat",
  "text_postnl": "text_postnl",
  "text_postnord": "text_postnord",
  "text_quantium_solutions": "Quantium Solutions",
  "text_shipping_carrier_not_fixed_message": "배송사 미정",
  "text_team_fresh": "팀프레시",
  "text_ups": "text_ups",
  "text_willport": "윌포트",
  "text_yodel": "text_yodel",
  "text_yomiuri_shinbun_sbs": "YC 배송편",
  "text_pw_valid_format": "암호는 8-20자여야 하며 영문, 숫자, 특수문자를 포함해야 합니다. (특수문자는 !\"#$%&'()*+,-./:;<=>?@[]^_`{}|~에 한하여 사용이 가능합니다.)",
  "text_change_default_address": "기본 주소 변경",
  "text_app_do_not_sell_personal_info_link": "text_app_do_not_sell_personal_info_link",
  "text_app_preference_settings_cookie_setting_description": "text_app_preference_settings_cookie_setting_description",
  "text_enewsletter_recieve_check_box": "text_enewsletter_recieve_check_box",
  "text_error_preference_settings_description_01": "text_error_preference_settings_description_01",
  "text_error_preference_settings_description_02": "text_error_preference_settings_description_02",
  "text_error_preference_settings_description_03": "text_error_preference_settings_description_03",
  "text_error_preference_settings_description_04": "text_error_preference_settings_description_04",
  "text_error_preference_settings_description_05": "text_error_preference_settings_description_05",
  "text_error_preference_settings_description_06": "text_error_preference_settings_description_06",
  "text_error_preference_settings_description_07": "text_error_preference_settings_description_07",
  "text_error_preference_settings_subscription_email_address": "text_error_preference_settings_subscription_email_address",
  "text_error_preference_settings_subscription_enewsletter": "text_error_preference_settings_subscription_enewsletter",
  "text_error_preference_settings_subscription_personalized_information": "text_error_preference_settings_subscription_personalized_information",
  "text_error_preference_settings_title_01": "text_error_preference_settings_title_01",
  "text_error_preference_settings_title_02": "text_error_preference_settings_title_02",
  "text_personalized_information_title": "text_personalized_information_title",
  "text_preference_settings_cookie_setting_description": "text_preference_settings_cookie_setting_description",
  "text_preference_settings_description": "text_preference_settings_description",
  "text_preference_settings_personalized_information_advertisements_checkbox_gu": "text_preference_settings_personalized_information_advertisements_checkbox_gu",
  "text_preference_settings_personalized_information_advertisements_checkbox_pl": "text_preference_settings_personalized_information_advertisements_checkbox_pl",
  "text_preference_settings_personalized_information_advertisements_checkbox_uq": "text_preference_settings_personalized_information_advertisements_checkbox_uq",
  "text_preference_settings_personalized_information_advertisements_description_gu": "text_preference_settings_personalized_information_advertisements_description_gu",
  "text_preference_settings_personalized_information_advertisements_description_pl": "text_preference_settings_personalized_information_advertisements_description_pl",
  "text_preference_settings_personalized_information_advertisements_description_uq": "text_preference_settings_personalized_information_advertisements_description_uq",
  "text_preference_settings_personalized_information_no_consent": "text_preference_settings_personalized_information_no_consent",
  "text_preference_settings_personalized_information_note": "text_preference_settings_personalized_information_note",
  "text_preference_settings_personalized_information_note_01": "text_preference_settings_personalized_information_note_01",
  "text_preference_settings_personalized_information_note_02": "text_preference_settings_personalized_information_note_02",
  "text_preference_settings_personalized_information_product_checkbox_gu": "text_preference_settings_personalized_information_product_checkbox_gu",
  "text_preference_settings_personalized_information_product_checkbox_uq": "text_preference_settings_personalized_information_product_checkbox_uq",
  "text_preference_settings_personalized_information_product_description_gu": "text_preference_settings_personalized_information_product_description_gu",
  "text_preference_settings_personalized_information_product_description_uq": "text_preference_settings_personalized_information_product_description_uq",
  "text_preference_settings_subtitle": "text_preference_settings_subtitle",
  "text_preference_settings_title": "text_preference_settings_title",
  "text_return_to_preference_settings": "text_return_to_preference_settings",
  "text_subscription_email_address_description_01": "text_subscription_email_address_description_01",
  "text_subscription_email_address_description_02": "text_subscription_email_address_description_02",
  "text_subscription_email_address_title": "text_subscription_email_address_title",
  "text_membinfo_removecomplete": "유니클로 APP과 연결된 회원정보가 해제되었습니다.",
  "text_meminfo_description_details": "회원정보 연결을 해제하면, 유니클로 APP 연결이 해제 됩니다. 또, 온라인 스토어（uniqlo.com）에서 등록한 위시리스트, 구입이력 확인이 어렵습니다.",
  "text_meminfo_remove": "회원정보 연결 해제",
  "text_productid": "제품 번호",
  "text_ordersummary": "주문 상세내역",
  "text_order_history_delivery_method_ship_by_mail_notes01": "이 배송 제품은 택배로 배송됩니다.",
  "text_change_phone_number": "text_change_phone_number",
  "text_enter_phone_number": "text_enter_phone_number",
  "text_register_phone_number": "text_register_phone_number",
  "text_remove_phone_number": "text_remove_phone_number",
  "text_remove_verification_phone_number": "text_remove_verification_phone_number",
  "text_remove_verification_phone_number_confirmation": "text_remove_verification_phone_number_confirmation",
  "text_returnto_verification_top": "text_returnto_verification_top",
  "text_send_phone_number": "text_send_phone_number",
  "text_verification_completed_title": "text_verification_completed_title",
  "text_verification_phone_number_settings_title": "text_verification_phone_number_settings_title",
  "text_verification_sms_phone_number": "text_verification_sms_phone_number",
  "text_verification_sms_phone_number_description": "text_verification_sms_phone_number_description",
  "text_verification_sms_phone_number_title": "text_verification_sms_phone_number_title",
  "text_edit_membership_address_link": "고객주소 편집",
  "text_edit_membership_address_title": "고객주소 편집",
  "text_shipping_address": "배송 주소",
  "text_membership_referral_campaign_code": "추천 코드",
  "text_return_to_original_lage_after_sign_up": "이전 페이지로 돌아가기",
  "text_purchased_date": "구매일",
  "text_purchased_place": "구매 장소",
  "text_purchase_items": "제품 구매",
  "text_membership_privacy_preferences": "개인정보 보호",
  "text_privacy_settings_description": "text_privacy_settings_description",
  "text_app_preference_setting": "text_app_preference_setting",
  "text_app_coupon": "쿠폰",
  "text_app_questionnaire": "유니클로 APP 서비스앙게이트",
  "text_buyagain_title": "재구매",
  "text_membership_store_information_title": "Store information",
  "text_app_membership_id_copied": "APP 회원번호를 복사하였습니다.",
  "text_app_memberinfo_profilesettings": "MY PAGE",
  "text_app_referral_campaign_button": "친구에게 공유하기",
  "text_app_referral_campaign_code_copy": "추천 코드를 복사했습니다.",
  "text_app_referral_campaign_Description": "유니클로 APP을 다운로드하지 않은 친구, 가족에게 유니클로 APP을 추천해 주세요! 추천받은 친구에게는 즉시 5천원 쿠폰 지급 및 친구가 가입 후 3만원 이상 첫 구매할 경우 초대한 친구에게도 5천원 쿠폰을 지급해 드립니다.",
  "text_app_referral_campaign_description_coupon": "쿠폰은 추천받은 친구의 주문 발송일로부터 30일 후 추천자 계정에 부여됩니다.",
  "text_app_referral_campaign_description_unable_sharing": "친구에게 공유하기 버튼 클릭 시 원하시는 서비스가 나오지 않을 경우 직접 코드를 복사하여 전송해 주세요.",
  "text_app_referral_campaign_screen_title": "친구 추천",
  "text_app_referral_campaign_title": "친구 추천할 때마다 친구도 나도 5천원 할인 쿠폰 지급",
  "text_app_share_referral_title": "유니클로 온라인 스토어 친구 추천 코드 안내",
  "text_error_referral_api_general": "추천 코드를 확인할 수 없습니다. 인터넷 연결 상태를 확인 후 다시 시도해 주세요.",
  "text_error_referral_code_invalid_or_usage_limit_exceeded": "추천 코드를 확인할 수 없습니다. 인터넷 연결 상태를 확인 후 다시 시도해 주세요.",
  "text_error_referral_general": "죄송합니다. 추천 코드를 확인할 수 없습니다. 다시 시도해주시기 바랍니다.",
  "text_membership_about_referral_campaign_code_gu_link": "",
  "text_membership_about_referral_campaign_code_link": "친구 추천 혜택에 대한 안내",
  "text_membership_enter_referral_campaign_code": "추천 코드를 입력해 주세요.",
  "text_membership_enter_referral_campaign_code_description": "추천 코드를 입력해 주세요.",
  "text_app_preference_setting_recommend_styles_and_content_description": "text_app_preference_setting_recommend_styles_and_content_description",
  "text_app_preference_setting_respond_question": "text_app_preference_setting_respond_question",
  "text_app_preference_setting_respond_this_question": "text_app_preference_setting_respond_this_question",
  "text_app_preference_setting_setup_complete_recommendation": "text_app_preference_setting_setup_complete_recommendation",
  "text_go_to_order_history_details": "주문 세부정보로 이동",
  "text_items_subtotal": "소계",
  "text_back": "뒤로",
  "text_orderid": "주문 번호",
  "text_united_states_postal_service": "USPS",
  "text_wishlist_list": "위시리스트",
  "text_verification_phone_number_removed": "text_verification_phone_number_removed",
  "text_verification_completed_description": "text_verification_completed_description",
  "text_howto_pickup_family_mart01": "Fami Port()",
  "text_howto_pickup_family_mart02": "패밀리마트에서 픽업하는 방법:",
  "text_howto_pickup_lawson_ministop01": "캐셔에게 픽업 바코드를 보여주시거나, Loppi에 픽업 코드와 인증 코드를 입력하면 픽업 티켓이 발급됩니다.",
  "text_howto_pickup_lawson_ministop02": "로손/미니스톱에서 픽업하는 방법:",
  "text_howto_pickup_seven_eleven01": "픽업 코드 링크를 통해 찾은 픽업 바코드를 보여주시거나 픽업 영수증을 인쇄하세요.",
  "text_howto_pickup_seven_eleven02": "픽업 영수증을 인쇄할 수 없는 경우 픽업 코드를 기록해 두세요.",
  "text_order_history_lotte_imark_description_01": "할인금액의 상세확인이 필요하신 경우 고객센터로 문의해 주시기 바랍니다.",
  "text_purchasehistory_imark_description1": "매장 및 온라인스토어에서 구매하신 제품 이력을 확인할 수 있습니다.",
  "text_purchasehistory_imark_description2": "온라인스토어에서 구매하신 제품은 출고일 다음날까지 반영됩니다.",
  "text_purchasehistory_imark_description3": "매장에서 구매하신 제품은 결제 시에 APP 회원 바코드를 스캔한 경우에 한하여 구매일 다음날까지 반영됩니다.",
  "text_purchasehistory_imark_description4": "반품/교환 내역은 구매제품이력에 반영되지 않습니다.",
  "text_purchasehistory_imark_description5": "매장에서 반품/교환을 희망하시는 경우, 구매 매장에 구매 영수증을 지참해 주세요. (교환은 전국 매장에서 가능합니다.)",
  "text_purchasehistory_imark_description6": "온라인스토어에서 구매한 제품의 반품/교환을 희망하시는 경우, 구매 내역 메뉴에서 '반품/교환' 버튼을 통해 진행해 주세요.",
  "text_purchasehistory_imark_description7": "이 페이지는 구매를 증명하거나 영수증의 용도로 사용할 수 없습니다.",
  "text_go_to_pdp": "제품 페이지",
  "text_no_wishlist_item": "위시리스트가 비어있습니다.",
  "text_address_book": "배송지",
  "text_app_setting_location_push_notification": "기기 설정",
  "text_coupon_use_at_store_annotation1": "※ 매장에서 사용 시",
  "text_coupon_use_at_store_annotation2": "결제 시 회원 바코드 스캔 후, 결제 화면에서 이용 가능한 쿠폰을 선택해 주세요.",
  "text_coupon_use_online_store_annotation1": "※ 온라인 스토어에서 사용 시",
  "text_coupon_use_online_store_annotation2": "결제 화면에서 이용 가능한 쿠폰을 선택해 주세요.",
  "text_storelocator": "매장 찾기",
  "text_usable_stores": "이용 가능 매장",
  "text_use_date": "사용일",
  "text_app_timezone_US_ET": "ET",
  "text_remove_credit_card": "신용카드 삭제",
  "text_verification_phone_number_settings": "text_verification_phone_number_settings",
  "text_giftcard_balance": "UNIQLO 기프트 카드 잔액 확인",
  "text_regist_new_phone_number": "text_regist_new_phone_number",
  "text_register_change_phone_number": "text_register_change_phone_number",
  "text_registered_phone_number": "text_registered_phone_number",
  "text_return_slip_links_expire_message_01": "반품 전표 출력 기간 만기",
  "text_error_my_size_maximum_register": "등록할 수 있는 마이사이즈 최대치가 초과되었습니다.",
  "text_mysize_confirm_edit": "마이 사이즈 수정",
  "text_edit_enewsletter_subscription": "이메일 뉴스레터 수신 동의 설정 변경",
  "text_select_enewsletter_message": "수신하길 원하는 뉴스레터를 선택하세요.",
  "text_cancel_order_description": "이 주문을 취소하려면 이 페이지 하단의 “주문 내역” 페이지로 이동하여 취소 정책을 참조하세요.",
  "text_download_return_slip": "반품전표 다운로드",
  "text_last_month": "지난 달",
  "text_order_class": "주문 등급",
  "text_order_history_filter_delivery_complete": "배송됨",
  "text_order_history_filter_order_canceled": "취소됨",
  "text_order_history_filter_planto_delivery": "배송 시작",
  "text_order_history_filter_reception_complete": "수령함",
  "text_order_status_shipped_home_delivery": "text_order_status_shipped_home_delivery",
  "text_order_status-1": "확인되지 않음",
  "text_order_status-10": "매장으로 출고 완료",
  "text_order_status-12": "완료됨",
  "text_order_status-2": "보류 중",
  "text_order_status-3": "수령함",
  "text_order_status-4": "취소됨",
  "text_order_status-5": "배송 준비 중",
  "text_order_status-6": "수령기한 초과에 따른 주문 취소",
  "text_order_status-7": "배송 완료",
  "text_order_status-8": "배송됨",
  "text_order_status-9": "매장 배송 준비 중",
  "text_order_substatus": "상세 상태",
  "text_orderfrom": "구매 장소",
  "text_orderhistory_title": "주문 내역",
  "text_orderstatus": "주문 상태",
  "text_past_one_year": "지난 1년",
  "text_past_six_month": "지난 6개월",
  "text_past_three_month": "지난 3개월",
  "text_payin_store_payment_status": "결제 상태",
  "text_payin_store_payment_status_complete": "완료됨",
  "text_payin_store_payment_status_incomplete": "완료 안 됨",
  "text_payment": "결제 정보",
  "text_pre_order_product": "예약판매 제품",
  "text_product_category": "제품 카테고리",
  "text_purchase_class": "구매 등급",
  "text_purchase_time": "구매일",
  "text_receipt": "접수",
  "text_receipt_period": "픽업 기한",
  "text_reload_order_history_details_request": "일부 정보를 불러 오지 못하였습니다. 화면을 새로고침 하여 주시기 바랍니다.",
  "text_shipping_method": "배송 방법",
  "text_shopping_bag_notes01": "매장픽업 상품 수령 시 쇼핑백이 무료 제공됩니다.",
  "text_symbol_colon": ":",
  "text_tax_inclusive_price_change_order_history_description_01": "주문은 부가세가 포함된 총액 표시됩니다.",
  "text_view_download_return_slip": "다운로드 반품전표 미리보기",
  "text_delivery_method:": "배송 방법",
  "text_filter_search_results_orders": "필터 | {count}개 주문",
  "text_pickup_date_range": "픽업 기한",
  "text_pickup_lawson_ministop_notes01": "로손/미니스톱에서 패키지를 픽업하는 방법은 2가지가 있습니다.",
  "text_pickup_lawson_ministop_notes02": "1. 캐셔에게 픽업 바코드를 보여주세요.",
  "text_tax": "세금(VAT)포함",
  "text_view_order_details": "주문 내역 세부정보 보기",
  "text_error_registered_field_over_maximum_length": "{max_length}자 이내로 입력하세요.",
  "text_purchasehistory_imark_description8": "구매이력_imark",
  "text_purchasehistory_noitems": "이 제품을 더는 취급하지 않습니다.",
  "text_sku": "SKU#",
  "text_maminfo_removelinkage_message1": "회원정보 연결을 해제 하시겠습니까? 삭제하시는 경우, 유니클로 APP와 연결이 해제 됩니다.",
  "text_maminfo_removelinkage_message2": "위시리스트 및 구매 내역에 액세스할 수도 없게 됩니다.",
  "text_meminfo_cancel": "취소",
  "text_meminfo_cancellation_description": "주의사항",
  "text_bank_account_details": "반품_은행계좌",
  "text_customer_service_center": "고객센터",
  "text_enter_ifsc_code_bank_branch": "반품_은행",
  "text_ifsc_code_bank_branch": "반품_은행",
  "text_order_details": "주문 상세",
  "text_original_payment_method": "반품_결제수단",
  "text_product_return_acceptable_condition_01": "반품 가능 조건",
  "text_product_return_acceptable_condition_02": "반품 가능 조건",
  "text_product_return_acceptable_condition_03": "반품 가능 조건",
  "text_product_return_acceptable_condition_04": "반품 가능 조건",
  "text_product_return_acceptable_condition_05": "반품 가능 조건",
  "text_product_return_acceptable_condition_note_01": "빈품",
  "text_product_return_address_to_pick_up": "반품_주소",
  "text_product_return_application": "반품 절차",
  "text_product_return_button_label": "반품 상품",
  "text_product_return_check_acceptable_condition_request": "반품 가능 조건",
  "text_product_return_enter_return_reason": "반품 이유",
  "text_product_return_item": "반품_상품",
  "text_product_return_order_contents_mistake_case_note_01": "빈품",
  "text_product_return_pickup_address_change_notes_01": "반품_주소변경",
  "text_product_return_pickup_notes_01": "반품_픽업",
  "text_product_return_reason": "반품 이유",
  "text_product_return_reason_damaged_item": "반품 이유_상품문제",
  "text_product_return_reason_item_different_from_picture": "반품 이유_상품차이",
  "text_product_return_reason_order_by_mistake": "반품 이유_고객변심",
  "text_product_return_reason_other": "반품 이유_기타",
  "text_product_return_reason_size_unmatched": "반품 이유_사이즈차이",
  "text_product_return_shipping_fee_deduction_note_01": "반품_반품배송비",
  "text_product_return_unacceptable_case_send_back_notes_01": "반품_반품불가이유",
  "text_product_return_unavailable_item_notes_01": "반품 상품 선택 불가",
  "text_select_check_box_required": "반품_요청",
  "text_select_return_item": "반품 상품 선택",
  "text_select_return_reason": "반품 사유를 선택해 주세요",
  "text_thank_you_for_shopping_with_uq": "반품_배송",
  "text_return_portal_return_reason": "반품_이유",
  "text_scanto_win_instruction04": "매장 스탭에게 멤버십 바코드를 제시하면 결제 시 스캔하고 게임을 진행하여 쿠폰을 획득할 수 있습니다.",
  "text_shopping_guide": "쇼핑 가이드",
  "text_app_setting_video_auto_play": "영상 자동 재생",
  "text_video_auto_play_always_play": "항상 재생",
  "text_video_auto_play_annotation01": "“항상 재생”을 선택하고 동영상을 재생하는 경우 데이터 통신이 필요할 수 있습니다.",
  "text_video_auto_play_annotation02": "배터리 전원이 부족하면 비디오 재생이 자동으로 일시 중지됩니다.",
  "text_video_auto_play_do_not_play": "재생 금지",
  "text_video_auto_play_play_when_connected_to_wifi": "Wi-Fi에 연결됐을 때에만 재생",
  "text_filter_search_results_items": "필터 | {count}개 제품",
  "text_payment_status_pending": "반품_상태",
  "text_warning_payment_pending_message": "반품_중지",
  "text_open_membership_card_button": "회원정보",
  "text_push_notification_promotion_for_modal_annotation1": "APP 알림 받는 방법",
  "text_push_notification_promotion_for_modal_annotation2": "APP 알림을 탭하세요.",
  "text_push_notification_promotion_for_modal_annotation3": "APP 알림을 허용하세요.",
  "text_push_notification_promotion_for_modal_os_setting": "APP 알림 설정",
  "text_meta_description": "메타_내용",
  "text_meta_description_find_in_store": "메타_매장검색",
  "text_meta_description_review": "메타_리뷰",
  "text_meta_title_default": "메타_기본",
  "text_meta_title_find_in_store": "메타_매장검색",
  "text_meta_title_suffix": "메타",
  "text_meta_description_find_in_store_search_result": "유니클로 {productName}의 매장 재고를 확인할 수 있습니다.",
  "text_meta_description_gender_baby": "베이비",
  "text_meta_description_gender_kids": "키즈",
  "text_meta_description_gender_men": "남성",
  "text_meta_description_gender_statiac_special_page": "text_meta_description_gender_statiac_special_page",
  "text_meta_description_gender_unisex": "젠더리스",
  "text_meta_description_gender_women": "여성",
  "text_meta_description_official_styling_baby_page": "유니클로의 {officialProduct}（베이비）패션아이템을 사용한 스타일 아이디어. 유행아아이템의 활용방법 체크!",
  "text_meta_description_official_styling_idea_men_page": "유니클로의 {officialProduct}（남성）패션아이템을 사용한 스타일 아이디어. 유행아아이템의 활용방법 체크!",
  "text_meta_description_official_styling_idea_women_page": "유니클로의 {officialProduct}（여성）패션아이템을 사용한 스타일 아이디어. 유행아아이템의 활용방법 체크!",
  "text_meta_description_official_styling_kids_page": "유니클로의 {officialProduct} 패션아이템을 사용한 스타일 아이디어. 유행아아이템의 활용방법 체크!",
  "text_meta_description_official_styling_unisex_page": "유니클로의 {officialProduct}（남여겸용）패션아이템을 사용한 스타일 아이디어. 유행아아이템의 활용방법 체크!",
  "text_meta_description_reviews": "유니클로 {countryCode}의 {productName}의 제품리뷰.",
  "text_meta_description_size_chart": "UNIQLO {countryCode}에서 {gender} {productName} 사이즈를 확인하세요.",
  "text_meta_description_size_chart_select_comparison_product": "UNIQLO {countryCode}의 {gender} {productName}와 다른 제품 사이즈 비교 확인",
  "text_meta_description_statiac_category_page": "{gender} {category}을(를) 확인하세요. UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_statiac_special_page": "text_meta_description_statiac_special_page",
  "text_meta_description_statiac_subcategory_page": "{gender} {category} ({subcategory}) 제품을 확인하세요. 유니클로 공식 온라인스토어에서 스타일리시하고 편안한 제품을 만나보세요.",
  "text_meta_description_static_class_page": "{gender} {class}을(를) 확인하세요. UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_static_feature_pages": "{gender} {pageTitle}을(를) 확인하세요. UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_static_feature_pages_no_gender": "{pageTitle}를 확인하세요. UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_static_feature_pages_no_page_title": "UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_static_gender_baby_page": "신생아옷부터 5세까지 아기를 위한 바디슈트, 커버올, 배냇저고리, 우주복, 배내옷, 레깅스, 턱받이와 악세사리 등 유니클로 베이비의 다양한 제품을 확인하세요.",
  "text_meta_description_static_gender_kids_page": "유니클로 키즈 아우터, 남아/여아옷, 상의, 키즈 원피스, 팬츠, 트레이닝세트, 주니어브라 등 아이의 시선에서 만듭니다. 온라인단독제품과 신규회원 할인혜택도 놓치지 마세요.",
  "text_meta_description_static_gender_men_page": "유니클로 남성 아우터, 셔츠, 자켓, 정장, 청바지, 이너웨어 등 다양한 제품을 만나보세요. 온라인 단독제품, 빅사이즈를 비롯한 특별사이즈, 할인혜택까지 만나보세요.",
  "text_meta_description_static_gender_page": "UNIQLO {regionName}에서 스타일리시하고 편안한 {gender} 의류를 온라인 쇼핑하세요. 획기적인 보온 기술로 모든 계절에 잘 어울립니다.",
  "text_meta_description_static_gender_women_page": "유니클로 여성 아우터, 상의, 블라우스, 팬츠, 원피스, 홈웨어, 속옷 등 다양한 제품을 만나보세요. 온라인 단독제품, 빅사이즈를 비롯한 특별사이즈, 할인혜택을 확인하세요",
  "text_meta_description_static_product_page": "온라인 스토어에서 {gender} {productName} 제품을 만나보세요. 고객 리뷰, 스타일링 팁을 확인할 수 있습니다.",
  "text_meta_description_static_semi_order_page": "{pageTitle}을(를) 확인하세요. UNIQLO {regionName}에서 스타일리시하고 편안한 의류를 쇼핑하세요.",
  "text_meta_description_static_top_page": "UNIQLO {regionName}에서 스타일리시하고 편안한 여성, 남성, 키즈 및 베이비 의류를 온라인 쇼핑하세요. 획기적인 보온 기술로 모든 계절에 잘 어울립니다.",
  "text_meta_description_style_hint_baby_page": "유니클로의 {stylehintProduct} (베이비) 패션아이템을 사용한 스타일 아이디어 {count}건 . 궁금한 신상품과 트렌드 아이템은 온라인 스토어에서 체크!",
  "text_meta_description_style_hint_kids_page": "유니클로의 {stylehintProduct} 패션아이템을 사용한 스타일 아이디어 {count}건 . 궁금한 신상품과 트렌드 아이템은 온라인 스토어에서 체크!",
  "text_meta_description_style_hint_men_page": "유니클로의 {stylehintProduct}（남성）패션아이템을 사용한 스타일 아이디어 {count}건 . 궁금한 신상품과 트렌드 아이템은 온라인 스토어에서 체크!",
  "text_meta_description_style_hint_unisex_page": "유니클로의 {stylehintProduct} (남여겸용) 패션아이템을 사용한 스타일 아이디어 {count}건 . 궁금한 신상품과 트렌드 아이템은 온라인 스토어에서 체크!",
  "text_meta_description_style_hint_women_page": "유니클로의 {stylehintProduct}（여성）패션아이템을 사용한 스타일 아이디어 {count}건 . 궁금한 신상품과 트렌드 아이템은 온라인 스토어에서 체크!",
  "text_meta_title_model_wearing_item": "UNIQLO KR / 착용아이템",
  "text_meta_titile_static_category_page": "{gender} {category} | UNIQLO {regionName}",
  "text_meta_titile_static_gender_page": "{gender} 의류 및 액세서리 | UNIQLO {regionName}",
  "text_meta_titile_gender_baby": "베이비",
  "text_meta_titile_gender_kids": "키즈",
  "text_meta_titile_gender_men": "남성",
  "text_meta_titile_gender_unisex": "젠더리스",
  "text_meta_titile_gender_women": "여성",
  "text_meta_titile_static_gender_baby_page": "BABY 베이비의류 / 아기옷ㅣ유니클로 한국",
  "text_meta_titile_static_gender_kids_page": "KIDS 키즈의류 / 아동복ㅣ유니클로 한국",
  "text_meta_titile_static_gender_men_page": "MEN 남성의류 / 남자옷 ㅣ 유니클로 한국",
  "text_meta_titile_static_gender_women_page": "WOMEN 여자의류 / 여성복 ㅣ 유니클로 한국",
  "text_meta_title_find_in_store_search_store": "유니클로 | {productName}의 매장재고 검색",
  "text_meta_title_gender_baby": "베이비",
  "text_meta_title_gender_kids": "키즈",
  "text_meta_title_gender_men": "남성",
  "text_meta_title_gender_unisex": "젠더리스",
  "text_meta_title_gender_women": "여성",
  "text_meta_title_official_styling_baby_page": "{officialProduct}（베이비）스타일 아이디어 {uqPostfix}",
  "text_meta_title_official_styling_idea_kids_page": "{officialProduct} 스타일 아이디어 {uqPostfix}",
  "text_meta_title_official_styling_idea_men_page": "{officialProduct}（남성）스타일 아이디어 {uqPostfix}",
  "text_meta_title_official_styling_idea_women_page": "{officialProduct}（여성）스타일 아이디어 {uqPostfix}",
  "text_meta_title_official_styling_unisex_page": "{officialProduct}（남여겸용）스타일 아이디어 {uqPostfix}",
  "text_meta_title_reviews": "유니클로 온라인스토어 | {productName}의 리뷰.",
  "text_meta_title_reviews_confirm": "유니클로 {countryCode}의 {productName}의 고객님의 제품 리뷰 확인.",
  "text_meta_title_reviews_thanks_page": "유니클로 {countryCode}의 {productName}의 제품리뷰 작성해 주셔서 감사합니다.",
  "text_meta_title_reviews_write_comment": "유니클로 온라인스토어 | {productName} 리뷰 작성.",
  "text_meta_title_size_chart": "{gender} {productName} 사이즈 확인 | UNIQLO {countryCode}",
  "text_meta_title_size_chart_select_comparison_product": "{gender} {productName}의 비교 제품 추가 | UNIQLO {countryCode}",
  "text_meta_title_static_class_page": "{gender} {class} | UNIQLO {regionName}",
  "text_meta_title_static_feature_pages": "{gender} {pageTitle} | UNIQLO {regionName}",
  "text_meta_title_static_feature_pages_no_gender": "{pageTitle} | UNIQLO {regionName}",
  "text_meta_title_static_feature_pages_no_page_title": "UNIQLO {regionName}",
  "text_meta_title_static_product_page": "{productName} | UNIQLO {countryCode}",
  "text_meta_title_static_semi_order_page": "{pageTitle} | UNIQLO {regionName}",
  "text_meta_title_static_subcategory_page": "{gender} {category} ({subcategory}) | 유니클로 한국",
  "text_meta_title_static_top_page": "여성, 남성 및 키즈 의류 및 액세서리 | UNIQLO {regionName}",
  "text_meta_title_style_hint_baby_page": "{stylehintProduct} (베이비) 착용 코디 {uqPostfix}",
  "text_meta_title_style_hint_kids_page": "{stylehintProduct} 착용 코디 {uqPostfix}",
  "text_meta_title_style_hint_men_page": "{stylehintProduct}（남성）착용 코디 {uqPostfix}",
  "text_meta_title_style_hint_unisex_page": "{stylehintProduct} (남여겸용) 착용 코디 {uqPostfix}",
  "text_meta_title_style_hint_women_page": "{stylehintProduct}（여성）착용 코디 {uqPostfix}",
  "text_view_model_wearing_item_page": "착용제품보기",
  "text_model_wearing_item": "착용제품",
  "text_model_wearing_item_left_model": "왼쪽 모델",
  "text_model_wearing_item_right_model": "오른쪽 모델",
  "text_model_wearing_item_model_height": "모델: {height}cm",
  "text_alteration_cost": "수선비",
  "text_round_adjustment": "반올림 조정",
  "text_selected": "선택",
  "text_estimated_tax": "세금(VAT)포함",
  "text_tbd": "미정",
  "text_a11y": "접근성",
  "text_uqapp": "유니클로 APP",
  "text_guapp": "GU APP",
  "text_height_feet": "키 cm",
  "text_height_inch": "키 inch",
  "text_metrology_in": "inch",
  "text_metrology_lbs": "kg",
  "text_height_feet_inch_display_format": "{feet}′ {inch}″",
  "text_metrology_feet": "cm",
  "text_metrology_ft": "cm",
  "text_metrology_inch": "inch",
  "text_metrology_pound": "kg",
  "text_size_recommendation_check_your_recommend_size_ga": "마이사이즈_추천사이즈",
  "text_size_recommendation_recommend_size_ga": "마이사이즈_추천사이즈",
  "text_size_conversion_chart": "마이사이즈_사이즈차트",
  "text_app_ranking_annotated_text": "* 어제 순위",
  "text_app_apk_downloading_snackbar_title": "다운로드 중...",
  "text_app_error_excessive_access_dialog_description": "사이트 이용에 불편을 드려 죄송합니다. 잠시 후 다시 접속 부탁드리겠습니다.",
  "text_app_error_excessive_access_dialog_title": "현재 접속량이 많습니다.",
  "text_app_ranking_title": "순위",
  "text_app_recentlyviewed_title": "최근에 본 제품",
  "text_app_update_snackbar_button": "재시작",
  "text_app_update_snackbar_title": "업데이트가 다운로드되었습니다.",
  "text_app_viewmore_ranking": "순위 더 보기",
  "text_app_viewmore_recentlyviewed": "최근에 많이 본 제품 보기",
  "text_naver_pay_payment_information_note": "주문 내역 확인후 NAVER PAY로 결제 진행.",
  "text_submit_naver_pay_payment": "계속",
  "text_naver_pay": "NAVER Pay",
  "text_naver_pay_complete_order_note": "[결제하기] 를 눌러 진행해 주세요. 결제 완료 전까지 결제 페이지를 이탈하거나 웹사이트를 신규로 생성하지 않도록 주의해 주세요.",
  "text_naver_pay_place_order": "결제하기",
  "text_naver_pay_proceed_payment_note": "주문 내역 확인후 NAVER PAY로 결제 진행.",
  "text_naver_pay_payment_completed_note": "NAVER Pay 결제가 완료되었습니다.",
  "text_store_recommendation_based_on_usage_history": "* 매장추천은 방문매장을 기초로 표시 됩니다",
  "text_mysize_assist_camera_function_available_notification": "새로운 마이 사이즈 카메라 기능을 사이즈 조정 지원에서 사용할 수 있습니다.",
  "text_pre_order_estimated_shipping_date_early_month": "{month} 초 입고 되는대로 발송",
  "text_pre_order_estimated_shipping_date_late_month": "{month} 말 입고 되는대로 발송",
  "text_pre_order_estimated_shipping_date_mid_month": "{month} 중순 입고 되는대로 발송",
  "text_continue_shopping": "쇼핑 계속하기",
  "text_pre_order_available_date_early_month": "{month}초 입고 예정",
  "text_pre_order_available_date_late_month": "{month}말 입고 예정",
  "text_pre_order_available_date_mid_month": "{month}중순 입고 예정",
  "text_pre_order_label": "예약판매 제품",
  "text_pre_order_credit_card_require_extra_expiry_date": "유효기간이 3개월 이상인 신용카드로 결제 부탁드립니다.",
  "text_items": "제품",
  "text_official_outfit": "공식 스타일링",
  "text_apply_search_filter": "적용하기",
  "text_filter_not_specified": "모두",
  "text_review_filter_gender_all": "모두",
  "text_stylehint_product_details_filter_height_031": "≧ 185 cm",
  "text_stylehint_product_details_filter_height_033": "≧ 165 cm",
  "text_stylehint_product_details_filter_height_034": "≧ 175 cm",
  "text_stylehint_product_details_filter_height_037": "≧ 160 cm",
  "text_inventory_annotation1": "ORDER & PICK (당일픽업) 버튼이 없는 경우, 해당 매장의 휴관일 혹은 서비스를 제공하지 않습니다.",
  "text_store_inventory_purhcase_recommend_store": "자주 가는 매장",
  "text_store_inventory_status_in_stock": "재고 있음",
  "text_store_inventory_status_low_stock": "품절 임박",
  "text_store_inventory_status_product_currently_unavailable_in_store": "현재 사용할 수 없음",
  "text_store_inventory_status_product_online_limited": "사용할 수 없음",
  "text_store_inventory_status_product_unavailable_store_inventory_purchase": "매장에서 확인",
  "text_store_inventory_status_unavailable_in_store": "사용할 수 없음",
  "text_inventory_annotation2": "재고 현황은 실시간으로 변동되므로 방문 시 품절될 수 있습니다. \n 또한, 전화 예약은 불가하오니 양해 부탁드립니다.",
  "text_search_tab": "검색",
  "text_baby": "BABY",
  "text_keyword_search_tips": "검색 도움말",
  "text_price_range_between": "-",
  "text_price_range_upto": "미만",
  "text_customer_styling_title": "게시된 스타일링",
  "text_product_detail_registered_identification_number": "text_product_detail_registered_identification_number",
  "text_styling_title": "스타일링",
  "text_check_storeinventory": "매장 재고 확인",
  "text_store_inventory_purchase_button_label": "ORDER & PICK (당일픽업)",
  "text_store_inventory_status_out_of_stock": "재고 없음",
  "text_handling": "세탁 방법",
  "text_product_detail_tax_inclusive_subtotal": "장바구니 제품 합계",
  "text_add_wishlist": "위시리스트에 추가",
  "text_addcart_promotion": "연관 추천 제품",
  "text_addto_cart_exceed2": "이 제품은 장바구니에 추가되지 않았습니다.",
  "text_addto_cart_exceed3": "{totalCount}개를 초과하는 제품을 한 번에 주문할 수 없습니다.",
  "text_back_in_stock": "재입고 알림",
  "text_error_ssr_failed_get_information": "정보를 가져오지 못했습니다. 페이지를 새로고침하세요.",
  "text_error_ssr_failed_get_inventory": "재고 정보를 가져오지 못했습니다. 페이지를 새로고침하세요.",
  "text_error_ssr_failed_get_price": "가격을 가져오지 못했습니다. 페이지를 새로고침하세요.",
  "text_fabric": "소재",
  "text_failed_addcart": "장바구니에 제품을 추가하지 못했습니다.",
  "text_find_in_store_unavailable_product_description01": "일부 제품은 매장 재고 확인이 불가합니다.",
  "text_item_added": "장바구니에 추가되었습니다.",
  "text_length_no_colon": "길이",
  "text_my_size_assist": "마이 사이즈 어시스트",
  "text_no_store_available_for_recommendation_message_01": "“매장 찾기”를 통해 매장 재고를 확인해 주세요.",
  "text_review": "리뷰",
  "text_search_store_inventory": "매장에서 찾기",
  "text_size_recommendation_recommend_size": "추천 사이즈: {size}",
  "text_store_inventory_purhcase_unavailable_ng_product": "매장에서 매장 재고를 확인해 주세요.",
  "text_store_inventory_purhcase_unavailable_online_only_product": "온라인 스토어 전용 제품 입니다.",
  "text_store_inventory_status": "매장 재고 현황",
  "text_added_items": "{count}개 제품",
  "text_review_report_abuse": "신고하기",
  "text_review_helpful": "도움돼요",
  "text_review_report_abuse_feedback": "신고해 주셔서 감사합니다.",
  "text_stylehint_posted_outfit": "StyleHint",
  "text_bis_notification_email_address": "이메일은 “ec-system@ma.store.uniqlo.com”에서 발송됩니다.",
  "text_addtocart": "장바구니에 담기",
  "text_register_back_in_stock": "재입고 알림 등록",
  "text_store_inventory_purchase_information_title": "ORDER & PICK (당일픽업) 설명",
  "text_store_inventory_purchase_require_login": "구입을 원하시는 경우 회원 가입이 필요합니다. 유니클로 온라인 스토어 회원이시면 로그인 후 사용 부탁드리겠습니다.",
  "text_display": "보기",
  "text_divided_delivery_pay_for_order_description": "제품은 주문번호에 따라 분할 배송될 예정입니다. 결제 금액은 동시에 주문하신 제품 전체를 포함한 금액이 됩니다.",
  "text_divided_delivery_pay_for_order_title": "분할배송 주문 결제",
  "text_tax_inclusive_subtotal": "제품 합계",
  "text_about_shipping_fee": "배송비 설명",
  "text_keyword_search_other_inquiry": "기타",
  "text_no_keyword_result": "검색어가 포함된 결과가 없습니다.",
  "text_no_search_result_notes01": "서비스에 대한 FAQ를 확인해 주세요.",
  "text_no_search_result_tips03": "더 일반적인 키워드를 사용해 주세요.",
  "text_search_feature_tab": "특집",
  "text_search_related_searches_title": "관련 키워드",
  "text_search_trend_word": "인기키워드",
  "text_enter_keyword": "키워드를 입력해 주세요.",
  "text_model_size_label02": "모델: {height01}cm, {height02}cm",
  "text_wearing_size_code02": "착용사이즈: {size_code01}, {size_code02}",
  "text_wearing_size_code01": "착용 사이즈: {size_code}",
  "text_error_failed_to_get_pdp_movie": "영상을 가져오지 못했습니다.",
  "text_error_failed_to_get_pdp_movie_instruction_01": "페이지를 새로고침하거나 나중에 다시 방문해 주세요.",
  "text_purchase_history_posted_review": "작성한 리뷰 수",
  "text_how_it_fit": "착용감",
  "text_store_inventory_purchase_information_description_02": "제품이 준비되면 메일로 안내드리겠습니다.",
  "text_store_inventory_purchase_information_description_03": "제품은 매장에서만 픽업 가능 합니다.",
  "text_store_inventory_purchase_information_description_01": "신용카드를 사용할 수 있습니다.",
  "text_length": "길이",
  "text_none": "적용 안 함",
  "text_pre_order_shipping_date_late": "{month}말",
  "text_pre_order_shipping_date_early": "{month}초",
  "text_pre_order_shipping_date_mid": "{month}중순",
  "text_review_abuse_report_confirmation": "이 리뷰를 신고하시겠습니까?",
  "text_review_entrytitle": "리뷰 작성",
  "text_review_helpful_login_required": "리뷰를 평가하려면 로그인해야 합니다.",
  "text_review_login_required": "리뷰를 작성하려면 로그인해야 합니다.",
  "text_review_report_login_required": "리뷰를 신고하려면 로그인해야 합니다.",
  "text_reviews_readall_title": "제품 리뷰",
  "text_fit": "착용감",
  "text_search_excluded_query": "포함하지 않음",
  "text_search_query": "{query}에 대한 결과",
  "text_android": "Android 설정",
  "text_android_annotation1": "높은 정확도로 모드를 설정합니다.",
  "text_android_annotation2": "모든 기기와 호환되지 않습니다.",
  "text_android_setting": "설정 > 위치 정보 > “켜기”로 설정합니다.",
  "text_gps_setting": "휴대폰에서 위치 서비스를 활성화해 주세요.",
  "text_iOS": "iOS 설정",
  "text_iOS_annotation1": "브라우저 위치 서비스를 활성화해 주세요.",
  "text_iOS_annotation2": "위치를 찾을 수 없습니다. 유니클로 APP에서 접속해 주세요.",
  "text_iOS_setting": "설정 > 개인정보 보호 > 위치 서비스 > 위치 서비스 켜기로 이동해 주세요.",
  "text_store_search_result_number": "{count}개 매장",
  "text_select_semi_order_fit": "핏 선택",
  "text_semi_order_how_to_measure_jacket_length_from_neck_to_hem": "text_semi_order_how_to_measure_jacket_length_from_neck_to_hem",
  "text_semi_order_how_to_measure_jacket_sleeve_length02": "text_semi_order_how_to_measure_jacket_sleeve_length02",
  "text_semi_order_how_to_measure_length_from_neck_to_hem_title": "목에서 밑단까지의 길이 측정 방법",
  "text_semi_order_how_to_measure_men_jacket_length_from_neck_to_hem_instruction01": "재킷 칼라를 똑바로 세운 상태에서 앞면이 아래로 가고 뒷면이 위를 향하도록 평평한 표면에 놓습니다.",
  "text_semi_order_how_to_measure_men_jacket_length_from_neck_to_hem_instruction02": "목 뒤 중앙에서 솔기 아래 밑단까지의 길이를 측정합니다.",
  "text_semi_order_how_to_measure_men_jacket_length_from_neck_to_shoulder_instruction01": "재킷 칼라를 세우고 평평한 테이블에 놓습니다. 목 뒤 중앙에서 어깨까지를 측정합니다.",
  "text_semi_order_how_to_measure_men_jacket_length_from_shoulder_to_sleeve_instruction01": "재킷 단추를 닫은 상태에서 바깥쪽 솔기를 따라 슬리브를 평평하게 만듭니다.",
  "text_semi_order_how_to_measure_men_jacket_length_from_shoulder_to_sleeve_instruction02": "슬리브 솔기와 어깨 솔기가 어깨 윗부분에서 만나는 지점을 기준으로 삼고, 어깨 부분이 흐트러지지 않게 솔기를 살며시 잡은 상태에서 솔기부터 커프 중앙 부분까지를 측정합니다.",
  "text_semi_order_length_from_neck_to_hem": "목에서 밑단까지의 길이",
  "text_semi_order_measure_dress_length": "소매 측정",
  "text_semi_order_select_men_jacket_color_pattern": "컬러 선택",
  "text_semi_order_select_men_jacket_fit_regular": "레귤러",
  "text_semi_order_select_men_jacket_fit_regular_description01": "가슴부터 허리까지 여유로운 핏입니다.",
  "text_semi_order_select_men_jacket_fit_slim": "슬림",
  "text_semi_order_select_men_jacket_fit_slim_description01": "전체적으로 슬림한 핏을 위해 팔, 가슴, 허리가 약간 슬림해졌습니다.",
  "text_semi_order_product_men_stretch_wool_jacket": "스트레치 울 재킷",
  "text_semi_order_chest_size": "가슴 사이즈",
  "text_semi_order_how_to_measure_men_shirt_chest_size_instruction01": "견갑골 상단을 가로질러 겨드랑이 사이의 등 너비를 측정합니다. 겨드랑이 사이의 가슴 앞쪽을 반복 측정합니다.",
  "text_semi_order_how_to_measure_men_shirt_chest_size_title": "가슴 사이즈 측정 방법",
  "text_semi_order_how_to_measure_men_shirt_neck_size_instruction01": "목 밑 부분을 측정합니다.",
  "text_semi_order_how_to_measure_men_shirt_neck_size_title": "목둘레 측정 방법",
  "text_semi_order_how_to_measure_men_shirt_sleeve_length_instruction02": "text_semi_order_how_to_measure_men_shirt_sleeve_length_instruction02",
  "text_semi_order_how_to_measure_men_shirt_sleeve_length_title": "슬리브 길이 측정 방법",
  "text_semi_order_how_to_measure_men_shirt_waist_size_instruction01": "허리의 가장 가는 부분 주위를 측정하세요.",
  "text_semi_order_how_to_measure_men_shirt_waist_size_title": "허리 사이즈 측정 방법",
  "text_semi_order_measure_men_shirt_neck_size": "목둘레 측정",
  "text_semi_order_measure_men_shirt_size_by_yourself": "직접 측정",
  "text_semi_order_measure_men_shirt_size_by_yourself_instruction01": "가슴 너비를 측정하고 소수점 이하에서 반올림하세요.",
  "text_semi_order_measure_men_shirt_size_by_yourself_instruction02": "가슴 너비를 측정하고 소수점 이하에서 반올림하세요.",
  "text_semi_order_measure_men_shirt_size_by_yourself_instruction03": "목 밑 부분을 측정합니다.",
  "text_semi_order_measure_men_shirt_size_by_yourself_instruction04": "text_semi_order_measure_men_shirt_size_by_yourself_instruction04",
  "text_semi_order_measure_men_shirt_sleeve_length": "슬리브 길이 측정",
  "text_semi_order_measure_using_uniqlo_men_shirt_instruction01": "UNIQLO 슈퍼 논아이론 셔츠나 캐나다 고급 천 셔츠를 준비하세요.",
  "text_semi_order_measure_using_uniqlo_men_shirt_instruction02": "셔츠 사이즈를 확인하세요.",
  "text_semi_order_measure_using_uniqlo_men_shirt_instruction04": "셔츠를 입고 첫 번째 단추를 채울 때 다음 중 목에 어떤 느낌이 드나요?",
  "text_semi_order_measure_using_uniqlo_men_shirt_instruction05": "소매 길이 조정이 필요 하신가요? 셔츠 착용후 손을 뻗었을때 손등에 조금 걸리는 정도가 이상적입니다.",
  "text_semi_order_men_shirt_collar_buttondown": "버튼다운",
  "text_semi_order_men_shirt_collar_description01": "장소불문 착용가능한 기본 칼라형",
  "text_semi_order_men_shirt_collar_description02": "넥타이 없이 목선이 깔끔하게 정리된 실루엣",
  "text_semi_order_men_shirt_collar_description03": "인기있는 칼라형으로 목선 깃이 약 90도 각도로 목둘레가 깔끔함",
  "text_semi_order_men_shirt_collar_regular": "레귤러",
  "text_semi_order_men_shirt_collar_semi_wide": "세미와이드",
  "text_semi_order_men_shirt_select_collar": "칼라 모양",
  "text_semi_order_men_shirt_select_color": "컬러 선택",
  "text_semi_order_men_shirt_texture_pinpoint_oxford": "핀포인트 옥스포드",
  "text_semi_order_neck_size": "목둘레",
  "text_semi_order_select_men_shirt_fit": "셔츠 핏",
  "text_semi_order_select_men_shirt_fit_regular": "레귤러",
  "text_semi_order_select_men_shirt_fit_regular_description01": "팔, 어깨, 가슴에 잘 맞습니다.",
  "text_semi_order_select_men_shirt_fit_slim": "슬림",
  "text_semi_order_select_men_shirt_fit_slim_description01": "깔끔하고 샤프한 핏입니다.",
  "text_semi_order_shirts_type_fine_broadcloth": "파인 브로드",
  "text_semi_order_shirts_type_fine_oxford": "파인옥스포드",
  "text_semi_order_waist_size": "허리 사이즈",
  "text_semi_order_indicator_fit": "핏",
  "text_semi_order_product_men_fine_cloth_shirts": "text_semi_order_product_men_fine_cloth_shirts",
  "text_semi_order_product_men_super_non_iron_shirts": "슈퍼 논아이론 셔츠",
  "text_semi_order_indicator_collar": "칼라",
  "text_jacket_length": "재킷 길이",
  "text_semi_order_check_dress_length": "소매 사이즈 검색",
  "text_semi_order_how_to_input_store_measure_size": "카드를 기준으로 측정 사이즈를 매장에서 선택하세요.",
  "text_semi_order_how_to_measure_jacket_sleeve_length01": "text_semi_order_how_to_measure_jacket_sleeve_length01",
  "text_semi_order_how_to_measure_length_from_shoulder_to_sleeve": "측정 방법",
  "text_semi_order_how_to_measure_using_uniqlo_jacket02": "UNIQLO 스트레치 테일러드 재킷과 줄자를 준비하세요.",
  "text_semi_order_how_to_measure_women_jacket_length_from_neck_to_shoulder_instruction01": "text_semi_order_how_to_measure_length_from_neck_to_shoulder_instruction",
  "text_semi_order_how_to_measure_women_jacket_length_from_shoulder_to_sleeve_instruction01": "재킷 단추를 잠근 상태에서 슬리브 바깥쪽 솔기를 따라 평평하게 놓습니다.",
  "text_semi_order_how_to_measure_women_jacket_length_from_shoulder_to_sleeve_instruction02": "어깨에서 슬리브까지의 길이를 측정하세요. 슬리브와 어깨의 솔기가 T자 모양으로 교차하는 부분을 기준으로 삼고, 어깨 부분이 흐트러지지 않게 살짝 잡은 상태에서 커프 중앙 부분까지를 측정합니다.",
  "text_semi_order_jacket_shape": "재킷 모양",
  "text_semi_order_jacket_size_chart": "사이즈 차트",
  "text_semi_order_select_height": "키를 선택하세요.",
  "text_semi_order_select_women_jacket_color_pattern": "컬러 및 패턴 선택",
  "text_semi_order_select_women_jacket_shape": "재킷 모양 선택",
  "text_semi_order_size_measurement_description01": "원하는 측정 옵션을 선택하세요.",
  "text_semi_order_women_jacket_one_button": "싱글 버튼",
  "text_semi_order_women_jacket_one_button_reccomendation": "스커트에 어울리는 싱글 버튼 재킷.",
  "text_semi_order_women_jacket_two_button": "더블 버튼",
  "text_semi_order_women_jacket_two_button_recommendation": "팬츠에 어울리는 더블 버튼 재킷.",
  "text_semi_order_dress_length": "드레스 길이",
  "text_semi_order_how_to_measure_jacket_length_from_shoulder_to_sleeve01": "text_semi_order_how_to_measure_jacket_length_from_shoulder_to_sleeve01",
  "text_semi_order_how_to_measure_length_from_neck_to_shoulder_title": "목에서 어깨까지의 길이 측정 방법",
  "text_semi_order_how_to_measure_length_from_shoulder_to_sleeve_title": "어깨에서 슬리브까지의 길이 측정 방법",
  "text_semi_order_how_to_measure_using_uniqlo_jacket01": "UNIQLO 재킷을 사용하여 사이즈 측정",
  "text_semi_order_length_from_neck_to_shoulder": "목에서 어깨까지의 길이",
  "text_semi_order_length_from_shoulder_to_sleeve": "어깨에서 슬리브까지의 길이",
  "text_semi_order_measure_using_uniqlo_jacket": "UNIQLO 재킷 사이즈 측정",
  "text_semi_order_owned_jacket_shirts_size": "갖고 계신 재킷 사이즈",
  "text_semi_order_select_size_using_uniqlo_jacket": "셔츠 또는 재킷 사이즈를 선택하세요.",
  "text_semi_order_sleeve_length": "슬리브 길이",
  "text_semi_order_select": "선택",
  "text_semi_order_select_size_measurement_method": "사이즈 측정 방법",
  "text_semi_order_shirts_jacket_sleeve_length": "소매",
  "text_semi_order_bust_size": "가슴 사이즈",
  "text_semi_order_how_to_measure_using_uniqlo_shirt02": "미리 셔츠 사이즈를 확인하세요.",
  "text_semi_order_measure_women_shirt_how_to_measure_chest_size_instruction": "견갑골 상단을 가로질러 겨드랑이 사이의 등 너비를 측정합니다.\n\n겨드랑이 사이의 가슴 앞쪽을 반복 측정합니다.",
  "text_semi_order_measure_women_shirt_how_to_measure_chest_size_title": "가슴 사이즈 측정 방법",
  "text_semi_order_measure_women_shirt_size_by_yourself_instruction01": "가슴 너비를 측정하고 소수점 이하에서 반올림하세요.",
  "text_semi_order_shirt_collar": "칼라 모양",
  "text_semi_order_shirt_front": "프런트",
  "text_semi_order_women_shirt_collar_regular": "레귤러",
  "text_semi_order_women_shirt_collar_regular_description": "클래식 칼라는 유행을 타지 않습니다.",
  "text_semi_order_women_shirt_collar_round": "라운드",
  "text_semi_order_women_shirt_collar_round_description": "라운드 칼라는 우아하고 여성스럽습니다.",
  "text_semi_order_women_shirt_collar_skipper": "스키퍼 칼라",
  "text_semi_order_women_shirt_collar_skipper_description": "스키퍼 칼라는 목을 드러냅니다.",
  "text_semi_order_women_shirt_front_french": "프렌치",
  "text_semi_order_women_shirt_front_french_description": "클래식하고 어디에나 어울리는 디자인으로 매일 착용할 수 있습니다.",
  "text_semi_order_women_shirt_front_fry": "플라이 프런트",
  "text_semi_order_women_shirt_front_fry_description": "세련된 룩을 위한 히든 버튼 디자인입니다.",
  "text_semi_order_women_shirt_front_pin_tuck": "핀턱",
  "text_semi_order_women_shirt_front_pin_tuck_description": "핀턱 팬츠로 어떤 룩이든 멋스럽게 연출해 보세요.",
  "text_semi_order_women_shirt_select_collar": "칼라 모양",
  "text_semi_order_women_shirt_select_color": "컬러 선택",
  "text_semi_order_women_shirt_select_front": "전면 디자인",
  "text_semi_order_how_to_measure_using_uniqlo_shirt01": "UNIQLO 셔츠를 사용하여 사이즈를 측정하세요.",
  "text_semi_order_measure_body_size": "신체 사이즈 측정",
  "text_semi_order_measure_using_uniqlo_shirt": "UNIQLO 셔츠 사이즈 측정",
  "text_semi_order_measure_women_shirt_size_by_yourself": "직접 측정",
  "text_semi_order_measure_women_shirt_size_by_yourself_description01": "길이, 목, 너비, 허리 등을 측정하고 사이즈 입력",
  "text_semi_order_measure_women_shirt_size_by_yourself_description02": "줄자를 준비하세요.",
  "text_semi_order_owned_shirts_size": "갖고 계신 셔츠 사이즈",
  "text_semi_order_shirt_alteration_extra_fee_notes": "수선 수수료가 있습니다. 자세한 내용은 다음 페이지에서 확인하세요.",
  "text_semi_order_shirt_alteration_not_select": "없음",
  "text_semi_order_shirt_size_chart": "사이즈 차트",
  "text_semi_order_input_size_instruction_measure_at_store": "매장 스탭에게 받은 측정 카드를 확인하세요.",
  "text_semi_order_select_size_measurement_method_description01": "측정 옵션을 선택하고 사이즈를 입력하세요.",
  "text_semi_order_measure_using_uniqlo_men_shirt_instruction03": "셔츠를 입었을 때 다음 중 가슴에 딱 맞는 옵션은 무엇인가요?",
  "text_semi_order_select_size": "사이즈 선택",
  "text_semi_order_body_size": "몸 사이즈",
  "text_semi_order_check_body_size": "신체 사이즈 검색",
  "text_semi_order_check_my_size": "마이 사이즈 확인",
  "text_semi_order_go_to_pdp": "확인",
  "text_semi_order_how_to_measure_at_store": "매장 스탭이 매장에서 사이즈를 측정해 드립니다.",
  "text_semi_order_measure_at_store": "매장에서 측정",
  "text_semi_order_product_preview": "임시 주문 미리보기",
  "text_semi_order_product_preview_confirmation": "제품을 확인하세요.",
  "text_semi_order_recommend_size": "권장 사이즈",
  "text_semi_order_select_size_based_on_size_suggestion": "권장 사이즈는 입력한 내용에 가장 가까운 사이즈입니다.",
  "text_semi_order_select_size_without_measurement": "측정하지 않고 사이즈 선택",
  "text_semi_order_select_size_without_measurement_description": "사이즈를 선택하세요.",
  "text_semi_order_size_measurement_method": "측정 방법",
  "text_semi_order_product_women_stretch_tailored_jacket": "스트레치 테일러드 재킷",
  "text_semi_order_product_women_supima_cotton_stretch_shirts_long_sleeve": "수피마 코튼 스트레치 롱 슬리브 셔츠",
  "text_online_store_inventory_status_in_stock": "재고있음",
  "text_online_store_inventory_status_low_stock": "품절임박",
  "text_online_store_inventory_status_out_of_stock": "재고없음",
  "text_people_also_viewed_title": "함께 본 제품",
  "text_error_select_purchased_color": "구매 컬러를 선택해 주세요.",
  "text_order_managerial_number": "관리번호",
  "text_tax_inclusive_estimated_tax": "세금(VAT)",
  "text_semi_order_indicator_color": "컬러",
  "text_semi_order_indicator_front": "프런트",
  "text_semi_order_indicator_size": "사이즈",
  "text_largestore": "대형 매장",
  "text_search_filter_allied": "적용된 필터",
  "text_view_product_details": "제품 세부정보 보기",
  "text_all": "모두",
  "text_error_failed_get_styling_wearing_item": "정보를 가져오지 못했습니다. 페이지를 새로고침해 주세요.",
  "text_wearing_items": "스타일링한 제품",
  "text_copy": "복사",
  "text_copied_to_clipboard": "클립보드에 복사됨",
  "text_find_in_store_notes01": "매장의 재고는 실시간 재고가 아니오니 정확한 재고 정보 확인을 위해서는 매장으로 전화하시거나 직접 방문하셔서 확인을 부탁드립니다. 전화로 예약 또는 주문이 불가하오니 양해 부탁드리겠습니다.",
  "text_cvs_pickup_unavailable_reason_02": "예약판매 제품을 주문하는 경우 편의점 픽업은 이용이 불가합니다.",
  "text_pay_at_store_payment_unavailable_reason_01": "예약판매 제품과 예약판매 이외의 제품을 함께 주문하는 경우 매장 결제서비스 이용이 불가합니다.",
  "text_pay_later_unavailable_reason_03": "예약판매 제품 구매 시 NP후불 결제 이용이 불가합니다.",
  "text_pre_order_notes": "예약판매에 대해",
  "text_pre_order_notes_01": "이 제품은 예약판매 제품입니다.",
  "text_pre_order_notes_02": "예약판매 제품은 수량이 한정되어 있어, 주문 한도 수량에 도달하면 예약판매가 종료됩니다.",
  "text_pre_order_notes_03": "제품 사양 및 배송일은 예고없이 변경될 수 있습니다. 미리 주의사항을 확인해 주세요.",
  "text_pre_order_notes_04": "예약판매 제품은 출고일로부터 30일 이내에 교환하실 수 있습니다.",
  "text_pre_order_notes_05": "또한 기프트 옵션은 이용할 수 없습니다. 주문 후 30분 이상 경과한 경우 취소는 불가능합니다.",
  "text_pre_order_notes_06": "예약판매 제품은 편의점수령은 불가능 합니다.",
  "text_store_pickup_unavailable_reason_03": "예약판매 제품과 예약판매 이외의 제품을 함께 주문하는 경우 [매장으로 배송]은 이용이 불가합니다.",
  "text_learn_more": "더보기",
  "text_alert_transition": "[확인] 버튼을 누르면 작성하던 리뷰가 저장되지 않습니다.",
  "text_backto_inputscreen": "리뷰 수정",
  "text_bit_loose": "크다",
  "text_bit_tight": "작다",
  "text_comments": "내용",
  "text_confirm_comments": "미리 보기",
  "text_enter_evaluation": "평가해 주세요.",
  "text_enter_nickname": "text_enter_nickname",
  "text_evaluation_required": "평가",
  "text_fitting": "고객 착용감",
  "text_nickname_note": "text_nickname_note",
  "text_ph_review_comments_example": "구매하신 제품은 어떠셨나요? 제품의 품질, 착용감, 디자인, 좋았던 점과 개선되었으면 하는 점을 작성해주세요.",
  "text_post_completion_first_reviewer": "고객님의 리뷰를 기다리고 있습니다. 많은 고객님에게 도움이 되어주세요.",
  "text_post_first_reviewer": "이 제품의 첫 리뷰를 남겨주세요!",
  "text_post_more_review": "구매하신 다른 제품에도 리뷰를 작성하시겠어요?",
  "text_post_more_review_description": "고객님의 리뷰는 다른 고객의 구매에 도움이 됩니다. 다른 제품에도 고객님의 의견을 꼭 들려주세요.",
  "text_review_agreement": "참고:",
  "text_review_already_submit": "이 제품의 리뷰를 이미 작성하셨거나,",
  "text_review_description": "리뷰 가이드라인",
  "text_review_description1": "작성해주신 리뷰는 광고 목적으로 사용될 수 있습니다.",
  "text_review_description2": "다른 브랜드, 개인 또는 조직명을 포함하는 게시글, 상품 재고나 사이즈 등에 대한 요청은 게재되지 않는 경우도 있으니 미리 양해 부탁드립니다.",
  "text_review_description4": "text_review_description4",
  "text_review_guideline_agreement": "리뷰 작성시 작성 가이드라인에 동의합니다.",
  "text_review_guideline_link": "리뷰 가이드라인",
  "text_review_post_failed": "리뷰를 게시하지 못했습니다.",
  "text_review_post_restriction": "제품 리뷰는 한 번만 작성 가능합니다.",
  "text_review_title": "제목",
  "text_review_unacceptable_before_release": "판매 전 제품의 리뷰는 작성할 수 없습니다.",
  "text_review_wearer_info": "착용자 정보",
  "text_review_wearer_info_description01": "착용자 정보를 입력해 주세요.",
  "text_review_wordlimits": "{min_comment}~{max_comment}자 사이로 작성해 주세요.",
  "text_write_review_from_purchase_history": "구매 내역에서 리뷰 쓰기",
  "text_review_other_size": "기타",
  "text_shoe_size": "신발 사이즈",
  "text_purchased_color": "구매 색상",
  "text_height": "키",
  "text_5outof5": "별 5 개 중 5 개",
  "text_1outof5": "별 5 개 중 1 개",
  "text_2outof5": "별 5 개 중 2 개",
  "text_3outof5": "별 5 개 중 3 개",
  "text_agerange": "나이",
  "text_loose": "크다",
  "text_addto_cart_exceed1": "총 금액은 {totalAmount}를 초과할 수 없습니다.",
  "text_addto_cart_exceed4": "각 제품을 {totalCount}개 초과하여 가질 수 없습니다.",
  "text_addto_cart_exceed5": "허용되는 최대 주문 한도에 도달했기 때문에 이 제품은 장바구니에 추가되지 않았습니다.",
  "text_addto_cart_exceed6": "허용되는 최대 주문 한도인 {product_upper_limit}에 초과했습니다.",
  "text_addto_cart_exceed7": "각 컬러의 최대 주문 수량 한도인 {color_upper_limit}개를 초과했습니다.",
  "text_alteration_without_tax": "수선",
  "text_prohibited_employee_purchase": "사원판매 대상이 아닙니다.",
  "text_aboutalteration": "수선 설명",
  "text_blindstitch": "오버로크 수선",
  "text_hem_sawingmachine": "일반 수선",
  "text_hemminglengh": "밑단",
  "text_inseam_blindstitch": "오버로크 수선",
  "text_inseam_doublestitch": "더블 스티치",
  "text_jacket_slevelength": "재킷: 슬리브 길이 조절",
  "text_nohem": "수선하지 않음",
  "text_risinglength": "증가",
  "text_app_search_tab_category_all": "{category} 모두보기",
  "text_promotion_term_range": "{start_date}~{end_date}",
  "text_error_failed_get_view_more_product": "제품을 가져오지 못했습니다. 페이지를 새로고침해 주세요.",
  "text_error_failed_sort": "선택한 기준으로 제품을 찾지 못했습니다. 다른 검색을 시도해 주세요.",
  "text_error_failed_sort_product": "선택하신 기준에 맞는 제품이 존재하지 않습니다. 재검색 해주시길 바랍니다.",
  "text_error_failed_update_filter_criteria": "필터 기준을 업데이트하지 못했습니다. 다시 시도해 주세요.",
  "text_error_failed_view_more": "정보를 가져오지 못했습니다. 다시 시도해 주세요.",
  "text_error_failed_view_more_product": "검색하지 못했습니다. 다시 시도해 주세요.",
  "text_clear_selected_filter_subcategory": "필터링된 카테고리 지우기",
  "text_currency": "$",
  "text_no_available_filter_criteria": "사용 가능한 필터가 없습니다.",
  "text_plus_tax_short": "세금 포함",
  "text_price_range_from": "+",
  "text_color_size_length_selection_required": "컬러와 사이즈를 선택해야 합니다.",
  "text_error_find_in_store_search_selected_sku_online_limited_item": "선택한 컬러 또는 사이즈는 온라인에서만 구매 가능합니다.",
  "text_find_in_store_no_stock": "이 제품은 현재 모든 매장에서 품절입니다.",
  "text_find_in_store_search_instruction01": "컬러와 사이즈를 선택하고 매장을 검색해 주세요.",
  "text_gps_setting_access_instruction": "위치 서비스를 활성화하신 후에 이 페이지를 새로고침하시면 이 기능을 사용하실 수 있습니다. 위치 서비스를 사용할 수 없는 경우에는 키워드 또는 우편번호를 입력하여 매장을 검색해 주세요.",
  "text_in_stock": "재고 있음",
  "text_inventory_annotation3": "text_inventory_annotation3",
  "text_low_stock": "재고 적음",
  "text_lowstock": "재고 적음",
  "text_no_stock": "재고 없음",
  "text_product_not_carried": "-",
  "text_search_store_inventory_in_other_store": "다른 매장의 재고 확인",
  "text_store_displayed_based_on_gps_information": "현 위치 기준 가까운 매장 표시",
  "text_store_inventory_purchase_alteration_restriction_notes_01": "ORDER & PICK (당일픽업) 주문은 수선이 불가합니다. 매장에서 제품 수령 후 수선 신청을 부탁드립니다.",
  "text_store_inventory_purchase_lead_time_notes_01": "빠르면 오늘 바로 받아 볼 수 있습니다.",
  "text_store_inventory_purchase_quantity_restriction_notes_01": "ORDER & PICK (당일픽업) 주문 시 제품당 1장씩만 선택 가능합니다. 수량을 변경해 주세요",
  "text_store_inventory_purchase_restriction_instruction_01": "2개 이상의 제품 또는 수선은 허용되지 않습니다. 수량 또는 수선을 변정해 주세요.",
  "text_store_inventory_purchase_restriction_instruction_02": "확인해 주세요.",
  "text_store_inventory_purchase_restriction_title": "ORDER & PICK (당일픽업) 설명",
  "text_store_inventory_search_form": "매장 찾기",
  "text_suggest_turn_on_location_service": "위치 서비스가 켜져 있으면 가장 가까운 매장 재고 상태를 표시할 수 있습니다.",
  "text_collapse_options": "축소",
  "text_display_large": "라지",
  "text_display_list": "리스트",
  "text_display_mid": "미디움",
  "text_expand_options": "확장",
  "text_multi_buy_meta_description": "UNIQLO {multi_buy_name} 페이지입니다.",
  "text_multi_buy_meta_title": "{multi_buy_name} 세트할인",
  "text_breadcrumb_limitedoffers": "/기간 한정",
  "text_markdown_items": "가격 인하",
  "text_markdown_title": "모든 매장 프로모션",
  "text_markeddown_description": "보다 더 저렴한 - 가격인하 아이템",
  "text_mulitbuy_bread_b": "BABY / 세트할인",
  "text_mulitbuy_bread_k": "KIDS / 세트할인",
  "text_mulitbuy_bread_m": "MEN / 세트할인",
  "text_mulitbuy_bread_w": "WOMEN / 세트할인",
  "text_multibuy_description": "세트할인",
  "text_multibuy_paypal_applied_items": "text_multibuy_paypal_applied_items",
  "text_newarrivals": "NEW",
  "text_newarrivals_bread_b": "BABY / NEW",
  "text_newarrivals_bread_k": "KIDS / NEW",
  "text_newarrivals_bread_m": "MEN / NEW",
  "text_newarrivals_bread_w": "WOMEN / NEW",
  "text_newarrivals_description": "매주 업데이트 되는 NEW ITEM",
  "text_top_selling_products_title": "요즘 잘나가는 제품",
  "text_confirm_mysize": "마이 사이즈 보기",
  "text_additional_discount": "네비게이션_배송",
  "text_babys": "Baby's",
  "text_check_shipping_address_delivery_availability": "네비게이션_배송",
  "text_error_failed_to_get_pdp_movie_app_instruction_01": "네트워크를 확인하고 다시 시도해 주세요.",
  "text_exchange_form_out_of_stock_exchange_title": "재고없음",
  "text_exchange_form_out_of_stock_item_exchange_note_01": "죄송합니다. 일부 제품은 재고가 없습니다.",
  "text_exchange_form_out_of_stock_item_exchange_note_02": "이전 페이지로 가셔서, 재고가 없는 제품은 삭제해 주세요.",
  "text_mens": "Men's",
  "text_meta_description_postfix_l3": "다양한 사이즈, 컬러, 소재 중에서 합리적인 가격으로 최고의 아웃핏을 찾아보세요!",
  "text_meta_description_prefix_l3": "UNIQLO{sub_categories}에서 {number_of_items}개의 스타일리시하고 편안한 {gender} {category}을(를) 쇼핑해 보세요!",
  "text_meta_description_subcatogery": "({sub_categories} 등 포함)",
  "text_meta_title_prefix_l3": "| UNIQLO",
  "text_ph_search_by_keyword": "키워드로 검색",
  "text_pre_order_available_date_early": "예약판매 제품: {month}월초 입고 예정",
  "text_pre_order_available_date_late": "예약판매 제품: {month}월말 입고 예정",
  "text_pre_order_available_date_mid": "예약판매 제품: {month}월중순 입고 예정",
  "text_pre_order_specific_available_date": "예약판매 제품: {date} 입고 예정",
  "text_pre_order_specific_available_specific_date": "{date}입하 예정",
  "text_price_change_start": "네비게이션_가격",
  "text_promotion_term_format": "{start_date}부터 {end_date}까지",
  "text_store_inventory_purhcase_unavailable_unreleased_product": "현재 매장에서 판매되지 않는 제품입니다.",
  "text_stylehint_model_information": "모델: {model_height}cm",
  "text_tax_excluded_information": "제품가격(세금포함)",
  "text_tax_inclusive_all_order_total": "합계",
  "text_womens": "WOMEN",
  "text_alteration_length": "길이",
  "text_color_size_warning": "컬러와 사이즈를 선택해 주세요.",
  "text_company_address_brandix_apparel_india_pvt_ltd_unit2_01": "india_회사주소",
  "text_company_address_brandix_apparel_india_pvt_ltd_unit3_01": "india_회사주소",
  "text_company_address_orient_fashion_exports_india_pvt_ltd_01": "india_회사주소",
  "text_company_address_shanhi_exports_pvt_ltd_01": "shanhi_회사주소",
  "text_company_address_shanhi_exports_pvt_ltd_02": "shanhi_회사주소",
  "text_company_address_shanhi_exports_pvt_ltd_03": "shanhi_회사주소",
  "text_company_address_shanhi_textiles_limited_01": "PDP",
  "text_company_address_tangerine_design_pvt_ltd_01": "PDP",
  "text_company_address_uniqlo_india_pvt_ltd_01": "PDP",
  "text_company_name_brandix_apparel_india_pvt_ltd_unit2": "india_회사이름",
  "text_company_name_brandix_apparel_india_pvt_ltd_unit3": "india_회사이름",
  "text_company_name_orient_fashion_exports_india_pvt_ltd": "india_회사이름",
  "text_company_name_shanhi_exports_pvt_ltd": "shanhi_회사이름",
  "text_company_name_shanhi_textiles_limited": "PDP",
  "text_company_name_tangerine_design_pvt_ltd": "PDP",
  "text_company_name_uniqlo_india_pvt_ltd": "PDP",
  "text_country_ad": "Andorra, Principality of",
  "text_country_ae": "United Arab Emirates",
  "text_country_af": "Afghanistan, Islamic Republic of",
  "text_country_ag": "Antigua and Barbuda",
  "text_country_ai": "Anguilla",
  "text_country_al": "Albania, Republic of",
  "text_country_am": "Armenia, Republic of",
  "text_country_ao": "Angola, Republic of",
  "text_country_aq": "Antarctica",
  "text_country_ar": "Argentina (Argentine Republic)",
  "text_country_as": "Samoa, Independent State of",
  "text_country_at": "Austria, Republic of",
  "text_country_au": "Australia",
  "text_country_aw": "Aruba",
  "text_country_ax": "Åland Islands",
  "text_country_az": "Azerbaijan, Republic of",
  "text_country_ba": "Bosnia and Herzegovina",
  "text_country_bb": "Barbados",
  "text_country_bd": "Bangladesh, People's Republic of",
  "text_country_be": "Belgium, Kingdom of",
  "text_country_bf": "Burkina Faso",
  "text_country_bg": "Bulgaria, Republic of",
  "text_country_bh": "Bahrain, Kingdom of",
  "text_country_bi": "Burundi, Republic of",
  "text_country_bj": "Benin, Republic of",
  "text_country_bl": "Saint Barthélemy",
  "text_country_bm": "Bermuda",
  "text_country_bn": "Brunei Darussalam",
  "text_country_bo": "Bolivia, Plurinational State of",
  "text_country_bq": "Bonaire, Sint Eustatius and Saba",
  "text_country_br": "Brazil, Federative Republic of",
  "text_country_bs": "Bahamas, Commonwealth of the",
  "text_country_bt": "Bhutan, Kingdom of",
  "text_country_bv": "Bouvet Island",
  "text_country_bw": "Botswana, Republic of",
  "text_country_by": "Belarus, Republic of",
  "text_country_bz": "Belize",
  "text_country_ca": "Canada",
  "text_country_cc": "Cocos (Keeling) Islands",
  "text_country_cd": "Congo, the Democratic Republic of the",
  "text_country_cf": "Central African Republic",
  "text_country_cg": "Congo",
  "text_country_ch": "Switzerland (Swiss Confederation)",
  "text_country_ci": "Côte d'Ivoire, Republic of",
  "text_country_ck": "Cook Islands",
  "text_country_cl": "Chile, Republic of",
  "text_country_cm": "Cameroon, Republic of",
  "text_country_cn": "China, People's Republic of",
  "text_country_co": "Colombia, Republic of",
  "text_country_cr": "Costa Rica, Republic of",
  "text_country_cu": "Cuba, Republic of",
  "text_country_cv": "The Republic of Cabo Verde",
  "text_country_cw": "Curaçao",
  "text_country_cx": "Christmas Island",
  "text_country_cy": "Cyprus, Republic of",
  "text_country_cz": "Czech Republic",
  "text_country_de": "Germany, Federal Republic of",
  "text_country_dj": "Djibouti, Republic of",
  "text_country_dk": "Denmark, Kingdom of",
  "text_country_dm": "Dominica, Commonwealth of",
  "text_country_do": "Dominican Republic",
  "text_country_dz": "Algeria, People's Democratic Republic of",
  "text_country_ec": "Ecuador, Republic of",
  "text_country_ee": "Estonia, Republic of",
  "text_country_eg": "Egypt, Arab Republic of",
  "text_country_eh": "Western Sahara",
  "text_country_er": "Eritrea, State of",
  "text_country_es": "Spain, Kingdom of",
  "text_country_et": "Ethiopia, Federal Democratic Republic of",
  "text_country_fi": "Finland, Republic of",
  "text_country_fj": "Fiji, Republic of",
  "text_country_fk": "Falkland Islands (Malvinas)",
  "text_country_fm": "Micronesia, Federated States of",
  "text_country_fo": "Faroe Islands",
  "text_country_fr": "France (French Republic)",
  "text_country_ga": "Gabon (Gabonese Republic)",
  "text_country_gb": "United Kingdom of Great Britain and Northern Ireland",
  "text_country_gd": "Grenada",
  "text_country_ge": "Georgia",
  "text_country_gf": "French Guiana",
  "text_country_gg": "Guernsey",
  "text_country_gh": "Ghana, Republic of",
  "text_country_gi": "Gibraltar",
  "text_country_gl": "Greenland",
  "text_country_gm": "Gambia, Republic of The",
  "text_country_gn": "Equatorial Guinea, Republic of",
  "text_country_gp": "Guadeloupe",
  "text_country_gq": "Equatorial Guinea, Republic of",
  "text_country_gr": "Greece (Hellenic Republic)",
  "text_country_gs": "South Georgia and the South Sandwich Islands",
  "text_country_gt": "Guatemala, Republic of",
  "text_country_gu": "Guam",
  "text_country_gw": "Guinea-Bissau, Republic of",
  "text_country_gy": "Guyana, Co-operative Republic of",
  "text_country_hk": "Hong Kong",
  "text_country_hm": "Heard Island and McDonald Islands",
  "text_country_hn": "Honduras, Republic of",
  "text_country_hr": "Croatia, Republic of",
  "text_country_ht": "Haiti, Republic of",
  "text_country_hu": "Hungary",
  "text_country_id": "Indonesia, Republic of",
  "text_country_ie": "Ireland",
  "text_country_il": "Israel, State of",
  "text_country_im": "Isle of Man",
  "text_country_in": "India, Republic of",
  "text_country_io": "British Indian Ocean Territory",
  "text_country_iq": "Iraq, Republic of",
  "text_country_ir": "Iran, Islamic Republic of",
  "text_country_is": "Iceland",
  "text_country_it": "Italy (Italian Republic)",
  "text_country_je": "Jersey",
  "text_country_jm": "Jamaica",
  "text_country_jo": "Jordan, Hashemite Kingdom of",
  "text_country_jp": "Japan",
  "text_country_ke": "Kenya, Republic of",
  "text_country_kg": "Kyrgyzstan (Kyrgyz Republic)",
  "text_country_kh": "Cambodia, Kingdom of",
  "text_country_ki": "Kiribati, Republic of",
  "text_country_km": "Comoros, Union of the",
  "text_country_kn": "Saint Kitts and Nevis",
  "text_country_kp": "Korea, Democratic People's Republic of",
  "text_country_kr": "Korea, Republic of",
  "text_country_kw": "Kuwait, State of",
  "text_country_ky": "Cayman Islands",
  "text_country_kz": "Kazakhstan, Republic of",
  "text_country_la": "Lao People's Democratic Republic",
  "text_country_lb": "Lebanon (Lebanese Republic)",
  "text_country_lc": "Saint Lucia",
  "text_country_li": "Liechtenstein, Principality of",
  "text_country_lk": "Sri Lanka, Democratic Socialist Republic of",
  "text_country_lr": "Liberia, Republic of",
  "text_country_ls": "Lesotho, Kingdom of",
  "text_country_lt": "Lithuania, Republic of",
  "text_country_lu": "Luxembourg, Grand Duchy of",
  "text_country_lv": "Latvia, Republic of",
  "text_country_ly": "Libya, State of",
  "text_country_ma": "Morocco, Kingdom of",
  "text_country_mc": "Monaco, Principality of",
  "text_country_md": "Republic of Moldova",
  "text_country_me": "Montenegro",
  "text_country_mf": "Collectivity of Saint Martin",
  "text_country_mg": "Madagascar, Republic of",
  "text_country_mh": "Marshall Islands, Republic of the",
  "text_country_mk": "North Macedonia, Republic of",
  "text_country_ml": "Mali, Republic of",
  "text_country_mm": "Myanmar, Republic of the Union of",
  "text_country_mn": "Mongolia",
  "text_country_mo": "Macao",
  "text_country_mp": "Northern Mariana Islands",
  "text_country_mq": "Martinique",
  "text_country_mr": "Mauritania, Islamic Republic of",
  "text_country_ms": "Montserrat",
  "text_country_mt": "Malta, Republic of",
  "text_country_mu": "Mauritius, Republic of",
  "text_country_mv": "Maldives, Republic of",
  "text_country_mw": "Malawi, Republic of",
  "text_country_mx": "Mexico (United Mexican States)",
  "text_country_my": "Malaysia",
  "text_country_mz": "Mozambique, Republic of",
  "text_country_na": "Namibia, Republic of",
  "text_country_nc": "New Caledonia",
  "text_country_ne": "Niger, Republic of the",
  "text_country_nf": "Norfolk Island",
  "text_country_ng": "Nigeria, Federal Republic of",
  "text_country_ni": "Nicaragua, Republic of",
  "text_country_nl": "Netherlands, Kingdom of the",
  "text_country_no": "Norway, Kingdom of",
  "text_country_np": "Nepal, Federal Democratic Republic of",
  "text_country_nr": "Nauru, Republic of",
  "text_country_nu": "Niue",
  "text_country_nz": "New Zealand",
  "text_country_of_origin": "제조국",
  "text_country_om": "Oman, Sultanate of",
  "text_country_pa": "Panama, Republic of",
  "text_country_pe": "Peru, Republic of",
  "text_country_pf": "French Polynesia",
  "text_country_pg": "Papua New Guinea, Independent State of",
  "text_country_ph": "Philippines, Republic of the",
  "text_country_pk": "Pakistan, Islamic Republic of",
  "text_country_pl": "Poland, Republic of",
  "text_country_pm": "Saint Pierre and Miquelon",
  "text_country_pn": "Pitcairn",
  "text_country_pr": "Puerto Rico",
  "text_country_ps": "Palestine, State of",
  "text_country_pt": "Portugal (Portuguese Republic)",
  "text_country_pw": "Palau, Republic of",
  "text_country_py": "Paraguay, Republic of",
  "text_country_qa": "Qatar, State of",
  "text_country_re": "Réunion",
  "text_country_ro": "Romania",
  "text_country_rs": "Serbia, Republic of",
  "text_country_ru": "Russian Federation",
  "text_country_rw": "Rwanda, Republic of",
  "text_country_sa": "Saudi Arabia, Kingdom of",
  "text_country_sb": "Solomon Islands",
  "text_country_sc": "Seychelles, Republic of",
  "text_country_sd": "Sudan",
  "text_country_se": "Sweden, Kingdom of",
  "text_country_sg": "Singapore, Republic of",
  "text_country_sh": "Saint Helena, Ascension and Tristan da Cunha",
  "text_country_si": "Slovenia, Republic of",
  "text_country_sj": "Svalbard and Jan Mayen Islands",
  "text_country_sk": "Slovakia (Slovak Republic)",
  "text_country_sl": "Sierra Leone, Republic of",
  "text_country_sm": "San Marino, Republic of",
  "text_country_sn": "Senegal, Republic of",
  "text_country_so": "Somalia, Federal Republic of",
  "text_country_sr": "Suriname, Republic of",
  "text_country_ss": "South Sudan, Republic of",
  "text_country_st": "Sao Tome and Principe, Democratic Republic of",
  "text_country_sv": "El Salvador, Republic of",
  "text_country_sx": "Sint Maarten",
  "text_country_sy": "Syrian Arab Republic",
  "text_country_sz": "Swaziland",
  "text_country_tc": "Turks and Caicos Islands",
  "text_country_td": "Chad, Republic of",
  "text_country_tf": "French Southern Territories",
  "text_country_tg": "Togo (Togolese Republic)",
  "text_country_th": "Thailand, Kingdom of",
  "text_country_tj": "Tajikistan, Republic of",
  "text_country_tk": "Tokelau",
  "text_country_tl": "Timor Leste, Democratic Republic of",
  "text_country_tm": "Turkmenistan",
  "text_country_tn": "Tunisia, Republic of",
  "text_country_to": "Tonga, Kingdom of",
  "text_country_tr": "Türkiye, Republic of",
  "text_country_tt": "Trinidad and Tobago, Republic of",
  "text_country_tv": "Tuvalu",
  "text_country_tw": "Taiwan, Province of China",
  "text_country_tz": "United Republic of Tanzania",
  "text_country_ua": "Ukraine",
  "text_country_ug": "Uganda, Republic of",
  "text_country_um": "United States Minor Outlying Islands",
  "text_country_us": "United States of America",
  "text_country_uy": "Uruguay, Eastern Republic of",
  "text_country_uz": "Uzbekistan, Republic of",
  "text_country_va": "Holy See (Vatican City State)",
  "text_country_vc": "Saint Vincent and the Grenadines",
  "text_country_ve": "Venezuela, Bolivarian Republic of",
  "text_country_vg": "Virgin Islands, British",
  "text_country_vi": "Virgin Islands, U.S.",
  "text_country_vn": "Viet Nam, Socialist Republic of",
  "text_country_vu": "Vanuatu, Republic of",
  "text_country_wf": "Wallis and Futuna",
  "text_country_ws": "Samoa, Independent State of",
  "text_country_ye": "Yemen, Republic of",
  "text_country_yt": "Mayotte",
  "text_country_za": "South Africa, Republic of",
  "text_country_zm": "Zambia, Republic of",
  "text_country_zw": "Zimbabwe, Republic of",
  "text_customer_center_address_label": "PDP",
  "text_customer_service": "PDP",
  "text_customer_service_email_address": "PDP",
  "text_customer_service_operation_hour": "PDP",
  "text_customer_service_operation_hour_label": "PDP",
  "text_customer_service_toll_free_dial_phone_number": "PDP",
  "text_doublestitch": "더블 스티치",
  "text_error_addtocart_coupon_amount": "죄송합니다. 장바구니에 제품이 추가되지 않았습니다. 적용된 쿠폰을 삭제후 다시 시도해 주세요.",
  "text_error_failed_add_to_cart_cart_total_smaller_coupon_discount": "장바구니에 추가하지 못했습니다. 장바구니 페이지에서 적용된 쿠폰을 삭제하고 다시 시도해 주세요.",
  "text_error_semi_order_add_to_cart_alteration_required": "이 제품은 수선 선택이 필요합니다. 수선 사항을 선택한 다음 장바구니에 다시 추가하세요.",
  "text_find_in_store_meta_description": "매장 페이지에서 찾은 UNIQLO {product_name}({l1_category name})입니다.",
  "text_functionality": "기능 세부정보",
  "text_instock": "재고 있음",
  "text_length:": "길이:",
  "text_model_size_label01": "모델: {height}cm, 착용사이즈: {size_code}",
  "text_net_quantity": "수량",
  "text_net_quantity_unit": "수령",
  "text_newcustomer": "신규 고객 대상",
  "text_pre_order_on_sale_soon": "판매 예정",
  "text_product_detail_meta_description_02": "text_product_detail_meta_description_02",
  "text_product_disclaimer_text_01": "PDP",
  "text_product_imported_and_marketed_by": "PDP",
  "text_product_manufactured_by": "PDP",
  "text_product_review_meta_description": "UNIQLO {product_name} 리뷰 페이지입니다.",
  "text_reselling_available_date": "가능한 날짜",
  "text_select_color": "컬러를 선택해 주세요.",
  "text_select_color_size": "컬러와 사이즈를 선택해 주세요.",
  "text_select_length": "길이를 선택해 주세요.",
  "text_select_size": "사이즈를 선택해 주세요.",
  "text_size_recommendation_check_your_recommend_size": "권장 사이즈 확인",
  "text_store_inventory_search": "매장에서 찾기",
  "text_toll_free_dial": "PDP",
  "text_app_membership_exclusive_limited_offer": "APP회원 한정",
  "text_app_membership_exclusive_limited_offer_until": "{startDate}부터 {date}까지 {flagName}",
  "text_app_membership_exclusive_limitedoffers_until": "{startDate}부터 {date}까지 APP회원 한정 특별가격",
  "text_app_membership_exclusive_multi_buy": "APP회원 한정 세트할인",
  "text_app_membership_exclusive_multi_buy_until": "{startDate}부터 {date}까지 APP회원 한정 세트할인",
  "text_agerange_typea_range0": "10대 미만",
  "text_agerange_typea_range1": "10대",
  "text_agerange_typea_range2": "20대",
  "text_agerange_typea_range3": "30대",
  "text_agerange_typea_range4": "40대",
  "text_agerange_typea_range5": "50대",
  "text_agerange_typea_range6": "60대 이상",
  "text_agerange_typeb_range0": "17세 이하",
  "text_agerange_typeb_range1": "18~24세",
  "text_agerange_typeb_range10": "나이 타입",
  "text_agerange_typeb_range11": "나이 타입",
  "text_agerange_typeb_range12": "나이 타입",
  "text_agerange_typeb_range13": "나이 타입",
  "text_agerange_typeb_range14": "나이 타입",
  "text_agerange_typeb_range2": "25~34세",
  "text_agerange_typeb_range3": "35~44세",
  "text_agerange_typeb_range4": "45~54세",
  "text_agerange_typeb_range5": "55~64세",
  "text_agerange_typeb_range6": "65세 이상",
  "text_agerange_typeb_range7": "나이 타입",
  "text_agerange_typeb_range8": "나이 타입",
  "text_agerange_typeb_range9": "나이 타입",
  "text_agreeto_terms_conditions": "이용약관에 동의합니다.",
  "text_duplicate_review": "죄송합니다. 이 제품의 리뷰를 이미 제출하셨습니다.",
  "text_enter_comments": "리뷰를 입력해 주세요.",
  "text_enter_fitting": "사이즈를 입력해 주세요.",
  "text_enter_gender": "성별을 선택해 주세요.",
  "text_enter_purchasedsize": "구매 사이즈를 선택해 주세요.",
  "text_enter_residence": "거주지역을 선택해 주세요.",
  "text_enter_review": "리뷰를 제출해 주세요.",
  "text_enter_review_rating": "평점을 선택하세요.",
  "text_enter_reviewcomments": "리뷰 코멘트를 입력해 주세요.",
  "text_enter_rewviewtitle": "리뷰 제목을 입력해 주세요.",
  "text_error_failed_get_review_selectable_value": "죄송합니다. 오류가 발생했습니다. 페이지를 새로고침 부탁 드립니다.",
  "text_error_failed_get_review_title": "리뷰 제목을 가져오지 못했습니다.",
  "text_error_reject_post_review_inappropriate_contents": "타사 브랜드 이름과 부적절한 내용이 포함되어 리뷰를 게시할 수 없습니다.\n리뷰 내용 수정후 다시 게시 부탁 드리겠습니다.",
  "text_error_submit_review_description_address": "리뷰 내에 이메일 주소를 입력할 수 없습니다.",
  "text_error_submit_review_description_body": "해당 영역 : 내용",
  "text_error_submit_review_description_matched_text": "수정이 필요한 단어: {matchedText}",
  "text_error_submit_review_description_ng_wording": "리뷰 내에 부적절한 단어가 포함되어 있습니다. 수정을 부탁 드립니다.",
  "text_error_submit_review_description_nickname": "",
  "text_error_submit_review_description_phone": "리뷰 내에 전화번호를 입력할 수 없습니다.",
  "text_error_submit_review_description_title": "해당 영역 : 제목",
  "text_error_submit_review_description_url": "리뷰 내에 URL을 입력할 수 없습니다.",
  "text_example": "예: 미디움, 25inch",
  "text_footsize": "발 사이즈",
  "text_footsize_over": "28cm 이상",
  "text_footsize_under": "22cm 미만",
  "text_guideline": "리뷰 가이드라인",
  "text_height_over": "181cm 이상",
  "text_height_under": "65cm 미만",
  "text_lessthan": "미만",
  "text_morethan": "초과",
  "text_nickname_valid_characters": "text_nickname_valid_characters",
  "text_ph_review_comments": "구매하신 제품은 어떠셨나요?",
  "text_posted_review_migration_notes": "※ 2020년 7월 16일 이전에 올린 리뷰는 현재 이 페이지에서는 표시되지 않습니다.",
  "text_reivew_comment_nickname_valid_characters": "4글자 이상 20글자 이내로 입력해주세요.",
  "text_review_announcement": "text_review_announcement",
  "text_review_announcement_link": "text_review_announcement_link",
  "text_review_comments_validation": "일반적으로 부적절한 것으로 판단되는 단어나 구문이 코멘트에 포함되어 있습니다. 수정해 주세요.",
  "text_review_description3": "리뷰 가이드라인",
  "text_review_filter_gender_female": "여성",
  "text_review_filter_gender_male": "남성",
  "text_review_filter_gender_no_answer": "대답 없음",
  "text_review_filter_gender_other": "기타",
  "text_review_helpful_feedback": "의견을 보내 주셔서 감사합니다!",
  "text_review_no_title_placeholder": "리뷰 제목 없음",
  "text_review_refinesearch": "리뷰 검색",
  "text_review_thankyou": "리뷰해 주셔서 감사합니다!",
  "text_review_title_valid_characters": "리뷰 제목은 100자 이내로 작성해주세요.",
  "text_selectage": "나이를 선택하세요.",
  "text_category_meta_description": "UNIQLO {l3_category_name}({l1_category_name}) 제품입니다.",
  "text_error_address_autofill": "오류가 발생했습니다. 다시 시도하거나, 주소를 입력해 주세요.",
  "text_image_seach_support_browser_os": "iOS 8 이상 및 Android 4.4.3 이상 기기에서 Safari 또는 Chrome을 이용하세요. 위의 조건을 만족하더라도 일부 기기에서는 이미지가 제대로 검색되지 않을 수 있습니다.",
  "text_keyword": "키워드",
  "text_no_search_result_tips01": "철자를 확인해 주세요.",
  "text_no_search_result_tips02": "다른 키워드를 사용해 보세요.",
  "text_ph_category_search": "카테고리로 검색",
  "text_product_detail_meta_description": "UNIQLO {product_name}({l1_category_name}) 세부정보입니다.",
  "text_search_other_method": "기타 방법으로 검색",
  "text_search_result_meta_description": "UNIQLO {query} 검색 결과입니다. 스타일, 사이즈, 컬러, 가격 또는 판매 유형으로 필터링할 수 있습니다.",
  "text_search_results_items": "필터 | 일치 항목: {count}개 결과",
  "text_semi_order_how_to_measure_length_from_neck_to_shoulder": "측정 방법",
  "text_semi_order_how_to_measure_men_shirt_sleeve_length_instruction01": "커프는 어디에서 끝나야 합니까? 이상적으로는 손목 아래 손등에 닿는 편이 좋습니다.",
  "text_semi_order_how_to_measure_sleeve_length": "측정 방법",
  "text_semi_order_measure_men_shirt_size_by_yourself_description02": "줄자를 준비하세요.",
  "text_semi_order_measurement_available_store": "이용 가능 매장",
  "text_semi_order_men_shirt_collar_cutaway": "화면 전환",
  "text_semi_order_product_customization_page": "사이즈 선택",
  "text_semi_order_select_men_jacket_fit": "재킷 핏 선택",
  "text_semi_order_select_men_shirt_fit_image_notes": "레귤러/슬림",
  "text_semi_order_shirt_use_alteration": "수선 옵션",
  "text_semi_order_title": "text_semi_order_title",
  "text_semi_order_top": "text_semi_order_top",
  "text_semi_order_women_shirt_skipper_collar_description": "스키퍼 칼라는 목을 드러냅니다.",
  "text_suggest_turn_on_location_service_in_store_select": "위치 접근 허용 시 가까운 매장이 표시됩니다.",
  "text_all_styling": "모든 스타일링",
  "text_app_viewmore_official_outfit": "공식 아웃핏 더 보기",
  "text_app_viewmore_stylehint_outfit": "StyleHint 스타일링 더 보기",
  "text_canada_post_office_box_unavailable_confirmation": "스타일링",
  "text_error_failed_save_information_due_to_not_supported_character_in_form": "사용 불가능한 문자나 기호가 포함되어 있어 저장할 수 없습니다. 입력한 내용을 확인하고 변경해 주세요.",
  "text_error_not_supported_character_in_form": "한글,영문,숫자,일부 특수문자에 한하여 가능합니다.",
  "text_styling_id_alt_tag": "UNIQLO 스타일링북 사진. 스타일 ID: <{styleid}>",
  "text_stylehint_product_details_filter_height_001": "≦ 60 cm",
  "text_stylehint_product_details_filter_height_002": "60 cm - 65 cm",
  "text_stylehint_product_details_filter_height_003": "65 cm - 70 cm",
  "text_stylehint_product_details_filter_height_004": "70 cm - 75 cm",
  "text_stylehint_product_details_filter_height_005": "75 cm - 80 cm",
  "text_stylehint_product_details_filter_height_006": "80 cm - 85 cm",
  "text_stylehint_product_details_filter_height_007": "85 cm - 90 cm",
  "text_stylehint_product_details_filter_height_008": "90 cm -95 cm",
  "text_stylehint_product_details_filter_height_009": "95 cm - 100 cm",
  "text_stylehint_product_details_filter_height_010": "100 cm - 105 cm",
  "text_stylehint_product_details_filter_height_011": "105 cm - 110 cm",
  "text_stylehint_product_details_filter_height_012": "110 cm -115 cm",
  "text_stylehint_product_details_filter_height_013": "115 cm - 120 cm",
  "text_stylehint_product_details_filter_height_014": "120 cm - 125 cm",
  "text_stylehint_product_details_filter_height_015": "125 cm - 130 cm",
  "text_stylehint_product_details_filter_height_016": "130 cm - 135 cm",
  "text_stylehint_product_details_filter_height_017": "135 cm - 140 cm",
  "text_stylehint_product_details_filter_height_018": "140 cm -145 cm",
  "text_stylehint_product_details_filter_height_019": "145 cm - 150 cm",
  "text_stylehint_product_details_filter_height_020": "150 cm - 155 cm",
  "text_stylehint_product_details_filter_height_021": "155 cm - 160 cm",
  "text_stylehint_product_details_filter_height_022": "160 cm -165 cm",
  "text_stylehint_product_details_filter_height_023": "165 cm - 170 cm",
  "text_stylehint_product_details_filter_height_024": "170 cm - 175 cm",
  "text_stylehint_product_details_filter_height_025": "175 cm - 180 cm",
  "text_stylehint_product_details_filter_height_026": "180 cm - 185 cm",
  "text_stylehint_product_details_filter_height_027": "185 cm - 190 cm",
  "text_stylehint_product_details_filter_height_028": "190 cm -195 cm",
  "text_stylehint_product_details_filter_height_029": "195 cm -200 cm",
  "text_stylehint_product_details_filter_height_030": "200 cm - 205 cm",
  "text_stylehint_product_details_filter_height_032": "≦ 155 cm",
  "text_stylehint_product_details_filter_height_035": "≦ 150 cm",
  "text_stylehint_product_details_filter_height_036": "≦ 160 cm",
  "text_comments_valid_characters": "코멘트는 50~999자 사이여야 합니다.",
  "text_network_error_backto_home": "HOME",
  "text_network_error_description": "일시적 시스템 오류가 발생하였습니다.\n 새로고침 후 다시 시도해 주세요.",
  "text_network_error_title": "시스템 오류",
  "text_show_only_in_stock_store": "재고가 있는 매장만 표시",
  "text_check_store_inventory_message_01": "“매장 선택”에서 지정한 매장의 재고 확인이 가능합니다.",
  "text_select_a_store": "매장 선택",
  "text_only_store_inventory": "매장 재고만",
  "text_return_to_product_search": "제품 검색으로 돌아가기",
  "text_order_and_pick_not_available": "ORDER & PICK (당일픽업)을 사용할 수 없습니다.",
  "text_recently_used_store": "최근 이용한 매장",
  "text_select_store": "매장 선택",
  "text_selected_store": "선택한 매장",
  "text_selected_store_message_01": "매장에 재고가 있는 경우 매장 선택 후 구매 가능합니다.",
  "text_selected_item": "선택한 제품",
  "text_change_store": "변경",
  "text_store_inventory_search_display_specific_store_inventory": "{Store name} 재고 포함",
  "text_store_inventory_search_display_store_inventory": "매장재고도 표시",
  "text_official_styling_non_listed_items_message_01": "※ 위에 제품 정보가 없는 착용 제품의 경우, 타사브랜드제품 혹은 유니클로 과거제품입니다.",
  "text_personalization_onboarding_share_your_location_description": "text_personalization_onboarding_share_your_location_description",
  "text_personalization_onboarding_share_your_location_title": "text_personalization_onboarding_share_your_location_title",
  "text_unattended_delivery_applied_message_01": "이 주문은 위탁장소 지정 배송({unattended_delivery_location})이 적용됩니다.",
  "text_unattended_delivery_instruction_01": "위탁 장소 미사용시 “위탁 장소 사용 안함”을 선택해 주세요.",
  "text_do_not_use_unattended_delivery": "위탁장소 미지정",
  "text_about_store_inventory_purchase": "ORDER & PICK (당일픽업)에 대해",
  "text_check_order_history": "2024년 2월 20일 이전 주문 내역 확인",
  "text_customer_order_complete_payment_with_credit_card": "text_customer_order_complete_payment_with_credit_card",
  "text_cannot_issue_purchase_certification_message_01": "구매 확정",
  "text_how_to_issue_purchase_certification_link": "구매 확정",
  "text_issue_purchase_certification_all_items_returned": "구매 확정",
  "text_issue_purchase_certification_button": "구매 확정",
  "text_issue_purchase_certification_message_01": "구매 확정",
  "text_issue_purchase_certification_when_available": "구매 확정",
  "text_item_original_order_number": "원거래 주문번호",
  "text_item_reshipment_order_added_by_operator_note": "고객센터 직원이 추가한 재출하 주문입니다.",
  "text_item_reshipment_order_number": "재출하 주문번호",
  "text_item_view_original_order": "원거래 주문보기",
  "text_order_history_detail_open_membership": "멤버십 바코드ID 열기",
  "text_return_form_about_return_and_exchange": "반품/교환 설명",
  "text_return_form_ec_receipt": "구매 내역서 보기",
  "text_return_form_return_due_date": "반품 기한",
  "text_return_form_instore_purchase": "매장",
  "text_return_form_online_purchase": "온라인",
  "text_no_purchase_in_store": "현재 확인할 수 있는 전자 영수증이 없습니다.",
  "text_order_history_in_store_purchase_e_receipts_note": "※ 전자 영수증에 대한 자세한 내용은 {clickHere}.",
  "text_order_history_in_store_purchase_e_receipts_note_view_faq": "여기(클릭)",
  "text_order_history_in_store_purchase_note": "매장 내 구매에 대한 전자 영수증만 표시됩니다.",
  "text_return_form_purchase_date": "구입일",
  "text_return_form_receipt_number": "영수증 번호",
  "text_return_form_purchase_store": "구입매장",
  "text_item_reshipment_order": "재출하 주문",
  "text_return_details_return_shipping_label_qr_code_confirmation_email_description": "text_return_details_return_shipping_label_qr_code_confirmation_email_description",
  "text_return_form_refund_amount": "환불 금액",
  "text_return_form_return_number": "반품 번호",
  "text_return_form_no_return_item": "반품된 제품이 없습니다.",
  "text_return_form_refund_issued": "환불됨",
  "text_return_form_return_completed": "반품 완료됨",
  "text_return_form_return_items_quantity": "반품 수량",
  "text_return_form_return_recieved": "반품 접수됨",
  "text_return_form_specific_details_message_01": "구체적인 내용을 적어주세요.",
  "text_return_form_cancel_return": "선택 해제",
  "text_return_form_return_reason": "반품사유",
  "text_return_form_return_this_item": "이 제품 선택",
  "text_return_form_download": "다운로드",
  "text_return_form_how_to_return_02": "지정하신 수거방법을 통해 제품이 반송될 수 있도록 미리 준비해 주세요.\n지정택배사를 통한 상품 수거 방법을 선택하신 경우, 반송비 3,000원이 차감된 금액으로 환불됩니다.",
  "text_return_form_how_to_return_01": "반송 박스 안에 ‘주문확인서’ 또는 ‘반품번호’ 중 1가지를 동봉해 주세요.",
  "text_returns": "반품",
  "text_return_form_how_to_return_title": "반품 절차",
  "text_return_form_back_to_order_history": "구매 내역으로 돌아가기",
  "text_return_form": "반품 / 교환 신청",
  "text_return_form_details": "반품 / 교환 이력",
  "text_return_form_go_to_fedex_prepaid_label_link": "라벨 생성",
  "text_return_form_eu_find_drop_off_location": "text_return_form_eu_find_drop_off_location",
  "text_return_form_return_method_eu_qr_code_button": "text_return_form_return_method_eu_qr_code_button",
  "text_return_form_return_method_eu_qr_code_description": "text_return_form_return_method_eu_qr_code_description",
  "text_return_form_back_to_previous_page": "이전 페이지로 돌아가기",
  "text_error_return_form_no_reason": "반품 사유를 입력하세요. 필수 항목입니다.",
  "text_error_return_form_reason_over_maximum_length": "반품 사유는 300자 이내여야 합니다.",
  "text_return_form_return_qr_code_confirmation_email_description": "text_return_form_return_qr_code_confirmation_email_description",
  "text_return_method_eu_qr_code_return_instruction_03_cod_sub_description_01": "text_return_method_eu_qr_code_return_instruction_03_cod_sub_description_01",
  "text_return_method_eu_qr_code_return_instruction_03_sub_description_01": "text_return_method_eu_qr_code_return_instruction_03_sub_description_01",
  "text_return_method_print_label_return_instruction_03_cod_sub_description_01": "text_return_method_print_label_return_instruction_03_cod_sub_description_01",
  "text_return_form_contact_email_address": "text_return_form_contact_email_address",
  "text_return_form_contact_number": "text_return_form_contact_number",
  "text_return_form_country_name": "text_return_form_country_name",
  "text_return_form_recipient_additional_information": "text_return_form_recipient_additional_information",
  "text_return_form_return_confirmation_send_to_registered_email_note": "text_return_form_return_confirmation_send_to_registered_email_note",
  "text_return_form_return_shipping_label_confirmation_email_description": "text_return_form_return_shipping_label_confirmation_email_description",
  "text_return_method_eu_qr_code_return_instruction_01": "text_return_method_eu_qr_code_return_instruction_01",
  "text_return_method_eu_qr_code_return_instruction_02": "text_return_method_eu_qr_code_return_instruction_02",
  "text_return_method_eu_qr_code_return_instruction_02_sub_description_01": "text_return_method_eu_qr_code_return_instruction_02_sub_description_01",
  "text_return_method_eu_qr_code_return_instruction_03": "text_return_method_eu_qr_code_return_instruction_03",
  "text_return_form_return_method_eu_qr_code_title": "text_return_form_return_method_eu_qr_code_title",
  "text_return_form_eu_drop_off_location": "text_return_form_eu_drop_off_location",
  "text_return_form_return_address": "반품 주소",
  "text_return_form_download_return_slip": "다운로드",
  "text_return_form_print_and_return": "인쇄하기",
  "text_return_form_select_item_and_reason": "상품과 반품사유를 선택",
  "text_review_order_payments_issuable_purchase_certification_description": "구매 확정",
  "text_download_invoice": "text_download_invoice",
  "text_manual_refund": "text_manual_refund",
  "text_non_merchandise_fee": "text_non_merchandise_fee",
  "text_return_invoice_number": "text_return_invoice_number",
  "text_return_order_number": "text_return_order_number",
  "text_return_reference_number": "text_return_reference_number",
  "text_return_registration": "text_return_registration",
  "text_return_transaction": "text_return_transaction",
  "text_returns_status": "text_returns_status",
  "text_sales_invoice_number": "text_sales_invoice_number",
  "text_error_download_purchase_certificate_unavailable_title": "구매 확정",
  "text_error_download_purhcase_certificate_unavailable_message_01": "구매 확정",
  "text_error_failed_to_get_purchase_certificate_infromation_message_01": "구매 확정",
  "text_purchase_certification_issued": "구매 확정",
  "text_order_history_instore_purchase_tab": "매장 구매",
  "text_order_history_online_purchase_tab": "온라인 구매",
  "text_return_form_continue": "계속",
  "text_return_form_edit_return_reason": "반품 사유 수정",
  "text_return_form_go_to_click_n_ship": "원클릭 배송(Click-N-Ship) 온라인 우편 요금 바로가기",
  "text_return_form_how_to_return_03": "아래의 주소로 상품을 보내주세요.",
  "text_return_form_how_to_return_04": "참고: 라벨을 만들기 위해서는 이 배송 번호가 필요합니다.",
  "text_return_form_how_to_return_05": "FedEx 또는 USPS로 주문을 반송합니다.",
  "text_return_form_leave_return_process_alert_message_01": "페이지를 닫으면 입력정보가 소멸됩니다. 페이지를 닫으시기 전에 반품신청을 완료해 주세요.",
  "text_return_form_payment_method": "결제수단",
  "text_return_form_please_note_message_01": "반품 처리는 고객님의 상품이 창고에 접수된 날부터 최대 4주가 소요될 수 있습니다. 배송비 및 수선비는 결함, 손상 또는 오배송 제품의 반품이 아닌 경우는 환불되지 않습니다.",
  "text_return_form_please_note_title": "주의사항",
  "text_return_form_print_shipping_label_message_01": "선택한 배송사의 라벨을 사용하거나 아래 링크에서 $7(반품 제품의 합계 금액에서 차감)의 선불 배송 라벨을 인쇄하여 FedEx로 주문을 반송할 수 있습니다.",
  "text_return_form_product_for_return": "반품 상품",
  "text_return_form_reminder": "다시 알림",
  "text_return_form_reminder_message_01": "반품 가이드에 충족되지 않는 제품은 반송될 수 있습니다.",
  "text_return_form_return_completed_date": "YYYY/MM/DD",
  "text_return_form_return_description_message_01": "반품 방법에 대해 아래 내용을 읽어주세요.",
  "text_return_form_return_reason_05": "기타",
  "text_return_form_return_reason_21": "주문한 제품과 다름",
  "text_return_form_return_reason_22": "주문한 수량과 다름",
  "text_return_form_return_reason_23": "제품의 손상 및 오염",
  "text_return_form_return_reason_24": "제품불량(봉제, 치수 등)",
  "text_return_form_return_reason_25": "배송지연",
  "text_return_form_return_reason_26": "잘못 주문함",
  "text_return_form_return_reason_27": "생각했던 것과 다름(색)",
  "text_return_form_return_reason_28": "생각했던 것과 다름(소재)",
  "text_return_form_return_reason_29": "사이즈 잘못 선택(큼)",
  "text_return_form_return_reason_30": "사이즈 잘못 선택(작음)",
  "text_return_form_return_reason_31": "그 외 고객 사유",
  "text_return_form_return_slip": "반품 양식",
  "text_return_form_sent_the_slip_message_01": "반품 상품과 메모에 주문번호를 기재하여 박스에 같이 동봉 부탁 드리겠습니다. (미동봉시 확인 작업에 환불까지 지연발생 할수 있는점 양해 부탁 드립니다.)",
  "text_return_form_shipment_number": "발송 번호",
  "text_return_form_shipment_number_barcode": "발송 번호 바코드",
  "text_return_form_sub_title": "반품 상품을 선택",
  "text_return_form_uq_returns": "유니클로 반품",
  "text_order_history_in_store_purchase_note_view_purchase_history": "구매제품일람",
  "text_save_order_settings_credit_card": "이 신용카드를 기본값으로 설정",
  "text_save_order_settings_pickup_store": "이 매장을 다음에도 사용",
  "text_express_order_setting_delivery_option": "배송 방법",
  "text_express_order_setting_payment_option": "결제 수단",
  "text_express_order_setting_payment_option_message_01": "결제 시 적용될 결제 수단을 설정할 수 있습니다.",
  "text_express_order_setting_payment_option_message_02": "등록된 결제 수단이 없습니다.",
  "text_express_order_setting_register_payment_option": "결제 수단 등록",
  "text_express_order_setting_set_credit_card": "신용카드 설정",
  "text_max_billing_address_registration": "청구지 주소는 최대 10개까지 등록할 수 있습니다.",
  "text_order_settings_billing_address": "청구지 주소",
  "text_order_settings_change_billing_address": "수정",
  "text_order_settings_current_shipping_address": "현재 배송 주소",
  "text_order_settings_no_saved_billing_address": "청구지주소가 선택 되지 않았습니다. 등록하신 회원정보내 주소가 구입 진행시 청구서 주소에 반영 됩니다.",
  "text_order_settings_set_billing_address": "설정",
  "text_register_new_billign_address": "새 주소 등록",
  "text_return_to_order_settings": "주문설정으로 돌아가기",
  "text_saved_billing_address_count": "청구지 주소:",
  "text_select_order_settings_billing_address": "청구지 주소 선택",
  "text_submit_order_settings_billing_address": "주문설정 청구지 주소 저장",
  "text_error_order_setting_not_select_shipping_address_or_store_pickup": "배송 주소 또는 수령할 매장을 선택해 주세요.",
  "text_register_billing_address_title": "청구지 주소 등록",
  "text_edit_billing_address": "청구지 주소 수정",
  "text_express_order_settings_current_billing_address": "현재 결제 주소",
  "text_register_billing_address": "새 청구지 주소",
  "text_save_order_settings_payment_method": "이 결제 수단을 다음에도 사용",
  "text_billing_address_validation_notes_01": "청구지 주소를 확인하세요. 잘못된 청구지 주소로 인해 주문이 취소되거나 지연될 수 있습니다.",
  "text_continue_selected_billing_address": "계속",
  "text_delete_selected_billing_address_confirmation": "선택한 주소를 삭제하시겠습니까?",
  "text_delete_selected_billing_address_title": "주소 삭제",
  "text_register_new_billing_address": "새 배송지 등록",
  "text_select_billing_address": "청구지 주소 선택",
  "text_save_order_settings_billing_address": "내 기본 청구 주소로 설정",
  "text_save_order_settings_shipping_address": "내 기본 배송 주소로 설정",
  "text_order_settings_select_your_bank": "text_order_settings_select_your_bank",
  "text_order_settings_set_bank": "text_order_settings_set_bank",
  "text_app_order_status_failed_get_order_information": "주문 상태를 표시할 수 없습니다.",
  "text_app_orderstatus_user_guidance": "text_app_orderstatus_user_guidance",
  "text_404_error_description": "일시적인 시스템 오류가 발생하여 원하시는 페이지를 찾을 수 없습니다.\n 정확한 URL 확인 또는 다른 페이지로 이동해 주세요.\n {text_uqtop}, {text_contactus}를 방문하거나 아래에서 검색해 보세요.",
  "text_404_error_description-1": "일시적인 시스템 오류가 발생하였습니다.",
  "text_404_error_description-2": "원하시는 페이지를 찾을 수 없습니다.",
  "text_404_error_description-3": "정확한 URL 확인 또는 다른 페이지로 이동해 주세요.",
  "text_404_error_description-4": "궁금한 점이 있을 경우 아래 링크를 통해 문의해 주세요.",
  "text_503_error_description-1": "일시적인 시스템 오류가 발생하였습니다.",
  "text_503_error_description-2": "나중에 다시 방문하거나, 이전 페이지로 돌아가 주세요.",
  "text_de_enewsletter_register": "이메일 뉴스레터 수신 동의",
  "text_de_enewsletter_register_notification_send": "이메일 뉴스레터 수신 동의",
  "text_de_enewsletter_subscription_consent_email_issued": "이메일 뉴스레터 수신 동의",
  "text_de_enewsletter_thank_you_for_subscribing": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_subscription_consent_complete_description_01": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_subscription_consent_complete_title": "이메일 뉴스레터 수신 동의",
  "text_ads_sender_colon": "광고 전송자:",
  "text_ads_sender_colon_en": "Ads sender:",
  "text_enewsletter_retry_button": "메일 구독 설정 재시도",
  "text_enewsletter_subscription": "메일 구독 해지",
  "text_enewsletter_subscription_en": "E-Newsletter Subscription",
  "text_enewsletter_unsubscribes": "구독 해지 완료",
  "text_enewsletter_unsubscribes_complete": "메일 구독 해지가 완료되었습니다.",
  "text_enewsletter_unsubscribes_complete_en": "Your subscription has been canceled.",
  "text_enewsletter_unsubscribes_en": "Complete",
  "text_enewsletter_unsubscribes_error": "메일 구독을 업데이트하지 못했습니다",
  "text_enewsletter_unsubscribes_error_description": "메일 구독을 취소하는 동안 오류가 발생했습니다. MY PAGE에서도 설정을 변경하실 수 있습니다.",
  "text_enewsletter_unsubscribes_error_description_en": "An error occurred while unsubscribing from the e-newsletter. You can change your e-newsletter settings on the MEMBERSHIP page.",
  "text_enewsletter_unsubscribes_error_en": "Failed to Unsubscribe",
  "text_enewsletter_unsubscribes_notes_01": "다시 구독을 원하신다면 MY PAGE에서 언제든 변경 가능합니다.",
  "text_enewsletter_unsubscribes_notes_01_en": "If you want to subscribe again, you can change the settings from MY PAGE at anytime.",
  "text_enewsletter_unsubscribes_notes_02": "항상 더 나은 서비스를 제공하기 위해 노력하겠습니다.",
  "text_enewsletter_unsubscribes_notes_02_en": "We will always strive to provide better services.",
  "text_frl": "에프알엘코리아 주식회사",
  "text_frl_en": "FRL Korea Co., Ltd.",
  "text_processing_date_colon": "처리 일시:",
  "text_processing_date_colon_en": "Processing date:",
  "text_processing_result_colon": "처리 결과:",
  "text_processing_result_colon_en": "Processing result:",
  "text_error_description": "일시적인 시스템 오류가 발생하였습니다. \n 입력 정보 재확인 또는 잠시 후 다시 시도해 주세요.",
  "text_click_here": "여기를",
  "text_enewsletter_title": "이메일 뉴스레터 수신 동의",
  "text_error_timeout": "비밀번호 재설정 링크가 만료되었습니다. 비밀번호 재설정 페이지를 방문하여 다시 시도해 주세요.",
  "text_currency_dollar": "$",
  "text_503_error_description": "일시적인 시스템 오류가 발생하였습니다. \n 이전 페이지로 이동 또는 잠시 후 다시 시도해 주세요.",
  "text_503_error_instruction": "궁금한 사항이 있으시면, 아래 링크에서 확인해주시기 바랍니다.",
  "text_error_title": "서비스를 일시적으로 사용할 수 없습니다.",
  "text_503_error_title": "일시적으로 사이트를 이용할 수 없습니다.",
  "text_canadian_dollar": "캐나다 달러",
  "text_de_enewsletter_subscription_consent_agreement": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_description": "최신 제품 및 프로모션에 대한 소식을 받으려면 메일링 리스트를 구독하세요.",
  "text_enewsletter_instruction": "절차가 완료될 때까지 여러 메시지를 보낼 수 있습니다.",
  "text_enewsletter_subscribe_complete": "이메일 뉴스레터 수신 동의 처리가 완료되었습니다.",
  "text_enewsletter_subscribe_description": "구독 확인 이메일을 받게 됩니다.\n• 전자 뉴스레터는 이메일 설정에 따라 텍스트 또는 HTML 형식으로 전송됩니다.\n• 전자 뉴스레터 구독은 무료입니다.\n• 표준 문자 메시지 및 기타 이동통신사 서비스 요금이 적용됩니다.\n• 모든 민감 정보는 전송 계층 보안(TLS) 암호화 기술로 보호됩니다.",
  "text_enewsletter_subscribe_description_for_registration": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_subscribe_description-1": "• 구독 확인 이메일을 받게 됩니다.",
  "text_enewsletter_subscribe_description-10": "text_enewsletter_subscribe_description-10",
  "text_enewsletter_subscribe_description-2": "• 전자 뉴스레터는 이메일 설정에 따라 텍스트 또는 HTML 형식으로 전송됩니다.",
  "text_enewsletter_subscribe_description-3": "• 전자 뉴스레터 구독은 무료입니다.",
  "text_enewsletter_subscribe_description-4": "• 문자 메시지 및 기타 서비스 요금이 부과됩니다.",
  "text_enewsletter_subscribe_description-5": "• 모든 민감 정보는 전송 계층 보안(TLS) 암호화 기술로 보호됩니다.",
  "text_enewsletter_subscribe_description-6": "• UNIQLO Canada로부터 뉴스, 업데이트 및 프로모션이 포함된 이메일 알림을 수신하는 데 동의합니다(언제든지 커뮤니케이션 기본 설정을 변경할 수 있습니다).",
  "text_enewsletter_subscribe_description-7": "• 이 정보를 제출하면 {terms_and_conditions} 및 {privacy_policy}에 동의하게 됩니다.",
  "text_enewsletter_subscribe_description-8": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_subscribe_description-9": "text_enewsletter_subscribe_description-9",
  "text_enewsletter_subscribe_email": "이메일 확인을 위해 받은 편지함을 확인하세요.",
  "text_enewsletter_subscribe_failed": "이메일 뉴스레터 수신 동의 설정에 실패하였습니다. {url}에서 재설정 해주시기 바랍니다.",
  "text_enewsletter_subscribe_subtitle": "UNIQLO 메일링 리스트 구독",
  "text_enewsletter_subscribe_title": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_unsubscribe_complete": "이메일 뉴스레터 수신 동의 해지",
  "text_enewsletter_unsubscribe_description": "리스트에서 삭제하려는 이메일 주소를 입력하고 취소를 클릭하세요. 처리하는 데 시간이 걸릴 수 있습니다.",
  "text_enewsletter_unsubscribe_email": "며칠 내에 이메일 확인 이메일을 받게 됩니다.",
  "text_enewsletter_unsubscribe_failed": "이메일 뉴스레터 수신 동의 해지에 실패하였습니다. {url}에서 재설정 해주시기 바랍니다.",
  "text_error_unsubscribe": "마케팅 수신 동의 설정 변경이 완료 되지 않았습니다. 다시 시도해 주세요.",
  "text_subscribe": "동의",
  "text_subscribe_complete": "동의 완료",
  "text_unsubscribe": "미동의",
  "text_unsubscribe_complete": "미동의 완료",
  "text_unsubscribe_description": "마케팅 수신 동의 철회",
  "text_unsubscribe_title": "마케팅 수신 동의 철회",
  "text_unsubuscribe_description": "마케팅 수신 동의 철회",
  "text_check_here": "여기를 클릭해 주세요.",
  "text_error_excessive_access_page_unavailable_message01": "온라인스토어 이용에 불편을 드려 죄송합니다. 현재 접속 사용자 많아 서비스 지연이 발생하고 있습니다. 잠시 후에 다시 이용해 주시기 바랍니다.",
  "text_error_excessive_access_page_unavailable_title": "죄송합니다.",
  "text_inquiry_about_uniqlo": "유니클로에 관한 문의",
  "text_alert_description": "연결 오류가 발생했습니다. 다시 시도하거나, 나중에 다시 시도해 주세요.",
  "text_alert_title": "연결 오류:",
  "text_error_withdrawal": "회원 탈퇴 처리가 완료되지 않았습니다. 다시 시도해 주세요.",
  "text_returnto_settingsfaq": "설정/FAQ로 돌아가기",
  "text_session_expired": "세션이 만료되었습니다. 데이터를 잃을 수 있습니다. 계속하시겠습니까?",
  "text_session_expired_title": "세션 만료됨",
  "text_app_member_explain": "이전에 사용한 국가 옆에 “앱 회원”이 표시됩니다.",
  "text_invalid_province_details": "text_invalid_province_details",
  "text_bank_account_holder_name": "예금주 성함",
  "text_bank_account_number": "은행 계좌번호",
  "text_bank_account_number_confirmation": "계좌번호 다시 확인",
  "text_bank_name": "은행명",
  "text_confirm_return_order_information": "내 주문 정보",
  "text_credit_debit_card_refund_support_notes01": "환불: {paymentMethod}를 사용하여 결제한 주문의 반품 및 환불 처리는 고객센터에 문의해 주세요.",
  "text_enter_bank_account_holder_name": "예금주 성함을 입력해 주세요.",
  "text_enter_bank_account_number": "은행 계좌번호를 입력해 주세요.",
  "text_enter_bank_account_number_confirmation": "계좌번호를 다시 확인해 주세요.",
  "text_enter_order_number": "주문 번호를 입력하세요.",
  "text_error_bank_account_nunber_unmatch": "계좌번호가 일치하지 않습니다. 계좌 번호를 다시 확인해 주세요.",
  "text_error_return_order_not_found": "반품 접수 _주문 확인 불가",
  "text_error_return_portal_general_error_message": "반품 접수 _기타 오류",
  "text_how_to_return": "반품 방법",
  "text_meta_title_return_portal": "반품 접수",
  "text_meta_title_return_portal_complete": "반품 완료",
  "text_meta_title_return_portal_confirmation": "반품 확정",
  "text_product_return": "반품 상품",
  "text_refund_initiated": "환불 진행",
  "text_return_in_progress": "반품 진행중",
  "text_return_number": "반품 번호",
  "text_return_portal": "반품 접수",
  "text_return_portal_bank_account_number_notes": "계좌 번호가 263-2-28976-3인 경우 2632289763(10자리)을 입력하세요.",
  "text_return_portal_terms_and_condition_agreement": "이용약관 동의",
  "text_return_portal_terms_and_conditions_agreement": "나는 이용약관을 읽었으며 이에 동의합니다.",
  "text_return_procedure": "반품 절차",
  "text_return_procedure_details": "자세한 내용은 아래 세부정보를 확인하세요.",
  "text_return_refund_important_notes_title": "중요",
  "text_return_refund_important_notes01": "배송 후 결제 주문(COD)에서 환불 크레딧을 활성화하려면 위에 은행 계좌 정보를 입력하세요.",
  "text_return_request_procedure_complete": "반품 등록 완료됨",
  "text_return_shipment_instruction01": "반품 양식(영수증 끝부분)에 반품 번호”를 기입하세요. 그런 다음 반품 시 동봉해 주세요. 반품하실 상품을 물류센터로 발송해 주세요.",
  "text_return_status": "상태",
  "text_select_bank_name": "은행을 선택하세요.",
  "text_submit_refund_bank_account_information_notes01": "환불 진행 _은행",
  "text_submit_return_request": "반품 제출",
  "text_terms_and_condition_agreement": "반품 확인",
  "text_completed_title": "완료",
  "text_enter_return_information": "반품 정보",
  "text_multibuy_item": "세트할인제품",
  "text_uqpay_error_credit_card": "text_uqpay_error_credit_card",
  "text_uqpay_error_credit_card_description": "text_uqpay_error_credit_card_description",
  "text_express_order_uqpay_unable_to_use_over_maximum_amount_message_01": "주문 금액이 ¥30,000을 초과하면 UNIQLO Pay를 이용하실 수 없습니다. “결제”로 돌아가서 다른 결제 수단으로 주문하세요.",
  "text_express_order_uqpay_unable_to_use_title": "UNIQLO Pay로 결제할 수 없습니다.",
  "text_uqpay_payment_type_atone_pay": "text_uqpay_payment_type_atone_pay",
  "text_uqpay_payment_type_atone_pay_additional_billing_fee_description": "text_uqpay_payment_type_atone_pay_additional_billing_fee_description",
  "text_uqpay_payment_type_atone_pay_additional_billing_fee_next_month_payment": "text_uqpay_payment_type_atone_pay_additional_billing_fee_next_month_payment",
  "text_uqpay_payment_type_atone_pay_additional_billing_fee_single_payment": "text_uqpay_payment_type_atone_pay_additional_billing_fee_single_payment",
  "text_uqpay_payment_type_atone_pay_note_01": "text_uqpay_payment_type_atone_pay_note_01",
  "text_uqpay_payment_type_atone_pay_note_02": "text_uqpay_payment_type_atone_pay_note_02",
  "text_uqpay_payment_type_atone_pay_postpaid_payment_available_message": "text_uqpay_payment_type_atone_pay_postpaid_payment_available_message",
  "text_cash_on_delivery_unavailable_reason_over_maximum_payment_amount": "현금결제 배송",
  "text_uqpay_need_to_update_app_message_01": "유니클로 APP 버전으로 인해 UNIQLO Pay를 이용할 수 없습니다. UNIQLO Pay를 이용하려면 유니클로 APP을 업데이트하세요.",
  "text_uqpay_payment_type_atone_pay_unavailable_select_divided_delivery_message": "text_uqpay_payment_type_atone_pay_unavailable_select_divided_delivery_message",
  "text_error_apple_pay_not_supported_device_browser_message_01": "브라우저 또는 기기가 Apple Pay를 지원하지 않습니다. 결제 수단을 변경하세요.",
  "text_bank_payment_confirmation_time": "Bank Pay",
  "text_credit_card_imark_description10": "text_credit_card_imark_description10",
  "text_credit_card_imark_description9": "text_credit_card_imark_description9",
  "text_pre_order_credit_card_unsupported": "text_pre_order_credit_card_unsupported",
  "text_pre_order_credit_card_unsupported_card_description1": "text_pre_order_credit_card_unsupported_card_description1",
  "text_pre_order_credit_card_unsupported_card_description2": "text_pre_order_credit_card_unsupported_card_description2",
  "text_pre_order_credit_card_unsupported_card_description3": "text_pre_order_credit_card_unsupported_card_description3",
  "text_gopay_payment_description_06": "text_gopay_payment_description_06",
  "text_gopay_payment_description_07": "text_gopay_payment_description_07",
  "text_error_np_pay_later_billing_address_contain_not_supported_character": "NP pay later",
  "text_error_np_pay_later_shipping_address_contain_not_supported_character": "NP pay later",
  "text_atm_card_payment_description_02": "text_atm_card_payment_description_02",
  "text_uqpay_payment_type_atone_pay_billing_fee": "text_uqpay_payment_type_atone_pay_billing_fee",
  "text_uqpay_payment_type_atone_pay_bnpl_per_purchase": "text_uqpay_payment_type_atone_pay_bnpl_per_purchase",
  "text_uqpay_payment_type_atone_pay_change_payment_method": "text_uqpay_payment_type_atone_pay_change_payment_method",
  "text_uqpay_payment_type_atone_pay_description_01": "text_uqpay_payment_type_atone_pay_description_01",
  "text_uqpay_payment_type_atone_pay_description_02": "text_uqpay_payment_type_atone_pay_description_02",
  "text_uqpay_payment_type_atone_pay_direct_debit_no_billing_fee": "text_uqpay_payment_type_atone_pay_direct_debit_no_billing_fee",
  "text_uqpay_payment_type_atone_pay_instruction_01": "text_uqpay_payment_type_atone_pay_instruction_01",
  "text_uqpay_payment_type_atone_pay_instruction_02": "text_uqpay_payment_type_atone_pay_instruction_02",
  "text_uqpay_payment_type_atone_pay_next_month_payment": "text_uqpay_payment_type_atone_pay_next_month_payment",
  "text_uqpay_payment_type_atone_pay_next_month_payment_register_description": "text_uqpay_payment_type_atone_pay_next_month_payment_register_description",
  "text_uqpay_payment_type_atone_pay_proceed_to_register_button": "text_uqpay_payment_type_atone_pay_proceed_to_register_button",
  "text_uqpay_payment_type_atone_pay_purchase_note_01": "text_uqpay_payment_type_atone_pay_purchase_note_01",
  "text_uqpay_payment_type_atone_pay_purchase_note_02": "text_uqpay_payment_type_atone_pay_purchase_note_02",
  "text_uqpay_payment_type_atone_pay_purchase_note_03": "text_uqpay_payment_type_atone_pay_purchase_note_03",
  "text_uqpay_payment_type_atone_pay_register": "text_uqpay_payment_type_atone_pay_register",
  "text_uqpay_payment_type_atone_pay_register_next_month_payment": "text_uqpay_payment_type_atone_pay_register_next_month_payment",
  "text_uqpay_payment_type_atone_pay_register_once": "text_uqpay_payment_type_atone_pay_register_once",
  "text_uqpay_payment_type_atone_pay_usage_note": "text_uqpay_payment_type_atone_pay_usage_note",
  "text_uqpay_error_cvv_input_5_times_description_02": "text_uqpay_error_cvv_input_5_times_description_02",
  "text_atm_card_payment_description_01": "결제수단",
  "text_grabpay_payment_description_01": "결제수단",
  "text_payment_method_atm_card": "결제수단",
  "text_payment_method_grabpay": "결제수단",
  "text_uqpay_bank_maintenance": "은행 계좌 점검 설명",
  "text_uqpay_payment_method_main_description_01": "UNIQLO Pay는 유니클로 APP에 미리 등록된 결제수단으로 결제할 수 있는 서비스입니다.",
  "text_uqpay_payment_method_note_message_01": "은행 계좌로 결제하실 경우 은행 정기점검으로 인해 이용이 불가할 수 있습니다.",
  "text_uqpay_payment_method_note_message_02": "이 경우 다른 결제수단을 선택하세요.",
  "text_uqpay_payment_method_note_message_03": "점검 시간에 대한 자세한 내용은 아래 링크에서 확인하세요(일본 전자 결제 진흥회 페이지로 이동).",
  "text_google_pay_complete_checkout_description": "text_google_pay_complete_checkout_description",
  "text_uqpay_payment_method_note_title": "[참고]",
  "text_pre_order_restriction_klarna_payment": "text_pre_order_restriction_klarna_payment",
  "text_personal_checkout_shopping_cart": "주문하기",
  "text_app_alert_leave_scanned_item_list": "이 화면에서 나가시겠어요?",
  "text_app_alert_transition_from_pco_screen": "이 화면에서는 스캔한 제품만 구매할 수 있습니다. 이 화면을 벗어나더라도 스캔 기록은 일정 기간 동안 유지됩니다.",
  "text_app_error_failed_scan_qr_code_general": "QR 코드를 읽지 못함",
  "text_app_error_scan_duplication": "이 제품은 이미 스캔되었습니다.",
  "text_app_error_scan_over_limit": "구매할 수 있는 최대 제품 수를 초과했습니다. 수량을 변경하세요.",
  "text_app_in_store_mode": "매장 모드",
  "text_app_in_store_mode_check_in": "주문하기",
  "text_app_in_store_mode_check_in_completion": "결제됨",
  "text_app_in_store_mode_check_in_instruction": "매장 모드를 사용하여 결제하세요.",
  "text_app_in_store_mode_expired": "일정 시간이 경과하여 매장 모드가 종료되었습니다.",
  "text_app_in_store_mode_terminate": "끄기",
  "text_app_in_store_mode_terminated_by_customer01": "매장 모드를 종료하시겠습니까?",
  "text_app_in_store_mode_terminated_by_customer02": "스캔한 제품은 삭제됩니다.",
  "text_app_instore_mode_terminated": "매장 모드가 종료되었습니다.",
  "text_app_pco_initial_hint": "카메라로 제품의 QR 코드를 스캔하면 제품이 장바구니에 추가됩니다.",
  "text_app_pco_instruction": "유니클로 APP에서 카메라로 제품의 QR 코드를 스캔하면 제품이 장바구니에 추가됩니다.",
  "text_app_remove_all_scanned_item_confirmation": "스캔한 모든 제품을 삭제하시겠습니까?",
  "text_app_remove_all_scanned_products": "모든 제품 삭제",
  "text_app_remove_multiple_scanned_items": "동일한 제품이 2개 이상일 경우 한번에 모두 삭제됩니다.",
  "text_app_remove_scanned_item_confirmation": "스캔한 제품을 삭제하시겠습니까?",
  "text_app_successfully_scanned_item": "추가됨",
  "text_app_welcome_in_store_mode": "환영합니다.",
  "text_persona_checkout_uqpay_register_required_description": "구매를 진행하려면 UNIQLO Pay 등록이 필요합니다.",
  "text_personal_checkout_failed_to_checkout": "결제하지 못함",
  "text_unit_item_pirce": "단가:",
  "text_error_personal_checkout_general_message_01": "결제시 오류 발생",
  "text_error_personal_checkout_general_title": "결제시 오류 발생",
  "text_error_personal_checkout_service_unavailable_message_01": "결제시 오류 발생",
  "text_error_personal_checkout_service_unavailable_title": "결제시 오류 발생",
  "text_error_personal_checkout_shopping_bag_unavailable_message_01": "결제시 오류 발생",
  "text_error_personal_checkout_unavailable_item_in_cart_message_01": "결제시 오류 발생",
  "text_error_personal_checkout_unavailable_item_in_cart_title": "결제시 오류 발생",
  "text_store_name_place_holder": "결제시 오류 발생",
  "text_product_detail_solve_size_selection_message": "구매한 제품과 치수를\\n비교할 수 있습니다.",
  "text_review_sampling_via_incentivized_campaign": "추천 리뷰",
  "text_filter_clear_all_category": "모든 카테고리 지우기",
  "text_review_filter_height_weight_notees": "구매 색상·신장·체중 필터를 설정하시면, 해당 정보가 입력되지 않은 리뷰는 표시되지 않습니다.",
  "text_review_most_helpful": "도움돼요 순",
  "text_review_rating_high": "평점 높은 순",
  "text_review_rating_low": "평점 낮은 순",
  "text_review_recently_posted": "최근 등록일순",
  "text_rvw_gndr_001": "남성",
  "text_rvw_gndr_002": "여성",
  "text_rvw_gndr_003": "기타",
  "text_rvw_gndr_004": "선택하지 않음",
  "text_material_description": "본 제품에는 리사이클 소재가 제품 중량의 20% 이상 포함되어 있습니다. 색상이나 품번에 따라 혼용률이 다를 수 있으므로 정확한 리사이클 소재의 혼용률은 제품 상세의 소재 정보를 참조해 주십시오.\n 당사는 온실가스 감축 목표 달성을 위해 2030년까지 제품 내 전체 사용 소재의 약 50%를 생산시 보다 적은 온실가스를 배출하는 원재료로 전환하는 것을 목표로 하고 있습니다.",
  "text_material_description_note": "※ 상세 내용은 '제품 상세'를 참조해 주십시오.",
  "text_material_used": "소재 :",
  "text_processability": "소재정보",
  "text_sewing_country_03": "소재 생산지(염색):",
  "text_store_inventory_status_by_nearest": "재고가 있는 인근 매장",
  "text_store_inventory_status_by_nearest_out_of_stock": "인근 매장에 재고가 없습니다.",
  "text_traceability_description_note": "※ 소재 생산지의 정보는 2024년 가을, 겨울 이후 상품을 대상으로 표시됩니다.",
  "text_inventory_status_only_selected_store_stock_available_note": "지정 매장에서 ORDER & PICK (당일픽업)으로 구매하실 수 있습니다.",
  "text_product_detail_ask_question_via_chat": "도움이 필요하시면 여기로 문의해 주세요.",
  "text_product_detail_check_size_wear_by_people_body_type_message": "나와 비슷한 체형의 고객이 착용한 사이즈를 확인해 보세요.",
  "text_product_detail_description_delivery_exchange_and_return_title": "배송 / 결제 / 교환 / 반품",
  "text_product_detail_description_details_title": "제품 상세 설명",
  "text_product_detail_description_exchange_and_return_information": "주문 후 30일 이내에 교환 및 반품이 가능합니다.* 매장에서 결제하신 경우, 반품은 해당 매장에서만 가능합니다. ● 교환은 전국 유니클로 매장에서 가능합니다. ● 온라인에서 교환을 원할 시, 교환 제품을 결제 후 기존 제품은 반송하셔야 합니다. *{link1}에서 교환 신청할 수 있습니다. * 제품에 하자가 있는 경우를 제외하고, 반송비는 고객 부담입니다. ● 교환, 반품을 원하실 경우 사전에 {link2}를 확인해 주세요. ● 교환 및 반품에 대한 자세한 내용은 {link3}에서 확인하세요.",
  "text_product_detail_description_exchange_and_return_order_history_link": "구매 내역",
  "text_product_detail_description_exchange_and_return_policy_link": "상세 조건",
  "text_product_detail_description_features_title": "제품 상세",
  "text_product_detail_description_materials_care_title": "소재 정보 / 세탁 방법",
  "text_product_detail_size_check_and_edit_recommend_image_capture_message": "추천 사이즈 확인",
  "text_product_detail_size_check_dimension_and_product_message": "제품을 구매하기 전, 이전에 구매했던 제품의 사이즈와 비교해 보세요.",
  "text_product_detail_size_check_image_length_by_height_message": "신장에 따른 제품의 전체 길이를 확인해 보세요.",
  "text_product_detail_styling_by_height": "신장별 스타일링",
  "text_sustainability_information": "생산 정보",
  "text_bis_details_description01": "재고 상황에 따라 입고 여부는 변경될 수 있습니다.",
  "text_bis_details_description02": "재입고 시 APP 알림 및 이메일을 통해 안내드립니다.",
  "text_bis_details_description03": "APP 알림 및 이메일 수신 동의 여부를 확인해 주세요.",
  "text_bis_login_required": "재입고 알림을 받으려면 로그인해야 합니다.",
  "text_bis_settings_completed": "재입고 신청이 완료되었습니다.",
  "text_bis_settings_completed_description": "재입고 알림 설정이 완료되었습니다.",
  "text_bis_settings_completed_description02": "제품 재고가 있는 경우에만 이메일 알림을 보내드립니다.",
  "text_bis_settings_completed_description03": "신청 후, 120일 이내에 제품이 재입고되면 알림이 전송됩니다.",
  "text_limited_offer_notes": "이 제품은 표시된 한정 기간이 지난 후에도, 할인 가격으로 판매 되거나, 가격이 인하될 수도 있습니다. 이점 미리 양해 부탁 드리겠습니다.",
  "text_limited_offer_notes_title": "기간 한정",
  "text_select_color_coming_soon_date_late": "선택한 컬러는 {month} 말에 판매될 예정입니다.",
  "text_select_length_coming_soon_date_late": "선택한 길이는 {month} 말에 판매될 예정입니다.",
  "text_select_size_coming_soon_date_late": "선택한 사이즈는 {month} 말에 판매될 예정입니다.",
  "text_sewing_country": "제품 제조국(봉제·니팅·조립):",
  "text_sns_share_description": "아이콘을 클릭하여 페이지를 공유할 수 있습니다.",
  "text_tax_excluded_description": "공급가액(VAT제외)",
  "text_traceability": "생산 정보",
  "text_traceability_description": "당사는 공급망의 생산 과정을 파악하고 자사 및 제3자의 검증을 실시하고 있습니다. 원재료의 생산지나 방적, 소재 생산, 봉제, 니팅 및 조립 공정의 위치 정보 파악 후 데이터베이스화하여 품질을 높이는 것과 동시에 고객님이 언제라도 열람하실 수 있도록 정보를 게재하고 있습니다.",
  "text_zero_review_product_description": "이 제품에 대한 리뷰가 없습니다. 첫 리뷰를 남겨 보세요.",
  "text_product_detail_contact_form": "text_product_detail_contact_form",
  "text_dc_stock_may_allocate_note": "이 제품의 배송은 최대 1주일 소요될 수 있습니다.",
  "text_product_detail_description_delivery_information": "● 택배 배송, 매장 픽업을 통해 주문 상품을 수령하실 수 있습니다. ● 배송 날짜 및 시간: 구매 과정에서 배송 방법 선택 시 주문 페이지에서 확인 가능합니다. ● 배송비: 3,000원 (30,000원 이상 구입하면 무료배송, 도서·산간지역 동일, 매장 픽업 서비스 이용 시 배송비 무료입니다.) ● 배송에 대한 자세한 내용은 {link}를 참조하세요. ● 결제수단: 신용카드, 네이버 페이 사용 가능합니다. 고액 결제의 경우, 고객의 결제 안전을 위하여 신용카드 부정 사용 등 비정상적인 주문으로 판단될 경우, 해당 주문 및 결제를 제한 될 수 있습니다.",
  "text_product_detail_description_delivery_subtitle": "배송 / 결제",
  "text_select_length_coming_soon_date_early": "선택한 길이는 {month} 초에 판매될 예정입니다.",
  "text_select_length_coming_soon_date_mid": "선택한 길이는 {month} 중순에 판매될 예정입니다.",
  "text_sewing_country_02": "소재 생산지(편직 및 직조):",
  "text_plus_tax": "세금 포함",
  "text_style_model_height": "cm",
  "text_bis_app_push_notification_setting_on": "",
  "text_bis_notification_available_subtitle": "재입고 알림 가능",
  "text_style_model_wearing_size": "사이즈:",
  "text_no_items": "제품이 없습니다.",
  "text_style_staff_customer_styling_title": "글로벌 스타일 정보",
  "text_style_styling_date": "YYYY/MM/DD",
  "text_style_styling_date_update": "업데이트",
  "text_bis_notification_available_description_01": "제품이 재입고된 경우에만 재입고 알림(앱 푸시 알림, 이메일)을 보내드립니다.",
  "text_bis_notification_available_description_02": "재고 상황에 따라 입고 여부는 변경될 수 있습니다.",
  "text_inventory_status_only_selected_store_stock_available_description": "온라인 스토어에서 재고가 없더라도 지정된 매장에서 구매하실 수 있습니다. \nORDER & PICK (당일픽업) 서비스를 이용해 보세요.",
  "text_bis_available_notes": "주문 시 주의사항",
  "text_bis_notification_or_selected_store_stock_available_subtitle": "재입고 알림을 받거나 지정 매장에서 ORDER & PICK (당일픽업) 서비스를 이용해 보세요.",
  "text_post_comments": "제출",
  "text_post_completion": "리뷰를 등록해 주셔서 감사합니다!",
  "text_post_thankyou": "리뷰를 등록해주셔서 감사합니다. 모든 리뷰는 리뷰 가이드라인을 준수하는 경우에 표시됩니다.",
  "text_ph_alteration_length": "없음",
  "text_ph_alteration_type": "없음",
  "text_bis_available_notes01": "text_bis_available_notes01",
  "text_bis_description01": "재고가 들어오면 이메일로 안내드립니다.",
  "text_bis_description02": "구매 시점에 따라 상품 품절이 발생할 수 있습니다.",
  "text_error_pre_order_high_threshold_cart_product_message": "text_error_pre_order_high_threshold_cart_product_message",
  "text_error_pre_order_high_threshold_cart_product_message_equal_quantity": "text_error_pre_order_high_threshold_cart_product_message_equal_quantity",
  "text_error_pre_order_high_threshold_cart_top_message": "text_error_pre_order_high_threshold_cart_top_message",
  "text_select_color_coming_soon_date_early": "선택한 컬러는 {month} 초에 판매될 예정입니다.",
  "text_select_color_coming_soon_date_mid": "선택한 컬러는 {month} 중순에 판매될 예정입니다.",
  "text_select_size_coming_soon_date_early": "선택한 사이즈는 {month} 초에 판매될 예정입니다.",
  "text_select_size_coming_soon_date_mid": "선택한 사이즈는 {month} 중순에 판매될 예정입니다.",
  "text_error_failed_get_current_store": "현재 매장 정보를 가져오지 못했습니다.",
  "text_no_messages": "메시지가 없습니다.",
  "text_error_gift_wrapping_unavailable_add_to_cart": "장바구니 제품내 기프트포장이 어려운 부피가 큰 제품 또는 수량이 있습니다. 선택하신 기프트박스를 해제 혹은 제품을 나누어 주문 부탁 드립니다.",
  "text_error_gift_wrapping_unavailable_apply_gift_option": "장바구니 제품 내 기프트 포장이 어려운 부피가 큰 제품 또는 수량이 있습니다. 선택하신 기프트 박스를 해제 혹은 제품을 나누어 주문 부탁드립니다.",
  "text_error_gift_wrapping_unavailable_cart": "장바구니 제품 내 기프트 포장이 어려운 부피가 큰 제품 또는 수량이 있습니다. 선택하신 기프트 박스를 해제 혹은 제품을 나누어 주문 부탁드립니다.",
  "text_error_gift_wrapping_unavailable_place_order": "장바구니 제품 내 기프트 포장이 어려운 부피가 큰 제품 또는 수량이 있습니다. 선택하신 기프트 박스를 해제 혹은 제품을 나누어 주문 부탁드립니다.",
  "text_length_guide_by_height": "text_length_guide_by_height",
  "text_cookie_settings": "",
  "text_csoon_early": "{month} 초 판매예정",
  "text_csoon_late": "{month} 말 판매예정",
  "text_csoon_mid": "{month} 중순 판매예정",
  "text_error_failed_display_info": "죄송합니다. 표시할 제품이 없습니다.",
  "text_error_failed_get_product_inventory": "재고 정보를 가져오지 못했습니다.",
  "text_product_detail_description_exchange_and_return_subtitle": "교환 / 반품",
  "text_product_detail_exchange_and_return_information_message": "교환 / 반품에 대한 안내",
  "text_pre_order_available_date": "가능한 날짜",
  "text_pre_order_product_description01": "예약판매에 대한 주의사항",
  "text_pre_order_product_description02": "예약판매 제품을 주문하시기 전 확인을 부탁드립니다.",
  "text_pre_order_product_description03": "예약판매 제품은 수량이 한정되어. 사전에 종료될 수 있습니다.",
  "text_pre_order_product_description04": "제품 사양 및 배송일은 예고 없이 변경될 수 있습니다.",
  "text_pre_order_product_description05": "주문 30분이 경과하거나, 제품의 배송 준비가 시작된 경우 주문 취소가 불가합니다. 배송 전 취소를 희망하시는 경우 1:1 문의로 문의해 주세요.",
  "text_size_recommendation_check_by_answering_question_message_01": "질문에 답해주시면, 고객님의 사이즈를 권장해 드립니다.",
  "text_including_incentivized_review_message": "상품 리뷰",
  "text_no_answer": "대답 없음",
  "text_post_confirm": "게시",
  "text_rvw_ag_001": "0~3개월",
  "text_rvw_ag_002": "4~6개월",
  "text_rvw_ag_003": "7~9개월",
  "text_rvw_ag_004": "10~12개월",
  "text_rvw_ag_005": "1~2년",
  "text_rvw_ag_006": "3~6세",
  "text_rvw_ag_007": "7~9세",
  "text_rvw_ag_008": "10대",
  "text_rvw_ag_009": "20대",
  "text_rvw_ag_010": "30대",
  "text_rvw_ag_011": "40대",
  "text_rvw_ag_012": "50대",
  "text_rvw_ag_013": "60대 이상",
  "text_rvw_ag_014": "10대 이하",
  "text_rvw_fs_001": "21.5cm 이하",
  "text_rvw_fs_002": "22.0cm",
  "text_rvw_fs_003": "22.5cm",
  "text_rvw_fs_004": "23.0cm",
  "text_rvw_fs_005": "23.5cm",
  "text_rvw_fs_006": "24.0cm",
  "text_rvw_fs_007": "24.5cm",
  "text_rvw_fs_008": "25.0cm",
  "text_rvw_fs_009": "25.5cm",
  "text_rvw_fs_010": "26.0cm",
  "text_rvw_fs_011": "26.5cm",
  "text_rvw_fs_012": "27.0cm",
  "text_rvw_fs_013": "27.5cm",
  "text_rvw_fs_014": "28.0cm",
  "text_rvw_fs_015": "28.5cm",
  "text_rvw_fs_016": "29.0cm",
  "text_rvw_fs_017": "29.5cm",
  "text_rvw_fs_018": "30.0cm 이상",
  "text_rvw_fs_019": "22.0cm 이하",
  "text_rvw_fs_020": "28.0cm 이상",
  "text_rvw_glbl_000": "대답 없음",
  "text_rvw_hr_001": "65cm 이하",
  "text_rvw_hr_002": "66~70cm",
  "text_rvw_hr_003": "71~75cm",
  "text_rvw_hr_004": "76~80cm",
  "text_rvw_hr_005": "81~85cm",
  "text_rvw_hr_006": "86~90cm",
  "text_rvw_hr_007": "91~95cm",
  "text_rvw_hr_008": "96~100cm",
  "text_rvw_hr_009": "101~110cm",
  "text_rvw_hr_010": "111~120cm",
  "text_rvw_hr_011": "121~130cm",
  "text_rvw_hr_012": "131~140cm",
  "text_rvw_hr_013": "141~150cm",
  "text_rvw_hr_014": "151~155cm",
  "text_rvw_hr_015": "156~160cm",
  "text_rvw_hr_016": "161~165cm",
  "text_rvw_hr_017": "166~170cm",
  "text_rvw_hr_018": "171~175cm",
  "text_rvw_hr_019": "176~180cm",
  "text_rvw_hr_020": "181~185cm",
  "text_rvw_hr_021": "186~190cm",
  "text_rvw_hr_022": "191cm 이상",
  "text_rvw_hr_023": "181cm 이상",
  "text_rvw_wr_001": "5kg 이하",
  "text_rvw_wr_002": "5~8kg",
  "text_rvw_wr_003": "9~12kg",
  "text_rvw_wr_004": "13~15kg",
  "text_rvw_wr_005": "16~20kg",
  "text_rvw_wr_006": "21~25kg",
  "text_rvw_wr_007": "26~30kg",
  "text_rvw_wr_008": "31~35kg",
  "text_rvw_wr_009": "36~40kg",
  "text_rvw_wr_010": "41~45kg",
  "text_rvw_wr_011": "46~50kg",
  "text_rvw_wr_012": "51~55kg",
  "text_rvw_wr_013": "56~60kg",
  "text_rvw_wr_014": "61~65kg",
  "text_rvw_wr_015": "66~70kg",
  "text_rvw_wr_016": "71~75kg",
  "text_rvw_wr_017": "76~80kg",
  "text_rvw_wr_018": "81~85kg",
  "text_rvw_wr_019": "86~90kg",
  "text_rvw_wr_020": "91kg 이상",
  "text_empty_height": "-'-\"",
  "text_one_cm_in_inch": "스타일 힌트_inch",
  "text_app_floor_map_description": "매장에 있는 제품의 위치가 표시됩니다.",
  "text_app_link_floor_map": "매장 지도",
  "text_personal_checkout_complete_order_message_01": "[결제]를 누르면 구매가 완료됩니다.",
  "text_personal_checkout_order_complete": "주문 / 결제",
  "text_personal_checkout_use_shopping_bag_checkbox": "쇼핑백 구매({price})",
  "text_personal_checkout_use_shopping_bag_checkbox_message_01": "대, 중, 소 중에서 쇼핑백을 선택해 주세요",
  "text_personal_checkout_shopping_bag": "쇼핑백",
  "text_personal_checkout_receipt_number": "영수증 번호",
  "text_store_receipt_barcode": "결제시 매장 영수증 바코드 생성",
  "text_personal_checkout_continue_shopping": "쇼핑 계속하기",
  "text_error_personal_checkout_place_order_time_out_message_01": "통신 시간 초과",
  "text_error_personal_checkout_place_order_time_out_title": "통신 시간 초과",
  "text_personal_checkout_check_store_receipt": "영수증 확인",
  "text_personal_checkout_leave_store_message_01": "매장에서 나가실때 바코드를 제시해 주세요. 메일로 발송된 영수증에서도 바코드를 확인할 수 있습니다.",
  "text_personal_checkout_leave_store_title": "매장에서 나가는 법",
  "text_error_personal_checkout_failed_to_add_to_cart_general_error_message_01": "결제시 일시적 오류가 발생 했습니다.",
  "text_error_personal_checkout_failed_to_add_to_cart_over_uq_pay_maximum_payment_amount_message_01": "결제시 일시적 오류가 발생 했습니다.",
  "text_error_personal_checkout_failed_to_add_to_cart_purchase_quantity_limit_message_01": "결제시 일시적 오류가 발생 했습니다.",
  "text_error_personal_checkout_failed_to_get_receipt_number": "결제시 일시적 오류가 발생 했습니다.",
  "text_personalization_onboarding_continue": "다음",
  "text_personalization_onboarding_select_category_baby": "BABY 유아(3-24개월)",
  "text_personalization_onboarding_select_category_newborn": "NEWBORN 신생아(0-3개월)",
  "text_personalization_onboarding_select_category_option_1": "OUTER(아우터)",
  "text_personalization_onboarding_select_category_option_10": "text_personalization_onboarding_select_category_option_10",
  "text_personalization_onboarding_select_category_option_11": "text_personalization_onboarding_select_category_option_11",
  "text_personalization_onboarding_select_category_option_12": "text_personalization_onboarding_select_category_option_12",
  "text_personalization_onboarding_select_category_option_2": "TOPS(상의)",
  "text_personalization_onboarding_select_category_option_3": "PANTS(팬츠)",
  "text_personalization_onboarding_select_category_option_4": "DRESSES&SKIRT(원피스&스커트)",
  "text_personalization_onboarding_select_category_option_5": "INNERWEAR(이너웨어)",
  "text_personalization_onboarding_select_category_option_6": "HOMEWEAR(홈웨어)",
  "text_personalization_onboarding_select_category_option_7": "SPORT UTILITYWEAR(스포츠유틸리티웨어)",
  "text_personalization_onboarding_select_category_option_8": "ACCESSORIES(액세서리)",
  "text_personalization_onboarding_select_category_option_9": "MATERNITY(임부복)",
  "text_personalization_onboarding_select_category_sweaters_cardigans": "HOMEWEAR(홈웨어)",
  "text_personalization_onboarding_select_category_toddler": "TODDLER영유아 (6개월-4세)",
  "text_personalization_onboarding_select_gender_baby": "BABY",
  "text_personalization_onboarding_select_gender_kids": "KIDS",
  "text_personalization_onboarding_select_gender_men": "MEN",
  "text_personalization_onboarding_select_gender_women": "WOMEN",
  "text_personalization_onboarding_select_multiple_option_category_title_01": "어떤 카테고리에 관심이 있으신가요?",
  "text_personalization_onboarding_select_multiple_option_category_title_02": "(여러 옵션을 선택할 수 있습니다)",
  "text_personalization_onboarding_select_multiple_option_gender_title_01": "누구를 위해 쇼핑을 하시나요?",
  "text_personalization_onboarding_select_multiple_option_gender_title_02": "(여러 옵션을 선택할 수 있습니다)",
  "text_personalization_onboarding_select_multiple_option_instruction": "고객님의 취향에 가장 잘 맞는 제품을 추천해 드립니다.",
  "text_personalization_onboarding_select_multiple_option_style_title_01": "어떤 스타일이 자신을 가장 잘 표현하시나요?",
  "text_personalization_onboarding_select_multiple_option_style_title_02": "(여러 옵션을 선택할 수 있습니다)",
  "text_personalization_onboarding_select_style_active": "액티브",
  "text_personalization_onboarding_select_style_casual": "캐주얼",
  "text_personalization_onboarding_select_style_clean": "클린",
  "text_personalization_onboarding_select_style_cute": "큐트",
  "text_personalization_onboarding_select_style_graphic_logos": "그래픽 / 로고",
  "text_personalization_onboarding_select_style_lounge": "라운지",
  "text_personalization_onboarding_select_style_smart": "스마트",
  "text_personalization_onboarding_tell_us_about_you_description": "고객님의 쇼핑 취향을 고려한 제품을 추천해드립니다",
  "text_personalization_onboarding_tell_us_about_you_title": "고객님의 정보를 제공해 주세요.",
  "text_personalization_onboarding_turn_on_push_notification_description": "신상품 및 할인∙이벤트, 주문 배송 상태를 알 수 있는 다양한 정보 알림을 보내드려요",
  "text_personalization_onboarding_turn_on_push_notification_title": "최신 뉴스를 받으시려면 알림을 켜주세요",
  "text_personalization_onboarding_welcome": "유니클로 APP에 오신 것을 환영합니다",
  "text_personalization_onboarding_select_aspect_option_1": "text_personalization_onboarding_select_aspect_option_1",
  "text_personalization_onboarding_select_aspect_option_2": "text_personalization_onboarding_select_aspect_option_2",
  "text_personalization_onboarding_select_aspect_option_3": "text_personalization_onboarding_select_aspect_option_3",
  "text_personalization_onboarding_select_aspect_option_4": "text_personalization_onboarding_select_aspect_option_4",
  "text_personalization_onboarding_select_aspect_option_5": "text_personalization_onboarding_select_aspect_option_5",
  "text_personalization_for_you_popular_picks_in_your_area": "주변지역 인기 제품",
  "text_personalization_for_you_recommendation_purchase_again": "즐겨찾기에 저장",
  "text_personalization_for_you_stylehint_styling": "추천 스타일링",
  "text_personalization_for_you_top_picks": "인기 아이템",
  "text_new_arrivals": "NEW",
  "text_personalization_frequently_visited_store_closed_temprarily_description_01": "이용해 주셔서 감사합니다. 현재 운영 하고 있지 않습니다. 불편을 끼쳐드려 죄송합니다. 근처 가까운 매장을 이용해주시기 바랍니다.",
  "text_personalization_frequently_visited_store_limited_offer": "매장 기간 한정 혜택",
  "text_personalization_frequently_visited_store_new_arrivals": "매장 신제품",
  "text_personalization_frequently_visited_store_news": "매장 안내사항",
  "text_personalization_frequently_visited_store_reccommend_for_you": "매장 추천 ITEM",
  "text_personalization_frequently_visited_store_reccommend_infomation": "즐겨찾는 매장의 신제품 확인하기",
  "text_personalization_frequently_visited_store_reccommend_infomation_title": "즐겨찾는 매장",
  "text_personalization_frequently_visited_store_recommend_information_description_01": "재고 및 매장 스탭 스타일링을 포함하여 즐겨찾는 매장에 대한 정보를 확인할 수 있습니다.",
  "text_personalization_frequently_visited_store_recommend_information_no_registered_store_description_01": "즐겨찾는 매장을 선택하여 신상품, 프로모션 및 더 많은 추천 스타일을 확인해 보세요.",
  "text_personalization_frequently_visited_store_sale": "매장 세일",
  "text_personalization_frequently_visited_store_top_selling_ranking": "매장 인기 ITEM",
  "text_personalization_frequently_visited_store_view_more_recommended_by_store": "매장 정보 더 보기",
  "text_personalization_recommendation_from_store": "{storeName}의 신제품을 확인하세요.",
  "text_personalization_staff_stylehint_styling": "스탭 스타일 힌트",
  "text_personalization_store_best_seller": "인기 ITEM",
  "text_personalization_store_limited_time_offer": "기간 한정",
  "text_personalization_you_may_also_like": "추천 상품",
  "text_view_more_limited_offer": "기간한정 더 보기",
  "text_view_more_markdown": "가격인하 상품 더보기",
  "text_view_more_new_arrivals": "더 보기",
  "text_view_more_topselling_ranking": "순위 제품 더보기",
  "text_view_purchase_history": "구매 내역 보기",
  "text_placeholder_credit_card_security_code": "보안 코드",
  "text_pl_enewsletter_list": "text_pl_enewsletter_list",
  "text_copyright_pl": "PLST_Copyright © PLST Co., Ltd. All rights reserved.",
  "text_go_to_top_pl": "PLST_TOP",
  "text_app_header_plst_top": "PLST_Header",
  "text_brand_pl": "PLST",
  "text_pl_enewsletter_setting_description_01": "PLST_이 페이지에서 PLST 메일 매거진의 전달 설정을 변경할 수 있습니다.",
  "text_pl_sns_facebook": "PLST_페이스북 공식계정",
  "text_pl_sns_instagram": "PLST_인스타그램 공식계정",
  "text_pl_sns_line": "PLST_LINE공식 계정",
  "text_pl_sns_pinterest": "PLST_핀터레스트 공식 계정",
  "text_pl_sns_twitter": "PLST_트위터 공식 계정",
  "text_pl_sns_youtube": "PLST_유투브 공식 계정",
  "text_plapp": "PLST_APP",
  "text_pllogo": "PLST_로고",
  "text_plmail_magaginze_fr": "PLST_온라인스토어",
  "text_plmail_magazine": "PLST_메일매거진",
  "text_plonline": "PLST_TOP",
  "text_pltop": "PLST",
  "text_returnto_plapp": "PLST_반품",
  "text_social_account": "PLST_계정",
  "text_product_display_markdown": "{startDate}부터 {flagName}",
  "text_limited_offer_until_date": "{startDate}부터 {date}까지 {flagName}",
  "text_markdown": "판매",
  "text_multibuy_limited_offer_until_date": "세트할인, {date}까지 기간 한정",
  "text_multibuy_markdown": "세트할인, 가격인하",
  "text_online_store_exclusive_limited_offer_until_date": "{startDate}부터 {date}까지 {flagName}",
  "text_post_review_unavailable_product": "해당 상품의 리뷰를 작성할 수 없습니다.",
  "text_king_promotion_over_upper_limit": "기간 한정 가격 적용 상한금액 초과",
  "text_king_prmotion_special_price_applied": "기간 한정 가격 적용",
  "text_pudo_enter_phone": "text_pudo_enter_phone",
  "text_pudo_first_name": "text_pudo_first_name",
  "text_pudo_last_name": "text_pudo_last_name",
  "text_pudo_receipt_pick_up_location": "EU단독_배송제한",
  "text_pudo_delivery_method_order_history_details": "EU단독_픽업지역배송",
  "text_order_status_pudo_order_acceptance": "text_order_status_pudo_order_acceptance",
  "text_order_status_pudo_order_arrived": "text_order_status_pudo_order_arrived",
  "text_order_status_pudo_order_preparing": "text_order_status_pudo_order_preparing",
  "text_order_status_pudo_order_shipped": "text_order_status_pudo_order_shipped",
  "text_ph_pudo_parcel_shop_search": "text_ph_pudo_parcel_shop_search",
  "text_pudo_contact_infromation_title": "text_pudo_contact_infromation_title",
  "text_pudo_new_contact_infromation": "text_pudo_new_contact_infromation",
  "text_pudo_pick_up_location": "EU단독_픽업지역",
  "text_pudo_search_location": "text_pudo_search_location",
  "text_pudo_delivery_method": "EU단독_배송방법",
  "text_pudo": "EU단독",
  "text_pudo_parcel_shop_unavailable_pickup_description": "text_pudo_parcel_shop_unavailable_pickup_description",
  "text_pudo_phone_number_hint_text": "text_pudo_phone_number_hint_text",
  "text_pudo_find_location": "EU단독_지역찾기",
  "text_pudo_no_location_found": "EU단독_지역찾기",
  "text_pudo_select_delivery_method_unavailable_due_to_order_volume": "EU단독_배송제한",
  "text_pudo_select_delivery_method_unavailable_include_pre_order_item": "EU단독",
  "text_pudo_submit_pick_up_location": "EU단독_픽업지역",
  "text_purchase_history_error_notes": "text_purchase_history_error_notes",
  "text_app_onboarding_push_notifications_consent_when_on": "알림을 끄시겠어요?",
  "text_app_onboarding_push_notifications_description_when_on": "신제품 및 할인 소식, 다양한 이벤트와 혜택 알림을 더 이상 받을 수 없게 됩니다.\n정말 알림을 끄시겠어요?",
  "text_app_onboarding_push_notifications_no_when_on": "OFF",
  "text_app_onboarding_push_notifications_yes_when_on": "ON 상태 유지",
  "text_app_open_notification_settings": "APP 알림 설정",
  "text_app_push_notification_back_in_stock_complete_note": "제품이 재입고된 경우 재입고 알림(APP 알림, 이메일)를 보내드립니다.",
  "text_app_push_notification_back_in_stock_description": "재입고 알림 푸시를 받으시려면 알림을 허용해 주세요.",
  "text_app_push_notification_back_in_stock_ios_description": "잠금 화면 표시와 배너 설정으로 더 쉽게 알림을 확인하실 수 있습니다.",
  "text_app_push_notification_back_in_stock_ios_title": "알림이 눈에 띄지 않게 표시됩니다.",
  "text_app_push_notification_back_in_stock_off_description": "위시리스트에 등록된 제품의 할인 정보, 재입고 뉴스에 대해 알려 드립니다.",
  "text_app_push_notification_back_in_stock_off_title": "제품에 대한 알림을 받아보세요!",
  "text_app_push_notification_back_in_stock_title": "기기의 알림 설정이 꺼져 있습니다.",
  "text_qrcode_trademark_description": "QR Code is registered trademark of DENSO WAVE INCORPORATED.",
  "text_store_receipt_expired_message_01": "구매 후 48시간이 지났기 때문에 더 이상 이메일 주소를 입력하실 수 없습니다.",
  "text_store_receipt_expired_message_02": "불편을 끼쳐드려 죄송합니다.",
  "text_store_receipt_expired_title": "전자 영수증의 유효 기간이 만료되었습니다.",
  "text_store_receipt_number": "영수증 번호",
  "text_store_receipt_web_form_complete_message_01": "고객님의 이메일 주소로 전자 영수증을 보내드립니다.",
  "text_store_receipt_web_form_complete_notes_message_01": "5분 이내에 전자 영수증이 전송되지 않으면 영수증 번호를 저장하신 후에 매장 직원에게 문의해 주시기 바랍니다.",
  "text_store_receipt_web_form_complete_notes_title": "메모",
  "text_store_receipt_web_form_complete_thanks": "감사합니다.",
  "text_store_receipt_web_form_email_sent_once_checkbox": "[보내기] 버튼을 누르면 전자 영수증이 전송 되는 것에 동의합니다. 이 페이지는 48시간 동안 유효합니다.",
  "text_store_receipt_web_form_message_01": "전자 영수증을 받으시려면 이메일 주소를 입력해주세요.",
  "text_store_receipt_web_form_privacy_policy": "유니클로 개인정보처리방침",
  "text_store_receipt_web_form_privacy_policy_description": "유니클로는 전자 영수증 발급을 목적으로 고객님의 이메일 주소를 수집 및 활용하고 있습니다. 고객님의 이메일 주소는 5일간 안전하게 보관되며, 다른 목적으로는 사용되지 않습니다. 자세한 내용은 유니클로 개인정보처리방침에서 확인하실 수 있습니다.",
  "text_store_receipt_web_form_send_button": "보내기",
  "text_store_receipt_web_form_title": "전자 영수증 받기",
  "text_contact_customer_center": "문의 사항이 있으신 경우 아래 링크를 클릭해 주세요.",
  "text_enter_email_address_register_customer_order_description": "고객 주문 시 등록한 메일 주소를 입력해 주세요.",
  "text_enter_mobile_phone_receive_receipt": "주문 시, 등록한 휴대폰 번호를 입력해 주세요.",
  "text_error_unmatch_registered_information": "입력한 정보가 일치하지 않습니다. 입력 정보를 확인해 주세요.",
  "text_invoice_regulation_contact_us": "문의하기",
  "text_invoice_regulation_receipt_expired_subtitle": "구매 내역서 확인 기한이 만료되었습니다.",
  "text_invoice_regulation_receive_receipt_title": "구매 내역서 받기",
  "text_receipt_expired_description": "본 주문에 관한 구매 내역서는 회사 온라인스토어 또는 기재하신 이메일/SMS를 통해 열람 및 다운로드할 수 있습니다.",
  "text_view_receipt_title": "구매 내역서 보기",
  "text_narvar_site_return_form_link": "2022년 3월 23일 이전에 구매한 제품 반품",
  "text_error_store_receipt_no_data_message_01": "궁금한점 있으시면 고객 센터로 문의 부탁 드립니다.",
  "text_error_store_receipt_no_data_message_02": "문의하기",
  "text_error_store_receipt_no_data_title": "데이터가 없습니다.",
  "text_error_store_receipt_web_form_acknowledgment_uncheck": "아래 내용을 꼭 확인해 주시기 바랍니다.",
  "text_error_store_receipt_web_form_invalid_email_address": "유효한 이메일 주소를 입력하세요.",
  "text_error_store_receipt_web_form_submit_multiple_email_address": "이메일 주소는 한 번만 제출할 수 있습니다.",
  "text_error_store_receipt_web_form_submit_same_email_address": "이메일 주소는 한 번만 제출할 수 있습니다.",
  "text_return_form_uq_us_warehouse_address_line_01": "9000 Rand Blvd. Building 7",
  "text_return_form_uq_us_warehouse_address_line_02": "Philipsburg, NJ 08865",
  "text_error_store_receipt_web_form_email_sent_once_checkbox_uncheck": "이메일로 영수증 수신에 대한 확인 및 동의가 필요합니다.",
  "text_app_referral_no_network_connection": "추천 코드를 확인할 수 없습니다. 인터넷 연결 상태를 확인 후 다시 시도해 주세요.",
  "text_app_share_referral_appstore_link_title": "유니클로 APP 다운로드",
  "text_app_share_referral_code": "추천 코드",
  "text_app_share_referral_description": "친구가 유니클로 온라인스토어에서 사용할 수 있는 5천원 쿠폰을 선물했습니다. 가입 시 추천 코드를 입력하시면 쿠폰이 자동으로 부여됩니다. 3만원 이상 첫 구매 시에는 추천한 친구에게도 5천원 쿠폰을 선물해 드립니다.",
  "text_return_form_home_return_pickup_note_01": "제품이 배송된 주소로 방문하여 수거합니다.",
  "text_return_form_lotte_pickup_note_01": "반품 상품은 직접 반송하셔야 합니다.",
  "text_return_form_return_by_customer_note_01": "다른 일반 택배사를 통해 반송하실 경우, 착불 반송은 불가합니다.",
  "text_return_form_return_by_customer_note_02": "반송 방법 변경 시, 반품 배송비가 변경됩니다.",
  "text_return_form_return_method_option_title": "제품 반송 방법",
  "text_return_form_shipping_fee_for_home_return_pickup": "반품 배송비: 3,000원(제품 검품후 회사귀책일 경우, 미청구)",
  "text_return_form_shipping_fee_for_lotte_pickup": "반품 배송비: 3,000원(제품 검품후 회사귀책일 경우, 미청구)",
  "text_return_form_shipping_fee_for_return_by_customer": "반품 배송비: 고객 개별 부담",
  "text_return_form_request_cancel_description": "참고 : 지정 택배사로 진행 후 접수 취소를 원하는 경우, 택배사로 부터 수거 연락을 받을 수 있으니 수거할 상품이 없음을 안내해주세요.\n\n*반품/교환 접수 변경을 희망하실 경우 재접수가 필요합니다.",
  "text_return_acceptable_term_expired_message_01": "이미 반품/교환 신청이 완료되었거나, 반품 기한이 초과되었습니다.",
  "text_return_form_prepare_shipment_description": "구매 시 동봉된 주문확인서를 반품 제품과 함께 박스에 동봉해 주세요.",
  "text_return_form_replacement_card": "주문확인서를 동봉",
  "text_return_form_sale_slip": "주문확인서를 동봉",
  "text_return_form_lotte_pickup": "지정 택배사",
  "text_return_form_lotte_pickup_send_back_package_description": "[수거 신청하기] 클릭 후 주소를 입력해 주세요.",
  "text_return_form_send_back_package_description": "상품과 주문확인서를 함께 포장하여 지정된 주소로 보내주시기 바랍니다.",
  "text_return_item_method_message": "반송 기한 내에 상품이 도착할 수 있도록 반송해 주세요.",
  "text_return_form_home_return_pickup_note_02": "고객 사유로 인한 반품의 경우 반품 배송비 3,000원이 차감된 금액으로 환불해 드립니다.",
  "text_return_form_home_return_pickup_note_03": "영업일 기준 1~3일 이내로 고객님의 연락처로 수거 안내 및 방문 예정입니다.",
  "text_return_form_home_return_pickup_note_04": "반품 취소 후 수거 안내를 받으실 경우, 택배사에 직접 수거취소 연락을 부탁드립니다.",
  "text_return_form_home_return_pickup_note_05": "수거 주소의 변경을 희망하시는 경우 고객센터로 문의해 주시기 바랍니다.",
  "text_return_form_home_return_pickup_prepaid_title": "지정 택배사를 통한 상품 수거",
  "text_return_form_lotte_pickup_check_pickup_location": "택배사 수거 신청하기",
  "text_return_form_lotte_pickup_check_return_operation_description": "① [반품 예약] > [업체코드로 접수] > [274244] 입력 \n ② 보내시는 분 정보 직접 입력 \n ③ 받으시는 분 자동 입력 (강남구 세곡동, 서울남부지점) \n ④ 물품명 [의류] > 물품개수 [1] > 택배운임 [신용] 선택\n \n ※ 수거 신청 후, 이 화면으로 복귀하여 아래 [신청 확정] 을 클릭해 주세요.",
  "text_return_form_lotte_pickup_method": "[수거 신청하기] 클릭 후 주소를 입력해 주세요.",
  "text_return_form_lotte_pickup_note_02": "① [반품 예약] > [업체코드로 접수] > [274244] 입력 \n ② 보내시는 분 정보 직접 입력 \n ③ 받으시는 분 자동 입력 (강남구 세곡동, 서울남부지점) \n ④ 물품명 [의류] > 물품개수 [1] > 택배운임 [신용] 선택\n \n ※ 수거 신청 후, 이 화면으로 복귀하여 아래 [신청 확정] 을 클릭해 주세요.",
  "text_return_form_lotte_pickup_note_03": "접수하신 다음 날로부터 영업일 기준 1 ~ 3일 이내에 수거가 진행됩니다.",
  "text_return_form_pickup_address": "택배사 수거 신청하기",
  "text_return_form_return_by_customer_lotte_pickup_title": "지정 택배사를 통한 제품 수거 (수거지 입력 필요)",
  "text_return_form_return_by_customer_title": "고객 직접 반송",
  "text_return_form_warehouse_address_street_name": "도로명 : 경기도 이천시 마장면 프리미엄 아울렛로 113-60 A동 롯데닷컴 유니클로센터 8번 도크",
  "text_return_form_warehouse_address": "지 번 : 경기도 이천시 마장면 표교리 711번지 A동 롯데닷컴 유니클로센터 8번 도크",
  "text_return_form_warehouse_address_to": "받는 사람 : 이천 유니클로 EC센터 / 080-722-3300",
  "text_failed_get_exchange_return_confirmation_description_01": "죄송합니다. 입력해 주신 일부 정보를 가지고 오지 못했습니다.",
  "text_failed_get_exchange_return_confirmation_description_02": "이전 페이지로 돌아가서 다시 입력해 주시기 바랍니다.",
  "text_failed_get_exchange_return_confirmation_title": "정보를 가지고 오지 못했습니다.",
  "text_return_and_exchange_form_failing_return_label_generation_description": "text_return_and_exchange_form_failing_return_label_generation_description",
  "text_return_and_exchange_form_failing_return_label_generation_faq_instruction_link": "text_return_and_exchange_form_failing_return_label_generation_faq_instruction_link",
  "text_exchange_and_return_form_incomplete_application_expired": "요청 취소",
  "text_exchange_and_return_form_incomplete_application_expired_description_01": "아래 주문번호의 반품 / 교환신청이 완료되지 않은 상태로 접수가능기간이 종료되었습니다. 진행상태를 중단해 주세요.",
  "text_exchange_and_return_form_incomplete_application_expired_description_02": "먼저 미완료 요청을 취소해 주세요.",
  "text_exchange_and_return_form_incomplete_application_expired_title": "요청이 제출되지 않았습니다.",
  "text_error_return_form_failed_generate_qr_code_shipping_label": "text_error_return_form_failed_generate_qr_code_shipping_label",
  "text_return_form_cancel_qr_code_shipping_label_note": "text_return_form_cancel_qr_code_shipping_label_note",
  "text_return_form_generate_qr_code_shipping_label_note": "text_return_form_generate_qr_code_shipping_label_note",
  "text_product_return_initiate_refund_note": "IN 지역",
  "text_product_return_pickup_notes_02": "IN 지역",
  "text_product_return_warehouse_receive_note": "IN 지역",
  "text_bank_account_faq_link": "BDO 은행 계좌(en-PH)",
  "text_original_delivery_method": "반송 픽업 주소에 대한 반송 흐름",
  "text_return_portal_complete_title": "태국어에 대한 포털 제목 반환",
  "text_return_portal_confirm_title": "태국어에 대한 포털 제목 반환",
  "text_return_portal_registration": "반품 등록",
  "text_return_portal_terms_and_conditions": "PH_반품조건",
  "text_return_portal_title": "태국어에 대한 포털 제목 반환",
  "text_store_pickup_order_return_disclaimer_01": "반송 픽업 주소에 대한 반송 흐름",
  "text_terms_and_conditions": "PH_조건확인",
  "text_review_google_translation_link": "text_review_google_translation_link",
  "text_review_show_original_review": "text_review_show_original_review",
  "text_review_syndication_reviewed_country": "에서 리뷰함",
  "text_review_syndication_reviews_from_country": "리뷰 지역",
  "text_review_number_display_view_review_list": "(리뷰 {count}건)",
  "text_reveiw_imark_google_translation_title": "text_reveiw_imark_google_translation_title",
  "text_review_imark_google_translation_description": "text_review_imark_google_translation_description",
  "text_filter_country_reviews_from": "text_filter_country_reviews_from",
  "text_error_review_google_translation": "text_error_review_google_translation",
  "text_display_reviews": "결과",
  "text_in_stock_select_store": "선택 매장 재고 있음",
  "text_no_stock_online_store": "온라인스토어 재고 없음",
  "text_review_agreeto_terms_n_conditions1": "",
  "text_review_agreeto_terms_n_conditions2": "",
  "text_review_number_display_view_all_review_list": "리뷰 전체보기({count})",
  "text_review_opt_out_product_sampling_pgm": "",
  "text_review_product_sampling_pgm_description": "",
  "text_review_product_sampling_pgm_details": "",
  "text_submit_shipping_address_mismatch_message_01": "시/구/군이 일치하지 않을 수 있습니다.",
  "text_place_order_shipping_address_mismatch_continue_checkout": "배송지 주소 확인",
  "text_place_order_shipping_address_mismatch_message_02": "일치하지 않을 경우 상품 배송이 불가할 수 있습니다.",
  "text_place_order_shipping_address_mismatch_title": "배송지 주소를 확인해 주세요",
  "text_submit_shipping_address_mismatch_continue_checkout": "주문 계속",
  "text_submit_shipping_address_mismatch_edit_address": "주소 변경",
  "text_submit_shipping_address_mismatch_message_02": "일치하지 않을 경우 상품 배송이 불가할 수 있습니다.",
  "text_submit_shipping_address_mismatch_title": "배송지 주소를 확인해 주세요",
  "text_place_order_shipping_address_mismatch_message_01": "시/구/군이 일치하지 않을 수 있습니다.",
  "text_place_order_shipping_address_mismatch_message_03": "배송지 주소에 오류가 없으면 다시 주문하기 버튼을 눌러주세요.",
  "text_prohibited_camera_access_02": "카메라를 사용하여 스캔하는 경우 카메라 설정을 켜야 합니다. 설정에서 카메라를 허용해주시기 바랍니다.",
  "text_allow_start_scan": "text_allow_start_scan",
  "text_scan_usage_description": "카메라를 사용하여 스캔하는 경우 카메라 설정을 켜야 합니다.",
  "text_search_filter_unavailable_size_option": "사용 가능한 사이즈 필터 옵션이 없습니다.",
  "text_search_results": "결과: {count}개 리뷰",
  "text_filter_size": "XS,S,M,L,XL,XXL,3XL,4XL",
  "text_search_filter_all_stock": "온라인 스토어 + 선택한 매장",
  "text_search_filter_all_stock_both": "온라인 + 매장",
  "text_search_filter_change_store": "매장 변경",
  "text_search_filter_gender_and_category": "성별 및 카테고리",
  "text_search_filter_in_store_only": "지정한 매장재고만",
  "text_search_filter_no_results": "필터와 일치하는 결과가 없습니다.",
  "text_search_filter_online_store_stock": "온라인 스토어",
  "text_search_filter_online_store_stock_only": "온라인 스토어 재고만",
  "text_search_filter_select_category_message_01": "카테고리 표시 원하시면 성별을 선택해 주세요.",
  "text_search_filter_select_store": "매장 선택",
  "text_search_filter_select_store_message_01": "재고를 검색할 매장을 선택해 주세요.",
  "text_search_filter_selected_store_stock": "지정한 매장재고만",
  "text_search_filter_stock": "재고 검색",
  "text_search_filter_stock_search": "재고 검색 방법 선택:",
  "text_sort_byreview": "평점 높은 순",
  "text_men": "MEN",
  "text_image_search": "이미지 검색",
  "text_nosearchresult": "검색과 일치하는 결과가 없습니다.",
  "text_category": "카테고리",
  "text_productsearch": "검색",
  "text_search_all": "모두",
  "text_search_alternative_search_method": "다른 방법으로 검색해 주세요.",
  "text_search_by_category": "카테고리로 검색",
  "text_search_by_purchase_history": "구매 내역으로 검색",
  "text_search_category": "카테고리",
  "text_search_no_suggestion": "검색 결과가 없습니다.",
  "text_search_find_store": "매장 찾기",
  "text_searchbykeyword": "키워드로 검색",
  "text_search_no_product_search_result": "검색어가 포함된 결과가 없습니다.",
  "text_filter": "필터",
  "text_boys": "BOYS",
  "text_department": "성별",
  "text_exlarge_store_only": "초대형 매장만 판매",
  "text_filter_byother": "기타 필터",
  "text_filter_color": "WHITE,GRAY,BLACK,PINK,RED,ORANGE,BEIGE,BROWN,YELLOW,GREEN,BLUE,PURPLE",
  "text_filter_pricerange": "~1만원 미만,1만원 ~ 3만원 미만,3만원 ~ 5만원 미만, 5만원 ~ 7만원 미만, 7만원 ~ 10만원 미만, 10만원 이상~",
  "text_filter_sizemum": "34,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,52,54,55,56,58,61,64,67,70,73,76,79,80,82,85,88,90,100,110,120,130140,150,160",
  "text_girls": "GIRLS",
  "text_large_store_only": "대형 매장만 판매",
  "text_limited_offer": "기간 한정",
  "text_newcolor": "새로운 컬러",
  "text_newprice": "새로운 가격",
  "text_online_store_only": "온라인 스토어 전용",
  "text_onlinestore_limited": "온라인 한정",
  "text_ph_search_country_code": "",
  "text_presale": "사전판매 - 온라인 스토어 전용",
  "text_search_byimage": "사진으로 찾기",
  "text_search_filter": "필터링 기준",
  "text_search_results_for": "검색",
  "text_seo_searchresults": "{query}에 대한 검색 결과",
  "text_store_only": "일부 매장만 판매",
  "text_style_material": "스타일 및 소재",
  "text_subcategory": "하위 카테고리",
  "text_unisex": "UNISEX",
  "text_recommended_producs": "좋아할만한 제품",
  "text_search_select_store_meta_description": "매장을 지정하면 해당 매장의 재고 확인이 가능합니다.",
  "text_breadcrumbs_top": "UNIQLO",
  "text_login_meta_description": "UNIQLO 온라인 스토어에 로그인 해 주세요.",
  "text_meta_description_postfix": "UNIQLO {region_name}",
  "text_meta_description_prefix": "UNIQLO.com에서 {page_title}를 확인해 주세요.",
  "text_meta_keywords_postfix": "메타 키워드",
  "text_meta_keywords_prefix": "UNIQLO {region_name},",
  "text_meta_title_postfix": "| UNIQLO",
  "text_meta_title_prefix": "UNIQLO |",
  "text_pwreset_meta_description": "비밀번호를 재설정 해 주세요.",
  "text_search_meta_description": "제품 검색 페이지입니다. 키워드및 카테고리에서 제품을 쉽게 찾을 수 있습니다. 또한 스타일, 사이즈, 컬러, 가격등 타입별로 필터 하여 원하는 제품을 바로 찾을 수 있습니다.",
  "text_shipping_fee_from": "최소 {min_shipping_fee}",
  "text_similar_products": "비슷한 제품",
  "text_similar_products_list": "비슷한 제품",
  "text_similar_products_list_column_empty": "-",
  "text_similar_products_viewing_item": "제품 보기",
  "text_size_multiplication_sign": "✕",
  "text_size_chart_compare_demension_with_your_product_notification": "제품과 치수를 비교할 수 있습니다.",
  "text_size_chart_store_not_selectd": "선택한 매장 없음",
  "text_size_chart": "사이즈표",
  "text_size_chart_return_to_product_detail": "제품 페이지로 돌아가기",
  "text_size_chart_view_length_guide_by_height": "신장별 착용 가이드",
  "text_size_chart_nude_dimensions": "신체 치수",
  "text_comparison_product_selection": "비교 제품 선택",
  "text_error_size_chart_exceed_number_of_compared_products": "비교 재품의 개수의 최대 한도인 20개를 초과했습니다.",
  "text_size_chart_add_other_product": "비교 제품 추가",
  "text_size_chart_add_other_product_description_01": "사이즈 비교는 최대 20개까지 가능합니다.",
  "text_size_chart_added_item": "추가 제품",
  "text_size_chart_bra_size_guide": "UNIQLO 브라 사이즈 가이드",
  "text_size_chart_comparing_item": "제품 비교",
  "text_size_chart_comparison_product_select": "선택",
  "text_size_chart_comparison_with_additional_products_title": "추가 제품과 비교",
  "text_size_chart_comparison_with_purchased_products_title": "구매한 제품과 비교",
  "text_size_chart_description_01": "구매하신 제품과 사이즈 비교가 가능합니다.",
  "text_size_chart_how_to_measure": "측정 방법 설명",
  "text_size_chart_login_description": "동일한 카테고리에서 구매한 제품과 사이즈를 비교하려면 로그인해 주세요.",
  "text_size_chart_no_purchase_product": "비교 가능한 구매 제품이 없습니다.",
  "text_size_chart_note": "※주의사항",
  "text_size_chart_note_01": "구입 제품 중 일부 표시되지 않는 제품이 있습니다.",
  "text_size_chart_note_02": "제품 원단의 특성에 따라 1~2cm(벨트는 1~3cm) 정도의 사이즈 차이가 있을 수 있습니다.",
  "text_size_chart_note_03": "제품 사이즈는 실제 제품 사이즈입니다.",
  "text_size_chart_note_04": "동일한 사이즈의 제품/의류라도 핏이 다를 수 있습니다.",
  "text_size_chart_note_05": "턱과 주름이 있는 제품에 표시된 사이즈는 턱과 주름을 펼친 상태에서 측정됩니다.",
  "text_size_chart_note_06": "제품 태그에 기재된 사이즈는 신체 치수입니다.",
  "text_size_chart_note_07": "신체 치수는 \"신체치수 보기\"를 확인해 주세요.",
  "text_size_chart_number_of_compared_products": "{count}건 제품이 추가 되었습니다.",
  "text_size_chart_return_to_size_chard": "사이즈 차트로 돌아가기",
  "text_size_chart_select_size": "사이즈 선택",
  "text_size_chart_size": "사이즈",
  "text_size_chart_table_description_01": "제품 치수가 표시됩니다.",
  "text_size_chart_table_description_02": "최종 사이즈의 단위는 센치(cm)입니다.",
  "text_size_chart_unavailable_value_hyphen": "-",
  "text_size_chart_unit_cm": "cm",
  "text_size_chart_unit_inch": "inch",
  "text_size_chart_view_nude_dimension": "신체치수 보기",
  "text_size_chart_view_product_detail": "제품 상세정보 보기",
  "text_size_chart_unit_cmm": "",
  "text_size_chart_add_other_product_table_description_01": "추가된 제품은 선택한 사이즈로 표시됩니다.",
  "text_uq_sns_instagram": "UNIQLO Instagram 방문하기",
  "text_uq_sns_line": "UNIQLO LINE 방문하기",
  "text_uq_sns_pinterest": "UNIQLO Pinterest 방문하기",
  "text_uq_sns_tiktok": "text_uq_sns_tiktok",
  "text_uq_sns_twitter": "UNIQLO Twitter 방문하기",
  "text_uq_sns_youtube": "UNIQLO YouTube 방문하기",
  "text_tiktok": "TikTok",
  "text_uq_sns_facebook": "UNIQLO Facebook 방문하기",
  "text_coming_soon_store": "곧 오픈",
  "text_store_pickup_location_title": "픽업 위치",
  "text_storesearch": "매장 찾기",
  "text_car": "자동차",
  "text_store_pickup_location_title_colon": "픽업 위치:",
  "text_todays_store_opening_hours": "오늘의 영업시간",
  "text_store_locator_search_form_placeholder": "매장명・주소・우편번호",
  "text_holiday": "휴일",
  "text_ph_store_search_form": "키워드로 검색",
  "text_parkinglot_available": "주차장 이용 가능",
  "text_parkinglot": "주차장",
  "text_openinghour": "영업시간",
  "text_friday_mid": "금요일",
  "text_monday_mid": "월요일",
  "text_saturday_mid": "토요일",
  "text_thursday_mid": "목요일",
  "text_tuesday_mid": "화요일",
  "text_wednesday_mid": "수요일",
  "text_store_holiday": "매장 휴무일",
  "text_sunday_mid": "일요일",
  "text_special_store_hours": "변경 운영시간",
  "text_nostore_found": "현재 검색 기준과 일치하는 매장 결과가 없습니다.",
  "text_storesearch_bynearest": "현재 위치 사용",
  "text_bus": "버스",
  "text_hiringinfo": "구인정보",
  "text_irregular_opening_day": "영업시간(변동가능)",
  "text_open_maps_with_popular_times": "Google 지도로 매장 확인",
  "text_parking_information_title": "주차 정보",
  "text_regular_employee": "현재 직원 채용중",
  "text_showdirection": "길 찾기",
  "text_small_store": "소형 매장",
  "text_standard_store": "표준 매장",
  "text_store_announcement": "매장 안내사항",
  "text_store_announcements": "매장 안내사항",
  "text_store_available_at": "서비스 정보",
  "text_store_available_payment_method": "결제 수단",
  "text_store_locator_opening_fliyer_link": "오프닝 전단지 확인",
  "text_store_locator_pay_in_store": "매장 결제",
  "text_store_locator_products": "취급제품",
  "text_store_locator_store_pick_up": "매장으로 배송",
  "text_storestaff_hiring": "매장 스탭 모집중",
  "text_train": "전철",
  "text_carry_open_front_inner": "text_carry_open_front_inner",
  "text_store_locator_accessible_parking_lot": "text_store_locator_accessible_parking_lot",
  "text_store_locator_multi_purpose_toilet": "text_store_locator_multi_purpose_toilet",
  "text_store_locator_no_steps": "text_store_locator_no_steps",
  "text_store_locator_slope": "text_store_locator_slope",
  "text_store_locator_spacious_fitting_room": "text_store_locator_spacious_fitting_room",
  "text_uniqlo_flower": "text_uniqlo_flower",
  "text_ut_me": "text_ut_me",
  "text_store_locator_store_service": "매장 서비스",
  "text_carry_women": "WOMEN",
  "text_carrybaby": "BABY",
  "text_carrykids": "KIDS",
  "text_carrymaternity": "Maternity",
  "text_carry_teen": "text_carry_teen",
  "text_megastore": "초대형 매장",
  "text_store_locator_filter_product": "취급제품",
  "text_store_locator_filter_store_type": "매장 유형",
  "text_stores": "매장",
  "text_storesearch_byprefecture": "도시 검색",
  "text_view_all_store": "모든 매장 보기",
  "text_access": "접근",
  "text_clear": "지우기",
  "text_close_filter": "필터 닫기",
  "text_closingdate": "마감 시간:",
  "text_country_or_region": "국가 혹은 지역",
  "text_custom_order_men": "text_custom_order_men",
  "text_custom_order_women": "text_custom_order_women",
  "text_extra_large_store": "초대형 매장",
  "text_friday_long": "금요일",
  "text_friday_short": "금",
  "text_info_from_store": "매장 안내사항",
  "text_Kids_Baby": "KIDS,BABY",
  "text_km": "킬로미터",
  "text_local_storestaff_hiring": "현재 지역 매장 스탭을 모집하고 있습니다.",
  "text_maintenance_link_label": "자세히 보기",
  "text_mile": "마일",
  "text_monday_long": "월요일",
  "text_monday_short": "월",
  "text_new_store": "신규 오픈",
  "text_normal_store": "표준점포",
  "text_open_map_app": "지도 APP 사용",
  "text_purchasehistory_imark_description_08": "구매이력_imark",
  "text_re_uniqlo_studio": "text_re_uniqlo_studio",
  "text_read_storenews": "매장 소식 보기",
  "text_regular_hours": "운영시간",
  "text_saturday_long": "토요일",
  "text_saturday_short": "토",
  "text_search_result_store": "{count} 건",
  "text_search_this_area": "이 지역 검색",
  "text_station": "역",
  "text_store_address": "주소",
  "text_store_closed_certain_period": "일시적 휴업중",
  "text_store_closed_permanently": "폐점",
  "text_store_closed_state_of_emergency": "휴업중",
  "text_store_closed_temporarily": "임시 휴업중",
  "text_store_locator_details_meta_description": "안내 페이지 입니다.",
  "text_store_locator_details_meta_title": "| UNIQLO 매장 검색",
  "text_store_locator_staff_styling": "스탭 스타일링",
  "text_store_locator_top_meta_description": "유니클로 매장을 매장명, 가까운역・주소・우편번호・가까운위치로 찾을수 있습니다.",
  "text_store_locator_top_meta_title": "매장 찾기 - UNIQLO | UNIQLO 매장 검색",
  "text_store_new_open_date": "신규 오픈",
  "text_store_news": "매장 소식",
  "text_store_phone_call": "전화걸기",
  "text_store_size": "매장 규모",
  "text_store_type": "매장 유형",
  "text_storenews": "매장 소식 리스트",
  "text_storeopen_hour": "영업시간:",
  "text_storesearch_appliedfilter": "적용된 필터",
  "text_storesearch_filter": "필터",
  "text_sunday_long": "일요일",
  "text_sunday_short": "일",
  "text_thursday_long": "목요일",
  "text_thursday_short": "목",
  "text_tuesday_long": "화요일",
  "text_tuesday_short": "화",
  "text_wednesday_long": "수요일",
  "text_wednesday_short": "수",
  "text_when_holidays": "휴점일 :",
  "text_carry_kids_baby": "text_carry_kids_baby",
  "text_store_locator_order_and_pick": "ORDER & PICK (당일픽업)",
  "text_carry_men": "MEN",
  "text_all_gender": "text_all_gender",
  "text_best_seller": "베스트셀러",
  "text_recommendation_for_you": "text_recommendation_for_you",
  "text_storemode_promotion_description": "text_storemode_promotion_description",
  "text_storemode_promotion_description_best_fit": "text_storemode_promotion_description_best_fit",
  "text_storemode_promotion_description_find_product": "text_storemode_promotion_description_find_product",
  "text_storemode_promotion_description_product_availability": "text_storemode_promotion_description_product_availability",
  "text_storemode_promotion_pick_up_my_order_button": "text_storemode_promotion_pick_up_my_order_button",
  "text_storemode_unavailable_item_description": "text_storemode_unavailable_item_description",
  "text_my_order_login_required": "text_my_order_login_required",
  "text_push_center_notification_order_ready_description": "text_push_center_notification_order_ready_description",
  "text_push_center_notification_order_ready_title": "text_push_center_notification_order_ready_title",
  "text_start_floor_map_button": "text_start_floor_map_button",
  "text_store_guide": "text_store_guide",
  "text_stylehint": "스타일 힌트",
  "text_stylehint_view_more_officialstyling_button": "공식 스타일링 더 보기",
  "text_stylehint_view_more_postedstyling_button": "StyleHint 스타일링 더 보기",
  "text_stylehint_non_listed_items_currently_unavailable_message": "※ 위에 게재되지 않은 착용제품은 타사브랜드제품 또는 유니클로 과거제품입니다.",
  "text_stylehint_no_filtering_result": "필터와 일치하는 결과가 없습니다.",
  "text_stylehint_clear_all_filters": "모든 필터 지우기",
  "text_stylehint_no_filtering_result_tip": "필터를 변경 후 사용해 보세요.",
  "text_stylehint_app": "스타일 힌트 APP",
  "text_styling_book_enews_letter": "이메일 뉴스레터",
  "text_styling_book_stylehint_page_title": "스타일 힌트",
  "text_stylehint_non_listed_items_message_01": "※ 위에 제품 정보가 없는 착용 제품의 경우, 타사브랜드제품 혹은 유니클로 과거제품입니다.",
  "text_stylehintapp": "스타일 힌트 앱",
  "text_styling_book_gender_menu_men": "MEN",
  "text_styling_book_gender_menu_women": "WOMEN",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_meta_kids_and_baby": "text_styling_book_meta_kids_and_baby",
  "text_account_link": "회원정보",
  "text_official_styling_top_page_link": "공식 스타일링 상위 페이지",
  "text_stylehint_top_page_link": "스타일 힌트 상위 페이지",
  "text_styling_book_apply_filters_button": "필터 적용",
  "text_styling_book_clear_all_filters": "모두 지우기",
  "text_styling_book_hashtag_title": "해시태그",
  "text_styling_book_no_results": "결과 없음",
  "text_styling_book_official_styling": "공식 스타일링",
  "text_styling_book_official_styling_page_title": "공식 스타일링",
  "text_styling_book_related_styling_title": "관련 스타일링",
  "text_styling_book_search_by_color": "컬러 검색",
  "text_styling_book_search_by_feature": "컬렉션에서 검색",
  "text_styling_book_search_by_hashtag": "해시태그에서 검색",
  "text_styling_book_search_results_number": "{total} 건",
  "text_styling_book_sort_latest": "신상품순",
  "text_styling_book_sort_popular": "판매순",
  "text_styling_book_staff_customer_filter_customer_styling": "고객님",
  "text_styling_book_stylehint": "스타일 힌트",
  "text_styling_book_stylehint_staff_and_customer": "스타일 힌트(스탭 및 고객 스타일링)",
  "text_styling_book_gender_menu_kids_and_baby": "KIDS / BABY",
  "text_styling_book_breadcrumb_official_styling": "공식 스타일링",
  "text_styling_book_breadcrumb_stylehint": "스타일 힌트",
  "text_styling_book_breadcrumb_styling_number": "스타일링 번호",
  "text_styling_book_breadcrumb_stylingbook": "스타일링북",
  "text_no_styling_under_selected_product": "이 제품에 해당하는 스타일이 없습니다.",
  "text_styling_book_filter_height_under": "이하",
  "text_styling_book_meta_baby": "BABY",
  "text_styling_book_meta_kids": "KIDS",
  "text_styling_book_meta_men": "MEN",
  "text_styling_book_meta_official_styling": "스타일링 아이디어",
  "text_styling_book_meta_stylehint": "스타일링 아이디어",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "WOMEN",
  "text_styling_book_official_detail_id_alt_tag": "「{officialProducts}」의 스타일링 팁을 확인해보세요",
  "text_styling_book_official_detail_meta_description": "「{officialProducts}」의 이번 시즌 스타일 및 전체 스타일링을 {brand}.com에서 확인해보세요!",
  "text_styling_book_official_detail_meta_title": "「{officialProducts}」을(를) 착용하였습니다.{uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "{brand}의 제품으로 {gender} 「{filterOptions}」 스타일링 팁 및 트렌드에 맞는 제품으로 스타일링하는 방법을 만나보세요.",
  "text_styling_book_official_gender_filter_meta_title": "{gender}의 「{filterOptions}」 착용 리스트 {uqPostfix}",
  "text_styling_book_official_gender_meta_description": "{brand} 공식 온라인 스토어의 스타일링 북입니다. {gender}의 패션 제품을 스타일링하기 위해 최신 트렌드를 알아보세요. 모델들이 착용한 제품도 온라인 매장에서 만나보세요.",
  "text_styling_book_official_gender_meta_title": "{gender} 착용 제품 리스트{uqPostfix}",
  "text_styling_book_official_styling_id_alt_tag": "{brand}스타일링 북 스타일링 팁 스타일 ID: <{styleid}>",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_customer_user_meta_description": "{brand} 제품을 착용한 {userName} ({height}) 스타일링를 만나보세요. 온라인 스토어에서 모델이 착용한 제품도 확인해보세요.",
  "text_styling_book_stylehint_customer_user_meta_title": "{userName}({height})의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_detail_id_alt_tag": "「{stylehintProducts}」의 스타일링 팁을 확인해보세요",
  "text_styling_book_stylehint_detail_meta_description": "{brand}의「{stylehintProducts}」을(를) 활용한 스타일링를 소개합니다. 매장 스탭와 고객의 스타일링도 놓치지 마세요.",
  "text_styling_book_stylehint_detail_meta_title": "「{stylehintProducts}」의 착용 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_feature_alt_tag": "{gender} 「{feature}」의 스타일링 팁",
  "text_styling_book_stylehint_filter_meta_description": "{brand} 제품을 활용한 {gender} {filterOptions} 스타일링 팁 {searchCount}건을 확인해보세요. 온라인 스토어에서 신상품과 인기 상품도 놓치지 마세요.",
  "text_styling_book_stylehint_filter_meta_title": "{gender}의 「{filterOptions}」스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "{brand} 공식 스타일 힌트. 매장 스탭, 고객의 {gender} 스타일링「{count}」건을 만나보세요.",
  "text_styling_book_stylehint_gender_meta_title": "{gender} 패션 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_hashtag_alt_tag": "{gender} 「{hashtag}」의 스타일링 팁",
  "text_styling_book_stylehint_ins_user_meta_description": "Instagram 유저인 {userName}」의 {brand} 제품으로 믹스매치한 스타일링 팁 을 만나보세요. 다른 유저들의 스타일링도 만나볼 수 있으며 최신 트렌드 제품의 스타일링 방법도 확인해보세요.",
  "text_styling_book_stylehint_ins_user_meta_title": "{userName}의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "{brand}({storeName})의 스탭 {staffName}({height} 의 스타일링를 만나보세요. 최신 트렌드 제품을 활용한 스타일링 방법도 확인해보세요.",
  "text_styling_book_stylehint_store_user_meta_title": "{userName}({storeName})의 스타일링 리스트 {uqPostfix}",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand}스타일링 북 스타일링 팁 스타일 ID: <{styleid}>",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_filter_height_over": "이상",
  "text_styling_book_gender_menu_baby": "Baby",
  "text_styling_book_gender_menu_kids": "Kids",
  "text_styling_book_search_by_category": "카테고리에서 검색",
  "text_styling_book_search_by_coordinate": "키워드에서 검색",
  "text_styling_book_search_by_height": "키에서 검색",
  "text_styling_book_search_results": "검색 결과",
  "text_styling_book_staff_customer_filter_all": "모두",
  "text_styling_book_staff_customer_filter_staff_styling": "UNIQLO 스탭",
  "text_styling_book_staff_customer_filter_title": "게시자",
  "text_styling_book_go_to_top": "UNIQLO home",
  "text_locale_hk_zh": "繁體中文",
  "text_size_chart_add_select_product_notification": "비교 제품을 업데이트하였습니다",
  "text_express_order_setting_delivery_option_title": "배송 방법 설정",
  "text_uqpay_payment_online_registered_creditcard_01": "Credit cards already registered at the online store",
  "text_uqpay_payment_online_registered_creditcard_02": "You can set the registered credit cards as your UNIQLO Pay payment method.",
  "text_uqpay_payment_online_registered_creditcard_03": "To register a credit card or payment methods other than those listed above, please select from the options below.",
  "text_uqpay_not_setup": "text_uqpay_not_setup",
  "text_express_order_setting_title": "배송지 및 결제 수단 정보",
  "text_uqpay_bank_refund_description_01": "해당주문은 UNIQLO Pay의 은행 계좌이체 또는 d결제로 인해, 결제기한이지난 경우 주문 취소될 경우 환불까지 시간이 걸립니다.미리 양해 부탁드립니다.",
  "text_express_order_setting_no_settings": "설정 없음",
  "text_express_order_setting_save": "저장",
  "text_express_order_setting_set_address": "주소 설정",
  "text_express_order_setting_set_pickup_store": "픽업 매장 설정",
  "text_express_order_setting_change": "수정",
  "text_uqpay_payment_amount": "UNIQLO Pay결제금액",
  "text_uqpay_payment_type_credit_card": "신용카드결제",
  "text_uqpay_payment_type_d_pay": "d수단",
  "text_uqpay_payment_type_bank_direct_debit": "은행이체",
  "text_uqpay_unavailable_reason_upper_limit_per_order": "주문합계과 결제 금액의 상한을 초과하는 경우 UNIQLO Pay를 이용할 수 없습니다.",
  "text_uqpay_payment_description": "이용하시는 유니클로 APP에서 등록된 UNIQLO Pay로 결제를 진행합니다.",
  "text_error_uq_pay_bank_account_balance_message": "UNIQLO Pay로 등록된 계좌의 잔액이 부족합니다.다른 결제 방법을 선택해주세요.",
  "text_error_uq_pay_daily_usage_limit_exceeded_message": "UNIQLO Pay로 하루에 결제가능한 상한선을 초과하는 결제는 불가능합니다.구입할 상품을 변경하거나 다른 결제 방법을 선택하십시오.",
  "text_error_uq_pay_invalid_card_message": "UNIQLO Pay에서 등록된 신용카드를 사용할 수 없습니다.다른 신용카드로 변경하거나 다른 결제 방법을 선택하십시오.",
  "text_error_uq_pay_pending_message": "UNIQLO Pay 결제가 되지 않았습니다.다른 결제 방법을 선택하십시오.",
  "text_express_order_setting_delivery_option_message_01": "배송 주소와 픽업 매장을 설정할 수 있습니다.",
  "text_express_order_setting_delivery_option_message_02": "등록된 배송 방법이 없습니다.",
  "text_express_order_setting_delivery_option_message_03": "“원클릭 구매”의 경우 주문설정에서 배송 주소가 자동으로 설정됩니다.",
  "text_express_order_setting_pickup_store_settings_title": "수령할 매장 선택",
  "text_express_order_setting_register_delivery_option": "배송 방법 등록",
  "text_express_order_setting_updated_message_01": "주문 설정이 변경되었습니다. 주문 설정을 확인하세요.",
  "text_express_order_setting_updated_title": "설정 완료",
  "text_express_unattended_delivery_settings_checkbox_message_01": "위탁 장소 선택 없이 진행 원하시는 경우 체크박스를 선택하지 않고 진행 해주세요",
  "text_uqpay_unregistered": "UNIQLO Pay가 설정되어 있지 않습니다.",
  "text_uqpay_payment_title": "결제수단 등록",
  "text_uqpay_payment_bank": "은행이체",
  "text_uqpay_payment_bank_description": "Bank Pay를 이용하면 주요 은행 및 지방 은행의 은행 계좌 결제가 가능합니다.",
  "text_uqpay_payment_bank_terms01": "은행계좌를 사용 할수 없습니다.",
  "text_uqpay_payment_bank_terms02": "충전 불필요, 즉시결제",
  "text_uqpay_payment_creditcard": "신용카드결제",
  "text_uqpay_payment_creditcard_description": "Visa/Mastercard/JCB/AMEX/Diners 신용카드를 사용할 수 있습니다.",
  "text_uqpay_payment_creditcard_notes": "※ 본인인증서비스(3D 시큐어) 등록이 필수입니다.",
  "text_uqpay_change_account_true_description": "UNIQLO Pay에 가입할 때와 다른 계정으로 로그인했기 때문에 이 휴대폰에서 UNIQLO Pay가 비활성화되었습니다.",
  "text_uqpay_unavailable_reason_already_used_payment_method": "text_uqpay_unavailable_reason_already_used_payment_method",
  "text_uqpay_unavailable_reason_system_error": "text_uqpay_unavailable_reason_system_error",
  "text_uqpay_regist_credit_card_up_to_2": "신용카드는 최대 2개까지 등록할 수 있습니다.",
  "text_app_version_update": "업데이트",
  "text_error_uq_pay_required_app_version_update_message_01": "이 기능은 APP 버전에서 사용할 수 없습니다. 최신 버전으로 업데이트하세요.",
  "text_error_uq_pay_required_app_version_update_title": "버전 업그레이드가 필요합니다.",
  "text_wishlist_store_inventory_description": "매장을 등록하신 경우, 선택한 매장과 온라인 스토어의 재고를 각각 선택하여 확인할 수 있습니다.",
  "text_wishlist_filter_select_store_message_01": "재고를 검색할 매장을 선택해 주세요.",
  "text_wishlist_instruction": "위시리스트에 제품을 추가하려면 하트를 클릭해 주세요",
  "text_styling_image_display_term_expired": "표시 기간 만료",
  "text_wishlist_reccomend": "로그인하시면 위시리스트 정보를 확인 가능 하십니다.",
  "text_wishlist_title": "내 위시리스트",
  "text_error_failed_to_unsubscribe_enews_on_account_withdrawal": "탈퇴에 따라 광고성 메일 수신 불가",
  "text_flower_about_uniqlo_flower_title": "text_flower_about_uniqlo_flower_title",
  "text_flower_not_return_message_01": "text_flower_not_return_message_01",
  "text_flower_shipping_fee_message_01": "text_flower_shipping_fee_message_01",
  "text_membership_address": "주소정보",
  "text_no_registered_address_description": "온라인 스토어 주문을 위해서는 이름, 주소, 전화번호가 필요합니다.",
  "text_flower_shipping_discount_message_01": "text_flower_shipping_discount_message_01",
  "text_coupon_unavailable_split_delivery_before_coupon_apply": "이 주문에는 분할 배송이 적용되어, 쿠폰을 사용할 수 없습니다.",
  "text_error_unavailable_applied_coupon": "적용한 쿠폰은 이 주문에 사용할 수 없습니다. 쿠폰 적용을 해제해 주세요.",
  "text_error_unavailable_applied_coupon_title": "쿠폰을 적용할 수 없습니다.",
  "text_unselect_all": "전체선택 해제",
  "text_newsletter_subscribe": "광고성 이메일 수신 동의 정보 변경",
  "text_address": "주소",
  "text_active_filters": "선택한 필터",
  "text_signin_signup": "신규 회원가입, 로그인",
  "text_gps_setting_alert": "단말기 설정으로 이동하여 위치 서비스를 활성화 해 주세요.",
  "text_flower_bundled_items": "text_flower_bundled_items",
  "text_flower_material": "text_flower_material",
  "text_flower_notes_message_01": "text_flower_notes_message_01",
  "text_flower_notes_message_02": "text_flower_notes_message_02",
  "text_flower_notes_message_03": "text_flower_notes_message_03",
  "text_flower_notes_message_04": "text_flower_notes_message_04",
  "text_flower_notes_message_05": "text_flower_notes_message_05",
  "text_flower_notes_title": "text_flower_notes_title",
  "text_flower_only_for_reference": "text_flower_only_for_reference",
  "text_flower_purchese_restriction_delivery_area_message_01": "text_flower_purchese_restriction_delivery_area_message_01",
  "text_flower_purchese_restriction_message_01": "text_flower_purchese_restriction_message_01",
  "text_flower_purchese_restriction_not_return_message_01": "text_flower_purchese_restriction_not_return_message_01",
  "text_flower_purchese_restriction_shipping_fee_message_01": "text_flower_purchese_restriction_shipping_fee_message_01",
  "text_flower_purchese_restriction_title": "text_flower_purchese_restriction_title",
  "text_l1_split_description": "이 제품은 동일 제품이라도 Tag에 기재된 제품 정보가 다른 경우가 있습니다. 양해 부탁 드리겠습니다.",
  "text_share": "공유",
  "text_show_less": "접기",
  "text_show_all": "모두 보기",
  "text_print_barcode": "바코드 인쇄",
  "text_check_delivery_status_external_service_message_01": "아래의 “배송 조회” 버튼을 클릭하여 배송 상태를 확인해 주세요.\n출고 완료 당일 저녁 또는 다음날부터 확인이 가능합니다.",
  "text_official_receipt_issued": "영수증 있음",
  "text_payment_status": "결제 상태",
  "text_payment_status_complete": "완료됨",
  "text_order_details_billing_information": "주문 금액",
  "text_print_order_detail": "주문 세부정보 인쇄",
  "text_return_form_store_receipt": "영수증 보기",
  "text_order_status_provisional_order": "배송 준비 중",
  "text_order_status_store_pickup_arrive_wait": "픽업매장 배송중",
  "text_order_status_store_pickup_arrived": "픽업매장 배송중",
  "text_order_status_store_pickup_complete": "픽업 완료",
  "text_order_status_store_pickup_none": "배송 준비 중",
  "text_order_status_store_pickup_receivable": "픽업매장 도착",
  "text_order_status_store_pickup_refund_complete": "주문취소-수령기간 초과",
  "text_order_status_store_pickup_return_complete": "주문취소-수령기간 초과",
  "text_order_status_bar_shippng_status_01": "주문 완료",
  "text_order_status_bar_shippng_status_02": "출고 준비 중",
  "text_order_status_bar_shippng_status_03": "출고 완료",
  "text_order_status_bar_shippng_status_04": "배송 완료",
  "text_order_status_bar_store_pickup_status_01": "주문 완료",
  "text_order_status_bar_store_pickup_status_02": "픽업 준비 중",
  "text_order_status_bar_store_pickup_status_03": "픽업 가능",
  "text_order_status_bar_store_pickup_status_04": "픽업 완료",
  "text_pay_at_store_selectable_durring_store_opening_hours_message_01": "이 상점은 현재 영업 시간이 아니므로 선택할 수 없습니다.",
  "text_payin_store_payment_notes": "매장에서 결제는 신용카드만 결제 가능 합니다.",
  "text_product_not_found": "제품을 찾을 수 없음",
  "text_product_not_found_description01": "죄송합니다. 이 제품을 찾을 수 없습니다.",
  "text_return_details_return_process_title": "반품",
  "text_flower_about_shipping_fee": "UNIQLO FLOWER 배송비 설명",
  "text_member_address": "주소정보",
  "text_semi_order_how_to_measure_using_uniqlo_jacket03": "UNIQLO 스트레치 울 재킷과 줄자를 준비하세요.",
  "text_error_flower_about_delivery_area": "text_error_flower_about_delivery_area",
  "text_error_flower_cannot_deliver_message_01": "text_error_flower_cannot_deliver_message_01",
  "text_error_flower_cannot_deliver_title": "text_error_flower_cannot_deliver_title",
  "text_flower_about_delivery_title": "text_flower_about_delivery_title",
  "text_flower_ship_to_address_delivery_area_message_01": "text_flower_ship_to_address_delivery_area_message_01",
  "text_flower_payment_method_restrictions_message_01": "text_flower_payment_method_restrictions_message_01",
  "text_flower_review_comments": "text_flower_review_comments",
  "text_address_contact_details": "text_address_contact_details",
  "text_business_regn_number": "text_business_regn_number",
  "text_business_regn_number_desc": "text_business_regn_number_desc",
  "text_business_regn_number_example": "text_business_regn_number_example",
  "text_company": "text_company",
  "text_company_details": "text_company_details",
  "text_company_full_name": "text_company_full_name",
  "text_company_individual": "text_company_individual",
  "text_company_name_desc": "text_company_name_desc",
  "text_country": "text_country",
  "text_different_shipping_address": "text_different_shipping_address",
  "text_error_mandatory_details": "text_error_mandatory_details",
  "text_full_name": "text_full_name",
  "text_full_name_desc": "text_full_name_desc",
  "text_identification_passport_number": "text_identification_passport_number",
  "text_identification_passport_number_desc": "text_identification_passport_number_desc",
  "text_identification_passport_number_example": "text_identification_passport_number_example",
  "text_identification_passport_number_validation": "text_identification_passport_number_validation",
  "text_identification_type": "text_identification_type",
  "text_individual": "text_individual",
  "text_individual_details": "text_individual_details",
  "text_invoice_address1_desc": "text_invoice_address1_desc",
  "text_invoice_email_desc": "text_invoice_email_desc",
  "text_invoice_phone_desc": "text_invoice_phone_desc",
  "text_invoice_phone_example": "text_invoice_phone_example",
  "text_invoice_terms_conditions": "text_invoice_terms_conditions",
  "text_recipient_business_regn_number": "text_recipient_business_regn_number",
  "text_recipient_business_tax_identification_number": "text_recipient_business_tax_identification_number",
  "text_recipient_business_tax_identification_number_desc": "text_recipient_business_tax_identification_number_desc",
  "text_recipient_company_details": "text_recipient_company_details",
  "text_recipient_company_full_name": "text_recipient_company_full_name",
  "text_recipient_company_individual": "text_recipient_company_individual",
  "text_recipient_details": "text_recipient_details",
  "text_recipient_full_name": "text_recipient_full_name",
  "text_recipient_identification_passport_number": "text_recipient_identification_passport_number",
  "text_recipient_identification_type": "text_recipient_identification_type",
  "text_recipient_tax_identification_number": "text_recipient_tax_identification_number",
  "text_request_einvoice": "text_request_einvoice",
  "text_request_invoice": "text_request_invoice",
  "text_sales_service_regn_number": "text_sales_service_regn_number",
  "text_sales_service_regn_number_desc": "text_sales_service_regn_number_desc",
  "text_sales_service_regn_number_example": "text_sales_service_regn_number_example",
  "text_shipping_address_details": "text_shipping_address_details",
  "text_tax_identification_number": "text_tax_identification_number",
  "text_tax_identification_number_desc": "text_tax_identification_number_desc",
  "text_tax_identification_number_example": "text_tax_identification_number_example",
  "text_tax_identification_number_ind_desc": "text_tax_identification_number_ind_desc",
  "text_tax_identification_number_ind_example": "text_tax_identification_number_ind_example",
  "text_tin_error_message": "text_tin_error_message",
  "text_error_address_field_over_maximum_length": "배송 주소 또는 회원정보 정보 주소가 최대 입력 길이를 초과했습니다. 배송 주소 또는 청구지 주소를 업데이트해 주세요.",
  "text_flower_delivery_area_message_01": "text_flower_delivery_area_message_01",
  "text_error_access_to_other_account_order_description_01": "해당 주문을 찾을수 없습니다. 사용하는 회원정보를 확인해 주세요.",
  "text_error_access_to_other_account_order_title": "주문을 찾을 수 없음",
  "text_allow": "허용",
  "text_app_already_linked": "현재 로그인되어 있습니다. 먼저 로그아웃해 주세요.",
  "text_app_coupon_menu": "쿠폰",
  "text_app_date_format": "yyyy/MM/dd",
  "text_app_date_time_format": "yyyy/M/dd HH:mm:ss",
  "text_app_scan_not_found": "제품을 찾을 수 없습니다.",
  "text_app_setting": "설정",
  "text_available_online_store_coupon_count": "온라인 스토어 쿠폰 | 사용 가능한 쿠폰 {count}개",
  "text_available_retail_store_coupon_count": "매장 쿠폰 | 사용 가능한 쿠폰 {count}개",
  "text_baby_description": "BABY",
  "text_backto_pickup_in_store": "[매장으로 배송]으로 돌아가기",
  "text_brighten": "화면 밝기조정",
  "text_call": "전화",
  "text_camera": "카메라",
  "text_canada_change_region": "(캐나다) 지역 변경",
  "text_caution": "주의사항",
  "text_city_province_postal_code": "시/주 또는 우편번호",
  "text_complete_loggout": "로그아웃",
  "text_contact_details": "연락처 정보",
  "text_continue_payment": "결제 계속하기",
  "text_coupon_expire_soon": "쿠폰이 곧 만료됩니다.",
  "text_currency_usd": "USD",
  "text_currency_yen": "￦",
  "text_delete_credit_card": "신용카드 삭제",
  "text_delete_credit_card_confirm": "이 신용카드를 삭제하시겠어요?",
  "text_delivery": "배송",
  "text_depth_short": "깊이 짧음",
  "text_dont_allow": "허용하지 않음",
  "text_dont_set": "설정하지 않음",
  "text_dot_separator": ",",
  "text_download": "text_download",
  "text_edit_profile_notes": "정보 변경후, 회원정보 업데이트를 눌러주세요.",
  "text_end_date_format": "MM/DD",
  "text_enewsletter": "이메일 뉴스레터 수신 동의",
  "text_enewsletter_signup": "가입하면 신제품, 프로모션, 매장 이벤트 등에 대해 가장 먼저 알아볼 수 있습니다.",
  "text_enter_coupon_code02": "쿠폰 코드 입력",
  "text_enter_legal_company_address": "VN 로컬 요구 사항_회사주소",
  "text_enter_legal_company_name": "VN 로컬 요구 사항_회사주소",
  "text_error_coupon_unavailable_split_delivery_after_coupon_apply": "이 주문에는 분할 배송이 적용되어, 쿠폰을 사용할 수 없습니다.",
  "text_error_coupon_unavailable_split_delivery_after_coupon_apply_top": "이 주문에는 쿠폰을 사용할 수 없습니다. 쿠폰을 삭제해 주세요",
  "text_error_lackof_inventory": "장바구니에 품절된 제품이 포함되어 있습니다. 계속 진행을 원하시면 장바구니내 품절 제품을 삭제해 주세요.",
  "text_error_lackof_inventory_title": "품절-재고부족",
  "text_error_login_registration": "죄송합니다. 회원 등록이 완료되었지만 로그인하지 못했습니다. 다시 로그인 진행 부탁드리겠습니다.",
  "text_error_newsletter_subscription": "구독하지 못했습니다. {url}에서 다시 시도하세요.",
  "text_error_not_supported_character_in_default_shipping_address_update_request_message": "죄송합니다. 현재 배송 주소에 입력 불가한 문자가 포함되어 있습니다. 입력 가능한 문자만 포함되어 있는지 확인해 주세요.",
  "text_error_not_supported_character_in_membership_address_update_request_message": "죄송합니다. 회원정보 또는 청구지 주소내입력 불가한 문자가 포함되어 있습니다. 입력한 내용을 확인해 주세요.",
  "text_error_price_calculation": "죄송합니다. 오류가 발생했습니다. 페이지를 새로고침 해 주세요",
  "text_error_product_info": "제품정보를 갖고 오지 못했습니다.",
  "text_error_stock_type": "이 제품은 구매 불가능합니다. 장바구니에 제품을 삭제해 주세요.",
  "text_error_unavailable_item_incart": "장바구니에 품절된 제품이 포함되어 있습니다. 계속 진행을 원하시면 장바구니내 품절 제품을 삭제해 주세요.",
  "text_error_unavailable_item_incart_title": "장바구니의 구매 불가능한 제품",
  "text_expire_soon": "만료 임박:",
  "text_find_location": "위치 찾기",
  "text_get_started": "시작하기",
  "text_gift_option_disabled": "기프트_비활성화",
  "text_gift_option_invalid_message_card_content": "기프타_메세지 카드",
  "text_gift_option_unavailable_gift_wrapper": "기프트_선물포장",
  "text_gift_option_unavailable_gift_wrapping_service": "기프트_선물포장 사용 불가",
  "text_gift_option_unavailable_message_card": "기프트_메세지 카드 사용 불가",
  "text_gps_instruction01": "위치 서비스를 활성화하여 가장 가까운 매장을 확인해 주세요",
  "text_gps_instruction02": "위치 서비스를 활성화하여 가장 가까운 매장 재고를 확인해 주세요",
  "text_gps_permission": "위치정보 이용 허가",
  "text_gps_setting_required": "위치 서비스를 활성화하세요.",
  "text_height_short": "높이 짧음",
  "text_help": "도움말",
  "text_history": "기록",
  "text_items_subtotal_price": "{price} 매",
  "text_kids_description": "KIDS",
  "text_kids_title": "KIDS",
  "text_language_setting_notification": "영어와 프랑스어가 지원됩니다. 계정 설정에서 언어 기본 설정을 변경하세요.",
  "text_legal_company_address": "VN 로컬 요구 사항_회사주소",
  "text_legal_company_name": "VN 로컬 요구 사항_회사이름",
  "text_loadmore": "더 보기",
  "text_location_service": "위치정보",
  "text_mark_down_price": "Thai만_가격인하",
  "text_men_description": "MEN",
  "text_mobile_warning_message": "전화 경고 메시지",
  "text_multi_use": "복수 선택",
  "text_my_store": "즐겨 찾는 매장",
  "text_my_store_instruction01": "즐겨 찾는 매장을 추가하고 매장 및 재고 정보를 확인해 주세요.",
  "text_my_store_instruction02": "즐겨 찾는 매장 설정 시 제품 페이지에 해당 매장 재고가 표시됩니다.",
  "text_my_store_notes": "즐겨 찾는 매장을 설정해 주세요",
  "text_my_store_set": "즐겨 찾는 매장을 설정하였습니다.",
  "text_newsletter_signup": "UNIQLO 뉴스에 가입하면 24시간 이내에 특별 환영 혜택을 받을 수 있습니다.",
  "text_no_filters_available": "사용 가능한 필터 없음",
  "text_no_history": "기록 없음",
  "text_no_network_connection": "인터넷에 연결되어 있지 않습니다. 온라인 상태일 때 다시 시도해 주세요.",
  "text_official_receipt_not_issued": "없음",
  "text_online_store_order_status": "주문 상태",
  "text_online_store_redeem_coupon": "온라인 스토어 쿠폰은 결제 시에만 사용할 수 있습니다.",
  "text_opinions": "제안,문의",
  "text_order_inpreparation": "준비 중",
  "text_order_number_placeholder": "주문번호 자릿수",
  "text_order_status_order_acceptance": "배송 준비 중",
  "text_order_title_canceled": "주문취소",
  "text_order_title_delivered": "배송됨",
  "text_order_title_inpreparation": "배송(제품) 준비중",
  "text_order_title_picked_up": "픽업 완료",
  "text_order_title_pre_shipping": "배송 준비 중",
  "text_payment_status_incomlete": "완료 안 됨",
  "text_pc_enewsletter_subscribe_description-1": "구독 확인 이메일을 보내드립니다.",
  "text_pc_enewsletter_subscribe_description-2": "전자 뉴스레터는 이메일 설정에 따라 텍스트 또는 HTML 형식으로 전송됩니다.",
  "text_pc_enewsletter_subscribe_description-3": "전자 뉴스레터 구독은 무료입니다.",
  "text_pc_enewsletter_subscribe_description-4": "표준 문자 메시지 및 기타 이동통신사 서비스 요금이 적용됩니다.",
  "text_pc_enewsletter_subscribe_description-5": "전송 계층 보안(TLS) 암호화 기술로 모든 민감 정보를 보호합니다.",
  "text_pc_enewsletter_subscribe_description-6": "text_pc_enewsletter_subscribe_description-6",
  "text_pc_enewsletter_subscribe_description-7": "text_pc_enewsletter_subscribe_description-7",
  "text_pc_estimated_tax": "세금(VAT)포함",
  "text_pc_item_total": "제품 합계",
  "text_ph_postal_code": "12345",
  "text_phone_warning_message": "전화 경고 메시지",
  "text_print_order_summary": "주문 요약 인쇄",
  "text_product_scan_instruction01": "스캔한 제품이 여기에 나타납니다.",
  "text_product_scan_instruction02": "제품의 바코드를 스캔하여 구매 가능한 컬러, 사이즈 및 재고를 확인할 수 있습니다.",
  "text_product_unavailable_temporarily": "이 제품은 일시적으로 구매 불가능합니다. 나중에 다시 확인해 주세요",
  "text_push_notification_instruction01": "신제품, 기간 한정 혜택 등에 대한 소식을 받아보세요!",
  "text_receive_push_notification": "알림 받기",
  "text_receive_refill_notification": "재입고 알림 등록",
  "text_remove_purhase_history": "구매 내역 삭제",
  "text_results": "결과",
  "text_retail_store_redeem_coupon": "매장쿠폰은 유니클로 매장에서만 사용 가능 합니다.",
  "text_review_summary": "리뷰 요약",
  "text_save_changes": "변경 사항 저장",
  "text_scanned_product_unavailable": "이 제품은 온라인 스토어에서 구매 불가능합니다.",
  "text_search_in_other_store": "다른 매장 검색",
  "text_see_all_submited_review": "제품 리뷰",
  "text_select_all": "전체선택",
  "text_select_size_inventory": "사이즈를 선택 하시면 재고가 표시 됩니다.",
  "text_settings": "설정",
  "text_shipping_name_validation": "배송지 이름 확인",
  "text_staff_only": "스탭전용",
  "text_stock_shortage_item": "주문가능 재고수는{inventoryQuantity}매 입니다.",
  "text_store_list": "매장 리스트",
  "text_store_srvice_questionaire": "매장 만족도 조사",
  "text_subscribe_now": "마케팅 수신 동의에 따른 광고 메일 수신",
  "text_switch_view": "보기 전환",
  "text_undo": "실행 취소",
  "text_uniqlo_social_account": "UNIQLO 소셜 계정",
  "text_until_date": "{date}까지",
  "text_unused": "미사용",
  "text_update_notes": "업데이트 정보",
  "text_uqapp_instruction": "시작하기",
  "text_valid_order_number": "주문번호",
  "text_vn": "Vietnam",
  "text_wearing_color_outofstock": "결품 컬러",
  "text_width_short": "넓이 짧음",
  "text_wishlist_instruction01": "구매하고 싶은 제품을 위시리스트에서 편리하게 관리하세요.",
  "text_women_description": "WOMEN",
  "textt_ordered_date": "주문일",
  "text_province_or_territory_warning_message": "text_province_or_territory_warning_message",
  "text_city_or_municipality_warning_message": "text_city_or_municipality_warning_message",
  "text_barangay_warning_message": "text_barangay_warning_message",
  "text_address_details_warning_message": "text_address_details_warning_message",
  "text_return_form_return_policy_accordion_other_message_03": "text_return_form_return_policy_accordion_other_message_03",
  "text_customer_services": "text_customer_services",
  "text_return_form_return_condition_05": "text_return_form_return_condition_05",
  "text_return_form_return_method_print_label_for_canada_post": "text_return_form_return_method_print_label_for_canada_post",
  "text_return_form_return_method_canada_post_qr_code_button": "text_return_form_return_method_canada_post_qr_code_button",
  "text_canada_post_drop_off_service": "text_canada_post_drop_off_service",
  "text_return_form_canada_post_find_location": "text_return_form_canada_post_find_location",
  "text_return_form_drop_off_find_location_description": "text_return_form_drop_off_find_location_description",
  "text_return_form_return_method_canada_post_qr_code_subtitle": "text_return_form_return_method_canada_post_qr_code_subtitle",
  "text_return_form_return_method_canada_post_qr_code_description": "text_return_form_return_method_canada_post_qr_code_description",
  "text_canada_post_qr_code_easy_return": "text_canada_post_qr_code_easy_return",
  "text_return_form_find_canada_post_location_qr_code_easy_return": "text_return_form_find_canada_post_location_qr_code_easy_return",
  "text_return_method_print_label_for_canada_post_return_instruction_03": "text_return_method_print_label_for_canada_post_return_instruction_03",
  "text_return_method_canada_post_qr_code_return_instruction_03": "text_return_method_canada_post_qr_code_return_instruction_03",
  "text_return_method_return_instruction_03_sub_description_01": "text_return_method_return_instruction_03_sub_description_01",
  "text_return_form_return_delivery_vendor": "text_return_form_return_delivery_vendor",
  "text_uq_privacy_policy": "text_uq_privacy_policy",
  "text_pl_privacy_policy": "text_pl_privacy_policy",
  "text_error_shipping_speed_option_pre_order_unavailable_except_standard_description": "text_error_shipping_speed_option_pre_order_unavailable_except_standard_description",
  "text_credit_card_unavailable_select_pre_order_description": "text_credit_card_unavailable_select_pre_order_description",
  "text_iq_chat": "IQ Chat",
  "text_fleet_optics": "text_fleet_optics",
  "text_payment_with_qris": "text_payment_with_qris",
  "text_gopay_payment_description_08": "text_gopay_payment_description_08",
  "text_bank_transfer_payment_label": "text_bank_transfer_payment_label",
  "text_bank_transfer_payment_bank_selection": "text_bank_transfer_payment_bank_selection",
  "text_indonesian_terms_of_condition": "text_indonesian_terms_of_condition",
  "text_indonesian_agreement_privacy_policy_terms_of_use_description01": "text_indonesian_agreement_privacy_policy_terms_of_use_description01",
  "text_indonesian_agreement_privacy_policy_terms_of_use_description02": "text_indonesian_agreement_privacy_policy_terms_of_use_description02",
  "text_indonesian_return_details_cash_on_delivery_description": "text_indonesian_return_details_cash_on_delivery_description",
  "text_gopay_qr_code_expired": "text_gopay_qr_code_expired",
  "text_gopay_not_available_on_pc_message": "text_gopay_not_available_on_pc_message",
  "text_return_form_return_condition_06": "text_return_form_return_condition_06",
  "text_return_form_return_condition_07": "text_return_form_return_condition_07",
  "text_return_form_return_condition_08": "text_return_form_return_condition_08",
  "text_return_form_return_condition_09": "text_return_form_return_condition_09",
  "text_return_form_return_condition_10": "text_return_form_return_condition_10",
  "text_return_form_return_condition_11": "text_return_form_return_condition_11",
  "text_return_form_return_condition_12": "text_return_form_return_condition_12",
  "text_return_form_return_condition_13": "text_return_form_return_condition_13",
  "text_return_form_how_to_return_01_sub_description_01": "text_return_form_how_to_return_01_sub_description_01",
  "text_return_form_how_to_return_03_sub_description_01": "text_return_form_how_to_return_03_sub_description_01",
  "text_return_form_how_to_return_03_description_02": "text_return_form_how_to_return_03_description_02",
  "text_return_form_how_to_return_03_description_03": "text_return_form_how_to_return_03_description_03",
  "text_enter_order_number_return_portal": "text_enter_order_number_return_portal",
  "text_a11y_quantity_number": "수량: {value}",
  "text_a11y_quantity_increase": "{value1}에서 {value2}로 변경",
  "text_a11y_quantity_decrease": "{value1}에서 {value2}로 변경",
  "text_a11y_quantity_minimum": "최소 수량 {value}",
  "text_a11y_quantity_maximum": "최대 수량 {value}",
  "text_a11y_video_play": "재생",
  "text_a11y_video_pause": "정지",
  "text_size_chart_note_08": "text_size_chart_note_08",
  "text_store_inventory_purchase_closing_time_message": "매장 영업 종료 2시간 전부터 영업 종료 후 주문 건은 다음날 수령 가능합니다.",
  "text_product_monitor_coupon": "체험단 제품 교환 쿠폰",
  "text_error_coupon_unavailable_apply_product_monitor_coupon": "체험단 제품 교환 쿠폰은 대상 제품 중 1개와 교환하실 수 있습니다. ORDER&PICK(당일 픽업)은 이용하실 수 없습니다.",
  "text_store_pickup_unavailable_reason_02": "체험단 제품 교환 쿠폰을 사용하실 경우,  '지정 주소로 배송'으로만 주문 신청이 가능합니다.",
  "text_coupon_not_require_additional_payment_method": "체험단 제품 교환 쿠폰 사용 시 별도의 결제 수단은 필요하지 않습니다.",
  "text_shipping_speed_option_unavailable_description_10": "체험단 제품 교환 쿠폰을 사용하실 경우, '감탄! 빛배송' 서비스는 이용하실 수 없습니다.",
  "text_common_ship_by_mail_unavailable_reason02": "체험단 제품 교환 쿠폰을 사용하실 경우, 우편함 수령은 이용하실 수 없습니다.",
  "text_cvs_pickup_unavailable_reason_03": "체험단 제품 교환 쿠폰을 사용하실 경우, 편의점 픽업은 이용하실 수 없습니다.",
  "text_gift_option_unavailable_apply_product_monitor_coupon": "체험단 제품 교환 쿠폰을 사용하실 경우, 기프트 옵션은 이용하실 수 없습니다.",
  "text_no_payment_product_monitor_coupon": "체험단 제품 교환 쿠폰을 사용한 주문은 결제가 필요 없습니다.",
  "text_return_form_return_condition_14": "text_return_form_return_condition_14",
  "text_return_form_return_condition_15": "text_return_form_return_condition_15",
  "text_return_form_about_refund_description_04": "text_return_form_about_refund_description_04",
  "text_return_form_about_refund_description_05": "text_return_form_about_refund_description_05",
  "text_return_form_about_refund_description_06": "text_return_form_about_refund_description_06",
  "text_link_contact_customer_center": "text_link_contact_customer_center",
  "text_app_order_status_locker_pickup": "이 주문은 매장픽업 보관함에서 수령할 수 있습니다.",
  "text_locker_pickup_start_pickup_process": "매장픽업 보관함에서 받기",
  "text_locker_pickup": "매장픽업 보관함 수령",
  "text_locker_pickup_by_membership_code": "회원 바코드로 수령",
  "text_locker_pickup_by_membership_code_description_01": "유니클로 APP 회원 바코드를 매장픽업 보관함 모니터에 스캔하시면 제품 수령이 가능합니다.",
  "text_locker_pickpu_by_membership_code": "회원 바코드로 수령",
  "text_locker_pickup_by_app": "APP에서 수령",
  "text_locker_pickup_by_app_bluetooth_permission_required": "APP에서 매장픽업 보관함을 오픈하려면 블루투스 사용을 허용해 주세요.",
  "text_allow_bluetooth_permission": "허용",
  "text_locker_pickup_by_app_bluetooth_turned_off": "APP에서 제품을 수령하시려면 블루투스를 설정을 ON으로 변경해 주세요.",
  "text_locker_pickup_by_app_open_locker_connecting_description_01": "매장픽업 보관함에 접근하면 자동으로 연결됩니다.",
  "text_locker_pickup_by_app_open_locker_description_01": "버튼을 누르면 매장픽업 보관함이 열립니다.",
  "text_locker_pickup_bluetooth_connection_failed": "해당 주문 건을 찾을 수 없습니다. 직원에게 문의해 주세요",
  "text_locker_pickup_bluetooth_connection_failed_description_01": "매장픽업 보관함 10m 이내에서 시도해 주세요. \n접속이 불가한 경우 매장픽업 보관함 태블릿과 연결을 해제해 주세요.",
  "text_locker_pickup_start_bluetooth_connection": "매장픽업 보관함 찾기",
  "text_locker_pickup_open_locker_description_01": "버튼을 누르면 매장픽업 보관함이 열립니다.",
  "text_locker_pickup_open_locker": "매장픽업 보관함 열기",
  "text_locker_pickup_opening_locker": "매장픽업 보관함을 열고 있습니다.",
  "text_locker_pickup_order_pickup": "제품 수령",
  "text_locke_pickup_order_pickup_description_01": "제품을 받고 문을 닫아주세요.",
  "text_locker_pickup_locker_code": "매장픽업 보관함 {lockerCode}",
  "text_locker_pickup_complete_order_pickup": "수령 완료",
  "text_locker_pickup_available_order": "수령 가능한 주문이 있습니다.",
  "text_locker_pickup_available_order_description_01": "이 매장에서 수령 가능한 주문이 있습니다. 주문 정보를 확인해 주세요.",
  "text_locker_pickup_return_to_message_box_orders": "주문 정보",
  "text_error_locker_pickup_inside_order_not_stored": "수령 가능한 주문이 없습니다.",
  "text_error_locker_pickup_inside_order_not_stored_description_01": "불편을 끼쳐 죄송합니다. 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_inside_multiple_orders": "입력된 번호에 여러 주문이 있습니다. 직원에게 문의해 주세요.",
  "text_error_locker_pickup_inside_multiple_orders_description_01": "불편을 끼쳐 죄송합니다. 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_inside_order_not_found": "수령 가능한 주문이 없습니다.",
  "text_error_locker_pickup_inside_order_not_found_description_01": "불편을 끼쳐 죄송합니다. 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_inside_general_message": "시스템 에러",
  "text_error_locker_pickup_inside_general_message_description_01": "불편을 끼쳐 죄송합니다. 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_outside_order_not_stored": "수령 가능한 주문이 없습니다.",
  "text_error_locker_pickup_outside_order_not_stored_description_01": "불편을 끼쳐 죄송합니다. 영업시간 중 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_outside_order_not_found": "수령 가능한 주문이 없습니다.",
  "text_error_locker_pickup_outside_order_not_found_description_01": "불편을 끼쳐 죄송합니다. 영업시간 중 가까운 직원에게 문의해 주세요.",
  "text_error_locker_pickup_outside_general_message": "시스템 에러",
  "text_error_locker_pickup_outside_general_message_description_01": "불편을 끼쳐 죄송합니다. 영업시간 중 가까운 직원에게 문의해 주세요.",
  "NSBluetoothAlwaysUsageDescription": "매장픽업 보관함에서 제품을 수령하시려면 블루투스 사용을 허가해 주세요.",
  "text_error_locker_pickup_common_title": "시스템 에러",
  "text_error_locker_pickup_common_message_01": "불편을 끼쳐 죄송합니다. 영업시간 중 가까운 직원에게 문의해 주세요.",
  "text_online_store_service_survey": "온라인 스토어 서비스 앙케이트",
  "text_test_ph_search_form": "",
  "text_shipping_speed_option_same_day_delivery": "text_shipping_speed_option_same_day_delivery",
  "text_shipping_speed_option_unavailable_description_11": "text_shipping_speed_option_unavailable_description_11",
  "text_old_order_history_link_label": "text_old_order_history_link_label",
  "text_old_order_history_return_and_exchange": "text_old_order_history_return_and_exchange",
  "text_old_order_history_notes": "text_old_order_history_notes",
  "text_old_order_history": "text_old_order_history",
  "text_return_to_old_order_history": "text_return_to_old_order_history",
  "text_select_language": "text_select_language",
  "text_return_form_about_return_description_01": "text_return_form_about_return_description_01",
  "text_return_form_about_return_description_02": "text_return_form_about_return_description_02",
  "text_return_form_return_condition_16": "text_return_form_return_condition_16",
  "text_return_form_comfirmation_checkbox_title": "text_return_form_comfirmation_checkbox_title",
  "text_return_form_comfirmation_checkbox_01": "text_return_form_comfirmation_checkbox_01",
  "text_return_form_comfirmation_checkbox_02": "text_return_form_comfirmation_checkbox_02",
  "text_return_form_comfirmation_checkbox_03": "text_return_form_comfirmation_checkbox_03",
  "text_return_form_comfirmation_checkbox_04": "text_return_form_comfirmation_checkbox_04",
  "text_return_form_comfirmation_checkbox_05": "text_return_form_comfirmation_checkbox_05",
  "text_return_form_comfirmation_note_description_01": "text_return_form_comfirmation_note_description_01",
  "text_return_form_comfirmation_note_description_02": "text_return_form_comfirmation_note_description_02",
  "text_faq_and_help": "text_faq_and_help",
  "text_return_form_pickup_address_title": "text_return_form_pickup_address_title",
  "text_return_form_pickup_address_description": "text_return_form_pickup_address_description",
  "text_return_form_about_refund_description_07": "text_return_form_about_refund_description_07",
  "text_return_form_notes_description_05": "text_return_form_notes_description_05",
  "text_return_form_notes_description_06": "text_return_form_notes_description_06",
  "text_return_form_return_condition_17": "text_return_form_return_condition_17",
  "text_return_form_return_condition_18": "text_return_form_return_condition_18",
  "text_return_form_how_to_return_06": "text_return_form_how_to_return_06",
  "text_return_form_how_to_return_06_description_01": "text_return_form_how_to_return_06_description_01",
  "text_order_history_delivery_status_track_button": "text_order_history_delivery_status_track_button",
  "text_order_history_delivery_status_title": "text_order_history_delivery_status_title",
  "text_shipping_speed_option_unavailable_description_12": "text_shipping_speed_option_unavailable_description_12",
  "text_shipping_speed_option_unavailable_description_13": "text_shipping_speed_option_unavailable_description_13",
  "text_gopay_qr_code_failed_display": "text_gopay_qr_code_failed_display",
  "text_return_form_how_to_return_03_sub_description_02": "text_return_form_how_to_return_03_sub_description_02",
  "text_return_form_end_of_step_1_message_description_01": "text_return_form_end_of_step_1_message_description_01",
  "text_return_form_about_refund_description_08": "text_return_form_about_refund_description_08",
  "text_return_form_return_condition_19": "text_return_form_return_condition_19",
  "text_dpd": "DPD",
  "text_mondial_relay": "Mondial Relay",
  "text_bartolini": "Bartolini",
  "text_shipping_speed_option_unavailable_description_14": "text_shipping_speed_option_unavailable_description_14",
  "text_shipping_speed_option_express_unavailable_message_08": "text_shipping_speed_option_express_unavailable_message_08",
  "text_old_order_history_description_01": "text_old_order_history_description_01",
  "text_old_order_history_button_label": "text_old_order_history_button_label",
  "text_product_marketed_and_distributed_by": "text_product_marketed_and_distributed_by",
  "text_invoice_number": "text_invoice_number",
  "text_app_a11y_lock_screen_orientation_title": "text_app_a11y_lock_screen_orientation_title",
  "text_app_a11y_lock_screen_orientation_description": "text_app_a11y_lock_screen_orientation_description",
  "text_return_form_go_to_australia_post_returns_portal": "text_return_form_go_to_australia_post_returns_portal",
  "text_bank_payment_received_order_description": "text_bank_payment_received_order_description",
  "text_return_form_return_condition_21": "text_return_form_return_condition_21",
  "text_return_form_return_condition_22": "text_return_form_return_condition_22",
  "text_return_form_return_condition_23": "text_return_form_return_condition_23",
  "text_return_form_return_condition_24": "text_return_form_return_condition_24",
  "text_order_complete_loading_payment_descirption_01": "처리 중입니다.",
  "text_order_complete_loading_payment_descirption_02": "결제를 계속하려면 PayPal 버튼을 클릭해 주세요.",
  "text_received_order_descriptioin_01": "{HH:MM} 까지 매장을 방문하여 매장 계산대에서 결제를 완료해 주세요.",
  "text_received_order_descriptioin_02": "구매내역에서 매장 및 결제 정보를 확인하실 수 있습니다.",
  "text_received_exchange_request": "감사합니다! 교환 신청이 완료되었습니다.",
  "text_cancelation_imark_description4": "구매 내역에서 '주문 취소' 버튼이 있는 경우 주문을 취소할 수 있습니다.",
  "text_cancelation_imark_description5": "주문 후 30분이 경과하거나, 제품의 배송 준비가 시작된 경우 주문 취소가 불가합니다. 배송 전 취소를 희망하시는 경우 1:1 문의로 문의해 주세요.",
  "text_order_complete_continue_application_form": "교환 신청하신 제품은 반품으로 진행됩니다. 원활한 반품 진행을 위해 반송 박스에 '주문확인서' 또는 '반품 번호'를 동봉해 주세요. 자세한 반품 방법은 '다음'을 눌러서 확인해 주시기 바랍니다.",
  "text_error_order_history_preparing_order_description": "아직 결제가 완료되지 않았습니다. 이어서 결제하시겠습니까?",
  "text_order_history_details_exchange_request": "교환 신청이 완료되었습니다.",
  "text_exchange_order_id": "교환 주문 번호:",
  "text_order_history_detail_exchange_order_title": "교환 주문입니다.",
  "text_exchange_original_order_id": "원거래 주문 번호:",
  "text_order_history_detail_go_to_exchange_detail": "세부정보로 이동",
  "text_delete_app_account": "APP 계정 삭제",
  "text_request_invoice_button_description": "text_request_invoice_button_description",
  "text_request_invoice_button_unavailable_description": "text_request_invoice_button_unavailable_description",
  "text_request_invoice_description_01": "text_request_invoice_description_01",
  "text_request_invoice_description_02": "text_request_invoice_description_02",
  "text_request_invoice_requester_information": "text_request_invoice_requester_information",
  "text_invoice_select_request_type_label": "text_invoice_select_request_type_label",
  "text_invoice_select_request_type_option": "text_invoice_select_request_type_option",
  "text_request_invoice_information_subtitle": "text_request_invoice_information_subtitle",
  "text_invoice_request_type_company_placeholder": "text_invoice_request_type_company_placeholder",
  "text_invoice_select_company_category_label": "text_invoice_select_company_category_label",
  "text_invoice_select_company_category_option": "text_invoice_select_company_category_option",
  "text_invoice_select_company_category_c": "text_invoice_select_company_category_c",
  "text_invoice_select_company_category_pt": "text_invoice_select_company_category_pt",
  "text_invoice_select_company_category_cs": "text_invoice_select_company_category_cs",
  "text_invoice_select_company_category_ta": "text_invoice_select_company_category_ta",
  "text_invoice_select_company_category_d": "text_invoice_select_company_category_d",
  "text_invoice_select_company_category_f": "text_invoice_select_company_category_f",
  "text_invoice_select_company_category_j": "text_invoice_select_company_category_j",
  "text_invoice_select_company_category_le": "text_invoice_select_company_category_le",
  "text_invoice_select_company_category_fa": "text_invoice_select_company_category_fa",
  "text_invoice_select_company_category_tp": "text_invoice_select_company_category_tp",
  "text_invoice_select_company_category_tc": "text_invoice_select_company_category_tc",
  "text_invoice_select_company_category_tr": "text_invoice_select_company_category_tr",
  "text_invoice_select_company_category_tn": "text_invoice_select_company_category_tn",
  "text_invoice_select_company_category_ig": "text_invoice_select_company_category_ig",
  "text_invoice_request_type_individual_input_full_name": "text_invoice_request_type_individual_input_full_name",
  "text_invoice_select_identification_type": "text_invoice_select_identification_type",
  "text_invoice_select_identification_type_mykad": "text_invoice_select_identification_type_mykad",
  "text_invoice_select_identification_type_mytentera": "text_invoice_select_identification_type_mytentera",
  "text_invoice_select_identification_type_passport": "text_invoice_select_identification_type_passport",
  "text_invoice_select_identification_type_mypr": "text_invoice_select_identification_type_mypr",
  "text_invoice_select_identification_type_mykas": "text_invoice_select_identification_type_mykas",
  "text_invoice_request_type_individual_identification_number_label": "text_invoice_request_type_individual_identification_number_label",
  "text_invoice_request_type_individual_input_number": "text_invoice_request_type_individual_input_number",
  "text_invoice_select_state_johor": "text_invoice_select_state_johor",
  "text_invoice_select_state_kedah": "text_invoice_select_state_kedah",
  "text_invoice_select_state_kelantan": "text_invoice_select_state_kelantan",
  "text_invoice_select_state_kuala_lumpur": "text_invoice_select_state_kuala_lumpur",
  "text_invoice_select_state_labuan": "text_invoice_select_state_labuan",
  "text_invoice_select_state_melaka": "text_invoice_select_state_melaka",
  "text_invoice_select_state_negeri_sembilan": "text_invoice_select_state_negeri_sembilan",
  "text_invoice_select_state_pahang": "text_invoice_select_state_pahang",
  "text_invoice_select_state_perak": "text_invoice_select_state_perak",
  "text_invoice_select_state_perlis": "text_invoice_select_state_perlis",
  "text_invoice_select_state_penang": "text_invoice_select_state_penang",
  "text_invoice_select_state_putrajaya": "text_invoice_select_state_putrajaya",
  "text_invoice_select_state_sabah": "text_invoice_select_state_sabah",
  "text_invoice_select_state_sarawak": "text_invoice_select_state_sarawak",
  "text_invoice_select_state_selangor": "text_invoice_select_state_selangor",
  "text_invoice_select_state_terengganu": "text_invoice_select_state_terengganu",
  "text_invoice_select_country_option": "text_invoice_select_country_option",
  "text_invoice_phone_country_code": "text_invoice_phone_country_code",
  "text_invoice_phone_number_hint": "text_invoice_phone_number_hint",
  "text_invoice_contact_email_address": "text_invoice_contact_email_address",
  "text_invoice_contact_email_address_hint": "text_invoice_contact_email_address_hint",
  "text_invoice_address_detail_checkbox_label": "text_invoice_address_detail_checkbox_label",
  "text_invoice_recipient_information_subtitle": "text_invoice_recipient_information_subtitle",
  "text_invoice_agreement": "text_invoice_agreement",
  "text_invoice_agreement_description_01": "text_invoice_agreement_description_01",
  "text_invoice_agreement_description_02": "text_invoice_agreement_description_02",
  "text_invoice_request_completed": "text_invoice_request_completed",
  "text_invoice_request_completed_description_01": "text_invoice_request_completed_description_01",
  "text_invoice_cancel_confirmation": "text_invoice_cancel_confirmation",
  "text_invoice_cancel_confirmation_description": "text_invoice_cancel_confirmation_description",
  "text_invoice_imark_description_01": "text_invoice_imark_description_01",
  "text_invoice_imark_description_02": "text_invoice_imark_description_02",
  "text_invoice_imark_description_03": "text_invoice_imark_description_03",
  "text_invoice_imark_description_04": "text_invoice_imark_description_04",
  "text_payment_method_upi_description": "text_payment_method_upi_description",
  "text_upi_payment_option": "text_upi_payment_option",
  "text_upi_payment_option_upi_id": "text_upi_payment_option_upi_id",
  "text_upi_payment_option_upi_qr_code": "text_upi_payment_option_upi_qr_code",
  "text_upi_payment_id_input_form_placeholder": "text_upi_payment_id_input_form_placeholder",
  "text_upi_payment_id_input_form_hint": "text_upi_payment_id_input_form_hint",
  "text_upi_payment_place_order": "text_upi_payment_place_order",
  "text_upi_payment_qr_code_title": "text_upi_payment_qr_code_title",
  "text_upi_payment_qr_code_description": "text_upi_payment_qr_code_description",
  "text_upi_payment_completed_description_01": "text_upi_payment_completed_description_01",
  "text_thirty_days_lowest_price": "text_thirty_days_lowest_price",
  "text_thirty_days_lowest_price_imark_title": "text_thirty_days_lowest_price_imark_title",
  "text_thirty_days_lowest_price_imark_description_01": "text_thirty_days_lowest_price_imark_description_01",
  "text_uk_thirty_days_lowest_price_imark_title": "text_uk_thirty_days_lowest_price_imark_title",
  "text_thirty_days_lowest_price_imark_sub_title_01": "text_thirty_days_lowest_price_imark_sub_title_01",
  "text_thirty_days_lowest_price_imark_description_02": "text_thirty_days_lowest_price_imark_description_02",
  "text_thirty_days_lowest_price_imark_sub_title_02": "text_thirty_days_lowest_price_imark_sub_title_02",
  "text_thirty_days_lowest_price_imark_description_03": "text_thirty_days_lowest_price_imark_description_03",
  "text_thirty_days_lowest_price_imark_description_04": "text_thirty_days_lowest_price_imark_description_04",
  "text_deliveree": "text_deliveree",
  "text_nittsu": "text_nittsu",
  "text_jne": "text_jne",
  "text_tge": "text_tge",
  "text_uber_direct": "text_uber_direct",
  "text_click_and_collect": "text_click_and_collect",
  "text_poslaju": "text_poslaju",
  "text_efmx": "text_efmx",
  "text_giao_hang_nhanh": "text_giao_hang_nhanh",
  "text_xpressbees_surface": "text_xpressbees_surface",
  "text_delhivery_surface": "text_delhivery_surface",
  "text_pikndel": "text_pikndel",
  "text_shadowfax": "text_shadowfax",
  "text_bluedart": "text_bluedart",
  "text_skyeair": "text_skyeair",
  "text_delivery_method_store_pickup_delivery_lead_time_description_01": "text_delivery_method_store_pickup_delivery_lead_time_description_01",
  "text_delivery_method_store_pickup_delivery_lead_time_description_02": "text_delivery_method_store_pickup_delivery_lead_time_description_02",
  "text_store_pickup_imark_description_01": "text_store_pickup_imark_description_01",
  "text_store_pickup_imark_description_02": "text_store_pickup_imark_description_02",
  "text_store_pickup_imark_description_03": "text_store_pickup_imark_description_03",
  "text_store_pickup_imark_description_04": "text_store_pickup_imark_description_04",
  "text_store_pickup_imark_description_05": "text_store_pickup_imark_description_05",
  "text_store_pickup_imark_description_06": "text_store_pickup_imark_description_06",
  "text_store_pickup_imark_description_07": "text_store_pickup_imark_description_07",
  "text_store_receipt_over_age_consent_checkbox": "만 14세 이상입니다.",
  "text_invoice_print": "text_invoice_print",
  "text_invoice_request_type_individual_personal_id_number_label": "text_invoice_request_type_individual_personal_id_number_label",
  "text_invoice_request_type_individual_input_personal_id_number": "text_invoice_request_type_individual_input_personal_id_number",
  "text_invoice_request_type_individual_passport_number_label": "text_invoice_request_type_individual_passport_number_label",
  "text_invoice_request_type_individual_input_passport_number": "text_invoice_request_type_individual_input_passport_number",
  "text_invoice_request_type_individual_state_budget_relationship_code_label": "text_invoice_request_type_individual_state_budget_relationship_code_label",
  "text_invoice_request_type_individual_input_code": "text_invoice_request_type_individual_input_code",
  "text_invoice_input_address_detail": "text_invoice_input_address_detail",
  "text_payment_completed_description_03": "text_payment_completed_description_03",
  "text_received_order_descriptioin_03": "text_received_order_descriptioin_03",
  "text_store_pickup_imark_description_08": "text_store_pickup_imark_description_08",
  "text_gopay_unavailable_reason_01": "text_gopay_unavailable_reason_01",
  "text_qris_unavailable_reason_01": "text_qris_unavailable_reason_01",
  "text_bank_transfer_unavailable_reason_01": "text_bank_transfer_unavailable_reason_01",
  "text_gopay_unavailable_reason_max_amount_limitation": "text_gopay_unavailable_reason_max_amount_limitation",
  "text_qris_unavailable_reason_max_amount_limitation": "text_qris_unavailable_reason_max_amount_limitation",
  "text_error_order_completed_payment_in_progress": "아직 결제가 완료되지 않았습니다.",
  "text_error_order_completed_payment_retry_confirmation": "아직 결제가 완료되지 않았습니다. 결제를 다시 시도하시겠습니까?",
  "text_error_order_completed_payment_resume": "이어서 결제하기",
  "text_error_order_completed_payment_continue_waiting": "계속 대기",
  "text_error_order_completed_payment_retry": "결제 재시도",
  "text_naver_pay_complete_checkout_description": "[네이버페이] 버튼을 클릭하시면 네이버페이로 결제가 진행됩니다.",
  "text_shippit": "text_shippit",
  "text_404_error_description_incorrect_link": "text_404_error_description_incorrect_link",
  "text_meta_title_static_color_class_page": "text_meta_title_static_color_class_page",
  "text_meta_title_static_color_category_page": "text_meta_title_static_color_category_page",
  "text_meta_title_static_color_subcategory_page": "text_meta_title_static_color_subcategory_page",
  "text_meta_description_static_color_class_page": "text_meta_description_static_color_class_page",
  "text_meta_description_static_color_category_page": "text_meta_description_static_color_category_page",
  "text_meta_description_static_color_subcategory_page": "text_meta_description_static_color_subcategory_page",
  "text_invalid_migrated_billing_address_description_01": "text_invalid_migrated_billing_address_description_01",
  "text_cash_on_delivery_unavailable_reason_pre_order_item_in_cart": "text_cash_on_delivery_unavailable_reason_pre_order_item_in_cart",
  "text_shipping_speed_option_unavailable_message_high_demand": "text_shipping_speed_option_unavailable_message_high_demand",
  "text_amazon": "text_amazon",
  "text_error_order_completed_payment_retry_expired": "이 페이지는 유효하지 않습니다.",
  "text_error_order_completed_payment_retry_expired_description": "이 페이지는 더 이상 유효하지 않습니다. 구매 내역에서 다시 확인해 주세요.",
  "text_log_in_to_checkout": "로그인",
  "text_new_account_registration_to_checkout_button": "신규 회원가입",
  "text_new_account_registration_to_checkout_note": "온라인 스토어 이용을 위해 회원가입이 필요합니다.",
  "text_register_account_button": "신규 회원가입",
  "text_authenticate_verification_code_button": "인증하기",
  "text_membership_referral_campaign_code_title": "추천 코드 입력",
  "text_new_account_registration_complete_message": "감사합니다. 회원가입이 완료되었습니다.",
  "text_error_new_account_registration_failed_to_get_ecwelcome_coupon_message": "쿠폰이 곧 발급될 예정입니다.",
  "text_error_new_account_registration_failed_to_get_ecwelcome_coupon_message_link": "상세",
  "text_product_detail_image_unsellable_color": "- 게재된 이미지에는 판매 예정이 없는 컬러가 포함되어 있을 수 있습니다.<br>- 취급 점포에 따라 상품의 품절 및 판매일 변경이 될 수 있습니다.<br>- 모니터사양에 따라 상품의 색상 및 무늬 등이 실제 상품과 다소 차이가 날 수 있습니다.",
  "text_cj_logistics": "CJ택배",
  "text_discontinued_product_message": "이 제품은 판매가 종료되었습니다. 비슷한 제품으로 확인해 주세요.",
  "text_discontinued_product_label": "판매 종료",
  "text_discontinued_product_view_similar_product": "비슷한 제품 보기",
  "text_discontinued_product": "이 제품은 판매가 종료되었습니다.",
  "text_inpost": "InPost",
  "text_shiprocket": "text_shiprocket",
  "text_lex": "text_lex",
  "text_wexpress": "text_wexpress",
  "text_lbc": "text_lbc",
  "text_xde": "text_xde",
  "text_cycle_and_carriage": "text_cycle_and_carriage",
  "text_kuehne_and_nagel": "text_kuehne_and_nagel",
  "text_kex_express": "text_kex_express",
  "text_jnt_express": "text_jnt_express",
  "text_size_chart_toggle_product": "제품 치수",
  "text_size_chart_toggle_body": "신체 치수",
  "text_size_chart_compare_size": "제품 사이즈 비교",
  "text_size_chart_compare_with_clothes": "구매한 제품과 사이즈 비교",
  "text_size_chart_select_size_description": "확인하고 싶은 사이즈를 선택해 주세요.",
  "text_size_chart_compare_purchased_products": "과거 구매한 제품",
  "text_size_chart_compare_added_products": "추가한 제품",
  "text_size_chart_rotate_screen_orientation": "기기를 세로로 전환하시거나 '제품 사이즈 비교' 링크를 클릭하여 사이즈 표를 확인해 주세요.",
  "text_search_in_faq": "「{query}」 연관 질문 보기",
  "text_select_return_item_quantity": "반품 수량을 선택해 주세요.",
  "text_error_select_return_item_quantity": "반품 수량을 선택해 주세요.",
  "text_purchase_history_filter_entire_duration": "전체",
  "text_purchase_history_filter_before_designated_term": "{term} 이전",
  "text_purchase_history_filter_purchase_date": "구매일",
  "text_new_account_registration_agreement_description": "서비스 이용약관과 개인정보 수집 및 이용을 확인하시고, 만 14세 이상임에 동의하신 후 다음 단계를 진행해 주세요.",
  "text_store_pickup_contact_information_description": "입력하신 이름과 전화번호는 고객님의 회원정보에 자동으로 등록됩니다.",
  "text_app_uqpay_new_registration_discontinued": "",
  "text_address_auto_complete_search_address_label": "text_address_auto_complete_search_address_label",
  "text_address_auto_complete_input_address_manually_button": "text_address_auto_complete_input_address_manually_button",
  "text_address_auto_complete_input_first_address_line_placeholder": "text_address_auto_complete_input_first_address_line_placeholder",
  "text_hint_no_shipping_outside_country": "text_hint_no_shipping_outside_country",
  "text_house_number": "text_house_number",
  "text_house_number_placeholder": "text_house_number_placeholder",
  "text_address_auto_complete_research_address_button": "text_address_auto_complete_research_address_button",
  "text_old_order_history_return_instruction": "text_old_order_history_return_instruction",
  "text_old_order_history_open_return_form_button": "text_old_order_history_open_return_form_button",
  "text_order_history_payment_failed_reason_more_info": "text_order_history_payment_failed_reason_more_info",
  "text_upi_payment_received_order_title": "text_upi_payment_received_order_title",
  "text_step_01": "text_step_01",
  "text_upi_payment_received_order_description_go_to_upi_app": "text_upi_payment_received_order_description_go_to_upi_app",
  "text_step_02": "text_step_02",
  "text_upi_payment_received_order_description_": "text_upi_payment_received_order_description_",
  "text_upi_payment_received_order_description_transaction_expiration_time": "text_upi_payment_received_order_description_transaction_expiration_time",
  "text_upi_payment_received_order_description_expiration_time": "text_upi_payment_received_order_description_expiration_time",
  "text_refer_purchase_history": "이미 주문을 완료한 제품에 대해서는 구매 내역을 확인해 주세요.",
  "text_purchase_history_filter_no_results": "필터와 일치하는 결과가 없습니다.",
  "text_filter_clear_all": "모두 지우기",
  "text_error_unavailable_delivery_shipping_address": "죄송합니다. 현재 주소는 배송이 불가능합니다. 배송 주소를 변경하시거나 새로운 배송 주소를 등록해 주시기 바랍니다.",
  "text_return_form_how_to_return_remove_shipping_label": "text_return_form_how_to_return_remove_shipping_label",
  "text_return_form_how_to_return_remove_shipping_label_description_01": "text_return_form_how_to_return_remove_shipping_label_description_01",
  "text_return_form_how_to_return_remove_shipping_label_reuse_delivery_bag_description": "text_return_form_how_to_return_remove_shipping_label_reuse_delivery_bag_description",
  "text_return_form_how_to_return_remove_shipping_label_description_02": "text_return_form_how_to_return_remove_shipping_label_description_02",
  "text_product_inventory_status_transit": "이 제품의 배송은 최대 1주일 소요될 수 있습니다.",
  "text_product_inventory_status_dc_stock": "이 제품의 배송은 최대 1주일 소요될 수 있습니다.",
  "text_estimated_delivery_time_description": "이 제품은 다른 창고에서 출고되므로 배송이 지연될 수 있습니다. 양해 부탁드립니다.",
  "text_num_4": "4.",
  "text_num_3": "3.",
  "text_guest_checkout_confirm_guest_id_link_label": "text_guest_checkout_confirm_guest_id_link_label",
  "text_guest_checkout_confirm_guest_id_title": "text_guest_checkout_confirm_guest_id_title",
  "text_guest_checkout_confirm_guest_id_description_01": "text_guest_checkout_confirm_guest_id_description_01",
  "text_guest_checkout_confirm_guest_id_description_02": "text_guest_checkout_confirm_guest_id_description_02",
  "text_back_to_guest_login": "text_back_to_guest_login",
  "text_guest_checkout_confirm_guest_id_check_your_email_subtitle": "text_guest_checkout_confirm_guest_id_check_your_email_subtitle",
  "text_guest_checkout_confirm_guest_id_check_your_email_description_01": "text_guest_checkout_confirm_guest_id_check_your_email_description_01",
  "text_guest_checkout_confirm_guest_id_check_your_email_description_02": "text_guest_checkout_confirm_guest_id_check_your_email_description_02",
  "text_guest_checkout_confirm_guest_id_check_your_email_again": "text_guest_checkout_confirm_guest_id_check_your_email_again",
  "text_guest_checkout_confirm_guest_id_return_to_edit_email_button": "text_guest_checkout_confirm_guest_id_return_to_edit_email_button",
  "text_error_guest_checkout_confirm_guest_id_failed_to_find_guest_id_message": "text_error_guest_checkout_confirm_guest_id_failed_to_find_guest_id_message",
  "text_error_guest_checkout_confirm_guest_id_failed_to_send_email_message": "text_error_guest_checkout_confirm_guest_id_failed_to_send_email_message",
  "text_guest_checkout_confirm_guest_id_how_to_check_guest_id_link": "text_guest_checkout_confirm_guest_id_how_to_check_guest_id_link",
  "text_error_invalid_invoice_request_type_company_full_name": "text_error_invalid_invoice_request_type_company_full_name",
  "text_error_invalid_invoice_request_type_company_business_registration_number": "text_error_invalid_invoice_request_type_company_business_registration_number",
  "text_error_invalid_invoice_request_tax_identification_number": "text_error_invalid_invoice_request_tax_identification_number",
  "text_invoice_select_state_unapplicable": "text_invoice_select_state_unapplicable",
  "text_error_invalid_invoice_request_type_individual_state_budget_relationship_code": "text_error_invalid_invoice_request_type_individual_state_budget_relationship_code",
  "text_error_invalid_invoice_request_type_company_tax_id": "text_error_invalid_invoice_request_type_company_tax_id",
  "text_review_order_return_and_exchange_title": "",
  "text_review_order_return_and_exchange_description_01": "",
  "text_review_order_return_and_exchange_description_02": "",
  "text_review_order_return_and_exchange_description_03": "",
  "text_review_order_return_and_exchange_description_04": "",
  "text_review_order_return_and_exchange_description_05": "",
  "text_prefecture_placeholder": "text_prefecture_placeholder",
  "text_preference_settings_personalized_information_product_eu_description_uq": "text_preference_settings_personalized_information_product_eu_description_uq",
  "text_preference_settings_personalized_information_advertisements_eu_description_uq": "text_preference_settings_personalized_information_advertisements_eu_description_uq",
  "text_account_registration_personalized_information_product_eu_description_uq": "text_account_registration_personalized_information_product_eu_description_uq",
  "text_account_registration_personalized_information_advertisements_eu_description_uq": "text_account_registration_personalized_information_advertisements_eu_description_uq"
}; // generated at Thu Sep 18 2025 15:36:39 GMT+0900 (JST)